import { j as Mt } from "./jsx-runtime-944c88e2.js";
import * as M from "react";
import { p as Ep } from "./index-efd35e77.js";
import { D as Mp, z as Ad } from "./index-93802845.js";
import { g as H, p as Sd, m as Td, a as Cd, E as kd, k as ri, d as Vn, f as wt, P as q, l as Us, R as Pt, G as pt, C as N, n as Rp, o as Pd, q as Od, s as Ed, v as Uc, u as Md, x as Rd, y as Ld, j as Ee, M as to, L as Id, z as Dd, b as $c, A as We, i as Bd, h as co, B as $s, I as zd } from "./surface-71c0d1c6.js";
import { C as Je, G as ve, T as Gc } from "./text-e26620ac.js";
import { a as jd } from "./Popup-b6c9078b.js";
import { l as Xa, v as Wc } from "./index-64063129.js";
import * as Vd from "react-dom";
import "./index-c07310bf.js";
import "./auto-scroll-b2de6e53.js";
var Nd = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(n) {
  (function(r, o, t, e) {
    var i = ["", "webkit", "Moz", "MS", "ms", "o"], a = o.createElement("div"), s = "function", l = Math.round, p = Math.abs, h = Date.now;
    function c(g, y, x) {
      return setTimeout(A(g, x), y);
    }
    function u(g, y, x) {
      return Array.isArray(g) ? (v(g, x[y], x), !0) : !1;
    }
    function v(g, y, x) {
      var S;
      if (g)
        if (g.forEach)
          g.forEach(y, x);
        else if (g.length !== e)
          for (S = 0; S < g.length; )
            y.call(x, g[S], S, g), S++;
        else
          for (S in g)
            g.hasOwnProperty(S) && y.call(x, g[S], S, g);
    }
    function f(g, y, x) {
      var S = "DEPRECATED METHOD: " + y + `
` + x + ` AT 
`;
      return function() {
        var E = new Error("get-stack-trace"), I = E && E.stack ? E.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", K = r.console && (r.console.warn || r.console.log);
        return K && K.call(r.console, S, I), g.apply(this, arguments);
      };
    }
    var d;
    typeof Object.assign != "function" ? d = function(y) {
      if (y === e || y === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var x = Object(y), S = 1; S < arguments.length; S++) {
        var E = arguments[S];
        if (E !== e && E !== null)
          for (var I in E)
            E.hasOwnProperty(I) && (x[I] = E[I]);
      }
      return x;
    } : d = Object.assign;
    var m = f(function(y, x, S) {
      for (var E = Object.keys(x), I = 0; I < E.length; )
        (!S || S && y[E[I]] === e) && (y[E[I]] = x[E[I]]), I++;
      return y;
    }, "extend", "Use `assign`."), _ = f(function(y, x) {
      return m(y, x, !0);
    }, "merge", "Use `assign`.");
    function w(g, y, x) {
      var S = y.prototype, E;
      E = g.prototype = Object.create(S), E.constructor = g, E._super = S, x && d(E, x);
    }
    function A(g, y) {
      return function() {
        return g.apply(y, arguments);
      };
    }
    function T(g, y) {
      return typeof g == s ? g.apply(y && y[0] || e, y) : g;
    }
    function k(g, y) {
      return g === e ? y : g;
    }
    function C(g, y, x) {
      v(X(y), function(S) {
        g.addEventListener(S, x, !1);
      });
    }
    function z(g, y, x) {
      v(X(y), function(S) {
        g.removeEventListener(S, x, !1);
      });
    }
    function V(g, y) {
      for (; g; ) {
        if (g == y)
          return !0;
        g = g.parentNode;
      }
      return !1;
    }
    function G(g, y) {
      return g.indexOf(y) > -1;
    }
    function X(g) {
      return g.trim().split(/\s+/g);
    }
    function W(g, y, x) {
      if (g.indexOf && !x)
        return g.indexOf(y);
      for (var S = 0; S < g.length; ) {
        if (x && g[S][x] == y || !x && g[S] === y)
          return S;
        S++;
      }
      return -1;
    }
    function ct(g) {
      return Array.prototype.slice.call(g, 0);
    }
    function It(g, y, x) {
      for (var S = [], E = [], I = 0; I < g.length; ) {
        var K = y ? g[I][y] : g[I];
        W(E, K) < 0 && S.push(g[I]), E[I] = K, I++;
      }
      return x && (y ? S = S.sort(function(Et, Bt) {
        return Et[y] > Bt[y];
      }) : S = S.sort()), S;
    }
    function Gt(g, y) {
      for (var x, S, E = y[0].toUpperCase() + y.slice(1), I = 0; I < i.length; ) {
        if (x = i[I], S = x ? x + E : y, S in g)
          return S;
        I++;
      }
      return e;
    }
    var Wt = 1;
    function ga() {
      return Wt++;
    }
    function Wr(g) {
      var y = g.ownerDocument || g;
      return y.defaultView || y.parentWindow || r;
    }
    var ya = /mobile|tablet|ip(ad|hone|od)|android/i, jo = "ontouchstart" in r, ma = Gt(r, "PointerEvent") !== e, Wf = jo && ya.test(navigator.userAgent), Mi = "touch", Xf = "pen", _a = "mouse", Yf = "kinect", qf = 25, Dt = 1, Pr = 2, bt = 4, Ft = 8, Vo = 1, Ri = 2, Li = 4, Ii = 8, Di = 16, Se = Ri | Li, Or = Ii | Di, cp = Se | Or, up = ["x", "y"], No = ["clientX", "clientY"];
    function te(g, y) {
      var x = this;
      this.manager = g, this.callback = y, this.element = g.element, this.target = g.options.inputTarget, this.domHandler = function(S) {
        T(g.options.enable, [g]) && x.handler(S);
      }, this.init();
    }
    te.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && C(this.element, this.evEl, this.domHandler), this.evTarget && C(this.target, this.evTarget, this.domHandler), this.evWin && C(Wr(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && z(this.element, this.evEl, this.domHandler), this.evTarget && z(this.target, this.evTarget, this.domHandler), this.evWin && z(Wr(this.element), this.evWin, this.domHandler);
      }
    };
    function Zf(g) {
      var y, x = g.options.inputClass;
      return x ? y = x : ma ? y = wa : Wf ? y = Uo : jo ? y = ba : y = Fo, new y(g, Qf);
    }
    function Qf(g, y, x) {
      var S = x.pointers.length, E = x.changedPointers.length, I = y & Dt && S - E === 0, K = y & (bt | Ft) && S - E === 0;
      x.isFirst = !!I, x.isFinal = !!K, I && (g.session = {}), x.eventType = y, Kf(g, x), g.emit("hammer.input", x), g.recognize(x), g.session.prevInput = x;
    }
    function Kf(g, y) {
      var x = g.session, S = y.pointers, E = S.length;
      x.firstInput || (x.firstInput = vp(y)), E > 1 && !x.firstMultiple ? x.firstMultiple = vp(y) : E === 1 && (x.firstMultiple = !1);
      var I = x.firstInput, K = x.firstMultiple, kt = K ? K.center : I.center, Et = y.center = fp(S);
      y.timeStamp = h(), y.deltaTime = y.timeStamp - I.timeStamp, y.angle = xa(kt, Et), y.distance = Ho(kt, Et), Jf(x, y), y.offsetDirection = gp(y.deltaX, y.deltaY);
      var Bt = dp(y.deltaTime, y.deltaX, y.deltaY);
      y.overallVelocityX = Bt.x, y.overallVelocityY = Bt.y, y.overallVelocity = p(Bt.x) > p(Bt.y) ? Bt.x : Bt.y, y.scale = K ? rd(K.pointers, S) : 1, y.rotation = K ? ed(K.pointers, S) : 0, y.maxPointers = x.prevInput ? y.pointers.length > x.prevInput.maxPointers ? y.pointers.length : x.prevInput.maxPointers : y.pointers.length, td(x, y);
      var Ce = g.element;
      V(y.srcEvent.target, Ce) && (Ce = y.srcEvent.target), y.target = Ce;
    }
    function Jf(g, y) {
      var x = y.center, S = g.offsetDelta || {}, E = g.prevDelta || {}, I = g.prevInput || {};
      (y.eventType === Dt || I.eventType === bt) && (E = g.prevDelta = {
        x: I.deltaX || 0,
        y: I.deltaY || 0
      }, S = g.offsetDelta = {
        x: x.x,
        y: x.y
      }), y.deltaX = E.x + (x.x - S.x), y.deltaY = E.y + (x.y - S.y);
    }
    function td(g, y) {
      var x = g.lastInterval || y, S = y.timeStamp - x.timeStamp, E, I, K, kt;
      if (y.eventType != Ft && (S > qf || x.velocity === e)) {
        var Et = y.deltaX - x.deltaX, Bt = y.deltaY - x.deltaY, Ce = dp(S, Et, Bt);
        I = Ce.x, K = Ce.y, E = p(Ce.x) > p(Ce.y) ? Ce.x : Ce.y, kt = gp(Et, Bt), g.lastInterval = y;
      } else
        E = x.velocity, I = x.velocityX, K = x.velocityY, kt = x.direction;
      y.velocity = E, y.velocityX = I, y.velocityY = K, y.direction = kt;
    }
    function vp(g) {
      for (var y = [], x = 0; x < g.pointers.length; )
        y[x] = {
          clientX: l(g.pointers[x].clientX),
          clientY: l(g.pointers[x].clientY)
        }, x++;
      return {
        timeStamp: h(),
        pointers: y,
        center: fp(y),
        deltaX: g.deltaX,
        deltaY: g.deltaY
      };
    }
    function fp(g) {
      var y = g.length;
      if (y === 1)
        return {
          x: l(g[0].clientX),
          y: l(g[0].clientY)
        };
      for (var x = 0, S = 0, E = 0; E < y; )
        x += g[E].clientX, S += g[E].clientY, E++;
      return {
        x: l(x / y),
        y: l(S / y)
      };
    }
    function dp(g, y, x) {
      return {
        x: y / g || 0,
        y: x / g || 0
      };
    }
    function gp(g, y) {
      return g === y ? Vo : p(g) >= p(y) ? g < 0 ? Ri : Li : y < 0 ? Ii : Di;
    }
    function Ho(g, y, x) {
      x || (x = up);
      var S = y[x[0]] - g[x[0]], E = y[x[1]] - g[x[1]];
      return Math.sqrt(S * S + E * E);
    }
    function xa(g, y, x) {
      x || (x = up);
      var S = y[x[0]] - g[x[0]], E = y[x[1]] - g[x[1]];
      return Math.atan2(E, S) * 180 / Math.PI;
    }
    function ed(g, y) {
      return xa(y[1], y[0], No) + xa(g[1], g[0], No);
    }
    function rd(g, y) {
      return Ho(y[0], y[1], No) / Ho(g[0], g[1], No);
    }
    var id = {
      mousedown: Dt,
      mousemove: Pr,
      mouseup: bt
    }, od = "mousedown", nd = "mousemove mouseup";
    function Fo() {
      this.evEl = od, this.evWin = nd, this.pressed = !1, te.apply(this, arguments);
    }
    w(Fo, te, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(y) {
        var x = id[y.type];
        x & Dt && y.button === 0 && (this.pressed = !0), x & Pr && y.which !== 1 && (x = bt), this.pressed && (x & bt && (this.pressed = !1), this.callback(this.manager, x, {
          pointers: [y],
          changedPointers: [y],
          pointerType: _a,
          srcEvent: y
        }));
      }
    });
    var ad = {
      pointerdown: Dt,
      pointermove: Pr,
      pointerup: bt,
      pointercancel: Ft,
      pointerout: Ft
    }, sd = {
      2: Mi,
      3: Xf,
      4: _a,
      5: Yf
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, yp = "pointerdown", mp = "pointermove pointerup pointercancel";
    r.MSPointerEvent && !r.PointerEvent && (yp = "MSPointerDown", mp = "MSPointerMove MSPointerUp MSPointerCancel");
    function wa() {
      this.evEl = yp, this.evWin = mp, te.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    w(wa, te, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(y) {
        var x = this.store, S = !1, E = y.type.toLowerCase().replace("ms", ""), I = ad[E], K = sd[y.pointerType] || y.pointerType, kt = K == Mi, Et = W(x, y.pointerId, "pointerId");
        I & Dt && (y.button === 0 || kt) ? Et < 0 && (x.push(y), Et = x.length - 1) : I & (bt | Ft) && (S = !0), !(Et < 0) && (x[Et] = y, this.callback(this.manager, I, {
          pointers: x,
          changedPointers: [y],
          pointerType: K,
          srcEvent: y
        }), S && x.splice(Et, 1));
      }
    });
    var ld = {
      touchstart: Dt,
      touchmove: Pr,
      touchend: bt,
      touchcancel: Ft
    }, pd = "touchstart", hd = "touchstart touchmove touchend touchcancel";
    function _p() {
      this.evTarget = pd, this.evWin = hd, this.started = !1, te.apply(this, arguments);
    }
    w(_p, te, {
      handler: function(y) {
        var x = ld[y.type];
        if (x === Dt && (this.started = !0), !!this.started) {
          var S = cd.call(this, y, x);
          x & (bt | Ft) && S[0].length - S[1].length === 0 && (this.started = !1), this.callback(this.manager, x, {
            pointers: S[0],
            changedPointers: S[1],
            pointerType: Mi,
            srcEvent: y
          });
        }
      }
    });
    function cd(g, y) {
      var x = ct(g.touches), S = ct(g.changedTouches);
      return y & (bt | Ft) && (x = It(x.concat(S), "identifier", !0)), [x, S];
    }
    var ud = {
      touchstart: Dt,
      touchmove: Pr,
      touchend: bt,
      touchcancel: Ft
    }, vd = "touchstart touchmove touchend touchcancel";
    function Uo() {
      this.evTarget = vd, this.targetIds = {}, te.apply(this, arguments);
    }
    w(Uo, te, {
      handler: function(y) {
        var x = ud[y.type], S = fd.call(this, y, x);
        S && this.callback(this.manager, x, {
          pointers: S[0],
          changedPointers: S[1],
          pointerType: Mi,
          srcEvent: y
        });
      }
    });
    function fd(g, y) {
      var x = ct(g.touches), S = this.targetIds;
      if (y & (Dt | Pr) && x.length === 1)
        return S[x[0].identifier] = !0, [x, x];
      var E, I, K = ct(g.changedTouches), kt = [], Et = this.target;
      if (I = x.filter(function(Bt) {
        return V(Bt.target, Et);
      }), y === Dt)
        for (E = 0; E < I.length; )
          S[I[E].identifier] = !0, E++;
      for (E = 0; E < K.length; )
        S[K[E].identifier] && kt.push(K[E]), y & (bt | Ft) && delete S[K[E].identifier], E++;
      if (kt.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          It(I.concat(kt), "identifier", !0),
          kt
        ];
    }
    var dd = 2500, xp = 25;
    function ba() {
      te.apply(this, arguments);
      var g = A(this.handler, this);
      this.touch = new Uo(this.manager, g), this.mouse = new Fo(this.manager, g), this.primaryTouch = null, this.lastTouches = [];
    }
    w(ba, te, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(y, x, S) {
        var E = S.pointerType == Mi, I = S.pointerType == _a;
        if (!(I && S.sourceCapabilities && S.sourceCapabilities.firesTouchEvents)) {
          if (E)
            gd.call(this, x, S);
          else if (I && yd.call(this, S))
            return;
          this.callback(y, x, S);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function gd(g, y) {
      g & Dt ? (this.primaryTouch = y.changedPointers[0].identifier, wp.call(this, y)) : g & (bt | Ft) && wp.call(this, y);
    }
    function wp(g) {
      var y = g.changedPointers[0];
      if (y.identifier === this.primaryTouch) {
        var x = { x: y.clientX, y: y.clientY };
        this.lastTouches.push(x);
        var S = this.lastTouches, E = function() {
          var I = S.indexOf(x);
          I > -1 && S.splice(I, 1);
        };
        setTimeout(E, dd);
      }
    }
    function yd(g) {
      for (var y = g.srcEvent.clientX, x = g.srcEvent.clientY, S = 0; S < this.lastTouches.length; S++) {
        var E = this.lastTouches[S], I = Math.abs(y - E.x), K = Math.abs(x - E.y);
        if (I <= xp && K <= xp)
          return !0;
      }
      return !1;
    }
    var bp = Gt(a.style, "touchAction"), Ap = bp !== e, Sp = "compute", Tp = "auto", Aa = "manipulation", Er = "none", Bi = "pan-x", zi = "pan-y", $o = _d();
    function Sa(g, y) {
      this.manager = g, this.set(y);
    }
    Sa.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(g) {
        g == Sp && (g = this.compute()), Ap && this.manager.element.style && $o[g] && (this.manager.element.style[bp] = g), this.actions = g.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var g = [];
        return v(this.manager.recognizers, function(y) {
          T(y.options.enable, [y]) && (g = g.concat(y.getTouchAction()));
        }), md(g.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(g) {
        var y = g.srcEvent, x = g.offsetDirection;
        if (this.manager.session.prevented) {
          y.preventDefault();
          return;
        }
        var S = this.actions, E = G(S, Er) && !$o[Er], I = G(S, zi) && !$o[zi], K = G(S, Bi) && !$o[Bi];
        if (E) {
          var kt = g.pointers.length === 1, Et = g.distance < 2, Bt = g.deltaTime < 250;
          if (kt && Et && Bt)
            return;
        }
        if (!(K && I) && (E || I && x & Se || K && x & Or))
          return this.preventSrc(y);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(g) {
        this.manager.session.prevented = !0, g.preventDefault();
      }
    };
    function md(g) {
      if (G(g, Er))
        return Er;
      var y = G(g, Bi), x = G(g, zi);
      return y && x ? Er : y || x ? y ? Bi : zi : G(g, Aa) ? Aa : Tp;
    }
    function _d() {
      if (!Ap)
        return !1;
      var g = {}, y = r.CSS && r.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(x) {
        g[x] = y ? r.CSS.supports("touch-action", x) : !0;
      }), g;
    }
    var Go = 1, ee = 2, Xr = 4, cr = 8, Ne = cr, ji = 16, Te = 32;
    function He(g) {
      this.options = d({}, this.defaults, g || {}), this.id = ga(), this.manager = null, this.options.enable = k(this.options.enable, !0), this.state = Go, this.simultaneous = {}, this.requireFail = [];
    }
    He.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(g) {
        return d(this.options, g), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(g) {
        if (u(g, "recognizeWith", this))
          return this;
        var y = this.simultaneous;
        return g = Wo(g, this), y[g.id] || (y[g.id] = g, g.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(g) {
        return u(g, "dropRecognizeWith", this) ? this : (g = Wo(g, this), delete this.simultaneous[g.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(g) {
        if (u(g, "requireFailure", this))
          return this;
        var y = this.requireFail;
        return g = Wo(g, this), W(y, g) === -1 && (y.push(g), g.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(g) {
        if (u(g, "dropRequireFailure", this))
          return this;
        g = Wo(g, this);
        var y = W(this.requireFail, g);
        return y > -1 && this.requireFail.splice(y, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(g) {
        return !!this.simultaneous[g.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(g) {
        var y = this, x = this.state;
        function S(E) {
          y.manager.emit(E, g);
        }
        x < cr && S(y.options.event + Cp(x)), S(y.options.event), g.additionalEvent && S(g.additionalEvent), x >= cr && S(y.options.event + Cp(x));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(g) {
        if (this.canEmit())
          return this.emit(g);
        this.state = Te;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var g = 0; g < this.requireFail.length; ) {
          if (!(this.requireFail[g].state & (Te | Go)))
            return !1;
          g++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(g) {
        var y = d({}, g);
        if (!T(this.options.enable, [this, y])) {
          this.reset(), this.state = Te;
          return;
        }
        this.state & (Ne | ji | Te) && (this.state = Go), this.state = this.process(y), this.state & (ee | Xr | cr | ji) && this.tryEmit(y);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(g) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function Cp(g) {
      return g & ji ? "cancel" : g & cr ? "end" : g & Xr ? "move" : g & ee ? "start" : "";
    }
    function kp(g) {
      return g == Di ? "down" : g == Ii ? "up" : g == Ri ? "left" : g == Li ? "right" : "";
    }
    function Wo(g, y) {
      var x = y.manager;
      return x ? x.get(g) : g;
    }
    function he() {
      He.apply(this, arguments);
    }
    w(he, He, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(g) {
        var y = this.options.pointers;
        return y === 0 || g.pointers.length === y;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(g) {
        var y = this.state, x = g.eventType, S = y & (ee | Xr), E = this.attrTest(g);
        return S && (x & Ft || !E) ? y | ji : S || E ? x & bt ? y | cr : y & ee ? y | Xr : ee : Te;
      }
    });
    function Xo() {
      he.apply(this, arguments), this.pX = null, this.pY = null;
    }
    w(Xo, he, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: cp
      },
      getTouchAction: function() {
        var g = this.options.direction, y = [];
        return g & Se && y.push(zi), g & Or && y.push(Bi), y;
      },
      directionTest: function(g) {
        var y = this.options, x = !0, S = g.distance, E = g.direction, I = g.deltaX, K = g.deltaY;
        return E & y.direction || (y.direction & Se ? (E = I === 0 ? Vo : I < 0 ? Ri : Li, x = I != this.pX, S = Math.abs(g.deltaX)) : (E = K === 0 ? Vo : K < 0 ? Ii : Di, x = K != this.pY, S = Math.abs(g.deltaY))), g.direction = E, x && S > y.threshold && E & y.direction;
      },
      attrTest: function(g) {
        return he.prototype.attrTest.call(this, g) && (this.state & ee || !(this.state & ee) && this.directionTest(g));
      },
      emit: function(g) {
        this.pX = g.deltaX, this.pY = g.deltaY;
        var y = kp(g.direction);
        y && (g.additionalEvent = this.options.event + y), this._super.emit.call(this, g);
      }
    });
    function Ta() {
      he.apply(this, arguments);
    }
    w(Ta, he, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Er];
      },
      attrTest: function(g) {
        return this._super.attrTest.call(this, g) && (Math.abs(g.scale - 1) > this.options.threshold || this.state & ee);
      },
      emit: function(g) {
        if (g.scale !== 1) {
          var y = g.scale < 1 ? "in" : "out";
          g.additionalEvent = this.options.event + y;
        }
        this._super.emit.call(this, g);
      }
    });
    function Ca() {
      He.apply(this, arguments), this._timer = null, this._input = null;
    }
    w(Ca, He, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [Tp];
      },
      process: function(g) {
        var y = this.options, x = g.pointers.length === y.pointers, S = g.distance < y.threshold, E = g.deltaTime > y.time;
        if (this._input = g, !S || !x || g.eventType & (bt | Ft) && !E)
          this.reset();
        else if (g.eventType & Dt)
          this.reset(), this._timer = c(function() {
            this.state = Ne, this.tryEmit();
          }, y.time, this);
        else if (g.eventType & bt)
          return Ne;
        return Te;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(g) {
        this.state === Ne && (g && g.eventType & bt ? this.manager.emit(this.options.event + "up", g) : (this._input.timeStamp = h(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function ka() {
      he.apply(this, arguments);
    }
    w(ka, he, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Er];
      },
      attrTest: function(g) {
        return this._super.attrTest.call(this, g) && (Math.abs(g.rotation) > this.options.threshold || this.state & ee);
      }
    });
    function Pa() {
      he.apply(this, arguments);
    }
    w(Pa, he, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: Se | Or,
        pointers: 1
      },
      getTouchAction: function() {
        return Xo.prototype.getTouchAction.call(this);
      },
      attrTest: function(g) {
        var y = this.options.direction, x;
        return y & (Se | Or) ? x = g.overallVelocity : y & Se ? x = g.overallVelocityX : y & Or && (x = g.overallVelocityY), this._super.attrTest.call(this, g) && y & g.offsetDirection && g.distance > this.options.threshold && g.maxPointers == this.options.pointers && p(x) > this.options.velocity && g.eventType & bt;
      },
      emit: function(g) {
        var y = kp(g.offsetDirection);
        y && this.manager.emit(this.options.event + y, g), this.manager.emit(this.options.event, g);
      }
    });
    function Yo() {
      He.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    w(Yo, He, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [Aa];
      },
      process: function(g) {
        var y = this.options, x = g.pointers.length === y.pointers, S = g.distance < y.threshold, E = g.deltaTime < y.time;
        if (this.reset(), g.eventType & Dt && this.count === 0)
          return this.failTimeout();
        if (S && E && x) {
          if (g.eventType != bt)
            return this.failTimeout();
          var I = this.pTime ? g.timeStamp - this.pTime < y.interval : !0, K = !this.pCenter || Ho(this.pCenter, g.center) < y.posThreshold;
          this.pTime = g.timeStamp, this.pCenter = g.center, !K || !I ? this.count = 1 : this.count += 1, this._input = g;
          var kt = this.count % y.taps;
          if (kt === 0)
            return this.hasRequireFailures() ? (this._timer = c(function() {
              this.state = Ne, this.tryEmit();
            }, y.interval, this), ee) : Ne;
        }
        return Te;
      },
      failTimeout: function() {
        return this._timer = c(function() {
          this.state = Te;
        }, this.options.interval, this), Te;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == Ne && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function Fe(g, y) {
      return y = y || {}, y.recognizers = k(y.recognizers, Fe.defaults.preset), new Oa(g, y);
    }
    Fe.VERSION = "2.0.7", Fe.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: Sp,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [ka, { enable: !1 }],
        [Ta, { enable: !1 }, ["rotate"]],
        [Pa, { direction: Se }],
        [Xo, { direction: Se }, ["swipe"]],
        [Yo],
        [Yo, { event: "doubletap", taps: 2 }, ["tap"]],
        [Ca]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var xd = 1, Pp = 2;
    function Oa(g, y) {
      this.options = d({}, Fe.defaults, y || {}), this.options.inputTarget = this.options.inputTarget || g, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = g, this.input = Zf(this), this.touchAction = new Sa(this, this.options.touchAction), Op(this, !0), v(this.options.recognizers, function(x) {
        var S = this.add(new x[0](x[1]));
        x[2] && S.recognizeWith(x[2]), x[3] && S.requireFailure(x[3]);
      }, this);
    }
    Oa.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(g) {
        return d(this.options, g), g.touchAction && this.touchAction.update(), g.inputTarget && (this.input.destroy(), this.input.target = g.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(g) {
        this.session.stopped = g ? Pp : xd;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(g) {
        var y = this.session;
        if (!y.stopped) {
          this.touchAction.preventDefaults(g);
          var x, S = this.recognizers, E = y.curRecognizer;
          (!E || E && E.state & Ne) && (E = y.curRecognizer = null);
          for (var I = 0; I < S.length; )
            x = S[I], y.stopped !== Pp && // 1
            (!E || x == E || // 2
            x.canRecognizeWith(E)) ? x.recognize(g) : x.reset(), !E && x.state & (ee | Xr | cr) && (E = y.curRecognizer = x), I++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(g) {
        if (g instanceof He)
          return g;
        for (var y = this.recognizers, x = 0; x < y.length; x++)
          if (y[x].options.event == g)
            return y[x];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(g) {
        if (u(g, "add", this))
          return this;
        var y = this.get(g.options.event);
        return y && this.remove(y), this.recognizers.push(g), g.manager = this, this.touchAction.update(), g;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(g) {
        if (u(g, "remove", this))
          return this;
        if (g = this.get(g), g) {
          var y = this.recognizers, x = W(y, g);
          x !== -1 && (y.splice(x, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(g, y) {
        if (g !== e && y !== e) {
          var x = this.handlers;
          return v(X(g), function(S) {
            x[S] = x[S] || [], x[S].push(y);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(g, y) {
        if (g !== e) {
          var x = this.handlers;
          return v(X(g), function(S) {
            y ? x[S] && x[S].splice(W(x[S], y), 1) : delete x[S];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(g, y) {
        this.options.domEvents && wd(g, y);
        var x = this.handlers[g] && this.handlers[g].slice();
        if (!(!x || !x.length)) {
          y.type = g, y.preventDefault = function() {
            y.srcEvent.preventDefault();
          };
          for (var S = 0; S < x.length; )
            x[S](y), S++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && Op(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function Op(g, y) {
      var x = g.element;
      if (x.style) {
        var S;
        v(g.options.cssProps, function(E, I) {
          S = Gt(x.style, I), y ? (g.oldCssProps[S] = x.style[S], x.style[S] = E) : x.style[S] = g.oldCssProps[S] || "";
        }), y || (g.oldCssProps = {});
      }
    }
    function wd(g, y) {
      var x = o.createEvent("Event");
      x.initEvent(g, !0, !0), x.gesture = y, y.target.dispatchEvent(x);
    }
    d(Fe, {
      INPUT_START: Dt,
      INPUT_MOVE: Pr,
      INPUT_END: bt,
      INPUT_CANCEL: Ft,
      STATE_POSSIBLE: Go,
      STATE_BEGAN: ee,
      STATE_CHANGED: Xr,
      STATE_ENDED: cr,
      STATE_RECOGNIZED: Ne,
      STATE_CANCELLED: ji,
      STATE_FAILED: Te,
      DIRECTION_NONE: Vo,
      DIRECTION_LEFT: Ri,
      DIRECTION_RIGHT: Li,
      DIRECTION_UP: Ii,
      DIRECTION_DOWN: Di,
      DIRECTION_HORIZONTAL: Se,
      DIRECTION_VERTICAL: Or,
      DIRECTION_ALL: cp,
      Manager: Oa,
      Input: te,
      TouchAction: Sa,
      TouchInput: Uo,
      MouseInput: Fo,
      PointerEventInput: wa,
      TouchMouseInput: ba,
      SingleTouchInput: _p,
      Recognizer: He,
      AttrRecognizer: he,
      Tap: Yo,
      Pan: Xo,
      Swipe: Pa,
      Pinch: Ta,
      Rotate: ka,
      Press: Ca,
      on: C,
      off: z,
      each: v,
      merge: _,
      extend: m,
      assign: d,
      inherit: w,
      bindFn: A,
      prefixed: Gt
    });
    var bd = typeof r < "u" ? r : typeof self < "u" ? self : {};
    bd.Hammer = Fe, typeof e == "function" && e.amd ? e(function() {
      return Fe;
    }) : n.exports ? n.exports = Fe : r[t] = Fe;
  })(window, document, "Hammer");
})(Nd);
var mr = "arc", Hd = "axisLabelClick", yt = "#000", it = "bottom", $ = "center", fe = "circle", Tt = 3, Xc = "cross", xr = "date", Yc = "12px sans-serif", qc = 400, nt = 10, Gs = 600, Lp = "end", Zc = /\{\d+:?/, yn = "height", Qc = 100, Ya = "inside", Q = "left", gt = Number.MAX_VALUE, xt = -Number.MAX_VALUE, qa = "none", Fd = "noteClick", Ud = "noteHover", $d = "noteLeave", Za = "object", sn = "outside", et = "right", Kc = "roundedRect", Gd = "start", Ws = "string", tt = "top", Wd = "triangle", Xt = "value", J = "#fff", mn = "width", D = "x", B = "y", Ip = 1;
function Ot(n) {
  return Array.isArray(n);
}
function mt(n, r) {
  for (var o = Ot(r) ? r : [r], t = 0; t < o.length; t++) {
    var e = o[t];
    n.className.indexOf(e) === -1 && (n.className += " " + e);
  }
}
var Xd = /\s+/g;
function Xs(n, r) {
  n && n.className && (n.className = n.className.replace(r, "").replace(Xd, " "));
}
var Yd = "#000", qd = function(n) {
  function r(t, e) {
    t === void 0 && (t = new ri()), e === void 0 && (e = {}), n.call(this, e), this.geometry(t), Vn(this.options.stroke) || this.stroke(Yd);
  }
  n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r;
  var o = { nodeType: { configurable: !0 } };
  return o.nodeType.get = function() {
    return "Arc";
  }, r.prototype._bbox = function(e) {
    return this._geometry.bbox(e);
  }, r.prototype.rawBBox = function() {
    return this.geometry().bbox();
  }, r.prototype.toPath = function() {
    var e = new H(), i = this.geometry().curvePoints();
    if (i.length > 0) {
      e.moveTo(i[0].x, i[0].y);
      for (var a = 1; a < i.length; a += 3)
        e.curveTo(i[a], i[a + 1], i[a + 2]);
    }
    return e;
  }, r.prototype._containsPoint = function(e) {
    return this.geometry().containsPoint(e);
  }, r.prototype._isOnPath = function(e) {
    return this.geometry()._isOnPath(e, this.options.stroke.width / 2);
  }, Object.defineProperties(r.prototype, o), r;
}(Sd(Td(Cd(kd))));
const Zd = qd;
function Qd(n, r, o) {
  var t = o.transform() || wt(), e = t.matrix();
  e.e += n.x - r.origin.x, e.f += n.y - r.origin.y, t.matrix(e), o.transform(t);
}
function qo(n, r, o, t, e) {
  var i;
  return o === "start" ? i = r.origin[t] : o === "end" ? i = r.origin[t] + r.size[e] - n : i = r.origin[t] + (r.size[e] - n) / 2, i;
}
function Kd(n, r, o, t, e) {
  var i;
  return o === "start" ? i = r.origin[t] + r.size[e] - n : o === "end" ? i = r.origin[t] : i = r.origin[t] + (r.size[e] - n) / 2, i;
}
var Jd = {
  alignContent: "start",
  justifyContent: "start",
  alignItems: "start",
  spacing: 0,
  orientation: "horizontal",
  lineSpacing: 0,
  wrap: !0,
  revers: !1
}, tg = function(n, r) {
  n.forEach(r);
}, eg = function(n, r) {
  for (var o = n.length, t = o - 1; t >= 0; t--)
    r(n[t], t);
}, rg = function(n) {
  function r(o, t) {
    n.call(this, Object.assign({}, Jd, t)), this._rect = o, this._fieldMap = {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.rect = function(t) {
    return t ? (this._rect = t, this) : this._rect;
  }, r.prototype._initMap = function() {
    var t = this.options, e = this._fieldMap;
    t.orientation === "horizontal" ? (e.sizeField = "width", e.groupsSizeField = "height", e.groupAxis = "x", e.groupsAxis = "y") : (e.sizeField = "height", e.groupsSizeField = "width", e.groupAxis = "y", e.groupsAxis = "x"), t.reverse ? (this.forEach = eg, this.justifyAlign = Kd) : (this.forEach = tg, this.justifyAlign = qo);
  }, r.prototype.reflow = function() {
    var t = this;
    if (!(!this._rect || this.children.length === 0)) {
      this._initMap(), this.options.transform && this.transform(null);
      for (var e = this.options, i = this._rect, a = this._initGroups(), s = a.groups, l = a.groupsSize, p = this._fieldMap, h = p.sizeField, c = p.groupsSizeField, u = p.groupAxis, v = p.groupsAxis, f = new q(), d = new q(), m = new Us(), _ = qo(l, i, e.alignContent, v, c), w, A, T, k = function(ct, It) {
        var Gt = A.elements[It];
        d[u] = w, d[v] = qo(ct.size[c], T, e.alignItems, v, c), Qd(d, ct, Gt), w += ct.size[h] + e.spacing;
      }, C = 0; C < s.length; C++)
        A = s[C], f[u] = w = t.justifyAlign(A.size, i, e.justifyContent, u, h), f[v] = _, m[h] = A.size, m[c] = A.lineSize, T = new Pt(f, m), t.forEach(A.bboxes, k), _ += A.lineSize + e.lineSpacing;
      if (!e.wrap && A.size > i.size[h]) {
        var z = i.size[h] / T.size[h], V = T.topLeft().scale(z, z), G = T.size[c] * z, X = qo(G, i, e.alignContent, v, c), W = wt();
        u === "x" ? W.translate(i.origin.x - V.x, X - V.y) : W.translate(X - V.x, i.origin.y - V.y), W.scale(z, z), this.transform(W);
      }
    }
  }, r.prototype._initGroups = function() {
    for (var t = this, e = this, i = e.options, a = e.children, s = i.lineSpacing, l = i.wrap, p = i.spacing, h = this._fieldMap.sizeField, c = this._newGroup(), u = [], v = function() {
      u.push(c), f += c.lineSize + s;
    }, f = -s, d = 0; d < a.length; d++) {
      var m = a[d], _ = a[d].clippedBBox();
      m.visible() && _ && (l && c.size + _.size[h] + p > t._rect.size[h] ? c.bboxes.length === 0 ? (t._addToGroup(c, _, m), v(), c = t._newGroup()) : (v(), c = t._newGroup(), t._addToGroup(c, _, m)) : t._addToGroup(c, _, m));
    }
    return c.bboxes.length && v(), {
      groups: u,
      groupsSize: f
    };
  }, r.prototype._addToGroup = function(t, e, i) {
    t.size += e.size[this._fieldMap.sizeField] + this.options.spacing, t.lineSize = Math.max(e.size[this._fieldMap.groupsSizeField], t.lineSize), t.bboxes.push(e), t.elements.push(i);
  }, r.prototype._newGroup = function() {
    return {
      lineSize: 0,
      size: -this.options.spacing,
      bboxes: [],
      elements: []
    };
  }, r;
}(pt);
const ig = rg;
function og(n) {
  return 0.5 - Math.cos(n * Math.PI) / 2;
}
function ng(n) {
  return n;
}
function ag(n, r, o, t) {
  var e = 1.70158, i = 0, a = t;
  return n === 0 ? o : n === 1 ? o + t : (i || (i = 0.5), a < Math.abs(t) ? (a = t, e = i / 4) : e = i / (2 * Math.PI) * Math.asin(t / a), a * Math.pow(2, -10 * n) * Math.sin((Number(n) - e) * (1.1 * Math.PI) / i) + t + o);
}
const sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  easeOutElastic: ag,
  linear: ng,
  swing: og
}, Symbol.toStringTag, { value: "Module" }));
var Ea, lg = function(n) {
  function r() {
    n.call(this), this._items = [];
  }
  n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r;
  var o = { current: { configurable: !0 } };
  return o.current.get = function() {
    return Ea || (Ea = new r()), Ea;
  }, r.prototype.register = function(e, i) {
    this._items.push({
      name: e,
      type: i
    });
  }, r.prototype.create = function(e, i) {
    var a = this._items, s;
    if (i && i.type) {
      for (var l = i.type.toLowerCase(), p = 0; p < a.length; p++)
        if (a[p].name.toLowerCase() === l) {
          s = a[p];
          break;
        }
    }
    if (s)
      return new s.type(e, i);
  }, Object.defineProperties(r, o), r;
}(N);
const De = lg;
var pg = function(n) {
  function r(t, e) {
    n.call(this), this.options = Object.assign({}, this.options, e), this.element = t;
  }
  n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r;
  var o = { options: { configurable: !0 } };
  return r.create = function(e, i, a) {
    return De.current.create(e, i, a);
  }, o.options.get = function() {
    return this._options || {
      duration: 500,
      easing: "swing"
    };
  }, o.options.set = function(t) {
    this._options = t;
  }, r.prototype.setup = function() {
  }, r.prototype.step = function() {
  }, r.prototype.play = function() {
    var e = this, i = this.options, a = i.duration, s = i.delay;
    s === void 0 && (s = 0);
    var l = sg[i.easing], p = Rp() + s, h = p + a;
    a === 0 ? (this.step(1), this.abort()) : setTimeout(function() {
      var c = function() {
        if (!e._stopped) {
          var u = Rp(), v = Od(u - p, 0, a), f = v / a, d = l(f, v, 0, 1, a);
          e.step(d), u < h ? Pd(c) : e.abort();
        }
      };
      c();
    }, s);
  }, r.prototype.abort = function() {
    this._stopped = !0;
  }, r.prototype.destroy = function() {
    this.abort();
  }, Object.defineProperties(r.prototype, o), r;
}(N);
const pe = pg;
function ae(n) {
  var r = 0.5;
  n.options.stroke && Vn(n.options.stroke.width) && n.options.stroke.width % 2 === 0 && (r = 0);
  for (var o = 0; o < n.segments.length; o++)
    n.segments[o].anchor().round(0).translate(r, r);
  return n;
}
function Dp(n, r) {
  return -n.x * r.y + n.y * r.x < 0;
}
function Y(n) {
  return typeof n == "number" && !isNaN(n);
}
function se(n) {
  return typeof n === Ws;
}
function Jc(n) {
  return Y(n) || se(n) && isFinite(n);
}
function vt(n) {
  return typeof n == "function";
}
var Bp = "object", hg = "undefined";
function tu(n, r) {
  for (var o in r) {
    var t = r[o], e = typeof t, i = void 0;
    if (e === Bp && t !== null ? i = t.constructor : i = null, i && i !== Array)
      if (t instanceof Date)
        n[o] = new Date(t.getTime());
      else if (vt(t.clone))
        n[o] = t.clone();
      else {
        var a = n[o];
        typeof a === Bp ? n[o] = a || {} : n[o] = {}, tu(n[o], t);
      }
    else
      e !== hg && (n[o] = t);
  }
  return n;
}
function b(n) {
  for (var r = arguments, o = arguments.length, t = 1; t < o; t++)
    tu(n, r[t]);
  return n;
}
function le(n) {
  return typeof n == "object";
}
function qr(n) {
  return Y(n) ? n + "px" : n;
}
var cg = /width|height|top|left|bottom|right/i;
function ug(n) {
  return cg.test(n);
}
function ut(n, r) {
  var o = se(r) ? [r] : r;
  if (Ot(o)) {
    for (var t = {}, e = window.getComputedStyle(n), i = 0; i < o.length; i++) {
      var a = o[i];
      t[a] = ug(a) ? parseFloat(e[a]) : e[a];
    }
    return t;
  } else if (le(r))
    for (var s in r)
      n.style[s] = qr(r[s]);
}
function ot(n, r) {
  r === void 0 && (r = 0);
  var o = { top: 0, right: 0, bottom: 0, left: 0 };
  return typeof n == "number" ? o[tt] = o[et] = o[it] = o[Q] = n : (o[tt] = n[tt] || r, o[et] = n[et] || r, o[it] = n[it] || r, o[Q] = n[Q] || r), o;
}
var eu = {
  compile: function(n) {
    return n;
  }
}, uo = function() {
};
uo.register = function(r) {
  eu = r;
};
uo.compile = function(r, o) {
  return eu.compile(r, o);
};
function Ct(n) {
  n === void 0 && (n = {});
  var r;
  return n.template ? n.template = r = uo.compile(n.template) : vt(n.content) && (r = n.content), r;
}
var vg = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g, $i = {};
$i.undefined = function(n) {
  return n;
};
function Qe(n) {
  if ($i[n])
    return $i[n];
  var r = [];
  return n.replace(vg, function(o, t, e, i) {
    r.push(Vn(t) ? t : e || i);
  }), $i[n] = function(o) {
    for (var t = o, e = 0; e < r.length && t; e++)
      t = t[r[e]];
    return t;
  }, $i[n];
}
function qt(n, r) {
  for (var o = n.length, t = [], e = 0; e < o; e++)
    r(n[e]) && t.push(n[e]);
  return t;
}
function _n(n, r) {
  if (n.className) {
    for (var o = r.split(" "), t = 0; t < o.length; t++)
      if (n.className.indexOf && n.className.indexOf(o[t]) !== -1)
        return !0;
  }
}
var vo = function() {
  this._map = {};
};
vo.prototype.get = function(r) {
  return this._map[this._key(r)];
};
vo.prototype.set = function(r, o) {
  this._map[this._key(r)] = o;
};
vo.prototype._key = function(r) {
  return r instanceof Date ? r.getTime() : r;
};
function Z(n, r) {
  if (r)
    return r.indexOf(n) !== -1;
}
function ie(n, r, o) {
  return Ed(n + (r - n) * o, Tt);
}
var zp = "trigger", de = function(r, o) {
  this.observer = r, this.handlerMap = b({}, this.handlerMap, o);
};
de.prototype.trigger = function(r, o) {
  var t = this, e = t.observer, i = t.handlerMap, a;
  return i[r] ? a = this.callObserver(i[r], o) : e[zp] && (a = this.callObserver(zp, r, o)), a;
};
de.prototype.callObserver = function(r) {
  for (var o = [], t = arguments.length - 1; t-- > 0; )
    o[t] = arguments[t + 1];
  return this.observer[r].apply(this.observer, o);
};
de.prototype.requiresHandlers = function(r) {
  var o = this;
  if (this.observer.requiresHandlers)
    return this.observer.requiresHandlers(r);
  for (var t = 0; t < r.length; t++)
    if (o.handlerMap[r[t]])
      return !0;
};
function fg(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function ru(n, r) {
  for (var o = n.length, t = [], e = 0; e < o; e++) {
    var i = r(n[e]);
    Vn(i) && t.push(i);
  }
  return t;
}
var dg = Uc.browser || {};
function Ys(n) {
  var r = 0;
  return n.wheelDelta ? (r = -n.wheelDelta / 120, dg.webkit && (r = r / (2 * Math.max(window.devicePixelRatio, 0.625)))) : n.detail && (r = n.detail / 3), r = r > 0 ? Math.ceil(r) : Math.floor(r), r;
}
var Lt = Md, Nr = Lt.append, Gi = Lt.bindEvents, P = Lt.defined, gr = Lt.deg, ii = Lt.elementOffset, Ye = Lt.elementSize, iu = Lt.eventCoordinates, ge = Lt.eventElement, gg = Lt.hashKey, dt = Lt.last, j = Lt.limitValue, yg = Lt.objectKey, _t = Lt.rad, R = Lt.round, Wi = Lt.unbindEvents, U = Lt.valueOrDefault, Lr = function() {
};
Lr.fetchFonts = function(r, o, t) {
  t === void 0 && (t = { depth: 0 });
  var e = 5;
  !r || t.depth > e || !document.fonts || Object.keys(r).forEach(function(i) {
    var a = r[i];
    i === "dataSource" || i[0] === "$" || !a || (i === "font" ? o.push(a) : typeof a == "object" && (t.depth++, Lr.fetchFonts(a, o, t), t.depth--));
  });
};
Lr.loadFonts = function(r, o) {
  var t = [];
  if (r.length > 0 && document.fonts) {
    try {
      t = r.map(function(e) {
        return document.fonts.load(e);
      });
    } catch (e) {
      Rd(e);
    }
    Promise.all(t).then(o, o);
  } else
    o();
};
Lr.preloadFonts = function(r, o) {
  var t = [];
  Lr.fetchFonts(r, t), Lr.loadFonts(t, o);
};
function O(n, r) {
  var o = n.prototype;
  o.options ? o.options = b({}, o.options, r) : o.options = r;
}
var mg = "k-icon", Ma = "k-i-", _g = "k-svg-icon", jp = "k-svg-i-", fi = function(r, o) {
  this.element = r, this.options = b({}, this.options, o), this.wrapper();
};
fi.prototype.wrapper = function() {
  this.addClasses();
};
fi.prototype.addClasses = function() {
};
fi.prototype.html = function() {
  return this.element.outerHTML;
};
O(fi, {
  name: "",
  size: "none",
  themeColor: "none",
  flip: "default",
  iconClass: "",
  stylingOptions: ["size", "themeColor", "fill"]
});
var ou = function(n) {
  function r(o, t) {
    n.call(this, o, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.wrapper = function() {
    var t = this.element.className.split(" ").find(function(i) {
      return i.startsWith(Ma);
    }), e = this.options.icon ? "" + (this.options.icon.startsWith(Ma) ? "" : Ma) + this.options.icon : "";
    this._className = e, mt(this.element, mg), Xs(this.element, t), mt(this.element, e), mt(this.element, this.options.iconClass || ""), n.prototype.wrapper.call(this);
  }, r;
}(fi);
O(ou, {
  name: "HTMLFontIcon",
  icon: null
});
var nu = function(n) {
  function r(o, t) {
    o.innerHTML = "", n.call(this, o, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.wrapper = function() {
    var t = this.options.icon, e = this.options.iconClass, i = this.element.className.split(" ").find(function(h) {
      return h.startsWith(jp);
    });
    if (!t && e) {
      var a = /k-i-(\w+(?:-\w+)*)/, s = e.match(a);
      s && (t = s[1], e = e.replace(s[0], ""));
    }
    se(t) && (t = t.replace("k-i-", "").replace(/-./g, function(h) {
      return h[1].toUpperCase();
    }), t = this.options.svgIcons[t] || this.options.svgIcons[t + "Icon"]);
    var l = t && t.name ? "" + jp + t.name : "";
    if (this._className = l, mt(this.element, _g), Xs(this.element, i), mt(this.element, l), mt(this.element, e || ""), this.element.setAttribute("aria-hidden", "true"), t && fg(t)) {
      var p = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      p.setAttribute("viewBox", t.viewBox || ""), p.setAttribute("focusable", "false"), p.innerHTML = t.content || "", this.element.appendChild(p);
    }
    n.prototype.wrapper.call(this);
  }, r;
}(fi);
O(nu, {
  name: "HTMLSvgIcon",
  icon: null,
  svgIcons: {}
});
var Vp = {
  svg: nu,
  font: ou
};
function Kr(n, r) {
  var o = n, t = r;
  return (!o || le(o) && !(o instanceof HTMLElement) || se(o)) && (t = o, o = document.createElement("span")), se(t) && (t = {
    icon: t
  }), t.type || (t.type = "svg"), Vp[t.type] ? new Vp[t.type](o, t).html() : null;
}
function Qa(n) {
  for (var r = gt, o = xt, t = 0, e = n.length; t < e; t++) {
    var i = n[t];
    i !== null && isFinite(i) && (r = Math.min(r, i), o = Math.max(o, i));
  }
  return {
    min: r === gt ? void 0 : r,
    max: o === xt ? void 0 : o
  };
}
function au(n, r) {
  for (var o = 0; o < n.length; o++) {
    var t = n[o];
    if (r(t, o, n))
      return t;
  }
}
var xn = Ld, xg = /matrix\((.*)\)/;
function wg(n) {
  var r = n.match(xg);
  if (r === null || r.length !== 2)
    return xn.unit();
  var o = r[1].split(",").map(function(t) {
    return parseFloat(t);
  });
  return new (Function.prototype.bind.apply(xn, [null].concat(o)))();
}
function Np(n) {
  var r = getComputedStyle(n).transform;
  return r === "none" ? xn.unit() : wg(r);
}
function bg(n) {
  if (!n)
    return xn.unit();
  for (var r = Np(n), o = n.parentElement; o; ) {
    var t = Np(o);
    r = r.multiplyCopy(t), o = o.parentElement;
  }
  return r.b = r.c = r.e = r.f = 0, r;
}
function qs(n) {
  var r = new Ee(n).isDark();
  return r ? J : yt;
}
var su = {}, Hr = function(r) {
  var o = this;
  this._index = {}, this._values = r ? r.slice(0) : [];
  for (var t = 0; t < this._values.length; t++)
    o._index[o._values[t]] = t;
}, lu = { size: { configurable: !0 } };
Hr.prototype.values = function() {
  return this._values.filter(function(r) {
    return r !== su;
  });
};
Hr.prototype.has = function(r) {
  return this._index[r] !== void 0;
};
Hr.prototype.add = function(r) {
  this.has(r) || (this._index[r] = this._values.length, this._values.push(r));
};
Hr.prototype.delete = function(r) {
  var o = this._index[r];
  o !== void 0 && (this._values[o] = su, delete this._index[r]);
};
Hr.prototype.clear = function() {
  this._index = {}, this._values = [];
};
lu.size.get = function() {
  return this._values.length;
};
Object.defineProperties(Hr.prototype, lu);
var Fr = function(r) {
  this._set = new Set(r);
}, pu = { size: { configurable: !0 } };
Fr.prototype.values = function() {
  return Array.from(this._set);
};
Fr.prototype.has = function(r) {
  return this._set.has(r);
};
Fr.prototype.add = function(r) {
  this._set.add(r);
};
Fr.prototype.delete = function(r) {
  this._set.delete(r);
};
Fr.prototype.clear = function() {
  this._set.clear();
};
pu.size.get = function() {
  return this._set.size;
};
Object.defineProperties(Fr.prototype, pu);
var Ag = function() {
  var n = !1;
  if (typeof Set == "function") {
    var r = /* @__PURE__ */ new Set([1]);
    n = r.has(1);
  }
  return n;
};
function Hp(n) {
  return Ag() ? new Fr(n) : new Hr(n);
}
function hu(n) {
  throw n;
}
var Jr = {
  INSERT: 45,
  DELETE: 46,
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  END: 35,
  HOME: 36,
  SPACEBAR: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  F2: 113,
  F10: 121,
  F12: 123,
  NUMPAD_PLUS: 107,
  NUMPAD_MINUS: 109,
  NUMPAD_DOT: 110
};
function fo(n, r) {
  var o = R(r - n, nt - 1);
  if (o === 0) {
    if (r === 0)
      return 0.1;
    o = Math.abs(r);
  }
  var t = Math.pow(10, Math.floor(Math.log(o) / Math.log(10))), e = R(o / t, nt), i = 1;
  return e < 1.904762 ? i = 0.2 : e < 4.761904 ? i = 0.5 : e < 9.523809 ? i = 1 : i = 2, R(t * i, nt);
}
var F = function(n) {
  function r(o, t) {
    n.call(this), this.x = o || 0, this.y = t || 0;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.clone = function() {
    return new r(this.x, this.y);
  }, r.prototype.equals = function(t) {
    return t && this.x === t.x && this.y === t.y;
  }, r.prototype.rotate = function(t, e) {
    var i = _t(e), a = Math.cos(i), s = Math.sin(i), l = t.x, p = t.y, h = this, c = h.x, u = h.y;
    return this.x = R(
      l + (c - l) * a + (u - p) * s,
      Tt
    ), this.y = R(
      p + (u - p) * a - (c - l) * s,
      Tt
    ), this;
  }, r.prototype.multiply = function(t) {
    return this.x *= t, this.y *= t, this;
  }, r.prototype.distanceTo = function(t) {
    var e = this.x - t.x, i = this.y - t.y;
    return Math.sqrt(e * e + i * i);
  }, r.onCircle = function(t, e, i) {
    var a = _t(e);
    return new r(
      t.x - i * Math.cos(a),
      t.y - i * Math.sin(a)
    );
  }, r;
}(N), L = function(n) {
  function r(o, t, e, i) {
    n.call(this), this.x1 = o || 0, this.y1 = t || 0, this.x2 = e || 0, this.y2 = i || 0;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.equals = function(t) {
    return this.x1 === t.x1 && this.x2 === t.x2 && this.y1 === t.y1 && this.y2 === t.y2;
  }, r.prototype.width = function() {
    return this.x2 - this.x1;
  }, r.prototype.height = function() {
    return this.y2 - this.y1;
  }, r.prototype.translate = function(t, e) {
    return this.x1 += t, this.x2 += t, this.y1 += e, this.y2 += e, this;
  }, r.prototype.move = function(t, e) {
    var i = this.height(), a = this.width();
    return P(t) && (this.x1 = t, this.x2 = this.x1 + a), P(e) && (this.y1 = e, this.y2 = this.y1 + i), this;
  }, r.prototype.wrap = function(t) {
    return this.x1 = Math.min(this.x1, t.x1), this.y1 = Math.min(this.y1, t.y1), this.x2 = Math.max(this.x2, t.x2), this.y2 = Math.max(this.y2, t.y2), this;
  }, r.prototype.wrapPoint = function(t) {
    var e = Ot(t), i = e ? t[0] : t.x, a = e ? t[1] : t.y;
    return this.wrap(new r(i, a, i, a)), this;
  }, r.prototype.snapTo = function(t, e) {
    return (e === D || !e) && (this.x1 = t.x1, this.x2 = t.x2), (e === B || !e) && (this.y1 = t.y1, this.y2 = t.y2), this;
  }, r.prototype.alignTo = function(t, e) {
    var i = this.height(), a = this.width(), s = e === tt || e === it ? B : D, l = s === B ? i : a;
    if (e === $) {
      var p = t.center(), h = this.center();
      this.x1 += p.x - h.x, this.y1 += p.y - h.y;
    } else
      e === tt || e === Q ? this[s + 1] = t[s + 1] - l : this[s + 1] = t[s + 2];
    return this.x2 = this.x1 + a, this.y2 = this.y1 + i, this;
  }, r.prototype.shrink = function(t, e) {
    return this.x2 -= t, this.y2 -= e, this;
  }, r.prototype.expand = function(t, e) {
    return this.shrink(-t, -e), this;
  }, r.prototype.pad = function(t) {
    var e = ot(t);
    return this.x1 -= e.left, this.x2 += e.right, this.y1 -= e.top, this.y2 += e.bottom, this;
  }, r.prototype.unpad = function(t) {
    var e = ot(t);
    return e.left = -e.left, e.top = -e.top, e.right = -e.right, e.bottom = -e.bottom, this.pad(e);
  }, r.prototype.clone = function() {
    return new r(this.x1, this.y1, this.x2, this.y2);
  }, r.prototype.center = function() {
    return new F(
      this.x1 + this.width() / 2,
      this.y1 + this.height() / 2
    );
  }, r.prototype.containsPoint = function(t) {
    return t.x >= this.x1 && t.x <= this.x2 && t.y >= this.y1 && t.y <= this.y2;
  }, r.prototype.points = function() {
    return [
      new F(this.x1, this.y1),
      new F(this.x2, this.y1),
      new F(this.x2, this.y2),
      new F(this.x1, this.y2)
    ];
  }, r.prototype.getHash = function() {
    return [this.x1, this.y1, this.x2, this.y2].join(",");
  }, r.prototype.overlaps = function(t) {
    return !(t.y2 < this.y1 || this.y2 < t.y1 || t.x2 < this.x1 || this.x2 < t.x1);
  }, r.prototype.rotate = function(t) {
    var e = this.width(), i = this.height(), a = this.center(), s = a.x, l = a.y, p = Zo(0, 0, s, l, t), h = Zo(e, 0, s, l, t), c = Zo(e, i, s, l, t), u = Zo(0, i, s, l, t);
    return e = Math.max(p.x, h.x, c.x, u.x) - Math.min(p.x, h.x, c.x, u.x), i = Math.max(p.y, h.y, c.y, u.y) - Math.min(p.y, h.y, c.y, u.y), this.x2 = this.x1 + e, this.y2 = this.y1 + i, this;
  }, r.prototype.toRect = function() {
    return new Pt([this.x1, this.y1], [this.width(), this.height()]);
  }, r.prototype.hasSize = function() {
    return this.width() !== 0 && this.height() !== 0;
  }, r.prototype.align = function(t, e, i) {
    var a = e + 1, s = e + 2, l = e === D ? mn : yn, p = this[l]();
    Z(i, [Q, tt]) ? (this[a] = t[a], this[s] = this[a] + p) : Z(i, [et, it]) ? (this[s] = t[s], this[a] = this[s] - p) : i === $ && (this[a] = t[a] + (t[l]() - p) / 2, this[s] = this[a] + p);
  }, r;
}(N);
function Zo(n, r, o, t, e) {
  var i = _t(e);
  return new F(
    o + (n - o) * Math.cos(i) + (r - t) * Math.sin(i),
    t - (n - o) * Math.sin(i) + (r - t) * Math.cos(i)
  );
}
var go = function(n) {
  function r(o, t, e, i, a) {
    n.call(this), this.center = o, this.innerRadius = t, this.radius = e, this.startAngle = i, this.angle = a;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.clone = function() {
    return new r(this.center, this.innerRadius, this.radius, this.startAngle, this.angle);
  }, r.prototype.middle = function() {
    return this.startAngle + this.angle / 2;
  }, r.prototype.setRadius = function(t, e) {
    return e ? this.innerRadius = t : this.radius = t, this;
  }, r.prototype.point = function(t, e) {
    var i = _t(t), a = Math.cos(i), s = Math.sin(i), l = e ? this.innerRadius : this.radius, p = R(this.center.x - a * l, Tt), h = R(this.center.y - s * l, Tt);
    return new F(p, h);
  }, r.prototype.adjacentBox = function(t, e, i) {
    var a = this.clone().expand(t), s = a.middle(), l = a.point(s), p = e / 2, h = i / 2, c = Math.sin(_t(s)), u = Math.cos(_t(s)), v = l.x - p, f = l.y - h;
    return Math.abs(c) < 0.9 && (v += p * -u / Math.abs(u)), Math.abs(u) < 0.9 && (f += h * -c / Math.abs(c)), new L(v, f, v + e, f + i);
  }, r.prototype.containsPoint = function(t) {
    var e = this.center, i = this.innerRadius, a = this.radius, s = this.startAngle, l = this.startAngle + this.angle, p = t.x - e.x, h = t.y - e.y, c = new F(p, h), u = this.point(s), v = new F(u.x - e.x, u.y - e.y), f = this.point(l), d = new F(f.x - e.x, f.y - e.y), m = R(p * p + h * h, Tt);
    return (v.equals(c) || Dp(v, c)) && !Dp(d, c) && m >= i * i && m <= a * a;
  }, r.prototype.getBBox = function() {
    var t = this, e = new L(gt, gt, xt, xt), i = R(this.startAngle % 360), a = R((i + this.angle) % 360), s = this.innerRadius, l = [0, 90, 180, 270, i, a].sort(Sg), p = l.indexOf(i), h = l.indexOf(a), c;
    i === a ? c = l : p < h ? c = l.slice(p, h + 1) : c = [].concat(
      l.slice(0, h + 1),
      l.slice(p, l.length)
    );
    for (var u = 0; u < c.length; u++) {
      var v = t.point(c[u]);
      e.wrapPoint(v), e.wrapPoint(v, s);
    }
    return s || e.wrapPoint(this.center), e;
  }, r.prototype.expand = function(t) {
    return this.radius += t, this;
  }, r;
}(N);
function Sg(n, r) {
  return n - r;
}
(function(n) {
  function r(o, t, e, i) {
    n.call(this, o, 0, t, e, i);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.expand = function(t) {
    return n.prototype.expand.call(this, t);
  }, r.prototype.clone = function() {
    return new r(this.center, this.radius, this.startAngle, this.angle);
  }, r.prototype.setRadius = function(t) {
    return this.radius = t, this;
  }, r;
})(go);
var Tg = 1e-3, oi = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createRing = function(t, e) {
    var i = t.startAngle + 180, a = t.angle + i;
    t.angle > 0 && i === a && (a += Tg);
    var s = new q(t.center.x, t.center.y), l = Math.max(t.radius, 0), p = Math.max(t.innerRadius, 0), h = new ri(s, {
      startAngle: i,
      endAngle: a,
      radiusX: l,
      radiusY: l
    }), c = H.fromArc(h, e).close();
    if (p) {
      h.radiusX = h.radiusY = p;
      var u = h.pointAt(a);
      c.lineTo(u.x, u.y), c.arc(a, i, p, p, !0);
    } else
      c.lineTo(s.x, s.y);
    return c;
  }, r;
}(N);
oi.current = new oi();
var rt = function(n) {
  function r(o) {
    n.call(this), this.children = [], this.options = b({}, this.options, this.initUserOptions(o));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initUserOptions = function(t) {
    return t;
  }, r.prototype.reflow = function(t) {
    for (var e = this.children, i, a = 0; a < e.length; a++) {
      var s = e[a];
      s.reflow(t), i = i ? i.wrap(s.box) : s.box.clone();
    }
    this.box = i || t;
  }, r.prototype.destroy = function() {
    var t = this.children;
    this.animation && this.animation.destroy();
    for (var e = 0; e < t.length; e++)
      t[e].destroy();
  }, r.prototype.getRoot = function() {
    var t = this.parent;
    return t ? t.getRoot() : null;
  }, r.prototype.getSender = function() {
    var t = this.getService();
    if (t)
      return t.sender;
  }, r.prototype.getService = function() {
    for (var t = this; t; ) {
      if (t.chartService)
        return t.chartService;
      t = t.parent;
    }
  }, r.prototype.translateChildren = function(t, e) {
    for (var i = this.children, a = i.length, s = 0; s < a; s++)
      i[s].box.translate(t, e);
  }, r.prototype.append = function() {
    for (var t = arguments, e = this, i = 0; i < arguments.length; i++) {
      var a = t[i];
      e.children.push(a), a.parent = e;
    }
  }, r.prototype.renderVisual = function() {
    this.options.visible !== !1 && (this.createVisual(), this.addVisual(), this.renderChildren(), this.createAnimation(), this.renderComplete());
  }, r.prototype.addVisual = function() {
    this.visual && (this.visual.chartElement = this, this.parent && this.parent.appendVisual(this.visual));
  }, r.prototype.renderChildren = function() {
    for (var t = this.children, e = t.length, i = 0; i < e; i++)
      t[i].renderVisual();
  }, r.prototype.createVisual = function() {
    this.visual = new pt({
      zIndex: this.options.zIndex,
      visible: U(this.options.visible, !0)
    });
  }, r.prototype.createAnimation = function() {
    this.visual && this.options.animation && (this.animation = pe.create(
      this.visual,
      this.options.animation
    ));
  }, r.prototype.appendVisual = function(t) {
    t.chartElement || (t.chartElement = this), t.options.noclip ? this.clipRoot().visual.append(t) : P(t.options.zIndex) ? this.stackRoot().stackVisual(t) : this.isStackRoot ? this.stackVisual(t) : this.visual ? this.visual.append(t) : this.parent.appendVisual(t);
  }, r.prototype.clipRoot = function() {
    return this.parent ? this.parent.clipRoot() : this;
  }, r.prototype.stackRoot = function() {
    return this.parent ? this.parent.stackRoot() : this;
  }, r.prototype.stackVisual = function(t) {
    var e = t.options.zIndex || 0, i = this.visual.children, a = i.length, s;
    for (s = 0; s < a; s++) {
      var l = i[s], p = U(l.options.zIndex, 0);
      if (p > e)
        break;
    }
    this.visual.insert(s, t);
  }, r.prototype.traverse = function(t) {
    for (var e = this.children, i = e.length, a = 0; a < i; a++) {
      var s = e[a];
      t(s), s.traverse && s.traverse(t);
    }
  }, r.prototype.closest = function(t) {
    for (var e = this, i = !1; e && !i; )
      i = t(e), i || (e = e.parent);
    if (i)
      return e;
  }, r.prototype.renderComplete = function() {
  }, r.prototype.hasHighlight = function() {
    var t = (this.options || {}).highlight;
    return !(!this.createHighlight || t && t.visible === !1 || this.visible === !1);
  }, r.prototype.toggleHighlight = function(t, e) {
    var i = this, a = (this.options || {}).highlight || {}, s = a.visual, l = this._highlight;
    if (!l) {
      var p = {
        fill: {
          color: J,
          opacity: e || 0.2
        },
        stroke: {
          color: J,
          width: 1,
          opacity: e || 0.2
        }
      };
      if (s) {
        if (l = this._highlight = s(
          Object.assign(
            this.highlightVisualArgs(),
            {
              createVisual: function() {
                return i.createHighlight(p);
              },
              sender: this.getSender(),
              series: this.series,
              dataItem: this.dataItem,
              category: this.category,
              value: this.value,
              percentage: this.percentage,
              runningTotal: this.runningTotal,
              total: this.total
            }
          )
        ), !l)
          return;
      } else
        l = this._highlight = this.createHighlight(p);
      P(l.options.zIndex) || (l.options.zIndex = U(a.zIndex, this.options.zIndex)), this.appendVisual(l);
    }
    l.visible(t);
  }, r.prototype.createGradientOverlay = function(t, e, i) {
    var a = new H(Object.assign({
      stroke: {
        color: "none"
      },
      fill: this.createGradient(i),
      closed: t.options.closed
    }, e));
    return a.segments.elements(t.segments.elements()), a;
  }, r.prototype.createGradient = function(t) {
    if (this.parent)
      return this.parent.createGradient(t);
  }, r.prototype.supportsPointInactiveOpacity = function() {
    return !0;
  }, r;
}(N);
rt.prototype.options = {};
var wr = function(n) {
  function r(o) {
    n.call(this, o), this.options.margin = ot(this.options.margin), this.options.padding = ot(this.options.padding);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = this.options, a = i.width, s = i.height, l = i.shrinkToFit, p = a && s, h = i.margin, c = i.padding, u = i.border.width, v, f = function() {
      e.align(t, D, i.align), e.align(t, B, i.vAlign), e.paddingBox = v.clone().unpad(h).unpad(u);
    }, d = t.clone();
    p && (d.x2 = d.x1 + a, d.y2 = d.y1 + s), l && d.unpad(h).unpad(u).unpad(c), n.prototype.reflow.call(this, d), p ? v = this.box = new L(0, 0, a, s) : v = this.box, l && p ? (f(), d = this.contentBox = this.paddingBox.clone().unpad(c)) : (d = this.contentBox = v.clone(), v.pad(c).pad(u).pad(h), f()), this.translateChildren(
      v.x1 - d.x1 + h.left + u + c.left,
      v.y1 - d.y1 + h.top + u + c.top
    );
    for (var m = this.children, _ = 0; _ < m.length; _++) {
      var w = m[_];
      w.reflow(w.box);
    }
  }, r.prototype.align = function(t, e, i) {
    this.box.align(t, e, i);
  }, r.prototype.hasBox = function() {
    var t = this.options;
    return t.border.width || t.background;
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this);
    var t = this.options;
    t.visible && this.hasBox() && this.visual.append(H.fromRect(
      this.paddingBox.toRect(),
      this.visualStyle()
    ));
  }, r.prototype.visualStyle = function() {
    var t = this.options, e = t.border || {};
    return {
      stroke: {
        width: e.width,
        color: e.color,
        opacity: U(e.opacity, t.opacity),
        dashType: e.dashType
      },
      fill: {
        color: t.background,
        opacity: t.opacity
      },
      cursor: t.cursor
    };
  }, r;
}(rt);
O(wr, {
  align: Q,
  vAlign: tt,
  margin: {},
  padding: {},
  border: {
    color: yt,
    width: 0
  },
  background: "",
  shrinkToFit: !1,
  width: 0,
  height: 0,
  visible: !0
});
var tr = function(n) {
  function r(o, t) {
    n.call(this, o), this.pointData = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.getElement = function() {
    var t = this, e = t.options, i = t.paddingBox, a = e.type, s = e.rotation, l = i.center(), p = i.width() / 2, h = i.height() / 2;
    if (!e.visible || !this.hasBox())
      return null;
    var c = this.visualStyle(), u;
    if (a === fe)
      u = new Je(
        new ve([
          R(i.x1 + p, Tt),
          R(i.y1 + h, Tt)
        ], Math.min(p, h)),
        c
      );
    else if (a === Wd)
      u = H.fromPoints([
        [i.x1 + p, i.y1],
        [i.x1, i.y2],
        [i.x2, i.y2]
      ], c).close();
    else if (a === Xc)
      u = new to(c), u.moveTo(i.x1, i.y1).lineTo(i.x2, i.y2), u.moveTo(i.x1, i.y2).lineTo(i.x2, i.y1);
    else {
      var v = i.toRect();
      if (a === Kc) {
        var f = U(e.borderRadius, v.width() / 5);
        v.setCornerRadius(f);
      }
      u = H.fromRect(v, c);
    }
    return s && u.transform(
      wt().rotate(-s, [l.x, l.y])
    ), u.options.zIndex = e.zIndex, u;
  }, r.prototype.createElement = function() {
    var t = this, e = this.options.visual, i = this.pointData || {}, a;
    return e ? a = e({
      value: i.value,
      dataItem: i.dataItem,
      sender: this.getSender(),
      series: i.series,
      category: i.category,
      rect: this.paddingBox.toRect(),
      options: this.visualOptions(),
      createVisual: function() {
        return t.getElement();
      }
    }) : a = this.getElement(), a;
  }, r.prototype.visualOptions = function() {
    var t = this.options;
    return {
      background: t.background,
      border: t.border,
      margin: t.margin,
      padding: t.padding,
      type: t.type,
      size: t.width,
      visible: t.visible
    };
  }, r.prototype.createVisual = function() {
    this.visual = this.createElement();
  }, r;
}(wr);
O(tr, {
  type: fe,
  align: $,
  vAlign: $
});
var Cg = "linear", Vi = "radial", kg = {
  glass: {
    type: Cg,
    rotation: 0,
    stops: [{
      offset: 0,
      color: J,
      opacity: 0
    }, {
      offset: 0.25,
      color: J,
      opacity: 0.3
    }, {
      offset: 1,
      color: J,
      opacity: 0
    }]
  },
  sharpBevel: {
    type: Vi,
    stops: [{
      offset: 0,
      color: J,
      opacity: 0.55
    }, {
      offset: 0.65,
      color: J,
      opacity: 0
    }, {
      offset: 0.95,
      color: J,
      opacity: 0.25
    }]
  },
  roundedBevel: {
    type: Vi,
    stops: [{
      offset: 0.33,
      color: J,
      opacity: 0.06
    }, {
      offset: 0.83,
      color: J,
      opacity: 0.2
    }, {
      offset: 0.95,
      color: J,
      opacity: 0
    }]
  },
  roundedGlass: {
    type: Vi,
    supportVML: !1,
    stops: [{
      offset: 0,
      color: J,
      opacity: 0
    }, {
      offset: 0.5,
      color: J,
      opacity: 0.3
    }, {
      offset: 0.99,
      color: J,
      opacity: 0
    }]
  },
  sharpGlass: {
    type: Vi,
    supportVML: !1,
    stops: [{
      offset: 0,
      color: J,
      opacity: 0.2
    }, {
      offset: 0.15,
      color: J,
      opacity: 0.15
    }, {
      offset: 0.17,
      color: J,
      opacity: 0.35
    }, {
      offset: 0.85,
      color: J,
      opacity: 0.05
    }, {
      offset: 0.87,
      color: J,
      opacity: 0.15
    }, {
      offset: 0.99,
      color: J,
      opacity: 0
    }]
  },
  bubbleShadow: {
    type: Vi,
    center: [0.5, 0.5],
    radius: 0.5
  }
};
function Pg(n, r) {
  if (n.x1 === r.x1 && n.y1 === r.y1 && n.x2 === r.x2 && n.y2 === r.y2)
    return r;
  var o = Math.min(n.x1, r.x1), t = Math.max(n.x1, r.x1), e = Math.min(n.x2, r.x2), i = Math.max(n.x2, r.x2), a = Math.min(n.y1, r.y1), s = Math.max(n.y1, r.y1), l = Math.min(n.y2, r.y2), p = Math.max(n.y2, r.y2), h = [];
  return h[0] = new L(t, a, e, s), h[1] = new L(o, s, t, l), h[2] = new L(e, s, i, l), h[3] = new L(t, l, e, p), n.x1 === o && n.y1 === a || r.x1 === o && r.y1 === a ? (h[4] = new L(o, a, t, s), h[5] = new L(e, l, i, p)) : (h[4] = new L(e, a, i, s), h[5] = new L(o, l, t, p)), qt(h, function(c) {
    return c.height() > 0 && c.width() > 0;
  })[0];
}
var cu = function(n) {
  function r(o) {
    n.call(this, o);
    var t = this.options;
    t.width = parseInt(t.width, 10), t.height = parseInt(t.height, 10), this.gradients = {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function() {
    var t = this, e = t.options, i = t.children, a = new L(0, 0, e.width, e.height);
    this.box = a.unpad(e.margin);
    for (var s = 0; s < i.length; s++)
      i[s].reflow(a), a = Pg(a, i[s].box) || new L();
  }, r.prototype.createVisual = function() {
    this.visual = new pt(), this.createBackground();
  }, r.prototype.createBackground = function() {
    var t = this.options, e = t.border || {}, i = this.box.clone().pad(t.margin).unpad(e.width), a = H.fromRect(i.toRect(), {
      stroke: {
        color: e.width ? e.color : "",
        width: e.width,
        dashType: e.dashType
      },
      fill: {
        color: t.background,
        opacity: t.opacity
      },
      zIndex: -10
    });
    this.visual.append(a);
  }, r.prototype.getRoot = function() {
    return this;
  }, r.prototype.createGradient = function(t) {
    var e = this.gradients, i = yg(t), a = kg[t.gradient], s;
    if (e[i])
      s = e[i];
    else {
      var l = Object.assign({}, a, t);
      a.type === "linear" ? s = new Id(l) : (t.innerRadius && (l.stops = Og(l)), s = new Dd(l), s.supportVML = a.supportVML !== !1), e[i] = s;
    }
    return s;
  }, r.prototype.cleanGradients = function() {
    var t = this.gradients;
    for (var e in t)
      t[e]._observers = [];
  }, r.prototype.size = function() {
    var t = this.options;
    return new L(0, 0, t.width, t.height);
  }, r;
}(rt);
O(cu, {
  width: Gs,
  height: qc,
  background: J,
  border: {
    color: yt,
    width: 0
  },
  margin: ot(5),
  zIndex: -2
});
function Og(n) {
  for (var r = n.stops, o = n.innerRadius / n.radius * 100, t = r.length, e = [], i = 0; i < t; i++) {
    var a = Object.assign({}, r[i]);
    a.offset = (a.offset * (100 - o) + o) / 100, e.push(a);
  }
  return e;
}
var Nn = function(n) {
  function r(o) {
    n.call(this, o), this._initDirection();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initDirection = function() {
    var t = this.options;
    t.vertical ? (this.groupAxis = D, this.elementAxis = B, this.groupSizeField = mn, this.elementSizeField = yn, this.groupSpacing = t.spacing, this.elementSpacing = t.vSpacing) : (this.groupAxis = B, this.elementAxis = D, this.groupSizeField = yn, this.elementSizeField = mn, this.groupSpacing = t.vSpacing, this.elementSpacing = t.spacing);
  }, r.prototype.reflow = function(t) {
    this.box = t.clone(), this.reflowChildren();
  }, r.prototype.reflowChildren = function() {
    var t = this, e = this, i = e.box, a = e.elementAxis, s = e.groupAxis, l = e.elementSizeField, p = e.groupSizeField, h = this.groupOptions(), c = h.groups, u = h.groupsSize, v = h.maxGroupElementsSize, f = c.length, d = i[s + 1] + this.alignStart(u, i[p]());
    if (f) {
      for (var m = d, _ = 0; _ < f; _++) {
        for (var w = c[_], A = w.groupElements, T = i[a + 1], k = A.length, C = 0; C < k; C++) {
          var z = A[C], V = t.elementSize(z), G = m + t.alignStart(V[p], w.groupSize), X = new L();
          X[s + 1] = G, X[s + 2] = G + V[p], X[a + 1] = T, X[a + 2] = T + V[l], z.reflow(X), T += V[l] + t.elementSpacing;
        }
        m += w.groupSize + t.groupSpacing;
      }
      i[s + 1] = d, i[s + 2] = d + u, i[a + 2] = i[a + 1] + v;
    }
  }, r.prototype.alignStart = function(t, e) {
    var i = 0, a = this.options.align;
    return a === et || a === it ? i = e - t : a === $ && (i = (e - t) / 2), i;
  }, r.prototype.groupOptions = function() {
    for (var t = this, e = this, i = e.box, a = e.children, s = e.elementSizeField, l = e.groupSizeField, p = e.elementSpacing, h = e.groupSpacing, c = R(i[s]()), u = a.length, v = [], f = 0, d = 0, m = 0, _ = 0, w = [], A = 0; A < u; A++) {
      var T = a[A];
      T.box || T.reflow(i);
      var k = t.elementSize(T);
      t.options.wrap && R(d + p + k[s]) > c && (v.push({
        groupElements: w,
        groupSize: f,
        groupElementsSize: d
      }), _ = Math.max(_, d), m += h + f, f = 0, d = 0, w = []), f = Math.max(f, k[l]), d > 0 && (d += p), d += k[s], w.push(T);
    }
    return v.push({
      groupElements: w,
      groupSize: f,
      groupElementsSize: d
    }), _ = Math.max(_, d), m += f, {
      groups: v,
      groupsSize: m,
      maxGroupElementsSize: _
    };
  }, r.prototype.elementSize = function(t) {
    return {
      width: t.box.width(),
      height: t.box.height()
    };
  }, r.prototype.createVisual = function() {
  }, r;
}(rt);
O(Nn, {
  vertical: !0,
  wrap: !0,
  vSpacing: 0,
  spacing: 0
});
var Eg = Gc, uu = function(n) {
  function r(o, t) {
    n.call(this, t), this.content = o, this.reflow(new L());
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this.options, i = e.size = $c(this.content, { font: e.font });
    this.baseline = i.baseline, this.box = new L(
      t.x1,
      t.y1,
      t.x1 + i.width,
      t.y1 + i.height
    );
  }, r.prototype.createVisual = function() {
    var t = this.options, e = t.font, i = t.color, a = t.opacity, s = t.cursor;
    this.visual = new Eg(this.content, this.box.toRect().topLeft(), {
      font: e,
      fill: { color: i, opacity: a },
      cursor: s
    });
  }, r;
}(rt);
O(uu, {
  font: Yc,
  color: yt
});
function Hn(n) {
  var r = n.origin, o = n.bottomRight();
  return new L(r.x, r.y, o.x, o.y);
}
var Mg = /\n/m, Qt = function(n) {
  function r(o, t, e) {
    n.call(this, t), this.content = o, this.data = e, this._initContainer(), this.options._autoReflow !== !1 && this.reflow(new L());
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initContainer = function() {
    var t = this.options, e = String(this.content).split(Mg), i = new Nn({ vertical: !0, align: t.align, wrap: !1 }), a = b({}, t, { opacity: 1, animation: null });
    this.container = i, this.append(i);
    for (var s = 0; s < e.length; s++) {
      var l = new uu(e[s].trim(), a);
      i.append(l);
    }
  }, r.prototype.reflow = function(t) {
    var e = this.options, i = e.visual;
    if (this.container.options.align = e.align, i && !this._boxReflow) {
      var a = t;
      a.hasSize() || (this._boxReflow = !0, this.reflow(a), this._boxReflow = !1, a = this.box);
      var s = this.visual = i(this.visualContext(a));
      s && (a = Hn(s.clippedBBox() || new Pt()), s.options.zIndex = e.zIndex), this.box = this.contentBox = this.paddingBox = a;
    } else if (n.prototype.reflow.call(this, t), e.rotation) {
      var l = ot(e.margin), p = this.box.unpad(l);
      this.targetBox = t, this.normalBox = p.clone(), p = this.rotate(), p.translate(l.left - l.right, l.top - l.bottom), this.rotatedBox = p.clone(), p.pad(l);
    }
  }, r.prototype.createVisual = function() {
    var t = this.options;
    if (this.visual = new pt({
      transform: this.rotationTransform(),
      zIndex: t.zIndex,
      noclip: t.noclip
    }), this.hasBox()) {
      var e = H.fromRect(this.paddingBox.toRect(), this.visualStyle());
      this.visual.append(e);
    }
  }, r.prototype.renderVisual = function() {
    if (this.options.visible)
      if (this.options.visual) {
        var t = this.visual;
        t && !P(t.options.noclip) && (t.options.noclip = this.options.noclip), this.addVisual(), this.createAnimation();
      } else
        n.prototype.renderVisual.call(this);
  }, r.prototype.visualContext = function(t) {
    var e = this, i = {
      text: this.content,
      rect: t.toRect(),
      sender: this.getSender(),
      options: this.options,
      createVisual: function() {
        return e._boxReflow = !0, e.reflow(t), e._boxReflow = !1, e.getDefaultVisual();
      }
    };
    return this.data && Object.assign(i, this.data), i;
  }, r.prototype.getDefaultVisual = function() {
    this.createVisual(), this.renderChildren();
    var t = this.visual;
    return delete this.visual, t;
  }, r.prototype.rotate = function() {
    var t = this.options;
    return this.box.rotate(t.rotation), this.align(this.targetBox, D, t.align), this.align(this.targetBox, B, t.vAlign), this.box;
  }, r.prototype.rotationTransform = function() {
    var t = this.options.rotation;
    if (!t)
      return null;
    var e = this.normalBox.center(), i = e.x, a = e.y, s = this.rotatedBox.center();
    return wt().translate(s.x - i, s.y - a).rotate(t, [i, a]);
  }, r;
}(wr), Ki = function(n) {
  function r(o) {
    n.call(this, o), this._textBox = new Qt(this.options.text, Object.assign({}, this.options, {
      vAlign: this.options.position
    })), this.append(this._textBox);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    n.prototype.reflow.call(this, t), this.box.snapTo(t, D);
  }, r.buildTitle = function(t, e) {
    var i = t;
    typeof t == "string" && (i = { text: t }), i = Object.assign({ visible: !0 }, e, i);
    var a;
    return i && i.visible && i.text && (a = new r(i)), a;
  }, r.orderTitles = function(t) {
    var e = [].concat(t), i = e.filter(function(s) {
      return s && s.options.position !== it;
    }), a = e.filter(function(s) {
      return s && s.options.position === it;
    });
    return Fp(i), Fp(a), a.reverse(), i.concat(a);
  }, r;
}(rt);
function Fp(n) {
  for (var r = 1; r < n.length; r++) {
    var o = n[r]._textBox, t = n[r - 1]._textBox;
    t.options.margin = Object.assign(ot(t.options.margin), { bottom: 0 }), o.options.margin = Object.assign(ot(o.options.margin), { top: 0 });
  }
}
O(Ki, {
  color: yt,
  position: tt,
  align: $,
  margin: ot(5),
  padding: ot(5)
});
var br = function(n) {
  function r(o, t, e, i, a) {
    n.call(this, t, a), this.text = t, this.value = o, this.index = e, this.dataItem = i, this.reflow(new L());
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.visualContext = function(t) {
    var e = n.prototype.visualContext.call(this, t);
    return e.value = this.value, e.dataItem = this.dataItem, e.format = this.options.format, e.culture = this.options.culture, e;
  }, r.prototype.click = function(t, e) {
    t.trigger(Hd, {
      element: ge(e),
      value: this.value,
      text: this.text,
      index: this.index,
      dataItem: this.dataItem,
      axis: this.parent.options
    });
  }, r.prototype.rotate = function() {
    if (this.options.alignRotation !== $) {
      var t = this.normalBox.toRect(), e = this.rotationTransform();
      this.box = Hn(t.bbox(e.matrix()));
    } else
      n.prototype.rotate.call(this);
    return this.box;
  }, r.prototype.rotationTransform = function() {
    var t = this.options, e = t.rotation;
    if (!e)
      return null;
    if (t.alignRotation === $)
      return n.prototype.rotationTransform.call(this);
    var i = wt().rotate(e).matrix(), a = this.normalBox.toRect(), s = this.targetBox.toRect(), l = t.rotationOrigin || tt, p = l === tt || l === it ? D : B, h = l === tt || l === it ? B : D, c = l === tt || l === Q ? s.origin : s.bottomRight(), u = a.topLeft().transformCopy(i), v = a.topRight().transformCopy(i), f = a.bottomRight().transformCopy(i), d = a.bottomLeft().transformCopy(i), m = Pt.fromPoints(u, v, f, d), _ = {};
    _[h] = s.origin[h] - m.origin[h];
    var w = Math.abs(u[h] + _[h] - c[h]), A = Math.abs(v[h] + _[h] - c[h]), T, k;
    R(w, nt) === R(A, nt) ? (T = u, k = v) : A < w ? (T = v, k = f) : (T = u, k = d);
    var C = T[p] + (k[p] - T[p]) / 2;
    return _[p] = s.center()[p] - C, wt().translate(_.x, _.y).rotate(e);
  }, r;
}(Qt);
O(br, {
  _autoReflow: !1
});
var Up = 7, Rg = "#fff", Zs = function(n) {
  function r(o, t, e) {
    n.call(this, t), this.fields = o, this.chartService = e, this.render();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.hide = function() {
    this.options.visible = !1;
  }, r.prototype.show = function() {
    this.options.visible = !0;
  }, r.prototype.render = function() {
    var t = this, e = this.options;
    if (e.visible) {
      var i = e.label, a = e.icon, s = new L(), l = function() {
        return t;
      }, p = a.size, h = this.fields.text, c, u;
      if (P(i) && i.visible) {
        var v = Ct(i);
        v ? h = v(this.fields) : i.format && (h = this.chartService.format.auto(i.format, h)), i.color || (i.color = i.position === Ya ? Rg : a.background), this.label = new Qt(h, b({}, i)), this.label.aliasFor = l, i.position === Ya && !P(p) && (a.type === fe ? p = Math.max(this.label.box.width(), this.label.box.height()) : (c = this.label.box.width(), u = this.label.box.height()), s.wrap(this.label.box));
      }
      a.width = c || p || Up, a.height = u || p || Up;
      var f = new tr(b({}, a));
      f.aliasFor = l, this.marker = f, this.append(f), this.label && this.append(this.label), f.reflow(new L()), this.wrapperBox = s.wrap(f.box);
    }
  }, r.prototype.reflow = function(t) {
    var e = this, i = e.options, a = e.label, s = e.marker, l = e.wrapperBox, p = t.center(), h = i.line.length, c = i.position;
    if (i.visible) {
      var u, v, f;
      Z(c, [Q, et]) ? c === Q ? (f = l.alignTo(t, c).translate(-h, t.center().y - l.center().y), i.line.visible && (u = [t.x1, p.y], this.linePoints = [
        u,
        [f.x2, p.y]
      ], v = f.clone().wrapPoint(u))) : (f = l.alignTo(t, c).translate(h, t.center().y - l.center().y), i.line.visible && (u = [t.x2, p.y], this.linePoints = [
        u,
        [f.x1, p.y]
      ], v = f.clone().wrapPoint(u))) : c === it ? (f = l.alignTo(t, c).translate(t.center().x - l.center().x, h), i.line.visible && (u = [p.x, t.y2], this.linePoints = [
        u,
        [p.x, f.y1]
      ], v = f.clone().wrapPoint(u))) : (f = l.alignTo(t, c).translate(t.center().x - l.center().x, -h), i.line.visible && (u = [p.x, t.y1], this.linePoints = [
        u,
        [p.x, f.y2]
      ], v = f.clone().wrapPoint(u))), s && s.reflow(f), a && (a.reflow(f), s && (i.label.position === sn && a.box.alignTo(s.box, c), a.reflow(a.box))), this.contentBox = f, this.targetBox = t, this.box = v || f;
    }
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this), this.visual.options.noclip = this.options.noclip, this.options.visible && this.createLine();
  }, r.prototype.renderVisual = function() {
    var t = this, e = this.options, i = e.visual;
    e.visible && i ? (this.visual = i(Object.assign(this.fields, {
      sender: this.getSender(),
      rect: this.targetBox.toRect(),
      options: {
        background: e.background,
        border: e.background,
        icon: e.icon,
        label: e.label,
        line: e.line,
        position: e.position,
        visible: e.visible
      },
      createVisual: function() {
        t.createVisual(), t.renderChildren();
        var a = t.visual;
        return delete t.visual, a;
      }
    })), this.addVisual()) : n.prototype.renderVisual.call(this);
  }, r.prototype.createLine = function() {
    var t = this.options.line;
    if (this.linePoints) {
      var e = H.fromPoints(this.linePoints, {
        stroke: {
          color: t.color,
          width: t.width,
          dashType: t.dashType
        }
      });
      ae(e), this.visual.append(e);
    }
  }, r.prototype.click = function(t, e) {
    var i = this.eventArgs(e);
    t.trigger(Fd, i) || e.preventDefault();
  }, r.prototype.over = function(t, e) {
    var i = this.eventArgs(e);
    t.trigger(Ud, i) || e.preventDefault();
  }, r.prototype.out = function(t, e) {
    var i = this.eventArgs(e);
    t.trigger($d, i);
  }, r.prototype.eventArgs = function(t) {
    var e = this.options;
    return Object.assign(this.fields, {
      element: ge(t),
      text: P(e.label) ? e.label.text : "",
      visual: this.visual
    });
  }, r;
}(wr);
O(Zs, {
  icon: {
    visible: !0,
    type: fe
  },
  label: {
    position: Ya,
    visible: !0,
    align: $,
    vAlign: $
  },
  line: {
    visible: !0
  },
  visible: !0,
  position: tt,
  zIndex: 2
});
var Lg = {
  format: function(n, r) {
    return r;
  },
  toString: function(n) {
    return n;
  },
  parseDate: function(n) {
    return new Date(n);
  },
  firstDay: function() {
    return 0;
  }
}, vu = Lg, Fn = function() {
}, fu = { implementation: { configurable: !0 } };
Fn.register = function(r) {
  vu = r;
};
fu.implementation.get = function() {
  return vu;
};
Object.defineProperties(Fn, fu);
var Ig = /\{(\d+)(:[^\}]+)?\}/g, Un = function(r) {
  this._intlService = r;
}, Qs = { intl: { configurable: !0 } };
Qs.intl.get = function() {
  return this._intlService || Fn.implementation;
};
Qs.intl.set = function(n) {
  this._intlService = n;
};
Un.prototype.auto = function(r) {
  for (var o = [], t = arguments.length - 1; t-- > 0; )
    o[t] = arguments[t + 1];
  var e = this.intl;
  return se(r) && r.match(Zc) ? e.format.apply(e, [r].concat(o)) : e.toString(o[0], r);
};
Un.prototype.localeAuto = function(r, o, t) {
  var e = this.intl, i;
  return se(r) && r.match(Zc) ? i = r.replace(Ig, function(a, s, l) {
    var p = o[parseInt(s, 10)];
    return e.toString(p, l ? l.substring(1) : "", t);
  }) : i = e.toString(o[0], r, t), i;
};
Object.defineProperties(Un.prototype, Qs);
var di = function(r, o) {
  o === void 0 && (o = {}), this._intlService = o.intlService, this.sender = o.sender || r, this.format = new Un(o.intlService), this.chart = r, this.rtl = !!o.rtl;
}, Ks = { intl: { configurable: !0 } };
Ks.intl.get = function() {
  return this._intlService || Fn.implementation;
};
Ks.intl.set = function(n) {
  this._intlService = n, this.format.intl = n;
};
di.prototype.notify = function(r, o) {
  this.chart && this.chart.trigger(r, o);
};
di.prototype.isPannable = function(r) {
  var o = ((this.chart || {}).options || {}).pannable;
  return o && o.lock !== r;
};
Object.defineProperties(di.prototype, Ks);
var Ka, yo = function() {
};
yo.register = function(r) {
  Ka = r;
};
yo.create = function(r, o) {
  if (Ka)
    return Ka.create(r, o);
};
function du(n, r) {
  var o = n.tickX, t = n.tickY, e = n.position, i = new H({
    stroke: {
      width: r.width,
      color: r.color
    }
  });
  return n.vertical ? i.moveTo(o, e).lineTo(o + r.size, e) : i.moveTo(e, t).lineTo(e, t + r.size), ae(i), i;
}
function gu(n, r) {
  var o = n.lineStart, t = n.lineEnd, e = n.position, i = new H({
    stroke: {
      width: r.width,
      color: r.color,
      dashType: r.dashType
    }
  });
  return n.vertical ? i.moveTo(o, e).lineTo(t, e) : i.moveTo(e, o).lineTo(e, t), ae(i), i;
}
var gi = function(n) {
  function r(o, t) {
    t === void 0 && (t = new di()), n.call(this, o), this.chartService = t, this.options.visible || (this.options = b({}, this.options, {
      labels: {
        visible: !1
      },
      line: {
        visible: !1
      },
      margin: 0,
      majorTickSize: 0,
      minorTickSize: 0
    })), this.options.minorTicks = b({}, {
      color: this.options.line.color,
      width: this.options.line.width,
      visible: this.options.minorTickType !== qa
    }, this.options.minorTicks, {
      size: this.options.minorTickSize,
      align: this.options.minorTickType
    }), this.options.majorTicks = b({}, {
      color: this.options.line.color,
      width: this.options.line.width,
      visible: this.options.majorTickType !== qa
    }, this.options.majorTicks, {
      size: this.options.majorTickSize,
      align: this.options.majorTickType
    }), this.initFields(), this.options._deferLabels || this.createLabels(), this.createTitle(), this.createNotes();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function() {
  }, r.prototype.labelsRange = function() {
    return {
      min: this.options.labels.skip,
      max: this.labelsCount()
    };
  }, r.prototype.normalizeLabelRotation = function(t) {
    var e = t.rotation;
    le(e) && (t.alignRotation = e.align, t.rotation = e.angle);
  }, r.prototype.createLabels = function() {
    var t = this, e = this.options, i = e.vertical ? et : $, a = b({}, e.labels, {
      align: i,
      zIndex: e.zIndex
    }), s = Math.max(1, a.step);
    if (this.clearLabels(), a.visible) {
      this.normalizeLabelRotation(a), a.rotation === "auto" && (a.rotation = 0, e.autoRotateLabels = !0);
      for (var l = this.labelsRange(), p = l.min; p < l.max; p += s) {
        var h = { index: p, count: l.max }, c = t.createAxisLabel(p, a, h);
        c && (t.append(c), t.labels.push(c));
      }
    }
  }, r.prototype.clearLabels = function() {
    this.children = qt(this.children, function(t) {
      return !(t instanceof br);
    }), this.labels = [];
  }, r.prototype.clearTitle = function() {
    var t = this;
    this.title && (this.children = qt(this.children, function(e) {
      return e !== t.title;
    }), this.title = void 0);
  }, r.prototype.clear = function() {
    this.clearLabels(), this.clearTitle();
  }, r.prototype.lineBox = function() {
    var t = this, e = t.options, i = t.box, a = e.vertical, s = e.labels.mirror, l = s ? i.x1 : i.x2, p = s ? i.y2 : i.y1, h = e.line.width || 0;
    return a ? new L(l, i.y1, l, i.y2 - h) : new L(i.x1, p, i.x2 - h, p);
  }, r.prototype.createTitle = function() {
    var t = this.options, e = b({
      rotation: t.vertical ? -90 : 0,
      text: "",
      zIndex: 1,
      visualSize: !0
    }, t.title);
    if (e.visible && e.text) {
      var i = new Qt(e.text, e);
      this.append(i), this.title = i;
    }
  }, r.prototype.createNotes = function() {
    var t = this, e = this.options, i = e.notes, a = i.data || [];
    this.notes = [];
    for (var s = 0; s < a.length; s++) {
      var l = b({}, i, a[s]);
      l.value = t.parseNoteValue(l.value);
      var p = new Zs({
        value: l.value,
        text: l.label.text,
        dataItem: l
      }, l, t.chartService);
      p.options.visible && (P(p.options.position) ? e.vertical && !Z(p.options.position, [Q, et]) ? p.options.position = e.reverse ? Q : et : !e.vertical && !Z(p.options.position, [tt, it]) && (p.options.position = e.reverse ? it : tt) : e.vertical ? p.options.position = e.reverse ? Q : et : p.options.position = e.reverse ? it : tt, t.append(p), t.notes.push(p));
    }
  }, r.prototype.parseNoteValue = function(t) {
    return t;
  }, r.prototype.renderVisual = function() {
    n.prototype.renderVisual.call(this), this.createPlotBands();
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this), this.createBackground(), this.createLine();
  }, r.prototype.gridLinesVisual = function() {
    var t = this._gridLines;
    return t || (t = this._gridLines = new pt({
      zIndex: -2
    }), this.appendVisual(this._gridLines)), t;
  }, r.prototype.createTicks = function(t) {
    var e = this.options, i = this.lineBox(), a = e.labels.mirror, s = e.majorTicks.visible ? e.majorUnit : 0, l = {
      // TODO
      // _alignLines: options._alignLines,
      vertical: e.vertical
    };
    function p(h, c, u) {
      var v = h.length, f = Math.max(1, c.step);
      if (c.visible)
        for (var d = c.skip; d < v; d += f)
          P(u) && d % u === 0 || (l.tickX = a ? i.x2 : i.x2 - c.size, l.tickY = a ? i.y1 - c.size : i.y1, l.position = h[d], t.append(du(l, c)));
    }
    p(this.getMajorTickPositions(), e.majorTicks), p(this.getMinorTickPositions(), e.minorTicks, s / e.minorUnit);
  }, r.prototype.createLine = function() {
    var t = this.options, e = t.line, i = this.lineBox();
    if (e.width > 0 && e.visible) {
      var a = new H({
        stroke: {
          width: e.width,
          color: e.color,
          dashType: e.dashType
        }
        /* TODO
        zIndex: line.zIndex,
        */
      });
      a.moveTo(i.x1, i.y1).lineTo(i.x2, i.y2), t._alignLines && ae(a);
      var s = this._lineGroup = new pt();
      s.append(a), this.visual.append(s), this.createTicks(s);
    }
  }, r.prototype.getActualTickSize = function() {
    var t = this.options, e = 0;
    return t.majorTicks.visible && t.minorTicks.visible ? e = Math.max(t.majorTicks.size, t.minorTicks.size) : t.majorTicks.visible ? e = t.majorTicks.size : t.minorTicks.visible && (e = t.minorTicks.size), e;
  }, r.prototype.createBackground = function() {
    var t = this, e = t.options, i = t.box, a = e.background;
    a && (this._backgroundPath = H.fromRect(i.toRect(), {
      fill: {
        color: a
      },
      stroke: null
    }), this.visual.append(this._backgroundPath));
  }, r.prototype.createPlotBands = function() {
    var t = this, e = this.options, i = e.plotBands || [], a = e.vertical, s = this.plotArea;
    if (i.length !== 0) {
      for (var l = this._plotbandGroup = new pt({
        zIndex: -1
      }), p = qt(this.pane.axes, function(w) {
        return w.options.vertical !== t.options.vertical;
      })[0], h = 0; h < i.length; h++) {
        var c = i[h], u = void 0, v = void 0, f = c.label, d = void 0;
        if (a ? (u = (p || s.axisX).lineBox(), v = t.getSlot(c.from, c.to, !0)) : (u = t.getSlot(c.from, c.to, !0), v = (p || s.axisY).lineBox()), f && (f.vAlign = f.position || Q, d = t.createPlotBandLabel(
          f,
          c,
          new L(
            u.x1,
            v.y1,
            u.x2,
            v.y2
          )
        )), u.width() !== 0 && v.height() !== 0) {
          var m = new Pt(
            [u.x1, v.y1],
            [u.width(), v.height()]
          ), _ = H.fromRect(m, {
            fill: {
              color: c.color,
              opacity: c.opacity
            },
            stroke: null
          });
          l.append(_), d && l.append(d);
        }
      }
      this.appendVisual(l);
    }
  }, r.prototype.createPlotBandLabel = function(t, e, i) {
    if (t.visible === !1)
      return null;
    var a = t.text, s;
    if (P(t) && t.visible) {
      var l = Ct(t);
      l ? a = l({ text: a, item: e }) : t.format && (a = this.chartService.format.auto(t.format, a)), t.color || (t.color = this.options.labels.color);
    }
    return s = new Qt(a, t), s.reflow(i), s.renderVisual(), s.visual;
  }, r.prototype.createGridLines = function(t) {
    var e = this.options, i = e.minorGridLines, a = e.majorGridLines, s = e.minorUnit, l = e.vertical, p = t.options.line.visible, h = a.visible ? e.majorUnit : 0, c = t.lineBox(), u = c[l ? "y1" : "x1"], v = {
      lineStart: c[l ? "x1" : "y1"],
      lineEnd: c[l ? "x2" : "y2"],
      vertical: l
    }, f = [], d = this.gridLinesVisual();
    function m(_, w, A) {
      var T = _.length, k = Math.max(1, w.step);
      if (w.visible)
        for (var C = w.skip; C < T; C += k) {
          var z = R(_[C]);
          Z(z, f) || C % A !== 0 && (!p || u !== z) && (v.position = z, d.append(gu(v, w)), f.push(z));
        }
    }
    return m(this.getMajorTickPositions(), a), m(this.getMinorTickPositions(), i, h / s), d.children;
  }, r.prototype.reflow = function(t) {
    for (var e = this, i = e.options, a = e.labels, s = e.title, l = i.vertical, p = a.length, h = l ? mn : yn, c = s ? s.box[h]() : 0, u = this.getActualTickSize() + i.margin + c, v = (this.getRoot() || {}).box || t, f = v[h](), d = 0, m = 0; m < p; m++) {
      var _ = a[m].box[h]();
      _ + u <= f && (d = Math.max(d, _));
    }
    l ? this.box = new L(
      t.x1,
      t.y1,
      t.x1 + d + u,
      t.y2
    ) : this.box = new L(
      t.x1,
      t.y1,
      t.x2,
      t.y1 + d + u
    ), this.arrangeTitle(), this.arrangeLabels(), this.arrangeNotes();
  }, r.prototype.getLabelsTickPositions = function() {
    return this.getMajorTickPositions();
  }, r.prototype.labelTickIndex = function(t) {
    return t.index;
  }, r.prototype.arrangeLabels = function() {
    for (var t = this, e = this, i = e.options, a = e.labels, s = this.labelsBetweenTicks(), l = i.vertical, p = i.labels.mirror, h = this.getLabelsTickPositions(), c = 0; c < a.length; c++) {
      var u = a[c], v = t.labelTickIndex(u), f = l ? u.box.height() : u.box.width(), d = h[v], m = h[v + 1], _ = void 0, w = void 0;
      if (l) {
        if (s) {
          var A = d + (m - d) / 2;
          _ = A - f / 2;
        } else
          _ = d - f / 2;
        w = _;
      } else
        s ? (_ = d, w = m) : (_ = d - f / 2, w = _ + f);
      t.positionLabel(u, p, _, w);
    }
  }, r.prototype.positionLabel = function(t, e, i, a) {
    a === void 0 && (a = i);
    var s = this.options, l = s.vertical, p = this.lineBox(), h = this.getActualTickSize() + s.margin, c;
    if (l) {
      var u = p.x2;
      e ? (u += h, t.options.rotationOrigin = Q) : (u -= h + t.box.width(), t.options.rotationOrigin = et), c = t.box.move(u, i);
    } else {
      var v = p.y1;
      e ? (v -= h + t.box.height(), t.options.rotationOrigin = it) : (v += h, t.options.rotationOrigin = tt), c = new L(
        i,
        v,
        a,
        v + t.box.height()
      );
    }
    t.reflow(c);
  }, r.prototype.autoRotateLabelAngle = function(t, e) {
    return t.width() < e ? 0 : t.height() > e ? -90 : -45;
  }, r.prototype.autoRotateLabels = function() {
    var t = this;
    if (!this.options.autoRotateLabels || this.options.vertical)
      return !1;
    for (var e = this.getMajorTickPositions(), i = this.labels, a = Math.min(i.length, e.length - 1), s = 0, l = 0; l < a; l++) {
      var p = Math.abs(e[l + 1] - e[l]), h = i[l].box, c = t.autoRotateLabelAngle(h, p);
      if (c !== 0 && (s = c), s === -90)
        break;
    }
    if (s !== 0) {
      for (var u = 0; u < i.length; u++)
        i[u].options.rotation = s, i[u].reflow(new L());
      return !0;
    }
  }, r.prototype.arrangeTitle = function() {
    var t = this, e = t.options, i = t.title, a = e.labels.mirror, s = e.vertical;
    i && (s ? (i.options.align = a ? et : Q, i.options.vAlign = i.options.position) : (i.options.align = i.options.position, i.options.vAlign = a ? tt : it), i.reflow(this.box));
  }, r.prototype.arrangeNotes = function() {
    for (var t = this, e = 0; e < this.notes.length; e++) {
      var i = t.notes[e], a = i.options.value, s = void 0;
      P(a) ? (t.shouldRenderNote(a) ? i.show() : i.hide(), s = t.noteSlot(a)) : i.hide(), i.reflow(s || t.lineBox());
    }
  }, r.prototype.noteSlot = function(t) {
    return this.getSlot(t);
  }, r.prototype.alignTo = function(t) {
    var e = t.lineBox(), i = this.options.vertical, a = i ? B : D;
    this.box.snapTo(e, a), i ? this.box.shrink(0, this.lineBox().height() - e.height()) : this.box.shrink(this.lineBox().width() - e.width(), 0), this.box[a + 1] -= this.lineBox()[a + 1] - e[a + 1], this.box[a + 2] -= this.lineBox()[a + 2] - e[a + 2];
  }, r.prototype.axisLabelText = function(t, e, i) {
    var a = this, s, l = Ct(e), p = function() {
      return e.format ? a.chartService.format.localeAuto(
        e.format,
        [t],
        e.culture
      ) : t;
    };
    if (l) {
      var h = Object.assign({}, i, {
        get text() {
          return p();
        },
        value: t,
        format: e.format,
        culture: e.culture
      });
      s = l(h);
    } else
      s = p();
    return s;
  }, r.prototype.slot = function(t, e, i) {
    var a = this.getSlot(t, e, i);
    if (a)
      return a.toRect();
  }, r.prototype.contentBox = function() {
    var t = this.box.clone(), e = this.labels;
    if (e.length) {
      var i = this.options.vertical ? B : D;
      if (this.chartService.isPannable(i)) {
        var a = this.maxLabelOffset();
        t[i + 1] -= a.start, t[i + 2] += a.end;
      } else {
        e[0].options.visible && t.wrap(e[0].box);
        var s = e[e.length - 1];
        s.options.visible && t.wrap(s.box);
      }
    }
    return t;
  }, r.prototype.maxLabelOffset = function() {
    for (var t = this, e = this.options, i = e.vertical, a = e.reverse, s = this.labelsBetweenTicks(), l = this.getLabelsTickPositions(), p = i ? B : D, h = this.labels, c = a ? 1 : 0, u = a ? 0 : 1, v = 0, f = 0, d = 0; d < h.length; d++) {
      var m = h[d], _ = t.labelTickIndex(m), w = void 0, A = void 0;
      s ? (w = l[_ + c], A = l[_ + u]) : w = A = l[_], v = Math.max(v, w - m.box[p + 1]), f = Math.max(f, m.box[p + 2] - A);
    }
    return {
      start: v,
      end: f
    };
  }, r.prototype.limitRange = function(t, e, i, a, s) {
    var l = this.options;
    if (t < i && s < 0 && (!P(l.min) || l.min <= i) || a < e && s > 0 && (!P(l.max) || a <= l.max))
      return null;
    if (e < i && s > 0 || a < t && s < 0)
      return {
        min: t,
        max: e
      };
    var p = e - t, h = t, c = e;
    return t < i && s < 0 ? (h = j(t, i, a), c = j(t + p, i + p, a)) : e > a && s > 0 && (c = j(e, i, a), h = j(e - p, i, a - p)), {
      min: h,
      max: c
    };
  }, r.prototype.valueRange = function() {
    return {
      min: this.seriesMin,
      max: this.seriesMax
    };
  }, r.prototype.lineDir = function() {
    var t = this.options, e = t.vertical, i = t.reverse;
    return (e ? -1 : 1) * (i ? -1 : 1);
  }, r.prototype.lineInfo = function() {
    var t = this.options, e = t.vertical, i = this.lineBox(), a = e ? i.height() : i.width(), s = e ? B : D, l = this.lineDir(), p = l === 1 ? 1 : 2, h = s + p.toString(), c = i[h];
    return {
      axis: s,
      axisOrigin: h,
      axisDir: l,
      lineBox: i,
      lineSize: a,
      lineStart: c
    };
  }, r.prototype.pointOffset = function(t) {
    var e = this.lineInfo(), i = e.axis, a = e.axisDir, s = e.axisOrigin, l = e.lineBox, p = e.lineSize, h = a > 0 ? t[i] - l[s] : l[s] - t[i], c = h / p;
    return c;
  }, r.prototype.scaleToDelta = function(t, e) {
    var i = 0.999, a = j(t, -i, i), s;
    return a > 0 ? s = e * Math.min(1, a) : s = e - e / (1 + a), s;
  }, r.prototype.labelsBetweenTicks = function() {
    return !this.options.justified;
  }, r.prototype.prepareUserOptions = function() {
  }, r;
}(rt);
O(gi, {
  labels: {
    visible: !0,
    rotation: 0,
    mirror: !1,
    step: 1,
    skip: 0
  },
  line: {
    width: 1,
    color: yt,
    visible: !0
  },
  title: {
    visible: !0,
    position: $
  },
  majorTicks: {
    align: sn,
    size: 4,
    skip: 0,
    step: 1
  },
  minorTicks: {
    align: sn,
    size: 3,
    skip: 0,
    step: 1
  },
  axisCrossingValue: 0,
  majorTickType: sn,
  minorTickType: qa,
  majorGridLines: {
    skip: 0,
    step: 1
  },
  minorGridLines: {
    visible: !1,
    width: 1,
    color: yt,
    skip: 0,
    step: 1
  },
  // TODO: Move to line or labels options
  margin: 5,
  visible: !0,
  reverse: !1,
  justified: !0,
  notes: {
    label: {
      text: ""
    }
  },
  _alignLines: !0,
  _deferLabels: !1
});
var wn = "milliseconds", Js = "seconds", tl = "minutes", mo = "hours", Re = "days", _o = "weeks", Dr = "months", er = "years", Dg = 1, el = 1e3, yi = 60 * el, $n = 60 * yi, rr = 24 * $n, rl = 7 * rr, il = 31 * rr, ol = 365 * rr, Pe = {
  years: ol,
  months: il,
  weeks: rl,
  days: rr,
  hours: $n,
  minutes: yi,
  seconds: el,
  milliseconds: Dg
};
function nl(n, r) {
  var o = n.getTime() - r, t = n.getTimezoneOffset() - r.getTimezoneOffset();
  return o - t * yi;
}
function St(n, r) {
  return new Date(n.getTime() + r);
}
function at(n) {
  var r;
  return n instanceof Date ? r = n : n && (r = new Date(n)), r;
}
function Bg(n, r) {
  r === void 0 && (r = 0);
  var o = 0, t = n.getDay();
  if (!isNaN(t))
    for (; t !== r; )
      t === 0 ? t = 6 : t--, o++;
  return St(n, -o * rr);
}
function Qo(n, r) {
  return r === 0 && n.getHours() === 23 ? (n.setHours(n.getHours() + 2), !0) : !1;
}
function zg(n, r) {
  var o = new Date(n);
  o.setMinutes(0, 0, 0);
  var t = (n.getTimezoneOffset() - o.getTimezoneOffset()) * yi;
  return St(o, t + r * $n);
}
function Ht(n, r, o, t) {
  var e = n;
  if (n) {
    var i = at(n), a = i.getHours();
    o === er ? (e = new Date(i.getFullYear() + r, 0, 1), Qo(e, 0)) : o === Dr ? (e = new Date(i.getFullYear(), i.getMonth() + r, 1), Qo(e, a)) : o === _o ? (e = Ht(Bg(i, t), r * 7, Re), Qo(e, a)) : o === Re ? (e = new Date(i.getFullYear(), i.getMonth(), i.getDate() + r), Qo(e, a)) : o === mo ? e = zg(i, r) : o === tl ? (e = St(i, r * yi), e.getSeconds() > 0 && e.setSeconds(0)) : o === Js ? e = St(i, r * el) : o === wn && (e = St(i, r)), o !== wn && e.getMilliseconds() > 0 && e.setMilliseconds(0);
  }
  return e;
}
function al(n, r, o) {
  return Ht(at(n), 0, r, o);
}
function yu(n, r, o) {
  var t = at(n);
  return t && al(t, r, o).getTime() === t.getTime() ? t : Ht(t, 1, r, o);
}
function Br(n, r) {
  return n && r ? n.getTime() - r.getTime() : -1;
}
function Oe(n, r) {
  return n.getTime() - r;
}
function st(n) {
  if (Ot(n)) {
    for (var r = [], o = 0; o < n.length; o++)
      r.push(st(n[o]));
    return r;
  } else if (n)
    return at(n).getTime();
}
function Ja(n, r) {
  return n && r ? st(n) === st(r) : n === r;
}
function $p(n, r, o) {
  return nl(n, r) / Pe[o];
}
function zr(n, r, o, t) {
  var e = at(n), i = at(r), a;
  return o === Dr ? a = e.getMonth() - i.getMonth() + (e.getFullYear() - i.getFullYear()) * 12 + $p(e, new Date(e.getFullYear(), e.getMonth()), Re) / new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate() : o === er ? a = e.getFullYear() - i.getFullYear() + zr(e, new Date(e.getFullYear(), 0), Dr, 1) / 12 : o === Re || o === _o ? a = $p(e, i, o) : a = Oe(e, r) / Pe[o], a / t;
}
function sl(n, r, o) {
  var t;
  return o === er ? t = r.getFullYear() - n.getFullYear() : o === Dr ? t = sl(n, r, er) * 12 + r.getMonth() - n.getMonth() : o === Re ? t = Math.floor(Oe(r, n) / rr) : t = Math.floor(Oe(r, n) / Pe[o]), t;
}
function Rt(n, r) {
  var o;
  return se(r) ? o = n.parseDate(r) || at(r) : o = at(r), o;
}
function mu(n, r) {
  if (Ot(r)) {
    for (var o = [], t = 0; t < r.length; t++)
      o.push(Rt(n, r[t]));
    return o;
  }
  return Rt(n, r);
}
function _u(n, r) {
  return Y(n.weekStartDay) ? n.weekStartDay : r && r.firstDay ? r.firstDay() : 0;
}
var jg = 0.01, Gp = 0.1;
function Vg(n, r) {
  if (n instanceof Date) {
    for (var o = r.length, t = 0; t < o; t++)
      if (Ja(r[t], n))
        return t;
    return -1;
  }
  return r.indexOf(n);
}
var Me = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function() {
    this._ticks = {};
  }, r.prototype.categoriesHash = function() {
    return "";
  }, r.prototype.clone = function() {
    var t = new r(Object.assign({}, this.options, {
      categories: this.options.srcCategories
    }), this.chartService);
    return t.createLabels(), t;
  }, r.prototype.initUserOptions = function(t) {
    var e = t.categories || [], i = P(t.min), a = P(t.max);
    if (t.srcCategories = t.categories = e, (i || a) && e.length) {
      var s = i ? Math.floor(t.min) : 0, l;
      a ? l = t.justified ? Math.floor(t.max) + 1 : Math.ceil(t.max) : l = e.length, t.categories = t.categories.slice(s, l);
    }
    return t;
  }, r.prototype.rangeIndices = function() {
    var t = this.options, e = t.categories.length || 1, i = Y(t.min) ? t.min % 1 : 0, a;
    return Y(t.max) && t.max % 1 !== 0 && t.max < this.totalRange().max ? a = e - (1 - t.max % 1) : a = e - (t.justified ? 1 : 0), {
      min: i,
      max: a
    };
  }, r.prototype.totalRangeIndices = function(t) {
    var e = this.options, i = Y(e.min) ? e.min : 0, a;
    if (Y(e.max) ? a = e.max : Y(e.min) ? a = i + e.categories.length : a = this.totalRange().max || 1, t) {
      var s = this.totalRange();
      i = j(i, 0, s.max), a = j(a, 0, s.max);
    }
    return {
      min: i,
      max: a
    };
  }, r.prototype.range = function() {
    var t = this.options, e = Y(t.min) ? t.min : 0, i = Y(t.max) ? t.max : this.totalRange().max;
    return {
      min: e,
      max: i
    };
  }, r.prototype.roundedRange = function() {
    return this.range();
  }, r.prototype.totalRange = function() {
    var t = this.options;
    return { min: 0, max: Math.max(this._seriesMax || 0, t.srcCategories.length) - (t.justified ? 1 : 0) };
  }, r.prototype.scaleOptions = function() {
    var t = this.rangeIndices(), e = t.min, i = t.max, a = this.lineBox(), s = this.options.vertical ? a.height() : a.width(), l = s / (i - e || 1);
    return {
      scale: l * (this.options.reverse ? -1 : 1),
      box: a,
      min: e,
      max: i
    };
  }, r.prototype.arrangeLabels = function() {
    n.prototype.arrangeLabels.call(this), this.hideOutOfRangeLabels();
  }, r.prototype.hideOutOfRangeLabels = function() {
    var t = this, e = t.box, i = t.labels;
    if (i.length > 0) {
      var a = this.options.vertical ? B : D, s = e[a + 1], l = e[a + 2], p = i[0], h = dt(i);
      (p.box[a + 1] > l || p.box[a + 2] < s) && (p.options.visible = !1), (h.box[a + 1] > l || h.box[a + 2] < s) && (h.options.visible = !1);
    }
  }, r.prototype.getMajorTickPositions = function() {
    return this.getTicks().majorTicks;
  }, r.prototype.getMinorTickPositions = function() {
    return this.getTicks().minorTicks;
  }, r.prototype.getLabelsTickPositions = function() {
    return this.getTicks().labelTicks;
  }, r.prototype.tickIndices = function(t) {
    for (var e = this.rangeIndices(), i = e.min, a = e.max, s = Math.ceil(a), l = Math.floor(i), p = []; l <= s; )
      p.push(l), l += t;
    return p;
  }, r.prototype.getTickPositions = function(t) {
    for (var e = this.options, i = e.vertical, a = e.reverse, s = this.scaleOptions(), l = s.scale, p = s.box, h = s.min, c = p[(i ? B : D) + (a ? 2 : 1)], u = this.tickIndices(t), v = [], f = 0; f < u.length; f++)
      v.push(c + R(l * (u[f] - h), Tt));
    return v;
  }, r.prototype.getTicks = function() {
    var t = this.options, e = this._ticks, i = this.rangeIndices(), a = this.lineBox(), s = a.getHash() + i.min + "," + i.max + t.reverse + t.justified;
    if (e._hash !== s) {
      var l = t.minorTicks.visible || t.minorGridLines.visible;
      e._hash = s, e.labelTicks = this.getTickPositions(1), e.majorTicks = this.filterOutOfRangePositions(e.labelTicks, a), e.minorTicks = l ? this.filterOutOfRangePositions(this.getTickPositions(0.5), a) : [];
    }
    return e;
  }, r.prototype.filterOutOfRangePositions = function(t, e) {
    if (!t.length)
      return t;
    for (var i = this.options.vertical ? B : D, a = function(h) {
      return e[i + 1] <= h && h <= e[i + 2];
    }, s = t.length - 1, l = 0; !a(t[l]) && l <= s; )
      l++;
    for (var p = s; !a(t[p]) && p >= 0; )
      p--;
    return t.slice(l, p + 1);
  }, r.prototype.lineInfo = function() {
    var t = this.options, e = t.vertical, i = t.reverse, a = this.lineBox(), s = e ? a.height() : a.width(), l = e ? B : D, p = i ? -1 : 1, h = p === 1 ? 1 : 2, c = l + h.toString(), u = a[c];
    return {
      axis: l,
      axisOrigin: c,
      axisDir: p,
      lineBox: a,
      lineSize: s,
      lineStart: u
    };
  }, r.prototype.lineDir = function() {
    var t = this.options, e = t.reverse;
    return e ? -1 : 1;
  }, r.prototype.getSlot = function(t, e, i) {
    var a = this.options, s = a.reverse, l = a.justified, p = this.scaleOptions(), h = p.scale, c = p.box, u = p.min, v = this.lineInfo(), f = v.axis, d = v.lineStart, m = c.clone(), _ = !P(e), w = U(t, 0), A = U(e, w);
    A = Math.max(A - 1, w), A = Math.max(w, A);
    var T = d + (w - u) * h, k = d + (A + 1 - u) * h;
    return _ && l && (k = T), i && (T = j(T, c[f + 1], c[f + 2]), k = j(k, c[f + 1], c[f + 2])), m[f + 1] = s ? k : T, m[f + 2] = s ? T : k, m;
  }, r.prototype.limitSlot = function(t) {
    var e = this.options.vertical, i = e ? B : D, a = this.lineBox(), s = t.clone();
    return s[i + 1] = j(t[i + 1], a[i + 1], a[i + 2]), s[i + 2] = j(t[i + 2], a[i + 1], a[i + 2]), s;
  }, r.prototype.slot = function(t, e, i) {
    var a = Math.floor(this.options.min || 0), s = t, l = e;
    return typeof s == "string" ? s = this.categoryIndex(s) : Y(s) && (s -= a), typeof l == "string" ? l = this.categoryIndex(l) : Y(l) && (l -= a), n.prototype.slot.call(this, s, l, i);
  }, r.prototype.pointCategoryIndex = function(t) {
    var e = this.options, i = e.reverse, a = e.justified, s = e.vertical, l = s ? B : D, p = this.scaleOptions(), h = p.scale, c = p.box, u = p.min, v = p.max, f = i ? v : u, d = c[l + 1], m = c[l + 2], _ = t[l];
    if (_ < d || _ > m)
      return null;
    var w = f + (_ - d) / h, A = w % 1;
    return a ? w = Math.round(w) : A === 0 && w > 0 && w--, Math.floor(w);
  }, r.prototype.getCategory = function(t) {
    var e = this.pointCategoryIndex(t);
    return e === null ? null : this.options.categories[e];
  }, r.prototype.categoryIndex = function(t) {
    return this.totalIndex(t) - Math.floor(this.options.min || 0);
  }, r.prototype.categoryAt = function(t, e) {
    var i = this.options;
    return (e ? i.srcCategories : i.categories)[t];
  }, r.prototype.categoriesCount = function() {
    return (this.options.categories || []).length;
  }, r.prototype.translateRange = function(t) {
    var e = this.options, i = this.lineBox(), a = e.vertical ? i.height() : i.width(), s = e.categories.length, l = a / s, p = R(t / l, nt);
    return {
      min: p,
      max: s + p
    };
  }, r.prototype.scaleRange = function(t, e) {
    var i = Math.abs(this.pointOffset(e)), a = this.totalRangeIndices(), s = a.max - a.min, l = this.scaleToDelta(t, s), p = i * l, h = (1 - i) * l, c = a.min + p, u = a.max - h;
    return u - c < Gp && (u = c + Gp), {
      min: c,
      max: u
    };
  }, r.prototype.zoomRange = function(t, e) {
    var i = this.totalRange(), a = i.min, s = i.max, l = this.scaleRange(t, e);
    return {
      min: j(l.min, a, s),
      max: j(l.max, a, s)
    };
  }, r.prototype.labelsCount = function() {
    var t = this.labelsRange();
    return t.max - t.min;
  }, r.prototype.labelsRange = function() {
    var t = this.options, e = t.justified, i = t.labels, a = this.totalRangeIndices(!0), s = a.min, l = a.max, p = Math.floor(s);
    e ? (s = Math.ceil(s), l = Math.floor(l)) : (s = Math.floor(s), l = Math.ceil(l));
    var h;
    return s > i.skip ? h = i.skip + i.step * Math.ceil((s - i.skip) / i.step) : h = i.skip, {
      min: h - p,
      max: (t.categories.length ? l + (e ? 1 : 0) : 0) - p
    };
  }, r.prototype.createAxisLabel = function(t, e, i) {
    var a = this.options, s = a.dataItems ? a.dataItems[t] : null, l = U(a.categories[t], "");
    i.dataItem = s;
    var p = this.axisLabelText(l, e, i);
    return new br(l, p, t, s, e);
  }, r.prototype.shouldRenderNote = function(t) {
    var e = this.totalRangeIndices();
    return Math.floor(e.min) <= t && t <= Math.ceil(e.max);
  }, r.prototype.noteSlot = function(t) {
    var e = this.options, i = t - Math.floor(e.min || 0);
    return this.getSlot(i);
  }, r.prototype.arrangeNotes = function() {
    n.prototype.arrangeNotes.call(this), this.hideOutOfRangeNotes();
  }, r.prototype.hideOutOfRangeNotes = function() {
    var t = this, e = t.notes, i = t.box;
    if (e && e.length)
      for (var a = this.options.vertical ? B : D, s = i[a + 1], l = i[a + 2], p = 0; p < e.length; p++) {
        var h = e[p];
        h.box && (l < h.box[a + 1] || h.box[a + 2] < s) && h.hide();
      }
  }, r.prototype.pan = function(t) {
    var e = this.totalRangeIndices(!0), i = this.scaleOptions(), a = i.scale, s = R(t / a, nt), l = this.totalRange(), p = e.min + s, h = e.max + s;
    return this.limitRange(p, h, 0, l.max, s);
  }, r.prototype.pointsRange = function(t, e) {
    var i = this.options, a = i.reverse, s = i.vertical, l = s ? B : D, p = this.totalRangeIndices(!0), h = this.scaleOptions(), c = h.scale, u = h.box, v = u[l + (a ? 2 : 1)], f = t[l] - v, d = e[l] - v, m = p.min + f / c, _ = p.min + d / c, w = Math.min(m, _), A = Math.max(m, _);
    if (A - w >= jg)
      return {
        min: w,
        max: A
      };
  }, r.prototype.valueRange = function() {
    return this.range();
  }, r.prototype.totalIndex = function(t) {
    var e = this.options, i = this._categoriesMap ? this._categoriesMap.get(t) : Vg(t, e.srcCategories);
    return i;
  }, r.prototype.currentRangeIndices = function() {
    var t = this.options, e = 0;
    Y(t.min) && (e = Math.floor(t.min));
    var i;
    return Y(t.max) ? i = t.justified ? Math.floor(t.max) : Math.ceil(t.max) - 1 : i = this.totalCount() - 1, {
      min: e,
      max: i
    };
  }, r.prototype.mapCategories = function() {
    if (!this._categoriesMap)
      for (var t = this._categoriesMap = new vo(), e = this.options.srcCategories, i = 0; i < e.length; i++)
        t.set(e[i], i);
  }, r.prototype.totalCount = function() {
    return Math.max(this.options.srcCategories.length, this._seriesMax || 0);
  }, r;
}(gi);
O(Me, {
  type: "category",
  vertical: !1,
  majorGridLines: {
    visible: !1,
    width: 1,
    color: yt
  },
  labels: {
    zIndex: 1
  },
  justified: !1,
  _deferLabels: !0
});
var Wp = 3e5, xu = {
  milliseconds: "HH:mm:ss.fff",
  seconds: "HH:mm:ss",
  minutes: "HH:mm",
  hours: "HH:mm",
  days: "M/d",
  weeks: "M/d",
  months: "MMM 'yy",
  years: "yyyy"
}, wu = 0.2, Ng = "auto", qe = [
  wn,
  Js,
  tl,
  mo,
  Re,
  _o,
  Dr,
  er
], bn = "fit";
function ln(n) {
  var r = n._range;
  return r || (r = n._range = Qa(n), r.min = at(r.min), r.max = at(r.max)), r;
}
var _e = function(r) {
  this.options = r;
};
_e.prototype.displayIndices = function() {
  return {
    min: 0,
    max: 1
  };
};
_e.prototype.displayRange = function() {
  return {};
};
_e.prototype.total = function() {
  return {};
};
_e.prototype.valueRange = function() {
  return {};
};
_e.prototype.valueIndex = function() {
  return -1;
};
_e.prototype.values = function() {
  return [];
};
_e.prototype.totalIndex = function() {
  return -1;
};
_e.prototype.valuesCount = function() {
  return 0;
};
_e.prototype.totalCount = function() {
  return 0;
};
_e.prototype.dateAt = function() {
  return null;
};
var Nt = function(r, o, t) {
  this.options = t, t.baseUnitStep = t.baseUnitStep || 1;
  var e = t.roundToBaseUnit, i = t.justified;
  this.start = Ht(r, 0, t.baseUnit, t.weekStartDay);
  var a = this.roundToTotalStep(o), s = !i && Ja(o, a) && !t.justifyEnd;
  this.end = this.roundToTotalStep(o, !i, s ? 1 : 0);
  var l = t.min || r;
  this.valueStart = this.roundToTotalStep(l), this.displayStart = e ? this.valueStart : l;
  var p = t.max;
  if (!p)
    this.valueEnd = a, this.displayEnd = e || s ? this.end : o;
  else {
    var h = !i && Ja(p, this.roundToTotalStep(p)) ? -1 : 0;
    this.valueEnd = this.roundToTotalStep(p, !1, h), this.displayEnd = e ? this.roundToTotalStep(p, !i) : t.max;
  }
  this.valueEnd < this.valueStart && (this.valueEnd = this.valueStart), this.displayEnd <= this.displayStart && (this.displayEnd = this.roundToTotalStep(this.displayStart, !1, 1));
};
Nt.prototype.displayRange = function() {
  return {
    min: this.displayStart,
    max: this.displayEnd
  };
};
Nt.prototype.displayIndices = function() {
  if (!this._indices) {
    var r = this.options, o = r.baseUnit, t = r.baseUnitStep, e = zr(this.displayStart, this.valueStart, o, t), i = zr(this.displayEnd, this.valueStart, o, t);
    this._indices = { min: e, max: i };
  }
  return this._indices;
};
Nt.prototype.total = function() {
  return {
    min: this.start,
    max: this.end
  };
};
Nt.prototype.totalCount = function() {
  var r = this.totalIndex(this.end);
  return r + (this.options.justified ? 1 : 0);
};
Nt.prototype.valueRange = function() {
  return {
    min: this.valueStart,
    max: this.valueEnd
  };
};
Nt.prototype.valueIndex = function(r) {
  var o = this.options;
  return Math.floor(zr(r, this.valueStart, o.baseUnit, o.baseUnitStep));
};
Nt.prototype.totalIndex = function(r) {
  var o = this.options;
  return Math.floor(zr(r, this.start, o.baseUnit, o.baseUnitStep));
};
Nt.prototype.dateIndex = function(r) {
  var o = this.options;
  return zr(r, this.valueStart, o.baseUnit, o.baseUnitStep);
};
Nt.prototype.valuesCount = function() {
  var r = this.valueIndex(this.valueEnd);
  return r + 1;
};
Nt.prototype.values = function() {
  var r = this._values;
  if (!r) {
    var o = this.options, t = this.valueRange();
    this._values = r = [];
    for (var e = t.min; e <= t.max; )
      r.push(e), e = Ht(e, o.baseUnitStep, o.baseUnit, o.weekStartDay);
  }
  return r;
};
Nt.prototype.dateAt = function(r, o) {
  var t = this.options;
  return Ht(o ? this.start : this.valueStart, t.baseUnitStep * r, t.baseUnit, t.weekStartDay);
};
Nt.prototype.roundToTotalStep = function(r, o, t) {
  var e = this.options, i = e.baseUnit, a = e.baseUnitStep, s = e.weekStartDay, l = this.start, p = zr(r, l, i, a), h = o ? Math.ceil(p) : Math.floor(p);
  return t && (h += t), Ht(l, h * a, i, s);
};
function bu(n, r, o) {
  for (var t = ln(n.categories), e = (n.max || t.max) - (n.min || t.min), i = n.autoBaseUnitSteps, a = n.maxDateGroups, s = n.baseUnit === bn, l = r ? qe.indexOf(r) : 0, p = s ? qe[l++] : n.baseUnit, h = e / Pe[p], c = h, u, v, f; !v || h >= a; ) {
    u = u || i[p].slice(0);
    do
      f = u.shift();
    while (f && r === p && f < o);
    if (f)
      v = f, h = c / v;
    else if (p === dt(qe)) {
      v = Math.ceil(c / a);
      break;
    } else if (s)
      p = qe[l++] || dt(qe), c = e / Pe[p], u = null;
    else {
      h > a && (v = Math.ceil(c / a));
      break;
    }
  }
  n.baseUnitStep = v, n.baseUnit = p;
}
function Hg(n) {
  for (var r = n.categories, o = P(r) ? r.length : 0, t = gt, e, i, a = 0; a < o; a++) {
    var s = r[a];
    if (s && e) {
      var l = nl(s, e);
      l > 0 && (t = Math.min(t, l), t >= ol ? i = er : t >= il - rr * 3 ? i = Dr : t >= rl ? i = _o : t >= rr ? i = Re : t >= $n ? i = mo : t >= yi ? i = tl : i = Js);
    }
    e = s;
  }
  n.baseUnit = i || Re;
}
function Fg(n) {
  var r = (n.baseUnit || "").toLowerCase(), o = r !== bn && !Z(r, qe);
  return o && Hg(n), (r === bn || n.baseUnitStep === Ng) && bu(n), n;
}
var xo = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.clone = function() {
    var t = new r(Object.assign({}, this.options), this.chartService);
    return t.createLabels(), t;
  }, r.prototype.categoriesHash = function() {
    var t = this.dataRange.total().min;
    return this.options.baseUnit + this.options.baseUnitStep + t;
  }, r.prototype.initUserOptions = function(t) {
    return t;
  }, r.prototype.initFields = function() {
    n.prototype.initFields.call(this);
    var t = this.chartService, e = t.intl, i = this.options, a = i.categories || [];
    if (a._parsed || (a = mu(e, a), a._parsed = !0), i = b({
      roundToBaseUnit: !0
    }, i, {
      categories: a,
      min: Rt(e, i.min),
      max: Rt(e, i.max),
      weekStartDay: _u(i, e)
    }), t.panning && t.isPannable(i.vertical ? B : D) && (i.roundToBaseUnit = !1), i.userSetBaseUnit = i.userSetBaseUnit || i.baseUnit, i.userSetBaseUnitStep = i.userSetBaseUnitStep || i.baseUnitStep, this.options = i, i.srcCategories = a, a.length > 0) {
      var s = ln(a), l = i.maxDivisions;
      if (this.dataRange = new Nt(s.min, s.max, Fg(i)), l) {
        var p = this.dataRange.displayRange(), h = Object.assign({}, i, {
          justified: !0,
          roundToBaseUnit: !1,
          baseUnit: "fit",
          min: p.min,
          max: p.max,
          maxDateGroups: l
        }), c = this.dataRange.options;
        bu(h, c.baseUnit, c.baseUnitStep), this.divisionRange = new Nt(s.min, s.max, h);
      } else
        this.divisionRange = this.dataRange;
    } else
      i.baseUnit = i.baseUnit || Re, this.dataRange = this.divisionRange = new _e(i);
    this.rangeLabels = [];
  }, r.prototype.tickIndices = function(t) {
    var e = this, i = e.dataRange, a = e.divisionRange, s = a.valuesCount();
    if (!this.options.maxDivisions || !s)
      return n.prototype.tickIndices.call(this, t);
    var l = [], p = a.values(), h = 0;
    this.options.justified || (p = p.concat(a.dateAt(s)), h = 0.5);
    for (var c = 0; c < p.length; c++)
      if (l.push(i.dateIndex(p[c]) + h), t !== 1 && c >= 1) {
        var u = l.length - 1;
        l.splice(c, 0, l[u - 1] + (l[u] - l[u - 1]) * t);
      }
    return l;
  }, r.prototype.shouldRenderNote = function(t) {
    var e = this.range(), i = this.options.categories || [];
    return Br(t, e.min) >= 0 && Br(t, e.max) <= 0 && i.length;
  }, r.prototype.parseNoteValue = function(t) {
    return Rt(this.chartService.intl, t);
  }, r.prototype.noteSlot = function(t) {
    return this.getSlot(t);
  }, r.prototype.translateRange = function(t) {
    var e = this.options, i = e.baseUnit, a = e.weekStartDay, s = e.vertical, l = this.lineBox(), p = s ? l.height() : l.width(), h = this.range(), c = p / (h.max - h.min), u = R(t / c, nt);
    if (h.min && h.max) {
      var v = St(e.min || h.min, u), f = St(e.max || h.max, u);
      h = {
        min: Ht(v, 0, i, a),
        max: Ht(f, 0, i, a)
      };
    }
    return h;
  }, r.prototype.labelsRange = function() {
    return {
      min: this.options.labels.skip,
      max: this.divisionRange.valuesCount()
    };
  }, r.prototype.pan = function(t) {
    if (this.isEmpty())
      return null;
    var e = this.options, i = this.lineBox(), a = e.vertical ? i.height() : i.width(), s = this.dataRange.displayRange(), l = s.min, p = s.max, h = this.dataRange.total(), c = a / (p - l), u = R(t / c, nt) * (e.reverse ? -1 : 1), v = St(l, u), f = St(p, u), d = this.limitRange(st(v), st(f), st(h.min), st(h.max), u);
    if (d)
      return d.min = at(d.min), d.max = at(d.max), d.baseUnit = e.baseUnit, d.baseUnitStep = e.baseUnitStep || 1, d.userSetBaseUnit = e.userSetBaseUnit, d.userSetBaseUnitStep = e.userSetBaseUnitStep, d;
  }, r.prototype.pointsRange = function(t, e) {
    if (this.isEmpty())
      return null;
    var i = n.prototype.pointsRange.call(this, t, e), a = this.dataRange.displayRange(), s = this.dataRange.displayIndices(), l = Oe(a.max, a.min) / (s.max - s.min), p = this.options, h = St(a.min, i.min * l), c = St(a.min, i.max * l);
    return {
      min: h,
      max: c,
      baseUnit: p.userSetBaseUnit || p.baseUnit,
      baseUnitStep: p.userSetBaseUnitStep || p.baseUnitStep
    };
  }, r.prototype.scaleRange = function(t, e) {
    if (this.isEmpty())
      return {};
    var i = this.options, a = i.userSetBaseUnit === bn, s = this.dataRange.total(), l = this.dataRange.displayRange(), p = l.min, h = l.max, c = Math.abs(this.pointOffset(e)), u = h - p, v = this.scaleToDelta(t, u), f = Math.round(c * v), d = Math.round((1 - c) * v), m = this.dataRange.options, _ = m.baseUnit, w = new Date(p.getTime() + f), A = new Date(h.getTime() - d);
    if (a) {
      var T = i.autoBaseUnitSteps, k = i.maxDateGroups, C = dt(T[_]) * k * Pe[_], z = Oe(h, p), V = Oe(A, w), G = qe.indexOf(_), X, W;
      if (V < Pe[_] && _ !== wn)
        _ = qe[G - 1], X = dt(T[_]), W = (z - (k - 1) * X * Pe[_]) / 2, w = St(p, W), A = St(h, -W);
      else if (V > C && _ !== er) {
        var ct = 0;
        do {
          G++, _ = qe[G], ct = 0, W = 2 * Pe[_];
          do
            X = T[_][ct], ct++;
          while (ct < T[_].length && W * X < z);
        } while (_ !== er && W * X < z);
        W = (W * X - z) / 2, W > 0 && (w = St(p, -W), A = St(h, W), w = St(w, j(A, s.min, s.max) - A), A = St(A, j(w, s.min, s.max) - w));
      }
    }
    if (w && A && Oe(A, w) > 0)
      return {
        min: w,
        max: A,
        baseUnit: i.userSetBaseUnit || i.baseUnit,
        baseUnitStep: i.userSetBaseUnitStep || i.baseUnitStep
      };
  }, r.prototype.zoomRange = function(t, e) {
    var i = this.dataRange.total(), a = this.scaleRange(t, e);
    return a && (a.min < i.min && (a.min = i.min), a.max > i.max && (a.max = i.max)), a;
  }, r.prototype.range = function() {
    return this.dataRange.displayRange();
  }, r.prototype.createLabels = function() {
    n.prototype.createLabels.call(this), this.createRangeLabels();
  }, r.prototype.clearLabels = function() {
    n.prototype.clearLabels.call(this), this.rangeLabels = [];
  }, r.prototype.arrangeLabels = function() {
    this.arrangeRangeLabels(), n.prototype.arrangeLabels.call(this);
  }, r.prototype.arrangeRangeLabels = function() {
    var t = this, e = t.options, i = t.rangeLabels;
    if (i.length !== 0) {
      var a = this.lineBox(), s = e.vertical, l = e.rangeLabels.mirror || e.labels.mirror, p = i[0];
      if (p) {
        var h = s ? a.y1 - p.box.height() / 2 : a.x1;
        this.positionLabel(p, l, h);
      }
      var c = i[1];
      if (c) {
        var u = s ? a.y2 - c.box.height() / 2 : a.x2;
        this.positionLabel(c, l, u);
      }
    }
  }, r.prototype.autoRotateLabels = function() {
    n.prototype.autoRotateLabels.call(this), this.autoRotateRangeLabels();
  }, r.prototype.hideOutOfRangeLabels = function() {
    n.prototype.hideOutOfRangeLabels.call(this), this.hideOverlappingLabels();
  }, r.prototype.hideOverlappingLabels = function() {
    var t = this, e = t.rangeLabels, i = t.labels;
    if (e.length === 0)
      return;
    function a(v, f) {
      return !f.options.visible || f.box.overlaps(v.box) ? (f.options.visible = !1, !0) : !1;
    }
    var s = e[0];
    if (s && s.options.visible)
      for (var l = 0; l < i.length; l++) {
        var p = a(s, i[l]);
        if (!p)
          break;
      }
    var h = e[1];
    if (h && h.options.visible)
      for (var c = i.length - 1; c > 0; --c) {
        var u = a(h, i[c]);
        if (!u)
          break;
      }
  }, r.prototype.contentBox = function() {
    for (var t = n.prototype.contentBox.call(this), e = this.rangeLabels, i = 0; i < e.length; i++) {
      var a = e[i];
      a.options.visible && t.wrap(a.box);
    }
    return t;
  }, r.prototype.createAxisLabel = function(t, e, i) {
    i === void 0 && (i = {});
    var a = this.options, s = a.dataItems && !a.maxDivisions ? a.dataItems[t] : null, l = this.divisionRange.dateAt(t), p = e.dateFormats[this.divisionRange.options.baseUnit];
    e.format = e.format || p, i.dataItem = s;
    var h = this.axisLabelText(l, e, i);
    if (h)
      return new br(l, h, t, s, e);
  }, r.prototype.createRangeLabels = function() {
    var t = this, e = this.divisionRange, i = e.displayStart, a = e.displayEnd, s = this.options, l = Object.assign({}, s.labels, s.rangeLabels, {
      align: $,
      zIndex: s.zIndex
    });
    if (l.visible === !0) {
      this.normalizeLabelRotation(l), l.alignRotation = $, l.rotation === "auto" && (l.rotation = 0, s.autoRotateRangeLabels = !0);
      var p = l.dateFormats[this.divisionRange.options.baseUnit];
      l.format = l.format || p;
      var h = function(v, f, d) {
        if (d) {
          var m = new br(f, d, v, null, l);
          t.append(m), t.rangeLabels.push(m);
        }
      }, c = this.axisLabelText(i, l, { index: 0, count: 2 });
      h(0, i, c);
      var u = this.axisLabelText(a, l, { index: 1, count: 2 });
      h(1, a, u);
    }
  }, r.prototype.autoRotateRangeLabels = function() {
    var t = this, e = this.rangeLabels;
    if (!(!this.options.autoRotateRangeLabels || this.options.vertical || e.length !== 2)) {
      var i = function(s, l, p) {
        var h = Math.abs(l[p + 1] - l[p]) * 2, c = t.autoRotateLabelAngle(s.box, h);
        c !== 0 && (s.options.rotation = c, s.reflow(new L()));
      }, a = this.getMajorTickPositions();
      i(e[0], a, 0), i(e[1], a, a.length - 2);
    }
  }, r.prototype.categoryIndex = function(t) {
    return this.dataRange.valueIndex(t);
  }, r.prototype.slot = function(t, e, i) {
    var a = this.dataRange, s = t, l = e;
    s instanceof Date && (s = a.dateIndex(s)), l instanceof Date && (l = a.dateIndex(l));
    var p = this.getSlot(s, l, i);
    if (p)
      return p.toRect();
  }, r.prototype.getSlot = function(t, e, i) {
    var a = t, s = e;
    return typeof a === Za && (a = this.categoryIndex(a)), typeof s === Za && (s = this.categoryIndex(s)), n.prototype.getSlot.call(this, a, s, i);
  }, r.prototype.valueRange = function() {
    var t = this.options, e = ln(t.srcCategories);
    return {
      min: at(e.min),
      max: at(e.max)
    };
  }, r.prototype.categoryAt = function(t, e) {
    return this.dataRange.dateAt(t, e);
  }, r.prototype.categoriesCount = function() {
    return this.dataRange.valuesCount();
  }, r.prototype.rangeIndices = function() {
    return this.dataRange.displayIndices();
  }, r.prototype.labelsBetweenTicks = function() {
    return !this.divisionRange.options.justified;
  }, r.prototype.prepareUserOptions = function() {
    this.isEmpty() || (this.options.categories = this.dataRange.values());
  }, r.prototype.getCategory = function(t) {
    var e = this.pointCategoryIndex(t);
    return e === null ? null : this.dataRange.dateAt(e);
  }, r.prototype.totalIndex = function(t) {
    return this.dataRange.totalIndex(t);
  }, r.prototype.currentRangeIndices = function() {
    var t = this.dataRange.valueRange();
    return {
      min: this.dataRange.totalIndex(t.min),
      max: this.dataRange.totalIndex(t.max)
    };
  }, r.prototype.totalRange = function() {
    return this.dataRange.total();
  }, r.prototype.totalCount = function() {
    return this.dataRange.totalCount();
  }, r.prototype.isEmpty = function() {
    return !this.options.srcCategories.length;
  }, r.prototype.roundedRange = function() {
    if (this.options.roundToBaseUnit !== !1 || this.isEmpty())
      return this.range();
    var t = this.options, e = ln(t.srcCategories), i = new Nt(e.min, e.max, Object.assign({}, t, {
      justified: !1,
      roundToBaseUnit: !0,
      justifyEnd: !1
    }));
    return i.displayRange();
  }, r;
}(Me);
O(xo, {
  type: xr,
  labels: {
    dateFormats: xu
  },
  rangeLabels: {
    visible: !1
  },
  autoBaseUnitSteps: {
    milliseconds: [1, 10, 100],
    seconds: [1, 2, 5, 15, 30],
    minutes: [1, 2, 5, 15, 30],
    hours: [1, 2, 3],
    days: [1, 2, 3],
    weeks: [1, 2],
    months: [1, 2, 3, 6],
    years: [1, 2, 3, 5, 10, 25, 50]
  },
  maxDateGroups: 10
});
function Ug(n, r, o) {
  if (!n && !r)
    return 0;
  var t;
  if (n >= 0 && r >= 0) {
    var e = n === r ? 0 : n, i = (r - e) / r;
    if (o === !1 || !o && i > wu)
      return 0;
    t = Math.max(0, e - (r - e) / 2);
  } else
    t = n;
  return t;
}
function $g(n, r, o) {
  if (!n && !r)
    return 1;
  var t;
  if (n <= 0 && r <= 0) {
    var e = n === r ? 0 : r, i = Math.abs((e - n) / e);
    if (o === !1 || !o && i > wu)
      return 0;
    t = Math.min(0, e - (n - e) / 2);
  } else
    t = r;
  return t;
}
function Au(n, r) {
  return R(Math.floor(n / r) * r, nt);
}
function An(n, r) {
  return R(Math.ceil(n / r) * r, nt);
}
function Sn(n) {
  return Math.max(Math.min(n, Wp), -Wp);
}
var Ra = Math.pow(10, -nt + 1), oe = function(n) {
  function r(o, t, e, i) {
    n.call(this, Object.assign({}, e, {
      seriesMin: o,
      seriesMax: t
    }), i);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initUserOptions = function(t) {
    var e = Gg(t.seriesMin, t.seriesMax, t);
    return this.totalOptions = Wg(e, t), Yg(e, t);
  }, r.prototype.initFields = function() {
    this.totalMin = this.totalOptions.min, this.totalMax = this.totalOptions.max, this.totalMajorUnit = this.totalOptions.majorUnit, this.seriesMin = this.options.seriesMin, this.seriesMax = this.options.seriesMax;
  }, r.prototype.clone = function() {
    return new r(
      this.seriesMin,
      this.seriesMax,
      Object.assign({}, this.options),
      this.chartService
    );
  }, r.prototype.startValue = function() {
    return 0;
  }, r.prototype.range = function() {
    var t = this.options;
    return { min: t.min, max: t.max };
  }, r.prototype.getDivisions = function(t) {
    if (t === 0)
      return 1;
    var e = this.options, i = e.max - e.min;
    return Math.floor(R(i / t, Tt)) + 1;
  }, r.prototype.getTickPositions = function(t, e) {
    var i = this.options, a = this.lineInfo(), s = a.axisDir, l = a.axisOrigin, p = a.lineBox, h = a.lineSize, c = i.max - i.min, u = h / c, v = t * u, f = this.getDivisions(t), d = [], m = p[l], _ = 0;
    e && (_ = e / t);
    for (var w = 0; w < f; w++)
      w % _ !== 0 && d.push(R(m, Tt)), m = m + v * s;
    return d;
  }, r.prototype.getMajorTickPositions = function() {
    return this.getTickPositions(this.options.majorUnit);
  }, r.prototype.getMinorTickPositions = function() {
    return this.getTickPositions(this.options.minorUnit);
  }, r.prototype.getSlot = function(t, e, i) {
    i === void 0 && (i = !1);
    var a = this.options, s = this.lineInfo(), l = s.axis, p = s.axisDir, h = s.lineBox, c = s.lineSize, u = s.lineStart, v = p * (c / (a.max - a.min)), f = U(t, e || 0), d = U(e, t || 0);
    i && (f = j(f, a.min, a.max), d = j(d, a.min, a.max));
    var m = Math.min(f, d) - a.min, _ = Math.max(f, d) - a.min, w = new L(h.x1, h.y1, h.x1, h.y1);
    return w[l + 1] = Sn(u + v * (p > 0 ? m : _)), w[l + 2] = Sn(u + v * (p > 0 ? _ : m)), w;
  }, r.prototype.getValue = function(t) {
    var e = this.options, i = Number(e.max), a = Number(e.min), s = this.pointOffset(t), l = s * (i - a);
    if (s < 0 || s > 1)
      return null;
    var p = a + l;
    return R(p, nt);
  }, r.prototype.translateRange = function(t) {
    var e = this.options, i = e.vertical, a = e.reverse, s = e.max, l = e.min, p = this.lineInfo(), h = p.lineSize, c = s - l, u = h / c, v = R(t / u, nt);
    return (i || a) && !(i && a) && (v = -v), {
      min: l + v,
      max: s + v,
      offset: v
    };
  }, r.prototype.labelsCount = function() {
    return this.getDivisions(this.options.majorUnit);
  }, r.prototype.createAxisLabel = function(t, e, i) {
    var a = this.options, s = R(a.min + t * a.majorUnit, nt), l = this.axisLabelText(s, e, i);
    return new br(s, l, t, null, e);
  }, r.prototype.shouldRenderNote = function(t) {
    var e = this.range();
    return e.min <= t && t <= e.max;
  }, r.prototype.pan = function(t) {
    var e = this.translateRange(t);
    return this.limitRange(e.min, e.max, this.totalMin, this.totalMax, e.offset);
  }, r.prototype.pointsRange = function(t, e) {
    var i = this.getValue(t), a = this.getValue(e), s = Math.min(i, a), l = Math.max(i, a);
    if (this.isValidRange(s, l))
      return {
        min: s,
        max: l
      };
  }, r.prototype.scaleRange = function(t, e) {
    var i = Math.abs(this.pointOffset(e)), a = this.options.max - this.options.min, s = this.scaleToDelta(t, a), l = i * s, p = (1 - i) * s, h = R(this.options.min + l, nt), c = R(this.options.max - p, nt);
    return c - h < Ra && (c = h + Ra), {
      min: h,
      max: c
    };
  }, r.prototype.zoomRange = function(t, e) {
    var i = this, a = i.totalMin, s = i.totalMax, l = this.scaleRange(t, e);
    return {
      min: j(l.min, a, s),
      max: j(l.max, a, s),
      narrowRange: !1
    };
  }, r.prototype.isValidRange = function(t, e) {
    return e - t > Ra;
  }, r;
}(gi);
function Gg(n, r, o) {
  var t = o.narrowRange, e = Ug(n, r, t), i = $g(n, r, t), a = fo(e, i), s = {
    majorUnit: a
  };
  return o.roundToMajorUnit !== !1 && (e < 0 && Xp(e, a, 1 / 3) && (e -= a), i > 0 && Xp(i, a, 1 / 3) && (i += a)), s.min = Au(e, a), s.max = An(i, a), s;
}
function Wg(n, r) {
  return {
    min: P(r.min) ? Math.min(n.min, r.min) : n.min,
    max: P(r.max) ? Math.max(n.max, r.max) : n.max,
    majorUnit: n.majorUnit
  };
}
function Xg(n, r) {
  for (var o = 0; o < r.length; o++) {
    var t = r[o];
    n[t] === null && (n[t] = void 0);
  }
}
function Yg(n, r) {
  var o = r, t, e;
  if (r) {
    Xg(r, ["min", "max"]), t = P(r.min), e = P(r.max);
    var i = t || e;
    i && r.min === r.max && (r.min > 0 ? r.min = 0 : r.max = 1), r.majorUnit ? (n.min = Au(n.min, r.majorUnit), n.max = An(n.max, r.majorUnit)) : i && (o = b(n, r), n.majorUnit = fo(o.min, o.max));
  }
  n.minorUnit = (o.majorUnit || n.majorUnit) / 5;
  var a = b(n, o);
  return a.min >= a.max && (t && !e ? a.max = a.min + a.majorUnit : !t && e && (a.min = a.max - a.majorUnit)), a;
}
function Xp(n, r, o) {
  var t = R(Math.abs(n % r), nt), e = r * (1 - o);
  return t === 0 || t > e;
}
O(oe, {
  type: "numeric",
  min: 0,
  max: 1,
  vertical: !0,
  majorGridLines: {
    visible: !0,
    width: 1,
    color: yt
  },
  labels: {
    format: "#.####################"
  },
  zIndex: 1
});
var Yp = 1e3, Su = function(n) {
  function r(o, t, e, i) {
    var a = at(o), s = at(t), l = i.intl, p = e || {};
    p = b(p || {}, {
      min: Rt(l, p.min),
      max: Rt(l, p.max),
      axisCrossingValue: mu(l, p.axisCrossingValues || p.axisCrossingValue),
      weekStartDay: _u(p, l)
    }), p = Zg(a, s, p), n.call(this, p, i), this.intlService = l, this.seriesMin = a, this.seriesMax = s;
    var h = p.weekStartDay || 0;
    this.totalMin = st(al(st(a) - 1, p.baseUnit, h)), this.totalMax = st(yu(st(s) + 1, p.baseUnit, h));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.clone = function() {
    return new r(this.seriesMin, this.seriesMax, Object.assign({}, this.options), this.chartService);
  }, r.prototype.range = function() {
    var t = this.options;
    return { min: t.min, max: t.max };
  }, r.prototype.getDivisions = function(t) {
    var e = this.options;
    return Math.floor(
      sl(e.min, e.max, e.baseUnit) / t + 1
    );
  }, r.prototype.getTickPositions = function(t) {
    for (var e = this.options, i = this.lineInfo(), a = i.axisDir, s = i.lineSize, l = i.lineStart, p = this.getDivisions(t), h = Oe(e.max, e.min), c = s / h, u = e.weekStartDay || 0, v = [l], f = 1; f < p; f++) {
      var d = Ht(e.min, f * t, e.baseUnit, u), m = l + Oe(d, e.min) * c * a;
      v.push(R(m, Tt));
    }
    return v;
  }, r.prototype.getMajorTickPositions = function() {
    return this.getTickPositions(this.options.majorUnit);
  }, r.prototype.getMinorTickPositions = function() {
    return this.getTickPositions(this.options.minorUnit);
  }, r.prototype.getSlot = function(t, e, i) {
    return oe.prototype.getSlot.call(
      this,
      Rt(this.intlService, t),
      Rt(this.intlService, e),
      i
    );
  }, r.prototype.getValue = function(t) {
    var e = oe.prototype.getValue.call(this, t);
    return e !== null ? at(e) : null;
  }, r.prototype.labelsCount = function() {
    return this.getDivisions(this.options.majorUnit);
  }, r.prototype.createAxisLabel = function(t, e, i) {
    var a = this.options, s = t * a.majorUnit, l = a.weekStartDay || 0, p = a.min;
    s > 0 && (p = Ht(p, s, a.baseUnit, l));
    var h = e.dateFormats[a.baseUnit];
    e.format = e.format || h;
    var c = this.axisLabelText(p, e, i);
    return new br(p, c, t, null, e);
  }, r.prototype.translateRange = function(t) {
    var e = this.options, i = this.lineBox(), a = e.vertical, s = e.reverse, l = a ? i.height() : i.width(), p = this.range(), h = l / Oe(p.max, p.min), c = R(t / h, nt);
    (a || s) && !(a && s) && (c = -c);
    var u = St(e.min, c), v = St(e.max, c);
    return {
      min: u,
      max: v,
      offset: c
    };
  }, r.prototype.shouldRenderNote = function(t) {
    var e = this.range();
    return Br(t, e.min) >= 0 && Br(t, e.max) <= 0;
  }, r.prototype.pan = function(t) {
    var e = this.translateRange(t, !0), i = this.limitRange(st(e.min), st(e.max), this.totalMin, this.totalMax, e.offset);
    if (i)
      return {
        min: at(i.min),
        max: at(i.max)
      };
  }, r.prototype.pointsRange = function(t, e) {
    var i = this.getValue(t), a = this.getValue(e), s = Math.min(i, a), l = Math.max(i, a);
    return {
      min: at(s),
      max: at(l)
    };
  }, r.prototype.scaleRange = function(t, e) {
    var i = Math.abs(this.pointOffset(e)), a = this.options.max - this.options.min, s = this.scaleToDelta(t, a), l = i * s, p = (1 - i) * s, h = at(st(this.options.min) + l), c = at(st(this.options.max) - p);
    return c - h < Yp && (c = at(st(h) + Yp)), {
      min: h,
      max: c
    };
  }, r.prototype.zoomRange = function(t, e) {
    var i = this.scaleRange(t, e), a = at(j(st(i.min), this.totalMin, this.totalMax)), s = at(j(st(i.max), this.totalMin, this.totalMax));
    return {
      min: a,
      max: s
    };
  }, r;
}(gi);
function qg(n) {
  var r = mo;
  return n >= ol ? r = er : n >= il ? r = Dr : n >= rl ? r = _o : n >= rr && (r = Re), r;
}
function Zg(n, r, o) {
  var t = o.min || n, e = o.max || r, i = o.baseUnit || (e && t ? qg(nl(e, t)) : mo), a = Pe[i], s = o.weekStartDay || 0, l = al(st(t) - 1, i, s) || at(e), p = yu(st(e) + 1, i, s), h = o.majorUnit ? o.majorUnit : void 0, c = h || An(
    fo(l.getTime(), p.getTime()),
    a
  ) / a, u = sl(l, p, i), v = An(u, c), f = v - u, d = Math.floor(f / 2), m = f - d;
  return o.baseUnit || delete o.baseUnit, o.baseUnit = o.baseUnit || i, o.min = o.min || Ht(l, -d, i, s), o.max = o.max || Ht(p, m, i, s), o.minorUnit = o.minorUnit || c / 5, o.majorUnit = c, o;
}
O(Su, {
  type: xr,
  majorGridLines: {
    visible: !0,
    width: 1,
    color: yt
  },
  labels: {
    dateFormats: xu
  }
});
var Tu = 10, qp = 1e-6, Gn = function(n) {
  function r(o, t, e, i) {
    var a = b({ majorUnit: Tu, min: o, max: t }, e), s = a.majorUnit, l = Jg(t, s), p = Kg(o, t, a), h = Qg(p, l, a, e);
    a.max = h.max, a.min = h.min, a.minorUnit = e.minorUnit || R(s - 1, nt), n.call(this, a, i), this.totalMin = P(e.min) ? Math.min(p, e.min) : p, this.totalMax = P(e.max) ? Math.max(l, e.max) : l, this.logMin = R(ce(h.min, s), nt), this.logMax = R(ce(h.max, s), nt), this.seriesMin = o, this.seriesMax = t, this.createLabels();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.clone = function() {
    return new r(
      this.seriesMin,
      this.seriesMax,
      Object.assign({}, this.options),
      this.chartService
    );
  }, r.prototype.startValue = function() {
    return this.options.min;
  }, r.prototype.getSlot = function(t, e, i) {
    var a = this, s = a.options, l = a.logMin, p = a.logMax, h = s.majorUnit, c = s.min, u = s.max, v = this.lineInfo(), f = v.axis, d = v.axisDir, m = v.lineBox, _ = v.lineSize, w = v.lineStart, A = d * (_ / (p - l)), T = U(t, e || 1), k = U(e, t || 1);
    if (T <= 0 || k <= 0)
      return null;
    i && (T = j(T, c, u), k = j(k, c, u)), T = ce(T, h), k = ce(k, h);
    var C = Math.min(T, k) - l, z = Math.max(T, k) - l, V = new L(m.x1, m.y1, m.x1, m.y1);
    return V[f + 1] = Sn(w + A * (d > 0 ? C : z)), V[f + 2] = Sn(w + A * (d > 0 ? z : C)), V;
  }, r.prototype.getValue = function(t) {
    var e = this, i = e.options, a = e.logMin, s = e.logMax, l = i.majorUnit, p = this.lineInfo(), h = p.axis, c = p.axisDir, u = p.lineStart, v = p.lineSize, f = (s - a) / v, d = c * (t[h] - u), m = d * f;
    if (d < 0 || d > v)
      return null;
    var _ = a + m;
    return R(Math.pow(l, _), nt);
  }, r.prototype.range = function() {
    var t = this.options;
    return { min: t.min, max: t.max };
  }, r.prototype.translateRange = function(t) {
    var e = this, i = e.options, a = e.logMin, s = e.logMax, l = i.reverse, p = i.vertical, h = i.majorUnit, c = this.lineBox(), u = p ? c.height() : c.width(), v = u / (s - a), f = R(t / v, nt);
    return (p || l) && !(p && l) && (f = -f), {
      min: Math.pow(h, a + f),
      max: Math.pow(h, s + f),
      offset: f
    };
  }, r.prototype.labelsCount = function() {
    var t = Math.floor(this.logMax), e = Math.floor(t - this.logMin) + 1;
    return e;
  }, r.prototype.getMajorTickPositions = function() {
    var t = [];
    return this.traverseMajorTicksPositions(function(e) {
      t.push(e);
    }, { step: 1, skip: 0 }), t;
  }, r.prototype.createTicks = function(t) {
    var e = this.options, i = e.majorTicks, a = e.minorTicks, s = e.vertical, l = e.labels.mirror, p = this.lineBox(), h = [], c = {
      // TODO
      // _alignLines: options._alignLines,
      vertical: s
    };
    function u(v, f) {
      c.tickX = l ? p.x2 : p.x2 - f.size, c.tickY = l ? p.y1 - f.size : p.y1, c.position = v, t.append(du(c, f));
    }
    return i.visible && this.traverseMajorTicksPositions(u, i), a.visible && this.traverseMinorTicksPositions(u, a), h;
  }, r.prototype.createGridLines = function(t) {
    var e = this.options, i = e.minorGridLines, a = e.majorGridLines, s = e.vertical, l = t.lineBox(), p = {
      lineStart: l[s ? "x1" : "y1"],
      lineEnd: l[s ? "x2" : "y2"],
      vertical: s
    }, h = [], c = this.gridLinesVisual();
    function u(v, f) {
      Z(v, h) || (p.position = v, c.append(gu(p, f)), h.push(v));
    }
    return a.visible && this.traverseMajorTicksPositions(u, a), i.visible && this.traverseMinorTicksPositions(u, i), c.children;
  }, r.prototype.traverseMajorTicksPositions = function(t, e) {
    for (var i = this.lineInfo(), a = i.lineStart, s = i.step, l = this, p = l.logMin, h = l.logMax, c = Math.ceil(p) + e.skip; c <= h; c += e.step) {
      var u = R(a + s * (c - p), nt);
      t(u, e);
    }
  }, r.prototype.traverseMinorTicksPositions = function(t, e) {
    for (var i = this, a = this.options, s = a.min, l = a.max, p = a.minorUnit, h = a.majorUnit, c = this.lineInfo(), u = c.lineStart, v = c.step, f = this, d = f.logMin, m = f.logMax, _ = Math.floor(d), w = _; w < m; w++)
      for (var A = i._minorIntervalOptions(w), T = e.skip; T < p; T += e.step) {
        var k = A.value + T * A.minorStep;
        if (k > l)
          break;
        if (k >= s) {
          var C = R(u + v * (ce(k, h) - d), nt);
          t(C, e);
        }
      }
  }, r.prototype.createAxisLabel = function(t, e, i) {
    var a = Math.ceil(this.logMin + t), s = Math.pow(this.options.majorUnit, a), l = this.axisLabelText(s, e, i);
    return new br(s, l, t, null, e);
  }, r.prototype.shouldRenderNote = function(t) {
    var e = this.range();
    return e.min <= t && t <= e.max;
  }, r.prototype.pan = function(t) {
    var e = this.translateRange(t);
    return this.limitRange(e.min, e.max, this.totalMin, this.totalMax, e.offset);
  }, r.prototype.pointsRange = function(t, e) {
    var i = this.getValue(t), a = this.getValue(e), s = Math.min(i, a), l = Math.max(i, a);
    return {
      min: s,
      max: l
    };
  }, r.prototype.scaleRange = function(t, e) {
    var i = this.options, a = i.majorUnit, s = ce(this.options.min, a), l = ce(this.options.max, a), p = Math.abs(this.pointOffset(e)), h = l - s, c = this.scaleToDelta(t, h), u = Math.pow(a, s + p * c), v = Math.pow(a, l - (1 - p) * c);
    return v - u < qp && (v = u + qp), {
      min: u,
      max: v
    };
  }, r.prototype.zoomRange = function(t, e) {
    var i = this.scaleRange(t, e), a = this, s = a.totalMin, l = a.totalMax;
    return {
      min: j(i.min, s, l),
      max: j(i.max, s, l)
    };
  }, r.prototype._minorIntervalOptions = function(t) {
    var e = this.options, i = e.minorUnit, a = e.majorUnit, s = Math.pow(a, t), l = Math.pow(a, t + 1), p = l - s, h = p / i;
    return {
      value: s,
      minorStep: h
    };
  }, r.prototype.lineInfo = function() {
    var t = n.prototype.lineInfo.call(this);
    return t.step = t.axisDir * (t.lineSize / (this.logMax - this.logMin)), t;
  }, r;
}(gi);
function Qg(n, r, o, t) {
  var e = o.min, i = o.max;
  return P(o.axisCrossingValue) && o.axisCrossingValue <= 0 && La(), P(t.max) ? t.max <= 0 && La() : i = r, P(t.min) ? t.min <= 0 && La() : e = n, {
    min: e,
    max: i
  };
}
function Kg(n, r, o) {
  var t = o.majorUnit, e = n;
  return n <= 0 ? e = r <= 1 ? Math.pow(t, -2) : 1 : o.narrowRange || (e = Math.pow(t, Math.floor(ce(n, t)))), e;
}
function Jg(n, r) {
  var o = R(ce(n, r), nt) % 1, t;
  return n <= 0 ? t = r : o !== 0 && (o < 0.3 || o > 0.9) ? t = Math.pow(r, ce(n, r) + 0.2) : t = Math.pow(r, Math.ceil(ce(n, r))), t;
}
function La() {
  throw new Error("Non positive values cannot be used for a logarithmic axis");
}
function ce(n, r) {
  return Math.log(n) / Math.log(r);
}
O(Gn, {
  type: "log",
  majorUnit: Tu,
  minorUnit: 1,
  axisCrossingValue: 1,
  vertical: !0,
  majorGridLines: {
    visible: !0,
    width: 1,
    color: yt
  },
  zIndex: 1,
  _deferLabels: !0
});
var Cu = {
  createGridLines: function(n) {
    var r = this.options, o = Math.abs(this.box.center().y - n.lineBox().y1), t = [], e = !1, i, a;
    return r.majorGridLines.visible && (i = this.majorGridLineAngles(n), e = !0, t = this.renderMajorGridLines(
      i,
      o,
      r.majorGridLines
    )), r.minorGridLines.visible && (a = this.minorGridLineAngles(n, e), Nr(t, this.renderMinorGridLines(
      a,
      o,
      r.minorGridLines,
      n,
      e
    ))), t;
  },
  renderMajorGridLines: function(n, r, o) {
    return this.renderGridLines(n, r, o);
  },
  renderMinorGridLines: function(n, r, o, t, e) {
    var i = this.radiusCallback && this.radiusCallback(r, t, e);
    return this.renderGridLines(n, r, o, i);
  },
  renderGridLines: function(n, r, o, t) {
    for (var e = {
      stroke: {
        width: o.width,
        color: o.color,
        dashType: o.dashType
      }
    }, i = this.box.center(), a = new ve([i.x, i.y], r), s = this.gridLinesVisual(), l = 0; l < n.length; l++) {
      var p = new H(e);
      t && (a.radius = t(n[l])), p.moveTo(a.center).lineTo(a.pointAt(n[l] + 180)), s.append(p);
    }
    return s.children;
  },
  gridLineAngles: function(n, r, o, t, e) {
    var i = this, a = this.intervals(r, o, t, e), s = n.options, l = s.visible && (s.line || {}).visible !== !1;
    return ru(a, function(p) {
      var h = i.intervalAngle(p);
      if (!l || h !== 90)
        return h;
    });
  }
}, eo = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.range = function() {
    return { min: 0, max: this.options.categories.length };
  }, r.prototype.reflow = function(t) {
    this.box = t, this.reflowLabels();
  }, r.prototype.lineBox = function() {
    return this.box;
  }, r.prototype.reflowLabels = function() {
    for (var t = this, e = this, i = e.labels, a = e.options.labels, s = a.skip || 0, l = a.step || 1, p = new L(), h = 0; h < i.length; h++) {
      i[h].reflow(p);
      var c = i[h].box;
      i[h].reflow(t.getSlot(s + h * l).adjacentBox(
        0,
        c.width(),
        c.height()
      ));
    }
  }, r.prototype.intervals = function(t, e, i, a) {
    a === void 0 && (a = !1);
    for (var s = this.options, l = s.categories.length, p = l / t || 1, h = 360 / p, c = e || 0, u = i || 1, v = [], f = 0, d = c; d < p; d += u)
      s.reverse ? f = 360 - d * h : f = d * h, f = R(f, Tt) % 360, a && Z(f, a) || v.push(f);
    return v;
  }, r.prototype.majorIntervals = function() {
    return this.intervals(1);
  }, r.prototype.minorIntervals = function() {
    return this.intervals(0.5);
  }, r.prototype.intervalAngle = function(t) {
    return (360 + t + this.options.startAngle) % 360;
  }, r.prototype.majorAngles = function() {
    var t = this;
    return ru(this.majorIntervals(), function(e) {
      return t.intervalAngle(e);
    });
  }, r.prototype.createLine = function() {
    return [];
  }, r.prototype.majorGridLineAngles = function(t) {
    var e = this.options.majorGridLines;
    return this.gridLineAngles(t, 1, e.skip, e.step);
  }, r.prototype.minorGridLineAngles = function(t, e) {
    var i = this.options, a = i.minorGridLines, s = i.majorGridLines, l = e ? this.intervals(1, s.skip, s.step) : null;
    return this.gridLineAngles(t, 0.5, a.skip, a.step, l);
  }, r.prototype.radiusCallback = function(t, e, i) {
    if (e.options.type !== mr) {
      var a = _t(360 / (this.options.categories.length * 2)), s = Math.cos(a) * t, l = this.majorAngles(), p = function(h) {
        return !i && Z(h, l) ? t : s;
      };
      return p;
    }
  }, r.prototype.createPlotBands = function() {
    for (var t = this, e = this.options.plotBands || [], i = this._plotbandGroup = new pt({
      zIndex: -1
    }), a = 0; a < e.length; a++) {
      var s = e[a], l = t.plotBandSlot(s), p = t.getSlot(s.from), h = s.from - Math.floor(s.from);
      l.startAngle += h * p.angle;
      var c = Math.ceil(s.to) - s.to;
      l.angle -= (c + h) * p.angle;
      var u = oi.current.createRing(l, {
        fill: {
          color: s.color,
          opacity: s.opacity
        },
        stroke: {
          opacity: s.opacity
        }
      });
      i.append(u);
    }
    this.appendVisual(i);
  }, r.prototype.plotBandSlot = function(t) {
    return this.getSlot(t.from, t.to - 1);
  }, r.prototype.getSlot = function(t, e) {
    var i = this.options, a = i.justified, s = this.box, l = this.majorAngles(), p = l.length, h = 360 / p, c = t;
    i.reverse && !a && (c = (c + 1) % p), c = j(Math.floor(c), 0, p - 1);
    var u = l[c];
    a && (u = u - h / 2, u < 0 && (u += 360));
    var v = j(Math.ceil(e || c), c, p - 1), f = v - c + 1, d = h * f;
    return new go(s.center(), 0, s.height() / 2, u, d);
  }, r.prototype.slot = function(t, e) {
    var i = this.getSlot(t, e), a = i.startAngle + 180, s = a + i.angle;
    return new ri([i.center.x, i.center.y], {
      startAngle: a,
      endAngle: s,
      radiusX: i.radius,
      radiusY: i.radius
    });
  }, r.prototype.pointCategoryIndex = function(t) {
    for (var e = this, i = this.options.categories.length, a = null, s = 0; s < i; s++) {
      var l = e.getSlot(s);
      if (l.containsPoint(t)) {
        a = s;
        break;
      }
    }
    return a;
  }, r;
}(Me);
O(eo, {
  startAngle: 90,
  labels: {
    margin: ot(10)
  },
  majorGridLines: {
    visible: !0
  },
  justified: !0
});
b(eo.prototype, Cu);
var ll = function(n) {
  function r(o, t) {
    n.call(this, o, t);
    var e = this.options;
    e.minorUnit = e.minorUnit || e.majorUnit / 2;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.getDivisions = function(t) {
    return oe.prototype.getDivisions.call(this, t) - 1;
  }, r.prototype.reflow = function(t) {
    this.box = t, this.reflowLabels();
  }, r.prototype.reflowLabels = function() {
    for (var t = this, e = this, i = e.options, a = e.labels, s = e.options.labels, l = s.skip || 0, p = s.step || 1, h = new L(), c = this.intervals(i.majorUnit, l, p), u = 0; u < a.length; u++) {
      a[u].reflow(h);
      var v = a[u].box;
      a[u].reflow(t.getSlot(c[u]).adjacentBox(0, v.width(), v.height()));
    }
  }, r.prototype.lineBox = function() {
    return this.box;
  }, r.prototype.intervals = function(t, e, i, a) {
    a === void 0 && (a = !1);
    for (var s = this.options.min, l = this.getDivisions(t), p = [], h = e || 0, c = i || 1, u = h; u < l; u += c) {
      var v = (360 + s + u * t) % 360;
      a && Z(v, a) || p.push(v);
    }
    return p;
  }, r.prototype.majorIntervals = function() {
    return this.intervals(this.options.majorUnit);
  }, r.prototype.minorIntervals = function() {
    return this.intervals(this.options.minorUnit);
  }, r.prototype.intervalAngle = function(t) {
    return (540 - t - this.options.startAngle) % 360;
  }, r.prototype.createLine = function() {
    return [];
  }, r.prototype.majorGridLineAngles = function(t) {
    var e = this.options.majorGridLines;
    return this.gridLineAngles(t, this.options.majorUnit, e.skip, e.step);
  }, r.prototype.minorGridLineAngles = function(t, e) {
    var i = this.options, a = i.minorGridLines, s = i.majorGridLines, l = e ? this.intervals(i.majorUnit, s.skip, s.step) : null;
    return this.gridLineAngles(t, i.minorUnit, a.skip, a.step, l);
  }, r.prototype.plotBandSlot = function(t) {
    return this.getSlot(t.from, t.to);
  }, r.prototype.getSlot = function(t, e) {
    var i = this, a = i.options, s = i.box, l = a.startAngle, p = j(t, a.min, a.max), h = j(e || p, p, a.max);
    if (a.reverse && (p *= -1, h *= -1), p = (540 - p - l) % 360, h = (540 - h - l) % 360, h < p) {
      var c = p;
      p = h, h = c;
    }
    return new go(s.center(), 0, s.height() / 2, p, h - p);
  }, r.prototype.slot = function(t, e) {
    e === void 0 && (e = t);
    var i = this.options, a = 360 - i.startAngle, s = this.getSlot(t, e), l = Math.min(t, e), p = Math.max(t, e), h, c;
    return i.reverse ? (h = l, c = p) : (h = 360 - p, c = 360 - l), h = (h + a) % 360, c = (c + a) % 360, new ri([s.center.x, s.center.y], {
      startAngle: h,
      endAngle: c,
      radiusX: s.radius,
      radiusY: s.radius
    });
  }, r.prototype.getValue = function(t) {
    var e = this.options, i = this.box.center(), a = t.x - i.x, s = t.y - i.y, l = Math.round(gr(Math.atan2(s, a))), p = e.startAngle;
    return e.reverse || (l *= -1, p *= -1), (l + p + 360) % 360;
  }, r.prototype.valueRange = function() {
    return {
      min: 0,
      max: Math.PI * 2
    };
  }, r;
}(gi);
O(ll, {
  type: "polar",
  startAngle: 0,
  reverse: !1,
  majorUnit: 60,
  min: 0,
  max: 360,
  labels: {
    margin: ot(10)
  },
  majorGridLines: {
    color: yt,
    visible: !0,
    width: 1
  },
  minorGridLines: {
    color: "#aaa"
  }
});
b(ll.prototype, Cu, {
  createPlotBands: eo.prototype.createPlotBands,
  majorAngles: eo.prototype.majorAngles,
  range: oe.prototype.range,
  labelsCount: oe.prototype.labelsCount,
  createAxisLabel: oe.prototype.createAxisLabel
});
var ku = {
  options: {
    majorGridLines: {
      visible: !0
    }
  },
  createPlotBands: function() {
    var n = this, r = this.options, o = r.majorGridLines.type, t = r.plotBands;
    t === void 0 && (t = []);
    for (var e = this.plotArea.polarAxis, i = e.majorAngles(), a = e.box.center(), s = this._plotbandGroup = new pt({
      zIndex: -1
    }), l = 0; l < t.length; l++) {
      var p = t[l], h = {
        fill: {
          color: p.color,
          opacity: p.opacity
        },
        stroke: {
          opacity: p.opacity
        }
      }, c = n.getSlot(p.from, p.to, !0), u = new go(a, a.y - c.y2, a.y - c.y1, 0, 360), v = void 0;
      o === mr ? v = oi.current.createRing(u, h) : v = H.fromPoints(n.plotBandPoints(u, i), h).close(), s.append(v);
    }
    this.appendVisual(s);
  },
  plotBandPoints: function(n, r) {
    for (var o = [], t = [], e = [n.center.x, n.center.y], i = new ve(e, n.innerRadius), a = new ve(e, n.radius), s = 0; s < r.length; s++)
      o.push(i.pointAt(r[s] + 180)), t.push(a.pointAt(r[s] + 180));
    return o.reverse(), o.push(o[0]), t.push(t[0]), t.concat(o);
  },
  createGridLines: function(n) {
    var r = this.options, o = this.radarMajorGridLinePositions(), t = n.majorAngles(), e = n.box.center(), i = [];
    if (r.majorGridLines.visible && (i = this.renderGridLines(
      e,
      o,
      t,
      r.majorGridLines
    )), r.minorGridLines.visible) {
      var a = this.radarMinorGridLinePositions();
      Nr(i, this.renderGridLines(
        e,
        a,
        t,
        r.minorGridLines
      ));
    }
    return i;
  },
  renderGridLines: function(n, r, o, t) {
    var e = {
      stroke: {
        width: t.width,
        color: t.color,
        dashType: t.dashType
      }
    }, i = t.skip;
    i === void 0 && (i = 0);
    var a = t.step;
    a === void 0 && (a = 0);
    for (var s = this.gridLinesVisual(), l = i; l < r.length; l += a) {
      var p = n.y - r[l];
      if (p > 0) {
        var h = new ve([n.x, n.y], p);
        if (t.type === mr)
          s.append(new Je(h, e));
        else {
          for (var c = new H(e), u = 0; u < o.length; u++)
            c.lineTo(h.pointAt(o[u] + 180));
          c.close(), s.append(c);
        }
      }
    }
    return s.children;
  },
  getValue: function(n) {
    var r = this.lineBox(), o = this.plotArea.polarAxis, t = o.majorAngles(), e = o.box.center(), i = n.distanceTo(e), a = i;
    if (this.options.majorGridLines.type !== mr && t.length > 1) {
      var s = n.x - e.x, l = n.y - e.y, p = (gr(Math.atan2(l, s)) + 540) % 360;
      t.sort(function(f, d) {
        return Ko(f, p) - Ko(d, p);
      });
      var h = Ko(t[0], t[1]) / 2, c = Ko(p, t[0]), u = 90 - h, v = 180 - c - u;
      a = i * (Math.sin(_t(v)) / Math.sin(_t(u)));
    }
    return this.axisType().prototype.getValue.call(
      this,
      new F(r.x1, r.y2 - a)
    );
  }
};
function Ko(n, r) {
  return 180 - Math.abs(Math.abs(n - r) - 180);
}
var Pu = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.radarMajorGridLinePositions = function() {
    return this.getTickPositions(this.options.majorUnit);
  }, r.prototype.radarMinorGridLinePositions = function() {
    var t = this.options, e = 0;
    return t.majorGridLines.visible && (e = t.majorUnit), this.getTickPositions(t.minorUnit, e);
  }, r.prototype.axisType = function() {
    return n;
  }, r;
}(oe);
b(Pu.prototype, ku);
var Ou = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.radarMajorGridLinePositions = function() {
    var t = [];
    return this.traverseMajorTicksPositions(function(e) {
      t.push(e);
    }, this.options.majorGridLines), t;
  }, r.prototype.radarMinorGridLinePositions = function() {
    var t = [];
    return this.traverseMinorTicksPositions(function(e) {
      t.push(e);
    }, this.options.minorGridLines), t;
  }, r.prototype.axisType = function() {
    return n;
  }, r;
}(Gn);
b(Ou.prototype, ku);
var Zp = 0.333, ty = 0.01, Wn = function(n) {
  function r(o) {
    n.call(this), this.closed = o;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.process = function(t) {
    var e = this, i = t.slice(0), a = [], s = this.closed, l = i.length;
    if (l > 2 && (this.removeDuplicates(0, i), l = i.length), l < 2 || l === 2 && i[0].equals(i[1]))
      return a;
    var p = i[0], h = i[1], c = i[2];
    for (a.push(new We(p)); p.equals(i[l - 1]); )
      s = !0, i.pop(), l--;
    if (l === 2) {
      var u = this.tangent(p, h, D, B);
      return dt(a).controlOut(
        this.firstControlPoint(u, p, h, D, B)
      ), a.push(new We(
        h,
        this.secondControlPoint(u, p, h, D, B)
      )), a;
    }
    var v, f;
    if (s) {
      p = i[l - 1], h = i[0], c = i[1];
      var d = this.controlPoints(p, h, c);
      v = d[1], f = d[0];
    } else {
      var m = this.tangent(p, h, D, B);
      v = this.firstControlPoint(m, p, h, D, B);
    }
    for (var _ = v, w = 0; w <= l - 3; w++)
      if (e.removeDuplicates(w, i), l = i.length, w + 3 <= l) {
        p = i[w], h = i[w + 1], c = i[w + 2];
        var A = e.controlPoints(p, h, c);
        dt(a).controlOut(_), _ = A[1];
        var T = A[0];
        a.push(new We(h, T));
      }
    if (s) {
      p = i[l - 2], h = i[l - 1], c = i[0];
      var k = this.controlPoints(p, h, c);
      dt(a).controlOut(_), a.push(new We(
        h,
        k[0]
      )), dt(a).controlOut(k[1]), a.push(new We(
        c,
        f
      ));
    } else {
      var C = this.tangent(h, c, D, B);
      dt(a).controlOut(_), a.push(new We(
        c,
        this.secondControlPoint(C, h, c, D, B)
      ));
    }
    return a;
  }, r.prototype.removeDuplicates = function(t, e) {
    for (; e[t + 1] && (e[t].equals(e[t + 1]) || e[t + 1].equals(e[t + 2])); )
      e.splice(t + 1, 1);
  }, r.prototype.invertAxis = function(t, e, i) {
    var a = !1;
    if (t.x === e.x)
      a = !0;
    else if (e.x === i.x)
      (e.y < i.y && t.y <= e.y || i.y < e.y && e.y <= t.y) && (a = !0);
    else {
      var s = this.lineFunction(t, e), l = this.calculateFunction(s, i.x);
      !(t.y <= e.y && i.y <= l) && !(e.y <= t.y && i.y >= l) && (a = !0);
    }
    return a;
  }, r.prototype.isLine = function(t, e, i) {
    var a = this.lineFunction(t, e), s = this.calculateFunction(a, i.x);
    return t.x === e.x && e.x === i.x || R(s, 1) === R(i.y, 1);
  }, r.prototype.lineFunction = function(t, e) {
    var i = (e.y - t.y) / (e.x - t.x), a = t.y - i * t.x;
    return [a, i];
  }, r.prototype.controlPoints = function(t, e, i) {
    var a = D, s = B, l = !1, p = !1, h;
    if (this.isLine(t, e, i))
      h = this.tangent(t, e, D, B);
    else {
      var c = {
        x: this.isMonotonicByField(t, e, i, D),
        y: this.isMonotonicByField(t, e, i, B)
      };
      if (c.x && c.y)
        h = this.tangent(t, i, D, B), l = !0;
      else if (this.invertAxis(t, e, i) && (a = B, s = D), c[a])
        h = 0;
      else {
        var u;
        i[s] < t[s] && t[s] <= e[s] || t[s] < i[s] && e[s] <= t[s] ? u = Qp((i[s] - t[s]) * (e[a] - t[a])) : u = -Qp((i[a] - t[a]) * (e[s] - t[s])), h = ty * u, p = !0;
      }
    }
    var v = this.secondControlPoint(h, t, e, a, s);
    if (p) {
      var f = a;
      a = s, s = f;
    }
    var d = this.firstControlPoint(h, e, i, a, s);
    return l && (this.restrictControlPoint(t, e, v, h), this.restrictControlPoint(e, i, d, h)), [v, d];
  }, r.prototype.restrictControlPoint = function(t, e, i, a) {
    t.y < e.y ? e.y < i.y ? (i.x = t.x + (e.y - t.y) / a, i.y = e.y) : i.y < t.y && (i.x = e.x - (e.y - t.y) / a, i.y = t.y) : i.y < e.y ? (i.x = t.x - (t.y - e.y) / a, i.y = e.y) : t.y < i.y && (i.x = e.x + (t.y - e.y) / a, i.y = t.y);
  }, r.prototype.tangent = function(t, e, i, a) {
    var s = e[i] - t[i], l = e[a] - t[a], p;
    return s === 0 ? p = 0 : p = l / s, p;
  }, r.prototype.isMonotonicByField = function(t, e, i, a) {
    return i[a] > e[a] && e[a] > t[a] || i[a] < e[a] && e[a] < t[a];
  }, r.prototype.firstControlPoint = function(t, e, i, a, s) {
    var l = e[a], p = i[a], h = (p - l) * Zp;
    return this.point(l + h, e[s] + h * t, a, s);
  }, r.prototype.secondControlPoint = function(t, e, i, a, s) {
    var l = e[a], p = i[a], h = (p - l) * Zp;
    return this.point(p - h, i[s] - h * t, a, s);
  }, r.prototype.point = function(t, e, i, a) {
    var s = new q();
    return s[i] = t, s[a] = e, s;
  }, r.prototype.calculateFunction = function(t, e) {
    for (var i = t.length, a = 0, s = 0; s < i; s++)
      a += Math.pow(e, s) * t[s];
    return a;
  }, r;
}(N);
function Qp(n) {
  return n <= 0 ? -1 : 1;
}
var ey = function(n) {
  function r(o) {
    n.call(this), this._axis = o, this.options = o.options;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.value = function(t) {
    var e = this._axis, i = e.getCategory ? e.getCategory(t) : e.getValue(t);
    return i;
  }, r.prototype.slot = function(t, e, i) {
    return i === void 0 && (i = !0), this._axis.slot(t, e, i);
  }, r.prototype.range = function() {
    return this._axis.range();
  }, r.prototype.valueRange = function() {
    return this._axis.valueRange();
  }, r;
}(N);
function Eu(n, r) {
  for (var o = 0; o < r.length; o++)
    if (r[o].options.name === n)
      return r[o].prepareUserOptions(), new ey(r[o]);
}
var Tn = function(r) {
  this.visual = r.visual, this.chartsVisual = r.chartContainer.visual, this._pane = r;
};
Tn.prototype.findAxisByName = function(r) {
  return Eu(r, this._pane.axes);
};
var ry = function(n) {
  function r(o) {
    n.call(this), this._plotArea = o, this.visual = o.visual, this.backgroundVisual = o._bgVisual;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(N);
function ts(n) {
  for (var r = n.length, o = 0, t = 0; t < r; t++) {
    var e = n[t];
    Y(e) && o++;
  }
  return o;
}
var es = {
  min: function(n) {
    for (var r = n.length, o = gt, t = 0; t < r; t++) {
      var e = n[t];
      Y(e) && (o = Math.min(o, e));
    }
    return o === gt ? n[0] : o;
  },
  max: function(n) {
    for (var r = n.length, o = xt, t = 0; t < r; t++) {
      var e = n[t];
      Y(e) && (o = Math.max(o, e));
    }
    return o === xt ? n[0] : o;
  },
  sum: function(n) {
    for (var r = n.length, o = 0, t = 0; t < r; t++) {
      var e = n[t];
      Y(e) && (o += e);
    }
    return o;
  },
  sumOrNull: function(n) {
    var r = null;
    return ts(n) && (r = es.sum(n)), r;
  },
  count: function(n) {
    for (var r = n.length, o = 0, t = 0; t < r; t++) {
      var e = n[t];
      e !== null && P(e) && o++;
    }
    return o;
  },
  avg: function(n) {
    var r = ts(n), o = n[0];
    return r > 0 && (o = es.sum(n) / r), o;
  },
  first: function(n) {
    for (var r = n.length, o = 0; o < r; o++) {
      var t = n[o];
      if (t !== null && P(t))
        return t;
    }
    return n[0];
  }
};
function Cn(n, r) {
  if (r === null)
    return r;
  var o = Qe(n);
  return o(r);
}
var ht = function(n) {
  function r() {
    n.call(this), this._valueFields = {}, this._otherFields = {}, this._nullValue = {}, this._undefinedValue = {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.register = function(t, e, i) {
    var a = this;
    e === void 0 && (e = [Xt]), i === void 0 && (i = {});
    for (var s = 0; s < t.length; s++) {
      var l = t[s];
      a._valueFields[l] = e, a._otherFields[l] = i, a._nullValue[l] = a._makeValue(e, null), a._undefinedValue[l] = a._makeValue(e, void 0);
    }
  }, r.prototype.canonicalFields = function(t) {
    return this.valueFields(t).concat(this.otherFields(t));
  }, r.prototype.valueFields = function(t) {
    return this._valueFields[t.type] || [Xt];
  }, r.prototype.otherFields = function(t) {
    return this._otherFields[t.type] || [Xt];
  }, r.prototype.bindPoint = function(t, e, i) {
    var a = t.data, s = P(i) ? i : a[e], l = { valueFields: { value: s } }, p = this.valueFields(t), h = this._otherFields[t.type], c, u;
    if (s === null)
      u = this._nullValue[t.type];
    else if (!P(s))
      u = this._undefinedValue[t.type];
    else if (Array.isArray(s)) {
      var v = s.slice(p.length);
      u = this._bindFromArray(s, p), c = this._bindFromArray(v, h);
    } else if (typeof s == "object") {
      var f = this.sourceFields(t, p), d = this.sourceFields(t, h);
      u = this._bindFromObject(s, p, f), c = this._bindFromObject(s, h, d);
    }
    return P(u) && (p.length === 1 ? l.valueFields.value = u[p[0]] : l.valueFields = u), l.fields = c || {}, l;
  }, r.prototype._makeValue = function(t, e) {
    for (var i = {}, a = t.length, s = 0; s < a; s++) {
      var l = t[s];
      i[l] = e;
    }
    return i;
  }, r.prototype._bindFromArray = function(t, e) {
    var i = {};
    if (e)
      for (var a = Math.min(e.length, t.length), s = 0; s < a; s++)
        i[e[s]] = t[s];
    return i;
  }, r.prototype._bindFromObject = function(t, e, i) {
    i === void 0 && (i = e);
    var a = {};
    if (e)
      for (var s = e.length, l = 0; l < s; l++) {
        var p = e[l], h = i[l];
        h !== null && (a[p] = Cn(h, t));
      }
    return a;
  }, r.prototype.sourceFields = function(t, e) {
    var i = [];
    if (e)
      for (var a = e.length, s = 0; s < a; s++) {
        var l = e[s], p = l === Xt ? "field" : l + "Field";
        i.push(t[p] !== null ? t[p] || l : null);
      }
    return i;
  }, r;
}(N);
ht.current = new ht();
var iy = "stderr", oy = "stddev", ny = /percent(?:\w*)\((\d+)\)/, ay = new RegExp("^" + oy + "(?:\\((\\d+(?:\\.\\d+)?)\\))?$"), Mu = function(n) {
  function r(o, t, e) {
    n.call(this), this.initGlobalRanges(o, t, e);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initGlobalRanges = function(t, e, i) {
    var a = e.data, s = ay.exec(t);
    if (s) {
      this.valueGetter = this.createValueGetter(e, i);
      var l = this.getAverage(a), p = this.getStandardDeviation(a, l, !1), h = s[1] ? parseFloat(s[1]) : 1, c = { low: l.value - p * h, high: l.value + p * h };
      this.globalRange = function() {
        return c;
      };
    } else if (t.indexOf && t.indexOf(iy) >= 0) {
      this.valueGetter = this.createValueGetter(e, i);
      var u = this.getStandardError(a, this.getAverage(a));
      this.globalRange = function(v) {
        return { low: v - u, high: v + u };
      };
    }
  }, r.prototype.createValueGetter = function(t, e) {
    var i = t.data, a = ht.current, s = a.valueFields(t), l = P(i[0]) ? i[0] : {}, p;
    if (Ot(l)) {
      var h = e ? s.indexOf(e) : 0;
      p = Qe("[" + h + "]");
    } else if (Y(l))
      p = Qe();
    else if (typeof l === Za) {
      var c = a.sourceFields(t, s);
      p = Qe(c[s.indexOf(e)]);
    }
    return p;
  }, r.prototype.getErrorRange = function(t, e) {
    var i, a, s;
    if (!P(e))
      return null;
    if (this.globalRange)
      return this.globalRange(t);
    if (Ot(e))
      i = t - e[0], a = t + e[1];
    else if (Y(s = parseFloat(e)))
      i = t - s, a = t + s;
    else if (s = ny.exec(e)) {
      var l = t * (parseFloat(s[1]) / 100);
      i = t - Math.abs(l), a = t + Math.abs(l);
    } else
      throw new Error("Invalid ErrorBar value: " + e);
    return { low: i, high: a };
  }, r.prototype.getStandardError = function(t, e) {
    return this.getStandardDeviation(t, e, !0) / Math.sqrt(e.count);
  }, r.prototype.getStandardDeviation = function(t, e, i) {
    for (var a = this, s = t.length, l = i ? e.count - 1 : e.count, p = 0, h = 0; h < s; h++) {
      var c = a.valueGetter(t[h]);
      Y(c) && (p += Math.pow(c - e.value, 2));
    }
    return Math.sqrt(p / l);
  }, r.prototype.getAverage = function(t) {
    for (var e = this, i = t.length, a = 0, s = 0, l = 0; l < i; l++) {
      var p = e.valueGetter(t[l]);
      Y(p) && (a += p, s++);
    }
    return {
      value: a / s,
      count: s
    };
  }, r;
}(N), sy = Uc.browser || {}, ne = 600, Cr = "fadeIn", Xn = 0.8, ue = 5, ro = sy.msie ? 1e-3 : 0, Ru = "errorLow", Lu = "errorHigh", ly = "xErrorLow", py = "xErrorHigh", hy = "yErrorLow", cy = "yErrorHigh", kn = 8, ir = "zero", ni = "interpolate", Kp = "gap", Pn = "above", rs = "below", mi = "smooth", Ji = "step", wo = "area", ye = "bar", bo = "boxPlot", _i = "bubble", Ar = "bullet", xi = "candlestick", or = "column", On = "donut", io = "funnel", oo = "pyramid", pl = "heatmap", ai = "horizontalWaterfall", Ao = "line", So = "ohlc", Sr = "pie", hl = "polarArea", cl = "polarLine", ul = "polarScatter", Yn = "radarArea", qn = "radarColumn", Zn = "radarLine", To = "rangeArea", si = "rangeBar", Co = "rangeColumn", vl = "scatter", fl = "scatterLine", li = "verticalArea", pi = "verticalBoxPlot", ko = "verticalBullet", hi = "verticalLine", ci = "verticalRangeArea", Po = "waterfall", Iu = [
  ye,
  or,
  So,
  xi,
  bo,
  pi,
  Ar,
  Co,
  si,
  Po,
  ai
], uy = "legendItemClick", vy = "legendItemHover", fy = "legendItemLeave", Du = "seriesClick", Bu = "seriesHover", zu = "seriesOver", ju = "seriesLeave", dy = "plotAreaClick", Vu = "plotAreaHover", Ia = "plotAreaLeave", Xi = "drag", Yi = "dragEnd", Da = "dragStart", Ni = "zoomStart", Zr = "zoom", Qr = "zoomEnd", is = "selectStart", qi = "select", os = "selectEnd", gy = "render", Nu = "showTooltip", Hu = "hideTooltip", yy = "paneRender", En = "log", Be = "category", Mn = "insideEnd", my = "insideBase", Ir = "outsideEnd", Rn = "wheel", ns = 150, _y = 0.3, xy = "drilldown", lr = "drilldown", Jp = 4, dl = function(n) {
  function r(o, t, e, i, a, s) {
    n.call(this, s), this.low = o, this.high = t, this.isVertical = e, this.chart = i, this.series = a;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this.options.endCaps, i = this.isVertical, a = this.getAxis(), s = a.getSlot(this.low, this.high), l = t.center(), p = this.getCapsWidth(t, i), h = i ? l.x : l.y, c = h - p, u = h + p, v;
    i ? (v = [
      new F(l.x, s.y1),
      new F(l.x, s.y2)
    ], e && v.push(
      new F(c, s.y1),
      new F(u, s.y1),
      new F(c, s.y2),
      new F(u, s.y2)
    ), this.box = new L(c, s.y1, u, s.y2)) : (v = [
      new F(s.x1, l.y),
      new F(s.x2, l.y)
    ], e && v.push(
      new F(s.x1, c),
      new F(s.x1, u),
      new F(s.x2, c),
      new F(s.x2, u)
    ), this.box = new L(s.x1, c, s.x2, u)), this.linePoints = v;
  }, r.prototype.getCapsWidth = function(t, e) {
    var i = e ? t.width() : t.height(), a = Math.min(Math.floor(i / 2), Jp) || Jp;
    return a;
  }, r.prototype.createVisual = function() {
    var t = this, e = this.options, i = e.visual;
    i ? this.visual = i({
      low: this.low,
      high: this.high,
      rect: this.box.toRect(),
      sender: this.getSender(),
      options: {
        endCaps: e.endCaps,
        color: e.color,
        line: e.line
      },
      createVisual: function() {
        t.createDefaultVisual();
        var a = t.visual;
        return delete t.visual, a;
      }
    }) : this.createDefaultVisual();
  }, r.prototype.createDefaultVisual = function() {
    var t = this, e = this, i = e.options, a = e.linePoints, s = {
      stroke: {
        color: i.color,
        width: i.line.width,
        dashType: i.line.dashType
      }
    };
    n.prototype.createVisual.call(this);
    for (var l = 0; l < a.length; l += 2) {
      var p = new H(s).moveTo(a[l].x, a[l].y).lineTo(a[l + 1].x, a[l + 1].y);
      ae(p), t.visual.append(p);
    }
  }, r;
}(rt);
O(dl, {
  animation: {
    type: Cr,
    delay: ne
  },
  endCaps: !0,
  line: {
    width: 2
  },
  zIndex: 1
});
var wy = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.getAxis = function() {
    var t = this.chart.seriesValueAxis(this.series);
    return t;
  }, r;
}(dl), by = 5;
function nr(n, r, o, t) {
  o === void 0 && (o = {}), t === void 0 && (t = !1);
  var e = o.defaults = o.defaults || {}, i = o.depth = o.depth || 0, a = !1;
  if (o.excluded = o.excluded || [], i > by)
    return null;
  for (var s in n)
    if (!Z(s, o.excluded) && n.hasOwnProperty(s)) {
      var l = n[s];
      vt(l) ? (a = !0, t || (n[s] = U(l(r), e[s]))) : le(l) && (t || (o.defaults = e[s]), o.depth++, a = nr(l, r, o, t) || a, o.depth--);
    }
  return a;
}
function gl(n) {
  for (var r = n.length, o = 0, t = 0; t < r; t++)
    o = Math.max(o, n[t].data.length);
  return o;
}
var ze = function(n) {
  function r(o, t) {
    n.call(this, t), this.plotArea = o, this.chartService = o.chartService, this.categoryAxis = o.seriesCategoryAxis(t.series[0]), this.valueAxisRanges = {}, this.points = [], this.categoryPoints = [], this.seriesPoints = [], this.seriesOptions = [], this._evalSeries = [], this.render();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this.traverseDataPoints(this.addValue.bind(this));
  }, r.prototype.pointOptions = function(t, e) {
    var i = this.seriesOptions[e];
    if (!i) {
      var a = this.pointType().prototype.defaults;
      this.seriesOptions[e] = i = b({}, a, {
        vertical: !this.options.invertAxes
      }, t);
    }
    return i;
  }, r.prototype.plotValue = function(t) {
    if (!t)
      return 0;
    if (this.options.isStacked100 && Y(t.value)) {
      for (var e = t.categoryIx, i = this.categoryPoints[e], a = [], s = 0, l = 0; l < i.length; l++) {
        var p = i[l];
        if (p) {
          var h = t.series.stack, c = p.series.stack;
          if (h && c && h.group !== c.group)
            continue;
          Y(p.value) && (s += Math.abs(p.value), a.push(Math.abs(p.value)));
        }
      }
      if (s > 0)
        return t.value / s;
    }
    return t.value;
  }, r.prototype.plotRange = function(t, e) {
    var i = this;
    e === void 0 && (e = 0);
    var a = this.categoryPoints[t.categoryIx];
    if (this.options.isStacked) {
      for (var s = this.plotValue(t), l = s >= 0, p = e, h = !1, c = 0; c < a.length; c++) {
        var u = a[c];
        if (t === u)
          break;
        var v = t.series.stack, f = u.series.stack;
        if (!(v && f && (typeof v === Ws && v !== f || v.group && v.group !== f.group))) {
          var d = i.plotValue(u);
          (d >= 0 && l || d < 0 && !l) && (p += d, s += d, h = !0, i.options.isStacked100 && (s = Math.min(s, 1)));
        }
      }
      return h && (p -= e), [p, s];
    }
    var m = t.series, _ = this.seriesValueAxis(m), w = this.categoryAxisCrossingValue(_);
    return [w, Jc(t.value) ? t.value : w];
  }, r.prototype.stackLimits = function(t, e) {
    for (var i = this, a = gt, s = xt, l = 0; l < this.categoryPoints.length; l++) {
      var p = i.categoryPoints[l];
      if (p)
        for (var h = 0; h < p.length; h++) {
          var c = p[h];
          if (c && (c.series.stack === e || c.series.axis === t)) {
            var u = i.plotRange(c, 0)[1];
            P(u) && isFinite(u) && (s = Math.max(s, u), a = Math.min(a, u));
          }
        }
    }
    return { min: a, max: s };
  }, r.prototype.updateStackRange = function() {
    var t = this, e = this.options, i = e.isStacked, a = e.series, s = {};
    if (i)
      for (var l = 0; l < a.length; l++) {
        var p = a[l], h = p.axis, c = h + p.stack, u = s[c];
        if (!u) {
          u = t.stackLimits(h, p.stack);
          var v = t.errorTotals;
          v && (v.negative.length && (u.min = Math.min(u.min, Qa(v.negative).min)), v.positive.length && (u.max = Math.max(u.max, Qa(v.positive).max))), u.min !== gt || u.max !== xt ? s[c] = u : u = null;
        }
        u && (t.valueAxisRanges[h] = u);
      }
  }, r.prototype.addErrorBar = function(t, e, i) {
    var a = t.value, s = t.series, l = t.seriesIx, p = t.options.errorBars, h = e.fields[Ru], c = e.fields[Lu], u;
    Y(h) && Y(c) ? u = { low: h, high: c } : p && P(p.value) && (this.seriesErrorRanges = this.seriesErrorRanges || [], this.seriesErrorRanges[l] = this.seriesErrorRanges[l] || new Mu(p.value, s, Xt), u = this.seriesErrorRanges[l].getErrorRange(a, p.value)), u && (t.low = u.low, t.high = u.high, this.addPointErrorBar(t, i));
  }, r.prototype.addPointErrorBar = function(t, e) {
    var i = !this.options.invertAxes, a = t.options.errorBars, s = t.series, l = t.low, p = t.high;
    if (this.options.isStacked) {
      var h = this.stackedErrorRange(t, e);
      l = h.low, p = h.high;
    } else {
      var c = { categoryIx: e, series: s };
      this.updateRange({ value: l }, c), this.updateRange({ value: p }, c);
    }
    var u = new wy(l, p, i, this, s, a);
    t.errorBars = [u], t.append(u);
  }, r.prototype.stackedErrorRange = function(t, e) {
    var i = this.plotRange(t, 0)[1] - t.value, a = t.low + i, s = t.high + i;
    return this.errorTotals = this.errorTotals || { positive: [], negative: [] }, a < 0 && (this.errorTotals.negative[e] = Math.min(this.errorTotals.negative[e] || 0, a)), s > 0 && (this.errorTotals.positive[e] = Math.max(this.errorTotals.positive[e] || 0, s)), { low: a, high: s };
  }, r.prototype.addValue = function(t, e) {
    var i = e.categoryIx, a = e.series, s = e.seriesIx, l = this.categoryPoints[i];
    l || (this.categoryPoints[i] = l = []);
    var p = this.seriesPoints[s];
    p || (this.seriesPoints[s] = p = []);
    var h = this.createPoint(t, e);
    h && (Object.assign(h, e), h.owner = this, h.noteText = t.fields.noteText, P(h.dataItem) || (h.dataItem = a.data[i]), this.addErrorBar(h, t, i)), this.points.push(h), p.push(h), l.push(h), this.updateRange(t.valueFields, e);
  }, r.prototype.evalPointOptions = function(t, e, i) {
    var a = i.categoryIx, s = i.category, l = i.series, p = i.seriesIx, h = {
      defaults: l._defaults,
      excluded: [
        "data",
        "aggregate",
        "_events",
        "tooltip",
        "content",
        "template",
        "visual",
        "toggle",
        "_outOfRangeMinPoint",
        "_outOfRangeMaxPoint",
        "drilldownSeriesFactory"
      ]
    }, c = this._evalSeries[p];
    P(c) || (this._evalSeries[p] = c = nr(t, {}, h, !0));
    var u = t;
    return c && (u = b({}, u), nr(u, {
      value: e,
      category: s,
      index: a,
      series: l,
      dataItem: l.data[a]
    }, h)), u;
  }, r.prototype.updateRange = function(t, e) {
    var i = e.series.axis, a = t.value, s = this.valueAxisRanges[i];
    isFinite(a) && a !== null && (s = this.valueAxisRanges[i] = s || { min: gt, max: xt }, s.min = Math.min(s.min, a), s.max = Math.max(s.max, a));
  }, r.prototype.seriesValueAxis = function(t) {
    var e = this.plotArea, i = t.axis, a = i ? e.namedValueAxes[i] : e.valueAxis;
    if (!a)
      throw new Error("Unable to locate value axis with name " + i);
    return a;
  }, r.prototype.reflow = function(t) {
    var e = this, i = this.categorySlots = [], a = this.points, s = this.categoryAxis, l = 0;
    this.traverseDataPoints(function(p, h) {
      var c = h.categoryIx, u = h.series, v = e.seriesValueAxis(u), f = a[l++], d = i[c];
      if (d || (i[c] = d = e.categorySlot(s, c, v)), f) {
        var m = e.plotRange(f, v.startValue()), _ = e.valueSlot(v, m);
        if (_) {
          var w = e.pointSlot(d, _);
          f.aboveAxis = e.aboveAxis(f, v), f.stackValue = m[1], e.options.isStacked100 && (f.percentage = e.plotValue(f)), e.reflowPoint(f, w);
        } else
          f.visible = !1;
      }
    }), this.reflowCategories(i), !this.options.clip && this.options.limitPoints && this.points.length && this.limitPoints(), this.box = t;
  }, r.prototype.valueSlot = function(t, e) {
    return t.getSlot(e[0], e[1], !this.options.clip);
  }, r.prototype.limitPoints = function() {
    for (var t = this, e = this.categoryPoints, i = e[0].concat(dt(e)), a = 0; a < i.length; a++)
      i[a] && t.limitPoint(i[a]);
  }, r.prototype.limitPoint = function(t) {
    var e = this.categoryAxis.limitSlot(t.box);
    e.equals(t.box) || t.reflow(e);
  }, r.prototype.aboveAxis = function(t, e) {
    var i = this.categoryAxisCrossingValue(e), a = t.value;
    return e.options.reverse ? a < i : a >= i;
  }, r.prototype.categoryAxisCrossingValue = function(t) {
    var e = this.categoryAxis, i = t.options, a = [].concat(
      i.axisCrossingValues || i.axisCrossingValue
    );
    return a[e.axisIndex || 0] || 0;
  }, r.prototype.reflowPoint = function(t, e) {
    t.reflow(e);
  }, r.prototype.reflowCategories = function() {
  }, r.prototype.pointSlot = function(t, e) {
    var i = this.options, a = i.invertAxes, s = a ? e : t, l = a ? t : e;
    return new L(s.x1, l.y1, s.x2, l.y2);
  }, r.prototype.categorySlot = function(t, e) {
    return t.getSlot(e);
  }, r.prototype.traverseDataPoints = function(t) {
    for (var e = this, i = this.options.series, a = gl(i), s = i.length, l = 0; l < s; l++)
      e._outOfRangeCallback(i[l], "_outOfRangeMinPoint", l, t);
    for (var p = 0; p < a; p++)
      for (var h = 0; h < s; h++) {
        var c = i[h], u = e.categoryAxis.categoryAt(p), v = e._bindPoint(c, h, p);
        t(v, {
          category: u,
          categoryIx: p,
          categoriesCount: a,
          series: c,
          seriesIx: h
        });
      }
    for (var f = 0; f < s; f++)
      e._outOfRangeCallback(i[f], "_outOfRangeMaxPoint", f, t);
  }, r.prototype._outOfRangeCallback = function(t, e, i, a) {
    var s = t[e];
    if (s) {
      var l = s.categoryIx, p = this._bindPoint(t, i, l, s.item);
      a(p, {
        category: s.category,
        categoryIx: l,
        series: t,
        seriesIx: i,
        dataItem: s.item
      });
    }
  }, r.prototype._bindPoint = function(t, e, i, a) {
    this._bindCache || (this._bindCache = []);
    var s = this._bindCache[e];
    s || (s = this._bindCache[e] = []);
    var l = s[i];
    return l || (l = s[i] = ht.current.bindPoint(t, i, a)), l;
  }, r.prototype.formatPointValue = function(t, e) {
    return t.value === null ? "" : this.chartService.format.auto(e, t.value);
  }, r.prototype.pointValue = function(t) {
    return t.valueFields.value;
  }, r;
}(rt);
O(ze, {
  series: [],
  invertAxes: !1,
  isStacked: !1,
  clip: !0,
  limitPoints: !0
});
var xe = {
  click: function(n, r) {
    return n.trigger(
      Du,
      this.eventArgs(r)
    );
  },
  hover: function(n, r) {
    return n.trigger(
      Bu,
      this.eventArgs(r)
    );
  },
  over: function(n, r) {
    return n.trigger(
      zu,
      this.eventArgs(r)
    );
  },
  out: function(n, r) {
    return n.trigger(
      ju,
      this.eventArgs(r)
    );
  },
  eventArgs: function(n) {
    return {
      value: this.value,
      percentage: this.percentage,
      stackValue: this.stackValue,
      category: this.category,
      series: this.series,
      dataItem: this.dataItem,
      runningTotal: this.runningTotal,
      total: this.total,
      element: ge(n),
      originalEvent: n,
      point: this
    };
  }
}, wi = {
  createNote: function() {
    var n = this.options.notes, r = this.noteText || n.label.text;
    n.visible !== !1 && P(r) && r !== null && (this.note = new Zs({
      value: this.value,
      text: r,
      dataItem: this.dataItem,
      category: this.category,
      series: this.series
    }, this.options.notes, this.owner.chartService), this.append(this.note));
  }
}, Le = function(n) {
  function r(o, t) {
    n.call(this), this.value = o, this.options = t, this.aboveAxis = U(this.options.aboveAxis, !0), this.tooltipTracking = !0;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    var t = this.options, e = t.markers, i = t.labels;
    if (!this._rendered) {
      if (this._rendered = !0, e.visible && e.size && (this.marker = this.createMarker(), this.append(this.marker)), i.visible) {
        var a = Ct(i), s = this.pointData(), l = this.value;
        a ? l = a(s) : i.format && (l = this.formatValue(i.format)), this.label = new Qt(
          l,
          b({
            align: $,
            vAlign: $,
            margin: {
              left: 5,
              right: 5
            },
            zIndex: U(i.zIndex, this.series.zIndex)
          }, i),
          s
        ), this.append(this.label);
      }
      this.createNote(), this.errorBar && this.append(this.errorBar);
    }
  }, r.prototype.markerBorder = function() {
    var t = this.options.markers, e = t.background, i = b({ color: this.color }, t.border);
    return P(i.color) || (i.color = new Ee(e).brightness(Xn).toHex()), i;
  }, r.prototype.createVisual = function() {
  }, r.prototype.createMarker = function() {
    var t = this.options.markers, e = new tr({
      type: t.type,
      width: t.size,
      height: t.size,
      rotation: t.rotation,
      background: t.background,
      border: this.markerBorder(),
      opacity: t.opacity,
      zIndex: U(t.zIndex, this.series.zIndex),
      animation: t.animation,
      visual: t.visual
    }, {
      dataItem: this.dataItem,
      value: this.value,
      series: this.series,
      category: this.category
    });
    return e;
  }, r.prototype.markerBox = function() {
    return this.marker || (this.marker = this.createMarker(), this.marker.reflow(this._childBox)), this.marker.box;
  }, r.prototype.reflow = function(t) {
    var e = this, i = this, a = i.options, s = i.aboveAxis, l = a.vertical;
    this.render(), this.box = t;
    var p = t.clone();
    if (l ? s ? p.y1 -= p.height() : p.y2 += p.height() : s ? p.x1 += p.width() : p.x2 -= p.width(), this._childBox = p, this.marker && this.marker.reflow(p), this.reflowLabel(p), this.errorBars)
      for (var h = 0; h < this.errorBars.length; h++)
        e.errorBars[h].reflow(p);
    if (this.note) {
      var c = this.markerBox();
      if (!(a.markers.visible && a.markers.size)) {
        var u = c.center();
        c = new L(u.x, u.y, u.x, u.y);
      }
      this.note.reflow(c);
    }
  }, r.prototype.reflowLabel = function(t) {
    var e = this, i = e.options, a = e.label, s = i.labels.position;
    a && (s = s === Pn ? tt : s, s = s === rs ? it : s, a.reflow(t), a.box.alignTo(this.markerBox(), s), a.reflow(a.box));
  }, r.prototype.createHighlight = function() {
    var t = this.options.highlight.markers, e = this.markerBorder().color, i = this.options.markers, a = i.size + (i.border.width || 0) + (t.border.width || 0), s = new tr({
      type: i.type,
      width: a,
      height: a,
      rotation: i.rotation,
      background: t.color || e,
      border: {
        color: t.border.color,
        width: t.border.width,
        opacity: U(t.border.opacity, 1)
      },
      opacity: U(t.opacity, 1)
    });
    return s.reflow(this._childBox), s.getElement();
  }, r.prototype.highlightVisual = function() {
    return (this.marker || {}).visual;
  }, r.prototype.highlightVisualArgs = function() {
    var t = this.marker, e, i;
    if (t)
      i = t.paddingBox.toRect(), e = t.visual;
    else {
      var a = this.options.markers.size, s = a / 2, l = this.box.center();
      i = new Pt([l.x - s, l.y - s], [a, a]);
    }
    return {
      options: this.options,
      rect: i,
      visual: e
    };
  }, r.prototype.tooltipAnchor = function() {
    var t = this.markerBox(), e = this.owner.pane.clipBox(), i = !e || e.overlaps(t);
    if (i) {
      var a = t.x2 + ue, s = Q, l, p;
      return this.aboveAxis ? (l = t.y1, p = it) : (l = t.y2, p = tt), {
        point: new F(a, l),
        align: {
          horizontal: s,
          vertical: p
        }
      };
    }
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.overlapsBox = function(t) {
    var e = this.markerBox();
    return e.overlaps(t);
  }, r.prototype.unclipElements = function() {
    this.label && (this.label.options.noclip = !0), this.note && (this.note.options.noclip = !0);
  }, r.prototype.pointData = function() {
    return {
      dataItem: this.dataItem,
      category: this.category,
      value: this.value,
      percentage: this.percentage,
      stackValue: this.stackValue,
      series: this.series
    };
  }, r;
}(rt);
Le.prototype.defaults = {
  vertical: !0,
  markers: {
    visible: !0,
    background: J,
    size: kn,
    type: fe,
    border: {
      width: 2
    },
    opacity: 1
  },
  labels: {
    visible: !1,
    position: Pn,
    margin: ot(3),
    padding: ot(4),
    animation: {
      type: Cr,
      delay: ne
    }
  },
  notes: {
    label: {}
  },
  highlight: {
    markers: {
      border: {
        color: "#fff",
        width: 2
      }
    },
    zIndex: Qc
  },
  errorBars: {
    line: {
      width: 1
    }
  }
};
b(Le.prototype, xe);
b(Le.prototype, wi);
var Ur = function(n) {
  function r(o, t, e) {
    n.call(this), this.linePoints = o, this.series = t, this.seriesIx = e;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.points = function() {
    return this.toGeometryPoints(this.linePoints);
  }, r.prototype.toGeometryPoints = function(t) {
    for (var e = [], i = 0, a = t.length; i < a; i++)
      t[i] && t[i].visible !== !1 && e.push(t[i]._childBox.toRect().center());
    return e;
  }, r.prototype.createVisual = function() {
    var t = this, e = this.series.visual;
    e ? (this.visual = e({
      points: this.toGeometryPoints(this.linePoints),
      series: this.series,
      sender: this.getSender(),
      createVisual: function() {
        return t.segmentVisual(), t.visual;
      }
    }), this.visual && !P(this.visual.options.zIndex) && (this.visual.options.zIndex = this.series.zIndex)) : this.segmentVisual();
  }, r.prototype.segmentVisual = function() {
    var t = this, e = t.options, i = t.series, a = i.color, s = i._defaults;
    vt(a) && s && (a = s.color);
    var l = H.fromPoints(this.points(), {
      stroke: {
        color: a,
        width: i.width,
        opacity: i.opacity,
        dashType: i.dashType
      },
      zIndex: i.zIndex
    });
    e.closed && l.close(), this.visual = l;
  }, r.prototype.aliasFor = function(t, e) {
    return this.parent.getNearestPoint(e.x, e.y, this.seriesIx);
  }, r;
}(rt);
O(Ur, {
  closed: !1
});
var yl = {
  calculateStepPoints: function(n) {
    for (var r = this.parent.plotArea.seriesCategoryAxis(this.series), o = r.options, t = o.justified, e = o.vertical, i = o.reverse, a = e ? D : B, s = e ? B : D, l = i ? 2 : 1, p = l, h = Ba(n[0], a, l, s, p), c = [h], u = 1; u < n.length; u++) {
      var v = Ba(n[u], a, l, s, p);
      if (h[a] !== v[a]) {
        var f = new q();
        f[a] = h[a], f[s] = v[s], c.push(f, v);
      }
      h = v;
    }
    return t ? h !== dt(c) && c.push(h) : c.push(Ba(dt(n), a, l, s, i ? 1 : 2)), c;
  }
};
function Ba(n, r, o, t, e) {
  var i = n.box, a = new q();
  return a[r] = i[r + o], a[t] = i[t + e], a;
}
var Fu = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.points = function() {
    return this.calculateStepPoints(this.linePoints);
  }, r;
}(Ur);
b(Fu.prototype, yl);
var ml = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.segmentVisual = function() {
    var t = this.series, e = t._defaults, i = t.color;
    vt(i) && e && (i = e.color);
    var a = new Wn(this.options.closed), s = a.process(this.points()), l = new H({
      stroke: {
        color: i,
        width: t.width,
        opacity: t.opacity,
        dashType: t.dashType
      },
      zIndex: t.zIndex
    });
    l.segments.push.apply(l.segments, s), this.visual = l;
  }, r;
}(Ur), _l = {
  renderSegments: function() {
    var n = this, r = this, o = r.options, t = r.seriesPoints, e = o.series, i = t.length, a;
    this._segments = [];
    for (var s = 0; s < i; s++) {
      for (var l = e[s], p = n.sortPoints(t[s]), h = p.length, c = [], u = 0; u < h; u++) {
        var v = p[u];
        v ? c.push(v) : n.seriesMissingValues(l) !== ni && (c.length > 1 && (a = n.createSegment(
          c,
          l,
          s,
          a
        ), n._addSegment(a)), c = []);
      }
      c.length > 1 && (a = n.createSegment(
        c,
        l,
        s,
        a
      ), n._addSegment(a));
    }
    this.children.unshift.apply(this.children, this._segments);
  },
  _addSegment: function(n) {
    this._segments.push(n), n.parent = this;
  },
  sortPoints: function(n) {
    return n;
  },
  seriesMissingValues: function(n) {
    var r = n.missingValues, o = !r && this.options.isStacked;
    return o ? ir : r || ni;
  },
  getNearestPoint: function(n, r, o) {
    for (var t = new F(n, r), e = this.seriesPoints[o], i = gt, a, s = 0; s < e.length; s++) {
      var l = e[s];
      if (l && P(l.value) && l.value !== null && l.visible !== !1) {
        var p = l.box, h = p.center().distanceTo(t);
        h < i && (a = l, i = h);
      }
    }
    return a;
  }
}, xl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    this._setEnd(this.options.box.x1);
  }, r.prototype.step = function(t) {
    var e = this.options.box;
    this._setEnd(ie(e.x1, e.x2, t));
  }, r.prototype._setEnd = function(t) {
    var e = this.element, i = e.segments, a = i[1].anchor(), s = i[2].anchor();
    e.suspend(), a.setX(t), e.resume(), s.setX(t);
  }, r;
}(pe);
O(xl, {
  duration: ne
});
De.current.register("clip", xl);
function Uu(n) {
  for (var r = 0; r < n.length; r++)
    if (P(n[r].zIndex))
      return !0;
}
var Qn = {
  createAnimation: function() {
    var n = this.getRoot();
    if (n && (n.options || {}).transitions !== !1) {
      var r = n.size(), o = H.fromRect(r.toRect());
      this.visual.clip(o), this.animation = new xl(o, {
        box: r
      }), Uu(this.options.series) && this._setChildrenAnimation(o);
    }
  },
  _setChildrenAnimation: function(n) {
    for (var r = this.animationPoints(), o = 0; o < r.length; o++) {
      var t = r[o];
      t && t.visual && P(t.visual.options.zIndex) && t.visual.clip(n);
    }
  }
}, Kn = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    n.prototype.render.call(this), this.updateStackRange(), this.renderSegments();
  }, r.prototype.pointType = function() {
    return Le;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.series, a = e.seriesIx, s = this.seriesMissingValues(i), l = t.valueFields.value;
    if (!P(l) || l === null)
      if (s === ir)
        l = 0;
      else
        return null;
    var p = this.pointOptions(i, a);
    p = this.evalPointOptions(p, l, e);
    var h = t.fields.color || i.color;
    vt(i.color) && (h = p.color);
    var c = new Le(l, p);
    return c.color = h, this.append(c), c;
  }, r.prototype.plotRange = function(t) {
    var e = this, i = this.plotValue(t);
    if (this.options.isStacked)
      for (var a = t.categoryIx, s = this.categoryPoints[a], l = 0; l < s.length; l++) {
        var p = s[l];
        if (t === p)
          break;
        i += e.plotValue(p), e.options.isStacked100 && (i = Math.min(i, 1));
      }
    return [i, i];
  }, r.prototype.createSegment = function(t, e, i) {
    var a = e.style, s;
    return a === Ji ? s = Fu : a === mi ? s = ml : s = Ur, new s(t, e, i);
  }, r.prototype.animationPoints = function() {
    for (var t = this.points, e = [], i = 0; i < t.length; i++)
      e.push((t[i] || {}).marker);
    return e.concat(this._segments);
  }, r.prototype.supportsPointInactiveOpacity = function() {
    return !1;
  }, r;
}(ze);
b(Kn.prototype, _l, Qn);
var bi = function(n) {
  function r(o, t, e, i, a) {
    n.call(this, o, t, e), this.prevSegment = i, this.stackPoints = a;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createVisual = function() {
    var t = this.series, e = t._defaults, i = t.line || {}, a = t.color;
    vt(a) && e && (a = e.color), this.visual = new pt({
      zIndex: t.zIndex
    }), this.createFill({
      fill: {
        color: a,
        opacity: t.opacity
      },
      stroke: null
    }), i.width > 0 && i.visible !== !1 && this.createStroke({
      stroke: b({
        color: a,
        opacity: t.opacity,
        lineCap: "butt"
      }, i)
    });
  }, r.prototype.strokeSegments = function() {
    var t = this._strokeSegments;
    return t || (t = this._strokeSegments = this.createStrokeSegments()), t;
  }, r.prototype.createStrokeSegments = function() {
    return this.segmentsFromPoints(this.points());
  }, r.prototype.stackSegments = function() {
    return this.prevSegment ? this.prevSegment.createStackSegments(this.stackPoints) : this.createStackSegments(this.stackPoints);
  }, r.prototype.createStackSegments = function(t) {
    return this.segmentsFromPoints(this.toGeometryPoints(t)).reverse();
  }, r.prototype.segmentsFromPoints = function(t) {
    return t.map(function(e) {
      return new We(e);
    });
  }, r.prototype.createStroke = function(t) {
    var e = new H(t);
    e.segments.push.apply(e.segments, this.strokeSegments()), this.visual.append(e);
  }, r.prototype.hasStackSegment = function() {
    return this.prevSegment || this.stackPoints && this.stackPoints.length;
  }, r.prototype.createFill = function(t) {
    var e = this.strokeSegments(), i = e.slice(0), a = this.hasStackSegment();
    if (a) {
      var s = this.stackSegments();
      Nr(i, s);
    }
    var l = new H(t);
    l.segments.push.apply(l.segments, i), !a && e.length > 1 && this.fillToAxes(l), this.visual.append(l);
  }, r.prototype.fillToAxes = function(t) {
    var e = this.parent, i = e.options.invertAxes, a = e.seriesValueAxis(this.series), s = e.categoryAxisCrossingValue(a), l = a.getSlot(s, s, !0), p = this.strokeSegments(), h = p[0].anchor(), c = dt(p).anchor(), u = i ? l.x1 : l.y1;
    i ? t.lineTo(u, c.y).lineTo(u, h.y) : t.lineTo(c.x, u).lineTo(h.x, u);
  }, r;
}(Ur), $u = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createStrokeSegments = function() {
    return this.segmentsFromPoints(this.calculateStepPoints(this.linePoints));
  }, r.prototype.createStackSegments = function(t) {
    return this.segmentsFromPoints(this.calculateStepPoints(t)).reverse();
  }, r;
}(bi);
b($u.prototype, yl);
var wl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createStrokeSegments = function() {
    var t = new Wn(this.options.closed), e = this.points();
    return t.process(e);
  }, r.prototype.createStackSegments = function() {
    for (var t = this.strokeSegments(), e = [], i = t.length - 1; i >= 0; i--) {
      var a = t[i];
      e.push(new We(
        a.anchor(),
        a.controlOut(),
        a.controlIn()
      ));
    }
    return e;
  }, r;
}(bi), Ay = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createSegment = function(t, e, i, a) {
    var s = this.options.isStacked, l = (e.line || {}).style, p, h;
    if (s && i > 0 && a) {
      var c = this.seriesMissingValues(e);
      c !== "gap" ? (h = a.linePoints, p = a) : h = this._gapStackPoints(t, i, l);
    }
    var u;
    return l === Ji ? u = $u : l === mi ? u = wl : u = bi, new u(t, e, i, p, h);
  }, r.prototype.reflow = function(t) {
    var e = this;
    n.prototype.reflow.call(this, t);
    var i = this._stackPoints;
    if (i)
      for (var a = 0; a < i.length; a++) {
        var s = i[a], l = e.categoryAxis.getSlot(s.categoryIx);
        s.reflow(l);
      }
  }, r.prototype._gapStackPoints = function(t, e, i) {
    var a = this, s = this.seriesPoints, l = t[0].categoryIx, p = t.length;
    l < 0 && (l = 0, p--);
    var h = l + p, c = this.seriesOptions[0]._outOfRangeMinPoint ? 1 : 0, u = [];
    this._stackPoints = this._stackPoints || [];
    for (var v = l; v < h; v++) {
      var f = v + c, d = e, m = void 0;
      do
        d--, m = s[d][f];
      while (d > 0 && !m);
      if (m)
        i !== Ji && v > l && !s[d][f - 1] && u.push(a._previousSegmentPoint(v, f, f - 1, d)), u.push(m), i !== Ji && v + 1 < h && !s[d][f + 1] && u.push(a._previousSegmentPoint(v, f, f + 1, d));
      else {
        var _ = a._createGapStackPoint(v);
        a._stackPoints.push(_), u.push(_);
      }
    }
    return u;
  }, r.prototype._previousSegmentPoint = function(t, e, i, a) {
    for (var s = this.seriesPoints, l = a, p; l > 0 && !p; )
      l--, p = s[l][i];
    return p ? p = s[l][e] : (p = this._createGapStackPoint(t), this._stackPoints.push(p)), p;
  }, r.prototype._createGapStackPoint = function(t) {
    var e = this.pointOptions({}, 0), i = new Le(0, e);
    return i.categoryIx = t, i.series = {}, i;
  }, r.prototype.seriesMissingValues = function(t) {
    return t.missingValues || ir;
  }, r.prototype.supportsPointInactiveOpacity = function() {
    return !1;
  }, r;
}(Kn), Ln = function(n) {
  function r() {
    n.call(this), this.axisRanges = {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.update = function(t) {
    var e = this.axisRanges;
    for (var i in t) {
      var a = t[i], s = e[i];
      e[i] = s = s || { min: gt, max: xt }, s.min = Math.min(s.min, a.min), s.max = Math.max(s.max, a.max);
    }
  }, r.prototype.reset = function(t) {
    this.axisRanges[t] = void 0;
  }, r.prototype.query = function(t) {
    return this.axisRanges[t];
  }, r;
}(N), Jn = function(n) {
  function r(o, t, e) {
    n.call(this, t), this.textBox = new Qt(o, this.options, e), this.append(this.textBox);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createVisual = function() {
    this.textBox.options.noclip = this.options.noclip;
  }, r.prototype.reflow = function(t) {
    var e = this.options, i = e.vertical, a = e.aboveAxis, s = this.children[0], l = s.options, p = s.box, h = s.options.padding, c = t;
    l.align = i ? $ : Q, l.vAlign = i ? tt : $, e.position === Mn ? i ? (l.vAlign = tt, !a && p.height() < t.height() && (l.vAlign = it)) : l.align = a ? et : Q : e.position === $ ? (l.vAlign = $, l.align = $) : e.position === my ? i ? l.vAlign = a ? it : tt : l.align = a ? Q : et : e.position === Ir && (i ? a ? c = new L(
      t.x1,
      t.y1 - p.height(),
      t.x2,
      t.y1
    ) : c = new L(
      t.x1,
      t.y2,
      t.x2,
      t.y2 + p.height()
    ) : (l.align = $, a ? c = new L(
      t.x2,
      t.y1,
      t.x2 + p.width(),
      t.y2
    ) : c = new L(
      t.x1 - p.width(),
      t.y1,
      t.x1,
      t.y2
    ))), e.rotation || (i ? h.left = h.right = (c.width() - s.contentBox.width()) / 2 : h.top = h.bottom = (c.height() - s.contentBox.height()) / 2), s.reflow(c);
  }, r.prototype.alignToClipBox = function(t) {
    var e = this.options.vertical, i = e ? B : D, a = i + "1", s = i + "2", l = this.children[0], p = this.parent.box;
    if (p[a] < t[a] || t[s] < p[s]) {
      var h = l.paddingBox.clone();
      h[a] = Math.max(p[a], t[a]), h[s] = Math.min(p[s], t[s]), this.reflow(h);
    }
  }, r;
}(rt);
O(Jn, {
  position: Ir,
  margin: ot(3),
  padding: ot(4),
  color: yt,
  background: "",
  border: {
    width: 1,
    color: ""
  },
  aboveAxis: !0,
  vertical: !1,
  animation: {
    type: Cr,
    delay: ne
  },
  zIndex: 2
});
function bl(n) {
  var r = n.overlay;
  return r && r.gradient && r.gradient !== "none";
}
var Sy = 6, Ai = function(n) {
  function r(o, t) {
    n.call(this), this.options = t, this.color = t.color || J, this.aboveAxis = U(this.options.aboveAxis, !0), this.value = o;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this._rendered || (this._rendered = !0, this.createLabel(), this.createNote(), this.errorBar && this.append(this.errorBar));
  }, r.prototype.createLabel = function() {
    var t = this.options, e = t.labels;
    if (e.visible) {
      var i = this.pointData(), a = Ct(e), s;
      a ? s = a(i) : s = this.formatValue(e.format), this.label = new Jn(
        s,
        b(
          {
            vertical: t.vertical
          },
          e
        ),
        i
      ), this.append(this.label);
    }
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.reflow = function(t) {
    var e = this;
    this.render();
    var i = this.label;
    if (this.box = t, i && (i.options.aboveAxis = this.aboveAxis, i.reflow(t)), this.note && this.note.reflow(t), this.errorBars)
      for (var a = 0; a < this.errorBars.length; a++)
        e.errorBars[a].reflow(t);
  }, r.prototype.createVisual = function() {
    var t = this, e = this, i = e.box, a = e.options, s = a.visual;
    if (this.visible !== !1)
      if (n.prototype.createVisual.call(this), s) {
        var l = this.rectVisual = s({
          category: this.category,
          dataItem: this.dataItem,
          value: this.value,
          sender: this.getSender(),
          series: this.series,
          percentage: this.percentage,
          stackValue: this.stackValue,
          runningTotal: this.runningTotal,
          total: this.total,
          rect: i.toRect(),
          createVisual: function() {
            var p = new pt();
            return t.createRect(p), p;
          },
          options: a
        });
        l && this.visual.append(l);
      } else
        i.width() > 0 && i.height() > 0 && this.createRect(this.visual);
  }, r.prototype.createRect = function(t) {
    var e = this.options, i = e.border, a = P(i.opacity) ? i.opacity : e.opacity, s = this.box.toRect();
    s.size.width = Math.round(s.size.width);
    var l = this.rectVisual = H.fromRect(s, {
      fill: {
        color: this.color,
        opacity: e.opacity
      },
      stroke: {
        color: this.getBorderColor(),
        width: i.width,
        opacity: a,
        dashType: i.dashType
      }
    }), p = this.box.width(), h = this.box.height(), c = e.vertical ? p : h;
    if (c > Sy && (ae(l), (p < 1 || h < 1) && (l.options.stroke.lineJoin = "round")), t.append(l), bl(e)) {
      var u = this.createGradientOverlay(l, { baseColor: this.color }, b({
        end: e.vertical ? void 0 : [0, 1]
      }, e.overlay));
      t.append(u);
    }
  }, r.prototype.createHighlight = function(t) {
    var e = H.fromRect(this.box.toRect(), t);
    return ae(e);
  }, r.prototype.highlightVisual = function() {
    return this.rectVisual;
  }, r.prototype.highlightVisualArgs = function() {
    return {
      options: this.options,
      rect: this.box.toRect(),
      visual: this.rectVisual
    };
  }, r.prototype.getBorderColor = function() {
    var t = this.color, e = this.options.border, i = e._brightness || Xn, a = e.color;
    return P(a) || (a = new Ee(t).brightness(i).toHex()), a;
  }, r.prototype.tooltipAnchor = function() {
    var t = this, e = t.options, i = t.box, a = t.aboveAxis, s = this.owner.pane.clipBox() || i, l = Q, p = tt, h, c;
    if (e.vertical)
      h = Math.min(i.x2, s.x2) + ue, a ? c = Math.max(i.y1, s.y1) : (c = Math.min(i.y2, s.y2), p = it);
    else {
      var u = Math.max(i.x1, s.x1), v = Math.min(i.x2, s.x2);
      e.isStacked ? (p = it, a ? (l = et, h = v) : h = u, c = Math.max(i.y1, s.y1) - ue) : (a ? h = v + ue : (h = u - ue, l = et), c = Math.max(i.y1, s.y1));
    }
    return {
      point: new F(h, c),
      align: {
        horizontal: l,
        vertical: p
      }
    };
  }, r.prototype.overlapsBox = function(t) {
    return this.box.overlaps(t);
  }, r.prototype.pointData = function() {
    return {
      dataItem: this.dataItem,
      category: this.category,
      value: this.value,
      percentage: this.percentage,
      stackValue: this.stackValue,
      runningTotal: this.runningTotal,
      total: this.total,
      series: this.series
    };
  }, r;
}(rt);
b(Ai.prototype, xe);
b(Ai.prototype, wi);
Ai.prototype.defaults = {
  border: {
    width: 1
  },
  vertical: !0,
  overlay: {
    gradient: "glass"
  },
  labels: {
    visible: !1,
    format: "{0}"
  },
  opacity: 1,
  notes: {
    label: {}
  }
};
function Gu(n, r) {
  n.forEach(r);
}
function Wu(n, r) {
  for (var o = n.length, t = o - 1; t >= 0; t--)
    r(n[t], t - o - 1);
}
var Oo = function(n) {
  function r(o) {
    n.call(this, o), this.forEach = o.rtl ? Wu : Gu;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this.options, i = e.vertical, a = e.gap, s = e.spacing, l = this.children, p = l.length, h = i ? B : D, c = p + a + s * (p - 1), u = (i ? t.height() : t.width()) / c, v = t[h + 1] + u * (a / 2);
    this.forEach(l, function(f, d) {
      var m = (f.box || t).clone();
      m[h + 1] = v, m[h + 2] = v + u, f.reflow(m), d < p - 1 && (v += u * s), v += u;
    });
  }, r;
}(rt);
O(Oo, {
  vertical: !1,
  gap: 0,
  spacing: 0
});
var Xu = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    for (var e = this, i = this.options.vertical ? D : B, a = this.children, s = a.length, l = this.box = new L(), p = 0; p < s; p++) {
      var h = a[p];
      if (h.visible !== !1) {
        var c = h.box.clone();
        c.snapTo(t, i), p === 0 && (l = e.box = c.clone()), h.reflow(c), l.wrap(c);
      }
    }
  }, r;
}(rt);
O(Xu, {
  vertical: !0
});
var Si = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    n.prototype.render.call(this), this.updateStackRange();
  }, r.prototype.pointType = function() {
    return Ai;
  }, r.prototype.clusterType = function() {
    return Oo;
  }, r.prototype.stackType = function() {
    return Xu;
  }, r.prototype.stackLimits = function(t, e) {
    var i = n.prototype.stackLimits.call(this, t, e);
    return i;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.categoryIx, a = e.series, s = e.seriesIx, l = this, p = l.options, h = l.children, c = p.isStacked, u = this.pointValue(t), v = this.pointOptions(a, s), f = v.labels;
    c && f.position === Ir && (f.position = Mn), v.isStacked = c;
    var d = t.fields.color || a.color;
    u < 0 && v.negativeColor && (d = v.negativeColor), v = this.evalPointOptions(v, u, e), vt(a.color) && (d = v.color);
    var m = this.pointType(), _ = new m(u, v);
    _.color = d;
    var w = h[i];
    if (!w) {
      var A = this.clusterType();
      w = new A({
        vertical: p.invertAxes,
        gap: p.gap,
        spacing: p.spacing,
        rtl: !p.invertAxes && (this.chartService || {}).rtl
      }), this.append(w);
    }
    if (c) {
      var T = this.getStackWrap(a, w);
      T.append(_);
    } else
      w.append(_);
    return _;
  }, r.prototype.getStackWrap = function(t, e) {
    var i = t.stack, a = i && (i.group || i), s = e.children, l;
    if (typeof a === Ws) {
      for (var p = 0; p < s.length; p++)
        if (s[p]._stackGroup === a) {
          l = s[p];
          break;
        }
    } else
      l = s[0];
    if (!l) {
      var h = this.stackType();
      l = new h({
        vertical: !this.options.invertAxes
      }), l._stackGroup = a, e.append(l);
    }
    return l;
  }, r.prototype.categorySlot = function(t, e, i) {
    var a = this.options, s = t.getSlot(e), l = i.startValue();
    if (a.isStacked) {
      var p = i.getSlot(l, l, !0), h = a.invertAxes ? D : B;
      s[h + 1] = s[h + 2] = p[h + 1];
    }
    return s;
  }, r.prototype.reflowCategories = function(t) {
    for (var e = this.children, i = e.length, a = 0; a < i; a++)
      e[a].reflow(t[a]);
  }, r.prototype.createAnimation = function() {
    this._setAnimationOptions(), n.prototype.createAnimation.call(this), Uu(this.options.series) && this._setChildrenAnimation();
  }, r.prototype._setChildrenAnimation = function() {
    for (var t = this, e = this.points, i = 0; i < e.length; i++) {
      var a = e[i], s = a.visual;
      s && P(s.options.zIndex) && (a.options.animation = t.options.animation, a.createAnimation());
    }
  }, r.prototype._setAnimationOptions = function() {
    var t = this.options, e = t.animation || {}, i;
    if (t.isStacked) {
      var a = this.seriesValueAxis(t.series[0]);
      i = a.getSlot(a.startValue());
    } else
      i = this.categoryAxis.getSlot(0);
    e.origin = new q(i.x1, i.y1), e.vertical = !t.invertAxes;
  }, r;
}(ze);
O(Si, {
  animation: {
    type: ye
  }
});
var Ti = function(n) {
  function r(o, t) {
    n.call(this, t), this.value = o;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = e.options, a = e.value, s = e.owner, l = s.seriesValueAxis(i), p = l.getSlot(a.open, a.close), h = l.getSlot(a.low, a.high);
    p.x1 = h.x1 = t.x1, p.x2 = h.x2 = t.x2, this.realBody = p;
    var c = h.center().x, u = [];
    u.push([[c, h.y1], [c, p.y1]]), u.push([[c, p.y2], [c, h.y2]]), this.lines = u, this.box = h.clone().wrap(p), this._rendered || (this._rendered = !0, this.createNote()), this.reflowNote();
  }, r.prototype.reflowNote = function() {
    this.note && this.note.reflow(this.box);
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this), this._mainVisual = this.mainVisual(this.options), this.visual.append(
      this._mainVisual
    ), this.createOverlay();
  }, r.prototype.mainVisual = function(t) {
    var e = new pt();
    return this.createBody(e, t), this.createLines(e, t), e;
  }, r.prototype.createBody = function(t, e) {
    var i = H.fromRect(this.realBody.toRect(), {
      fill: {
        color: this.color,
        opacity: e.opacity
      },
      stroke: null
    });
    e.border.width > 0 && i.options.set("stroke", {
      color: this.getBorderColor(),
      width: e.border.width,
      dashType: e.border.dashType,
      opacity: U(e.border.opacity, e.opacity)
    }), ae(i), t.append(i), bl(e) && t.append(this.createGradientOverlay(i, { baseColor: this.color }, b({
      end: e.vertical ? void 0 : [0, 1]
    }, e.overlay)));
  }, r.prototype.createLines = function(t, e) {
    this.drawLines(t, e, this.lines, e.line);
  }, r.prototype.drawLines = function(t, e, i, a) {
    if (i)
      for (var s = {
        stroke: {
          color: a.color || this.color,
          opacity: U(a.opacity, e.opacity),
          width: a.width,
          dashType: a.dashType,
          lineCap: "butt"
        }
      }, l = 0; l < i.length; l++) {
        var p = H.fromPoints(i[l], s);
        ae(p), t.append(p);
      }
  }, r.prototype.getBorderColor = function() {
    var t = this.options.border, e = t.color;
    return P(e) || (e = new Ee(this.color).brightness(t._brightness).toHex()), e;
  }, r.prototype.createOverlay = function() {
    var t = H.fromRect(this.box.toRect(), {
      fill: {
        color: J,
        opacity: 0
      },
      stroke: null
    });
    this.visual.append(t);
  }, r.prototype.createHighlight = function() {
    var t = this.options.highlight, e = this.color;
    this.color = t.color || this.color;
    var i = this.mainVisual(
      b({}, this.options, {
        line: {
          color: this.getBorderColor()
        }
      }, t)
    );
    return this.color = e, i;
  }, r.prototype.highlightVisual = function() {
    return this._mainVisual;
  }, r.prototype.highlightVisualArgs = function() {
    return {
      options: this.options,
      rect: this.box.toRect(),
      visual: this._mainVisual
    };
  }, r.prototype.tooltipAnchor = function() {
    var t = this.box, e = this.owner.pane.clipBox() || t;
    return {
      point: new F(t.x2 + ue, Math.max(t.y1, e.y1) + ue),
      align: {
        horizontal: Q,
        vertical: tt
      }
    };
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.overlapsBox = function(t) {
    return this.box.overlaps(t);
  }, r;
}(rt);
O(Ti, {
  vertical: !0,
  border: {
    _brightness: 0.8
  },
  line: {
    width: 2
  },
  overlay: {
    gradient: "glass"
  },
  tooltip: {
    format: "<table><tr><th colspan='2'>{4:d}</th></tr><tr><td>Open:</td><td>{0:C}</td></tr><tr><td>High:</td><td>{1:C}</td></tr><tr><td>Low:</td><td>{2:C}</td></tr><tr><td>Close:</td><td>{3:C}</td></tr></table>"
  },
  highlight: {
    opacity: 1,
    border: {
      width: 1,
      opacity: 1
    },
    line: {
      width: 1,
      opacity: 1
    }
  },
  notes: {
    visible: !0,
    label: {}
  }
});
b(Ti.prototype, xe);
b(Ti.prototype, wi);
function Yu(n) {
  return ts(n) === n.length;
}
var ta = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflowCategories = function(t) {
    for (var e = this.children, i = e.length, a = 0; a < i; a++)
      e[a].reflow(t[a]);
  }, r.prototype.addValue = function(t, e) {
    var i = e.categoryIx, a = e.category, s = e.series, l = e.seriesIx, p = this, h = p.children, c = p.options, u = t.valueFields, v = this.splitValue(u), f = Yu(v), d = s.data[i], m = this.categoryPoints[i], _;
    m || (this.categoryPoints[i] = m = []), f && (_ = this.createPoint(t, e));
    var w = h[i];
    w || (w = new Oo({
      vertical: c.invertAxes,
      gap: c.gap,
      spacing: c.spacing,
      rtl: !c.invertAxes && (this.chartService || {}).rtl
    }), this.append(w)), _ && (this.updateRange(u, e), w.append(_), _.categoryIx = i, _.category = a, _.series = s, _.seriesIx = l, _.owner = this, _.dataItem = d, _.noteText = t.fields.noteText), this.points.push(_), m.push(_);
  }, r.prototype.pointType = function() {
    return Ti;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.series, a = this.pointType(), s = t.valueFields, l = b({}, i), p = t.fields.color || i.color;
    l = this.evalPointOptions(l, s, e), i.type === xi && s.open > s.close && (p = t.fields.downColor || i.downColor || i.color), vt(i.color) && (p = l.color), l.vertical = !this.options.invertAxes;
    var h = new a(s, l);
    return h.color = p, h;
  }, r.prototype.splitValue = function(t) {
    return [t.low, t.open, t.close, t.high];
  }, r.prototype.updateRange = function(t, e) {
    var i = e.series.axis, a = this.splitValue(t), s = this.valueAxisRanges[i];
    s = this.valueAxisRanges[i] = s || { min: gt, max: xt }, s = this.valueAxisRanges[i] = {
      min: Math.min.apply(Math, a.concat([s.min])),
      max: Math.max.apply(Math, a.concat([s.max]))
    };
  }, r.prototype.formatPointValue = function(t, e) {
    var i = t.value;
    return this.chartService.format.auto(
      e,
      i.open,
      i.high,
      i.low,
      i.close,
      t.category
    );
  }, r.prototype.animationPoints = function() {
    return this.points;
  }, r;
}(ze);
b(ta.prototype, Qn);
var ea = function(n) {
  function r(o, t) {
    n.call(this, o, t), this.createNote();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = e.options, a = e.value, s = e.owner, l = s.seriesValueAxis(i), p, h;
    this.boxSlot = h = l.getSlot(a.q1, a.q3), this.realBody = h, this.reflowBoxSlot(t), this.whiskerSlot = p = l.getSlot(a.lower, a.upper), this.reflowWhiskerSlot(t);
    var c = l.getSlot(a.median);
    if (a.mean) {
      var u = l.getSlot(a.mean);
      this.meanPoints = this.calcMeanPoints(t, u);
    }
    this.whiskerPoints = this.calcWhiskerPoints(h, p), this.medianPoints = this.calcMedianPoints(t, c), this.box = p.clone().wrap(h), this.reflowNote();
  }, r.prototype.reflowBoxSlot = function(t) {
    this.boxSlot.x1 = t.x1, this.boxSlot.x2 = t.x2;
  }, r.prototype.reflowWhiskerSlot = function(t) {
    this.whiskerSlot.x1 = t.x1, this.whiskerSlot.x2 = t.x2;
  }, r.prototype.calcMeanPoints = function(t, e) {
    return [
      [[t.x1, e.y1], [t.x2, e.y1]]
    ];
  }, r.prototype.calcWhiskerPoints = function(t, e) {
    var i = e.center().x;
    return [[
      [i - 5, e.y1],
      [i + 5, e.y1],
      [i, e.y1],
      [i, t.y1]
    ], [
      [i - 5, e.y2],
      [i + 5, e.y2],
      [i, e.y2],
      [i, t.y2]
    ]];
  }, r.prototype.calcMedianPoints = function(t, e) {
    return [
      [[t.x1, e.y1], [t.x2, e.y1]]
    ];
  }, r.prototype.renderOutliers = function(t) {
    for (var e = this, i = this.value, a = i.outliers || [], s = Math.abs(i.q3 - i.q1) * 3, l = [], p = t.markers || {}, h = 0; h < a.length; h++) {
      var c = a[h];
      c < i.q3 + s && c > i.q1 - s ? p = t.outliers : p = t.extremes;
      var u = b({}, p.border);
      P(u.color) || (P(e.color) ? u.color = e.color : u.color = new Ee(p.background).brightness(Xn).toHex());
      var v = new tr({
        type: p.type,
        width: p.size,
        height: p.size,
        rotation: p.rotation,
        background: p.background,
        border: u,
        opacity: p.opacity
      });
      v.value = c, l.push(v);
    }
    return this.reflowOutliers(l), l;
  }, r.prototype.reflowOutliers = function(t) {
    for (var e = this, i = this.owner.seriesValueAxis(this.options), a = this.box.center(), s = 0; s < t.length; s++) {
      var l = t[s].value, p = i.getSlot(l);
      e.options.vertical ? p.move(a.x) : p.move(void 0, a.y), e.box = e.box.wrap(p), t[s].reflow(p);
    }
  }, r.prototype.mainVisual = function(t) {
    for (var e = n.prototype.mainVisual.call(this, t), i = this.renderOutliers(t), a = 0; a < i.length; a++) {
      var s = i[a].getElement();
      s && e.append(s);
    }
    return e;
  }, r.prototype.createLines = function(t, e) {
    this.drawLines(t, e, this.whiskerPoints, e.whiskers), this.drawLines(t, e, this.medianPoints, e.median), this.drawLines(t, e, this.meanPoints, e.mean);
  }, r.prototype.getBorderColor = function() {
    return (this.options.border || {}).color ? this.options.border.color : this.color ? this.color : n.prototype.getBorderColor.call(this);
  }, r;
}(Ti);
O(ea, {
  border: {
    _brightness: 0.8
  },
  line: {
    width: 2
  },
  median: {
    color: "#f6f6f6"
  },
  mean: {
    width: 2,
    dashType: "dash",
    color: "#f6f6f6"
  },
  overlay: {
    gradient: "glass"
  },
  tooltip: {
    format: "<table><tr><th colspan='2'>{6:d}</th></tr><tr><td>Lower:</td><td>{0:C}</td></tr><tr><td>Q1:</td><td>{1:C}</td></tr><tr><td>Median:</td><td>{2:C}</td></tr><tr><td>Mean:</td><td>{5:C}</td></tr><tr><td>Q3:</td><td>{3:C}</td></tr><tr><td>Upper:</td><td>{4:C}</td></tr></table>"
  },
  highlight: {
    opacity: 1,
    border: {
      width: 1,
      opacity: 1
    },
    line: {
      width: 1,
      opacity: 1
    }
  },
  notes: {
    visible: !0,
    label: {}
  },
  outliers: {
    visible: !0,
    size: kn,
    type: Xc,
    background: J,
    border: {
      width: 2,
      opacity: 1
    },
    opacity: 0
  },
  extremes: {
    visible: !0,
    size: kn,
    type: fe,
    background: J,
    border: {
      width: 2,
      opacity: 1
    },
    opacity: 0
  }
});
b(ea.prototype, xe);
var Ty = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflowBoxSlot = function(t) {
    this.boxSlot.y1 = t.y1, this.boxSlot.y2 = t.y2;
  }, r.prototype.reflowWhiskerSlot = function(t) {
    this.whiskerSlot.y1 = t.y1, this.whiskerSlot.y2 = t.y2;
  }, r.prototype.calcMeanPoints = function(t, e) {
    return [
      [[e.x1, t.y1], [e.x1, t.y2]]
    ];
  }, r.prototype.calcWhiskerPoints = function(t, e) {
    var i = e.center().y;
    return [[
      [e.x1, i - 5],
      [e.x1, i + 5],
      [e.x1, i],
      [t.x1, i]
    ], [
      [e.x2, i - 5],
      [e.x2, i + 5],
      [e.x2, i],
      [t.x2, i]
    ]];
  }, r.prototype.calcMedianPoints = function(t, e) {
    return [
      [[e.x1, t.y1], [e.x1, t.y2]]
    ];
  }, r;
}(ea), Cy = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.addValue = function(t, e) {
    var i = e.categoryIx, a = e.category, s = e.series, l = e.seriesIx, p = this, h = p.children, c = p.options, u = t.valueFields, v = this.splitValue(u), f = Yu(v), d = s.data[i], m = this.categoryPoints[i], _;
    m || (this.categoryPoints[i] = m = []), f && (_ = this.createPoint(t, e));
    var w = h[i];
    w || (w = new Oo({
      vertical: c.invertAxes,
      gap: c.gap,
      spacing: c.spacing,
      rtl: !c.invertAxes && (this.chartService || {}).rtl
    }), this.append(w)), _ && (this.updateRange(u, e), w.append(_), _.categoryIx = i, _.category = a, _.series = s, _.seriesIx = l, _.owner = this, _.dataItem = d), this.points.push(_), m.push(_);
  }, r.prototype.pointType = function() {
    return this.options.invertAxes ? Ty : ea;
  }, r.prototype.splitValue = function(t) {
    return [
      t.lower,
      t.q1,
      t.median,
      t.q3,
      t.upper
    ];
  }, r.prototype.updateRange = function(t, e) {
    var i = e.series.axis, a = this.valueAxisRanges[i], s = this.splitValue(t).concat(this.filterOutliers(t.outliers));
    P(t.mean) && (s = s.concat(t.mean)), a = this.valueAxisRanges[i] = a || { min: gt, max: xt }, a = this.valueAxisRanges[i] = {
      min: Math.min.apply(Math, s.concat([a.min])),
      max: Math.max.apply(Math, s.concat([a.max]))
    };
  }, r.prototype.formatPointValue = function(t, e) {
    var i = t.value;
    return this.chartService.format.auto(
      e,
      i.lower,
      i.q1,
      i.median,
      i.q3,
      i.upper,
      i.mean,
      t.category
    );
  }, r.prototype.filterOutliers = function(t) {
    for (var e = (t || []).length, i = [], a = 0; a < e; a++) {
      var s = t[a];
      P(s) && s !== null && i.push(s);
    }
    return i;
  }, r.prototype.supportsPointInactiveOpacity = function() {
    return !1;
  }, r;
}(ta), ky = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.getAxis = function() {
    var t = this.chart.seriesAxes(this.series), e = this.isVertical ? t.y : t.x;
    return e;
  }, r;
}(dl);
function Yt(n) {
  return P(n) && n !== null;
}
var Ci = function(n) {
  function r(o, t) {
    n.call(this, t), this.plotArea = o, this.chartService = o.chartService, this._initFields(), this.render();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initFields = function() {
    this.xAxisRanges = {}, this.yAxisRanges = {}, this.points = [], this.seriesPoints = [], this.seriesOptions = [], this._evalSeries = [];
  }, r.prototype.render = function() {
    this.traverseDataPoints(this.addValue.bind(this));
  }, r.prototype.addErrorBar = function(t, e, i) {
    var a = t.value[e], s = e + "Value", l = e + "ErrorLow", p = e + "ErrorHigh", h = i.seriesIx, c = i.series, u = t.options.errorBars, v = i[l], f = i[p];
    if (Y(a)) {
      var d;
      Y(v) && Y(f) && (d = { low: v, high: f }), u && P(u[s]) && (this.seriesErrorRanges = this.seriesErrorRanges || { x: [], y: [] }, this.seriesErrorRanges[e][h] = this.seriesErrorRanges[e][h] || new Mu(u[s], c, e), d = this.seriesErrorRanges[e][h].getErrorRange(a, u[s])), d && this.addPointErrorBar(d, t, e);
    }
  }, r.prototype.addPointErrorBar = function(t, e, i) {
    var a = t.low, s = t.high, l = e.series, p = e.options.errorBars, h = i === B, c = {};
    e[i + "Low"] = a, e[i + "High"] = s, e.errorBars = e.errorBars || [];
    var u = new ky(a, s, h, this, l, p);
    e.errorBars.push(u), e.append(u), c[i] = a, this.updateRange(c, l), c[i] = s, this.updateRange(c, l);
  }, r.prototype.addValue = function(t, e) {
    var i = t.x, a = t.y, s = e.seriesIx, l = this.options.series[s], p = this.seriesMissingValues(l), h = this.seriesPoints[s], c = t;
    Yt(i) && Yt(a) || (c = this.createMissingValue(c, p));
    var u;
    c && (u = this.createPoint(c, e), u && (Object.assign(u, e), this.addErrorBar(u, D, e), this.addErrorBar(u, B, e)), this.updateRange(c, e.series)), this.points.push(u), h.push(u);
  }, r.prototype.seriesMissingValues = function(t) {
    return t.missingValues;
  }, r.prototype.createMissingValue = function() {
  }, r.prototype.updateRange = function(t, e) {
    var i = this.chartService.intl, a = e.xAxis, s = e.yAxis, l = t.x, p = t.y, h = this.xAxisRanges[a], c = this.yAxisRanges[s];
    Yt(l) && (h = this.xAxisRanges[a] = h || { min: gt, max: xt }, se(l) && (l = Rt(i, l)), h.min = Math.min(h.min, l), h.max = Math.max(h.max, l)), Yt(p) && (c = this.yAxisRanges[s] = c || { min: gt, max: xt }, se(p) && (p = Rt(i, p)), c.min = Math.min(c.min, p), c.max = Math.max(c.max, p));
  }, r.prototype.evalPointOptions = function(t, e, i) {
    var a = i.series, s = i.seriesIx, l = {
      defaults: a._defaults,
      excluded: [
        "data",
        "tooltip",
        "content",
        "template",
        "visual",
        "toggle",
        "_outOfRangeMinPoint",
        "_outOfRangeMaxPoint",
        "drilldownSeriesFactory"
      ]
    }, p = this._evalSeries[s];
    P(p) || (this._evalSeries[s] = p = nr(t, {}, l, !0));
    var h = t;
    return p && (h = b({}, t), nr(h, {
      value: e,
      series: a,
      dataItem: i.dataItem
    }, l)), h;
  }, r.prototype.pointType = function() {
    return Le;
  }, r.prototype.pointOptions = function(t, e) {
    var i = this.seriesOptions[e];
    if (!i) {
      var a = this.pointType().prototype.defaults;
      this.seriesOptions[e] = i = b({}, a, {
        markers: {
          opacity: t.opacity
        },
        tooltip: {
          format: this.options.tooltip.format
        },
        labels: {
          format: this.options.labels.format
        }
      }, t);
    }
    return i;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.series, a = this.pointOptions(i, e.seriesIx), s = e.color || i.color;
    a = this.evalPointOptions(a, t, e), vt(i.color) && (s = a.color);
    var l = new Le(t, a);
    return l.color = s, this.append(l), l;
  }, r.prototype.seriesAxes = function(t) {
    var e = t.xAxis, i = t.yAxis, a = this.plotArea, s = e ? a.namedXAxes[e] : a.axisX, l = i ? a.namedYAxes[i] : a.axisY;
    if (!s)
      throw new Error("Unable to locate X axis with name " + e);
    if (!l)
      throw new Error("Unable to locate Y axis with name " + i);
    return {
      x: s,
      y: l
    };
  }, r.prototype.reflow = function(t) {
    var e = this, i = this.points, a = !this.options.clip, s = 0;
    this.traverseDataPoints(function(l, p) {
      var h = i[s++], c = e.seriesAxes(p.series), u = c.x.getSlot(l.x, l.x, a), v = c.y.getSlot(l.y, l.y, a);
      if (h)
        if (u && v) {
          var f = e.pointSlot(u, v);
          h.reflow(f);
        } else
          h.visible = !1;
    }), this.box = t;
  }, r.prototype.pointSlot = function(t, e) {
    return new L(t.x1, e.y1, t.x2, e.y2);
  }, r.prototype.traverseDataPoints = function(t) {
    for (var e = this, i = this, a = i.options.series, s = i.seriesPoints, l = 0; l < a.length; l++) {
      var p = a[l], h = s[l];
      h || (s[l] = []);
      for (var c = 0; c < p.data.length; c++) {
        var u = e._bindPoint(p, l, c), v = u.valueFields, f = u.fields;
        t(v, b({
          pointIx: c,
          series: p,
          seriesIx: l,
          dataItem: p.data[c],
          owner: e
        }, f));
      }
    }
  }, r.prototype.formatPointValue = function(t, e) {
    var i = t.value;
    return this.chartService.format.auto(e, i.x, i.y);
  }, r.prototype.animationPoints = function() {
    for (var t = this.points, e = [], i = 0; i < t.length; i++)
      e.push((t[i] || {}).marker);
    return e;
  }, r;
}(rt);
O(Ci, {
  series: [],
  tooltip: {
    format: "{0}, {1}"
  },
  labels: {
    format: "{0}, {1}"
  },
  clip: !0
});
b(Ci.prototype, Qn, {
  _bindPoint: ze.prototype._bindPoint
});
var no = function(n) {
  function r(o, t) {
    n.call(this, o, t), this.category = o.category;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createHighlight = function() {
    var t = this.options.highlight, e = t.border, i = this.options.markers, a = this.box.center(), s = (i.size + i.border.width + e.width) / 2, l = new pt(), p = new Je(new ve([a.x, a.y + s / 5 + e.width / 2], s + e.width / 2), {
      stroke: {
        color: "none"
      },
      fill: this.createGradient({
        gradient: "bubbleShadow",
        color: i.background,
        stops: [{
          offset: 0,
          color: i.background,
          opacity: 0.3
        }, {
          offset: 1,
          color: i.background,
          opacity: 0
        }]
      })
    }), h = new Je(new ve([a.x, a.y], s), {
      stroke: {
        color: e.color || new Ee(i.background).brightness(Xn).toHex(),
        width: e.width,
        opacity: e.opacity
      },
      fill: {
        color: i.background,
        opacity: t.opacity
      }
    });
    return l.append(p, h), l;
  }, r;
}(Le);
no.prototype.defaults = b({}, no.prototype.defaults, {
  labels: {
    position: $
  },
  highlight: {
    opacity: 1,
    border: {
      color: "#fff",
      width: 2,
      opacity: 1
    }
  }
});
no.prototype.defaults.highlight.zIndex = void 0;
var qu = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initFields = function() {
    this._maxSize = xt, n.prototype._initFields.call(this);
  }, r.prototype.addValue = function(t, e) {
    t.size !== null && (t.size > 0 || t.size < 0 && e.series.negativeValues.visible) ? (this._maxSize = Math.max(this._maxSize, Math.abs(t.size)), n.prototype.addValue.call(this, t, e)) : (this.points.push(null), this.seriesPoints[e.seriesIx].push(null));
  }, r.prototype.reflow = function(t) {
    this.updateBubblesSize(t), n.prototype.reflow.call(this, t);
  }, r.prototype.pointType = function() {
    return no;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.series, a = i.data.length, s = e.pointIx * (ne / a), l = {
      delay: s,
      duration: ne - s,
      type: _i
    }, p = e.color || i.color;
    t.size < 0 && i.negativeValues.visible && (p = U(
      i.negativeValues.color,
      p
    ));
    var h = b({
      labels: {
        animation: {
          delay: s,
          duration: ne - s
        }
      }
    }, this.pointOptions(i, e.seriesIx), {
      markers: {
        type: fe,
        border: i.border,
        opacity: i.opacity,
        animation: l
      }
    });
    h = this.evalPointOptions(h, t, e), vt(i.color) && (p = h.color), h.markers.background = p;
    var c = new no(t, h);
    return c.color = p, this.append(c), c;
  }, r.prototype.updateBubblesSize = function(t) {
    for (var e = this, i = this, a = i.options.series, s = Math.min(t.width(), t.height()), l = 0; l < a.length; l++)
      for (var p = a[l], h = e.seriesPoints[l], c = p.minSize || Math.max(s * 0.02, 10), u = p.maxSize || s * 0.2, v = c / 2, f = u / 2, d = Math.PI * v * v, m = Math.PI * f * f, _ = m - d, w = _ / e._maxSize, A = 0; A < h.length; A++) {
        var T = h[A];
        if (T) {
          var k = Math.abs(T.value.size) * w, C = Math.sqrt((d + k) / Math.PI), z = U(T.options.zIndex, 0), V = z + (1 - C / f);
          b(T.options, {
            zIndex: V,
            markers: {
              size: C * 2,
              zIndex: V
            },
            labels: {
              zIndex: V + 1
            }
          });
        }
      }
  }, r.prototype.formatPointValue = function(t, e) {
    var i = t.value;
    return this.chartService.format.auto(e, i.x, i.y, i.size, t.category);
  }, r.prototype.createAnimation = function() {
  }, r.prototype.createVisual = function() {
  }, r;
}(Ci);
O(qu, {
  tooltip: {
    format: "{3}"
  },
  labels: {
    format: "{3}"
  }
});
var Zu = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(tr);
b(Zu.prototype, xe);
var Eo = function(n) {
  function r(o, t) {
    n.call(this, t), this.aboveAxis = this.options.aboveAxis, this.color = t.color || J, this.value = o;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    var t = this.options;
    this._rendered || (this._rendered = !0, P(this.value.target) && (this.target = new Zu({
      type: t.target.shape,
      background: t.target.color || this.color,
      opacity: t.opacity,
      zIndex: t.zIndex,
      border: t.target.border,
      vAlign: tt,
      align: et
    }), this.target.value = this.value, this.target.dataItem = this.dataItem, this.target.series = this.series, this.append(this.target)), this.createLabel(), this.createNote());
  }, r.prototype.createLabel = function() {
    var t = this.options, e = t.labels;
    if (e.visible) {
      var i = this.pointData(), a = Ct(e), s;
      a ? s = a(i) : s = this.formatValue(e.format), this.label = new Jn(s, e, i), this.append(this.label);
    }
  }, r.prototype.reflow = function(t) {
    this.render();
    var e = this, i = e.options, a = e.target, s = e.owner, l = i.invertAxes, p = s.seriesValueAxis(this.options), h = s.categorySlot(s.categoryAxis, i.categoryIx, p), c = p.getSlot(this.value.target), u = l ? c : h, v = l ? h : c;
    if (a) {
      var f = new L(
        u.x1,
        v.y1,
        u.x2,
        v.y2
      );
      a.options.height = l ? f.height() : i.target.line.width, a.options.width = l ? i.target.line.width : f.width(), a.reflow(f);
    }
    var d = this.label;
    d && (d.options.aboveAxis = this.aboveAxis, d.reflow(t)), this.note && this.note.reflow(t), this.box = t;
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this);
    var t = this.options, e = H.fromRect(this.box.toRect(), {
      fill: {
        color: this.color,
        opacity: t.opacity
      },
      stroke: null
    });
    t.border.width > 0 && e.options.set("stroke", {
      color: t.border.color || this.color,
      width: t.border.width,
      dashType: t.border.dashType,
      opacity: U(t.border.opacity, t.opacity)
    }), this.bodyVisual = e, ae(e), this.visual.append(e);
  }, r.prototype.createAnimation = function() {
    this.bodyVisual && (this.animation = pe.create(
      this.bodyVisual,
      this.options.animation
    ));
  }, r.prototype.createHighlight = function(t) {
    return H.fromRect(this.box.toRect(), t);
  }, r.prototype.highlightVisual = function() {
    return this.bodyVisual;
  }, r.prototype.highlightVisualArgs = function() {
    return {
      rect: this.box.toRect(),
      visual: this.bodyVisual,
      options: this.options
    };
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.pointData = function() {
    return {
      dataItem: this.dataItem,
      category: this.category,
      value: this.value,
      series: this.series
    };
  }, r.prototype.overlapsBox = function(t) {
    return this.box.overlaps(t);
  }, r;
}(rt);
Eo.prototype.tooltipAnchor = Ai.prototype.tooltipAnchor;
O(Eo, {
  border: {
    width: 1
  },
  vertical: !1,
  opacity: 1,
  target: {
    shape: "",
    border: {
      width: 0,
      color: "green"
    },
    line: {
      width: 2
    }
  },
  labels: {
    visible: !1
  },
  tooltip: {
    format: "Current: {0}<br />Target: {1}"
  },
  notes: {
    label: {}
  }
});
b(Eo.prototype, xe);
b(Eo.prototype, wi);
var Al = function(n) {
  function r(o, t) {
    Py(t), n.call(this, o, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflowCategories = function(t) {
    for (var e = this.children, i = e.length, a = 0; a < i; a++)
      e[a].reflow(t[a]);
  }, r.prototype.plotRange = function(t) {
    var e = t.series, i = this.seriesValueAxis(e), a = this.categoryAxisCrossingValue(i);
    return [a, t.value.current || a];
  }, r.prototype.createPoint = function(t, e) {
    var i = e.categoryIx, a = e.series, s = this, l = s.options, p = s.children, h = t.valueFields, c = b({
      vertical: !l.invertAxes,
      overlay: a.overlay,
      categoryIx: i,
      invertAxes: l.invertAxes
    }, a), u = t.fields.color || a.color;
    c = this.evalPointOptions(c, h, e), vt(a.color) && (u = c.color);
    var v = new Eo(h, c);
    v.color = u;
    var f = p[i];
    return f || (f = new Oo({
      vertical: l.invertAxes,
      gap: l.gap,
      spacing: l.spacing,
      rtl: !l.invertAxes && (this.chartService || {}).rtl
    }), this.append(f)), f.append(v), v;
  }, r.prototype.updateRange = function(t, e) {
    var i = t.current, a = t.target, s = e.series.axis, l = this.valueAxisRanges[s];
    P(i) && !isNaN(i) && P(a && !isNaN(a)) && (l = this.valueAxisRanges[s] = l || { min: gt, max: xt }, l.min = Math.min(l.min, i, a), l.max = Math.max(l.max, i, a));
  }, r.prototype.formatPointValue = function(t, e) {
    return this.chartService.format.auto(e, t.value.current, t.value.target);
  }, r.prototype.pointValue = function(t) {
    return t.valueFields.current;
  }, r.prototype.aboveAxis = function(t) {
    var e = t.value.current;
    return e > 0;
  }, r.prototype.createAnimation = function() {
    var t = this, e = this.points;
    this._setAnimationOptions();
    for (var i = 0; i < e.length; i++) {
      var a = e[i];
      a.options.animation = t.options.animation, a.createAnimation();
    }
  }, r;
}(ze);
Al.prototype._setAnimationOptions = Si.prototype._setAnimationOptions;
O(Al, {
  animation: {
    type: ye
  }
});
function Py(n) {
  for (var r = n.series, o = 0; o < r.length; o++) {
    var t = r[o], e = t.data;
    e && !Ot(e[0]) && !le(e[0]) && (t.data = [e]);
  }
}
var ra = function(n) {
  function r(o, t) {
    n.call(this), this.chartService = o, this.options = b({}, this.options, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.getStyle = function(t, e) {
    var i = t.background, a = t.border.color;
    if (e) {
      var s = e.color || e.options.color;
      i = U(i, s), a = U(a, s);
    }
    var l = ot(t.padding || {}, "auto");
    return {
      backgroundColor: i,
      borderColor: a,
      font: t.font,
      color: t.color,
      opacity: t.opacity,
      borderWidth: qr(t.border.width),
      paddingTop: qr(l.top),
      paddingBottom: qr(l.bottom),
      paddingLeft: qr(l.left),
      paddingRight: qr(l.right)
    };
  }, r.prototype.show = function(t, e, i) {
    t.format = e.format;
    var a = this.getStyle(e, i);
    t.style = a;
    var s = new Ee(a.backgroundColor);
    !P(e.color) && !s.isDark() && (t.className = "k-chart-tooltip-inverse"), this.chartService.notify(Nu, t), this.visible = !0;
  }, r.prototype.hide = function() {
    this.chartService && this.chartService.notify(Hu), this.visible = !1;
  }, r.prototype.destroy = function() {
    delete this.chartService;
  }, r;
}(N);
O(ra, {
  border: {
    width: 1
  },
  opacity: 1
});
var Qu = function(n) {
  function r(o, t, e) {
    n.call(this, o, e), this.crosshair = t, this.formatService = o.format, this.initAxisName();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initAxisName = function() {
    var t = this.crosshair.axis, e = t.plotArea, i;
    e.categoryAxis ? i = t.getCategory ? "categoryAxis" : "valueAxis" : i = t.options.vertical ? "yAxis" : "xAxis", this.axisName = i;
  }, r.prototype.showAt = function(t) {
    var e = this, i = e.crosshair.axis, a = e.options, s = i[a.stickyMode ? "getCategory" : "getValue"](t), l = s;
    a.format ? l = this.formatService.auto(a.format, s) : i.options.type === xr && (l = this.formatService.auto(i.options.labels.dateFormats[i.options.baseUnit], s)), this.show({
      point: t,
      anchor: this.getAnchor(),
      crosshair: this.crosshair,
      value: l,
      axisName: this.axisName,
      axisIndex: this.crosshair.axis.axisIndex
    }, this.options);
  }, r.prototype.hide = function() {
    this.chartService.notify(Hu, {
      crosshair: this.crosshair,
      axisName: this.axisName,
      axisIndex: this.crosshair.axis.axisIndex
    });
  }, r.prototype.getAnchor = function() {
    var t = this, e = t.crosshair, i = t.options, a = i.position, s = i.padding, l = !e.axis.options.vertical, p = e.line.bbox(), h, c, u;
    return l ? (h = $, a === it ? (c = tt, u = p.bottomLeft().translate(0, s)) : (c = it, u = p.topLeft().translate(0, -s))) : (c = $, a === Q ? (h = et, u = p.topLeft().translate(-s, 0)) : (h = Q, u = p.topRight().translate(s, 0))), {
      point: u,
      align: {
        horizontal: h,
        vertical: c
      }
    };
  }, r;
}(ra);
O(Qu, {
  padding: 10
});
var Ku = function(n) {
  function r(o, t, e) {
    n.call(this, e), this.axis = t, this.stickyMode = t instanceof Me;
    var i = this.options.tooltip;
    i.visible && (this.tooltip = new Qu(
      o,
      this,
      b({}, i, { stickyMode: this.stickyMode })
    ));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.showAt = function(t) {
    this.point = t, this.moveLine(), this.line.visible(!0), this.tooltip && this.tooltip.showAt(t);
  }, r.prototype.hide = function() {
    this.line.visible(!1), this.tooltip && this.tooltip.hide();
  }, r.prototype.moveLine = function() {
    var t = this, e = t.axis, i = t.point, a = e.options.vertical, s = this.getBox(), l = a ? B : D, p = new q(s.x1, s.y1), h;
    if (a ? h = new q(s.x2, s.y1) : h = new q(s.x1, s.y2), i)
      if (this.stickyMode) {
        var c = e.getSlot(e.pointCategoryIndex(i));
        p[l] = h[l] = c.center()[l];
      } else
        p[l] = h[l] = i[l];
    this.box = s, this.line.moveTo(p).lineTo(h);
  }, r.prototype.getBox = function() {
    for (var t = this.axis, e = t.pane.axes, i = e.length, a = t.options.vertical, s = t.lineBox().clone(), l = a ? D : B, p, h = 0; h < i; h++) {
      var c = e[h];
      c.options.vertical !== a && (p ? p.wrap(c.lineBox()) : p = c.lineBox().clone());
    }
    return s[l + 1] = p[l + 1], s[l + 2] = p[l + 2], s;
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this);
    var t = this.options;
    this.line = new H({
      stroke: {
        color: t.color,
        width: t.width,
        opacity: t.opacity,
        dashType: t.dashType
      },
      visible: !1
    }), this.moveLine(), this.visual.append(this.line);
  }, r.prototype.destroy = function() {
    this.tooltip && this.tooltip.destroy(), n.prototype.destroy.call(this);
  }, r;
}(rt);
O(Ku, {
  color: yt,
  width: 2,
  zIndex: -1,
  tooltip: {
    visible: !1
  }
});
var Ju = function(n) {
  function r(o, t) {
    n.call(this, o), this.pane = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.shouldClip = function() {
    for (var t = this.children, e = t.length, i = 0; i < e; i++)
      if (t[i].options.clip === !0)
        return !0;
    return !1;
  }, r.prototype._clipBox = function() {
    return this.pane.chartsBox();
  }, r.prototype.createVisual = function() {
    if (this.visual = new pt({
      zIndex: 0
    }), this.shouldClip()) {
      var t = this.clipBox = this._clipBox(), e = t.toRect(), i = H.fromRect(e);
      ae(i), this.visual.clip(i), this.unclipLabels();
    }
  }, r.prototype.stackRoot = function() {
    return this;
  }, r.prototype.unclipLabels = function() {
    for (var t = this, e = t.children, i = t.clipBox, a = 0; a < e.length; a++)
      for (var s = e[a].points || {}, l = s.length, p = 0; p < l; p++) {
        var h = s[p];
        if (h && h.visible !== !1 && h.overlapsBox && h.overlapsBox(i))
          if (h.unclipElements)
            h.unclipElements();
          else {
            var c = h.label, u = h.note;
            c && c.options.visible && (c.alignToClipBox && c.alignToClipBox(i), c.options.noclip = !0), u && u.options.visible && (u.options.noclip = !0);
          }
      }
  }, r.prototype.destroy = function() {
    n.prototype.destroy.call(this), delete this.parent;
  }, r;
}(rt);
Ju.prototype.isStackRoot = !0;
var Sl = function(n) {
  function r(o) {
    n.call(this, o), this.id = Ey(), this.createTitle(), this.content = new rt(), this.chartContainer = new Ju({}, this), this.append(this.content), this.axes = [], this.charts = [];
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createTitle = function() {
    var t = this.options.title;
    le(t) && (t = b({}, t, {
      align: t.position,
      position: tt
    })), this.title = Ki.buildTitle(t, r.prototype.options.title), this.title && this.append(this.title);
  }, r.prototype.appendAxis = function(t) {
    this.content.append(t), this.axes.push(t), t.pane = this;
  }, r.prototype.appendAxisAt = function(t, e) {
    this.content.append(t), this.axes.splice(e, 0, t), t.pane = this;
  }, r.prototype.appendChart = function(t) {
    this.chartContainer.parent !== this.content && this.content.append(this.chartContainer), this.charts.push(t), this.chartContainer.append(t), t.pane = this;
  }, r.prototype.empty = function() {
    var t = this, e = this.parent;
    if (e) {
      for (var i = 0; i < this.axes.length; i++)
        e.removeAxis(t.axes[i]);
      for (var a = 0; a < this.charts.length; a++)
        e.removeChart(t.charts[a]);
    }
    this.axes = [], this.charts = [], this.content.destroy(), this.content.children = [], this.chartContainer.children = [];
  }, r.prototype.reflow = function(t) {
    var e;
    dt(this.children) === this.content && (e = this.children.pop()), n.prototype.reflow.call(this, t), e && this.children.push(e), this.title && (this.contentBox.y1 += this.title.box.height());
  }, r.prototype.visualStyle = function() {
    var t = n.prototype.visualStyle.call(this);
    return t.zIndex = -10, t;
  }, r.prototype.renderComplete = function() {
    this.options.visible && this.createGridLines();
  }, r.prototype.stackRoot = function() {
    return this;
  }, r.prototype.clipRoot = function() {
    return this;
  }, r.prototype.createGridLines = function() {
    for (var t = this.axes, e = t.concat(this.parent.axes), i = [], a = [], s = 0; s < t.length; s++)
      for (var l = t[s], p = l.options.vertical, h = p ? i : a, c = 0; c < e.length; c++)
        if (h.length === 0) {
          var u = e[c];
          p !== u.options.vertical && Nr(h, l.createGridLines(u));
        }
  }, r.prototype.refresh = function() {
    this.visual.clear(), this.content.parent = null, this.content.createGradient = this.createGradient.bind(this), this.content.renderVisual(), this.content.parent = this, this.title && this.visual.append(this.title.visual), this.visual.append(this.content.visual), this.renderComplete(), this.notifyRender();
  }, r.prototype.chartsBox = function() {
    for (var t = this.axes, e = t.length, i = new L(), a = 0; a < e; a++) {
      var s = t[a], l = s.options.vertical ? B : D, p = s.lineBox();
      i[l + 1] = p[l + 1], i[l + 2] = p[l + 2];
    }
    if (i.x2 === 0)
      for (var h = this.parent.axes, c = h.length, u = 0; u < c; u++) {
        var v = h[u];
        if (!v.options.vertical) {
          var f = v.lineBox();
          i.x1 = f.x1, i.x2 = f.x2;
        }
      }
    return i;
  }, r.prototype.clipBox = function() {
    return this.chartContainer.clipBox;
  }, r.prototype.notifyRender = function() {
    var t = this.getService();
    t && t.notify(yy, {
      pane: new Tn(this),
      index: this.paneIndex,
      name: this.options.name
    });
  }, r;
}(wr), Oy = 1;
function Ey() {
  return "pane" + Oy++;
}
Sl.prototype.isStackRoot = !0;
O(Sl, {
  zIndex: -1,
  shrinkToFit: !0,
  title: {
    align: Q
  },
  visible: !0
});
function pn(n, r) {
  r !== null && n.push(r);
}
function My(n, r, o) {
  var t = r.visible;
  if (P(t))
    return t;
  var e = n.pointVisibility;
  if (e)
    return e[o];
}
function tv(n) {
  for (var r = n.data, o = [], t = 0, e = 0, i = 0; i < r.length; i++) {
    var a = ht.current.bindPoint(n, i), s = a.valueFields.value;
    se(s) && (s = parseFloat(s)), Y(s) ? (a.visible = My(n, a.fields, i) !== !1, a.value = Math.abs(s), o.push(a), a.visible && (t += a.value), s !== 0 && e++) : o.push(null);
  }
  return {
    total: t,
    points: o,
    count: e
  };
}
function yr(n, r) {
  return n && r ? n.toLowerCase() === r.toLowerCase() : n === r;
}
function ft(n, r) {
  for (var o = [], t = [].concat(r), e = 0; e < n.length; e++) {
    var i = n[e];
    Z(i.type, t) && o.push(i);
  }
  return o;
}
function ev(n, r, o) {
  if (r === null)
    return r;
  var t = "_date_" + n, e = r[t];
  return e || (e = Rt(o, Qe(n)(r)), r[t] = e), e;
}
function rv(n, r) {
  var o = n.type, t = r instanceof Date;
  return !o && t || yr(o, xr);
}
function ui(n) {
  return n.length === 1 ? n[0] : n;
}
var Ry = /area/i;
function Ly(n) {
  return n.missingValues ? n.missingValues : Ry.test(n.type) || n.stack ? ir : ni;
}
function as(n, r) {
  var o = ht.current.bindPoint(n, null, r), t = o.valueFields;
  for (var e in t)
    if (Jc(t[e]))
      return !0;
}
function th(n) {
  var r = n.start, o = n.dir, t = n.min, e = n.max, i = n.getter, a = n.hasItem, s = n.series, l, p, h = r;
  do
    h += o, a(h) && (p = i(h), l = as(s, p.item));
  while (t <= h && h <= e && !l);
  if (l)
    return p;
}
function eh(n, r, o, t, e) {
  var i = r.min, a = r.max, s = i > 0 && i < o, l = a + 1 < o;
  if (s || l) {
    var p = Ly(n), h, c;
    if (p !== ni)
      s && (h = t(i - 1)), l && (c = t(a + 1));
    else {
      var u, v;
      s && (u = t(i - 1), v = as(n, u.item), v ? h = u : h = th({
        start: i,
        dir: -1,
        min: 0,
        max: o - 1,
        getter: t,
        hasItem: e,
        series: n
      })), l && (u = t(a + 1), v = as(n, u.item), v ? c = u : c = th({
        start: a,
        dir: 1,
        min: 0,
        max: o - 1,
        getter: t,
        hasItem: e,
        series: n
      }));
    }
    h && (n._outOfRangeMinPoint = h), c && (n._outOfRangeMaxPoint = c);
  }
}
var pr = function(n) {
  function r(o, t, e) {
    n.call(this, t), this.initFields(o, t), this.series = o, this.initSeries(), this.charts = [], this.options.legend = this.options.legend || {}, this.options.legend.items = [], this.axes = [], this.crosshairs = [], this.chartService = e, this.originalOptions = t, this.createPanes(), this.render(), this.createCrosshairs();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function() {
  }, r.prototype.initSeries = function() {
    for (var t = this.series, e = 0; e < t.length; e++)
      t[e].index = e;
  }, r.prototype.createPanes = function() {
    for (var t = this, e = this.options.title || {}, i = this.options.paneDefaults, a = this.options.panes || [], s = Math.max(a.length, 1), l = [], p = b({
      title: {
        color: e.color
      }
    }, i), h = 0; h < s; h++) {
      var c = b({}, p, a[h]);
      se(c.title) && (c.title = b({ text: c.title }, p.title));
      var u = new Sl(c);
      u.paneIndex = h, l.push(u), t.append(u);
    }
    this.panes = l;
  }, r.prototype.crosshairOptions = function(t) {
    return t.options.crosshair;
  }, r.prototype.createCrosshairs = function(t) {
    var e = this;
    t === void 0 && (t = this.panes);
    for (var i = 0; i < t.length; i++)
      for (var a = t[i], s = 0; s < a.axes.length; s++) {
        var l = a.axes[s], p = e.crosshairOptions(l);
        if (p && p.visible) {
          var h = new Ku(e.chartService, l, p);
          e.crosshairs.push(h), a.content.append(h);
        }
      }
  }, r.prototype.removeCrosshairs = function(t) {
    for (var e = this.crosshairs, i = t.axes, a = e.length - 1; a >= 0; a--)
      for (var s = 0; s < i.length; s++)
        if (e[a].axis === i[s]) {
          e.splice(a, 1);
          break;
        }
  }, r.prototype.hideCrosshairs = function() {
    for (var t = this.crosshairs, e = 0; e < t.length; e++)
      t[e].hide();
  }, r.prototype.findPane = function(t) {
    for (var e = this.panes, i, a = 0; a < e.length; a++)
      if (e[a].options.name === t) {
        i = e[a];
        break;
      }
    return i || e[0];
  }, r.prototype.findPointPane = function(t) {
    for (var e = this.panes, i, a = 0; a < e.length; a++)
      if (e[a].box.containsPoint(t)) {
        i = e[a];
        break;
      }
    return i;
  }, r.prototype.appendAxis = function(t) {
    var e = this.findPane(t.options.pane);
    e.appendAxis(t), this.axes.push(t), t.plotArea = this;
  }, r.prototype.removeAxis = function(t) {
    for (var e = this, i = [], a = 0; a < this.axes.length; a++) {
      var s = e.axes[a];
      t !== s ? i.push(s) : s.destroy();
    }
    this.axes = i;
  }, r.prototype.appendChart = function(t, e) {
    this.charts.push(t), e ? e.appendChart(t) : this.append(t);
  }, r.prototype.removeChart = function(t) {
    for (var e = this, i = [], a = 0; a < this.charts.length; a++) {
      var s = e.charts[a];
      s !== t ? i.push(s) : s.destroy();
    }
    this.charts = i;
  }, r.prototype.addToLegend = function(t) {
    for (var e = t.length, i = this.options.legend, a = i.labels || {}, s = i.inactiveItems || {}, l = s.labels || {}, p = [], h = 0; h < e; h++) {
      var c = t[h], u = c.visible !== !1;
      if (c.visibleInLegend !== !1) {
        var v = c.name, f = u ? Ct(a) : Ct(l) || Ct(a);
        f && (v = f({
          text: Yt(v) ? v : "",
          series: c
        }));
        var d = c._defaults, m = c.color;
        vt(m) && d && (m = d.color);
        var _ = void 0, w = void 0;
        u ? (_ = {}, w = m) : (_ = {
          color: l.color,
          font: l.font
        }, w = s.markers.color), Yt(v) && v !== "" && p.push({
          text: v,
          labels: _,
          markerColor: w,
          series: c,
          active: u
        });
      }
    }
    Nr(i.items, p);
  }, r.prototype.groupAxes = function(t) {
    for (var e = [], i = [], a = 0; a < t.length; a++)
      for (var s = t[a].axes, l = 0; l < s.length; l++) {
        var p = s[l];
        p.options.vertical ? i.push(p) : e.push(p);
      }
    return { x: e, y: i, any: e.concat(i) };
  }, r.prototype.groupSeriesByPane = function() {
    for (var t = this, e = this.series, i = {}, a = 0; a < e.length; a++) {
      var s = e[a], l = t.seriesPaneName(s);
      i[l] ? i[l].push(s) : i[l] = [s];
    }
    return i;
  }, r.prototype.filterVisibleSeries = function(t) {
    for (var e = [], i = 0; i < t.length; i++) {
      var a = t[i];
      a.visible !== !1 && e.push(a);
    }
    return e;
  }, r.prototype.reflow = function(t) {
    var e = this.options.plotArea, i = this.panes, a = ot(e.margin);
    this.box = t.clone().unpad(a), this.reflowPanes(), this.detachLabels(), this.reflowAxes(i), this.reflowCharts(i);
  }, r.prototype.redraw = function(t) {
    var e = this, i = [].concat(t);
    this.initSeries();
    var a = this.getRoot();
    a && a.cleanGradients();
    for (var s = 0; s < i.length; s++)
      e.removeCrosshairs(i[s]), i[s].empty();
    this.render(i), this.detachLabels(), this.reflowAxes(this.panes), this.reflowCharts(i), this.createCrosshairs(i);
    for (var l = 0; l < i.length; l++)
      i[l].refresh();
  }, r.prototype.axisCrossingValues = function(t, e) {
    for (var i = t.options, a = [].concat(
      i.axisCrossingValues || i.axisCrossingValue
    ), s = e.length - a.length, l = a[0] || 0, p = 0; p < s; p++)
      a.push(l);
    return a;
  }, r.prototype.alignAxisTo = function(t, e, i, a) {
    var s = t.getSlot(i, i, !0), l = t.options.reverse ? 2 : 1, p = e.getSlot(a, a, !0), h = e.options.reverse ? 2 : 1, c = t.box.translate(
      p[D + h] - s[D + l],
      p[B + h] - s[B + l]
    );
    t.pane !== e.pane && c.translate(0, t.pane.box.y1 - e.pane.box.y1), t.reflow(c);
  }, r.prototype.alignAxes = function(t, e) {
    for (var i = this, a = t[0], s = e[0], l = this.axisCrossingValues(a, e), p = this.axisCrossingValues(s, t), h = {}, c = {}, u = {}, v = {}, f = 0; f < e.length; f++) {
      var d = e[f], m = d.pane, _ = m.id, w = d.options.visible !== !1, A = ja(t, m) || a, T = l;
      A !== a && (T = i.axisCrossingValues(A, e)), i.alignAxisTo(d, A, p[f], T[f]), !d.options._overlap && (R(d.lineBox().x1) === R(A.lineBox().x1) && (h[_] && d.reflow(
        d.box.alignTo(h[_].box, Q).translate(-d.options.margin, 0)
      ), w && (h[_] = d)), R(d.lineBox().x2) === R(A.lineBox().x2) && (d._mirrored || (d.options.labels.mirror = !d.options.labels.mirror, d._mirrored = !0), i.alignAxisTo(d, A, p[f], T[f]), c[_] && d.reflow(
        d.box.alignTo(c[_].box, et).translate(d.options.margin, 0)
      ), w && (c[_] = d)), f !== 0 && s.pane === d.pane && (d.alignTo(s), d.reflow(d.box)));
    }
    for (var k = 0; k < t.length; k++) {
      var C = t[k], z = C.pane, V = z.id, G = C.options.visible !== !1, X = ja(e, z) || s, W = p;
      X !== s && (W = i.axisCrossingValues(X, t)), i.alignAxisTo(C, X, l[k], W[k]), !C.options._overlap && (R(C.lineBox().y1) === R(X.lineBox().y1) && (C._mirrored || (C.options.labels.mirror = !C.options.labels.mirror, C._mirrored = !0), i.alignAxisTo(C, X, l[k], W[k]), u[V] && C.reflow(
        C.box.alignTo(u[V].box, tt).translate(0, -C.options.margin)
      ), G && (u[V] = C)), R(C.lineBox().y2, Tt) === R(X.lineBox().y2, Tt) && (v[V] && C.reflow(
        C.box.alignTo(v[V].box, it).translate(0, C.options.margin)
      ), G && (v[V] = C)), k !== 0 && (C.alignTo(a), C.reflow(C.box)));
    }
  }, r.prototype.shrinkAxisWidth = function(t) {
    for (var e = this.groupAxes(t).any, i = za(e), a = 0, s = 0; s < t.length; s++) {
      var l = t[s];
      l.axes.length > 0 && (a = Math.max(
        a,
        i.width() - l.contentBox.width()
      ));
    }
    if (a !== 0)
      for (var p = 0; p < e.length; p++) {
        var h = e[p];
        h.options.vertical || h.reflow(h.box.shrink(a, 0));
      }
  }, r.prototype.shrinkAxisHeight = function(t) {
    for (var e, i = 0; i < t.length; i++) {
      var a = t[i], s = a.axes, l = Math.max(0, za(s).height() - a.contentBox.height());
      if (l !== 0) {
        for (var p = 0; p < s.length; p++) {
          var h = s[p];
          h.options.vertical && h.reflow(
            h.box.shrink(0, l)
          );
        }
        e = !0;
      }
    }
    return e;
  }, r.prototype.fitAxes = function(t) {
    for (var e = this.groupAxes(t).any, i = 0, a = 0; a < t.length; a++) {
      var s = t[a], l = s.axes, p = s.contentBox;
      if (l.length > 0) {
        var h = za(l), c = Math.max(p.y1 - h.y1, p.y2 - h.y2);
        i = Math.max(i, p.x1 - h.x1);
        for (var u = 0; u < l.length; u++) {
          var v = l[u];
          v.reflow(
            v.box.translate(0, c)
          );
        }
      }
    }
    for (var f = 0; f < e.length; f++) {
      var d = e[f];
      d.reflow(
        d.box.translate(i, 0)
      );
    }
  }, r.prototype.reflowAxes = function(t) {
    for (var e = this, i = this.groupAxes(t), a = 0; a < t.length; a++)
      e.reflowPaneAxes(t[a]);
    i.x.length > 0 && i.y.length > 0 && (this.alignAxes(i.x, i.y), this.shrinkAxisWidth(t), this.autoRotateAxisLabels(i), this.alignAxes(i.x, i.y), this.shrinkAxisWidth(t) && this.alignAxes(i.x, i.y), this.shrinkAxisHeight(t), this.alignAxes(i.x, i.y), this.shrinkAxisHeight(t) && this.alignAxes(i.x, i.y), this.fitAxes(t));
  }, r.prototype.autoRotateAxisLabels = function(t) {
    for (var e = this, i = this, a = i.panes, s = By(a), l, p = 0; p < s.length; p++) {
      var h = s[p];
      h.autoRotateLabels() && (l = !0);
    }
    if (l) {
      for (var c = 0; c < a.length; c++)
        e.reflowPaneAxes(a[c]);
      t.x.length > 0 && t.y.length > 0 && (this.alignAxes(t.x, t.y), this.shrinkAxisWidth(a));
    }
  }, r.prototype.reflowPaneAxes = function(t) {
    var e = t.axes, i = e.length;
    if (i > 0)
      for (var a = 0; a < i; a++)
        e[a].reflow(t.contentBox);
  }, r.prototype.reflowCharts = function(t) {
    for (var e = this.charts, i = e.length, a = this.box, s = 0; s < i; s++) {
      var l = e[s].pane;
      (!l || Z(l, t)) && e[s].reflow(a);
    }
  }, r.prototype.reflowPanes = function() {
    for (var t = this, e = t.box, i = t.panes, a = i.length, s = e.height(), l = 0, p = e.y1, h = 0; h < a; h++) {
      var c = i[h], u = c.options.height;
      if (c.options.width = e.width(), !c.options.height)
        l++;
      else {
        if (u.indexOf && u.indexOf("%")) {
          var v = parseInt(u, 10) / 100;
          c.options.height = v * e.height();
        }
        c.reflow(e.clone()), s -= c.options.height;
      }
    }
    for (var f = 0; f < a; f++) {
      var d = i[f];
      d.options.height || (d.options.height = s / l);
    }
    for (var m = 0; m < a; m++) {
      var _ = i[m], w = e.clone().move(e.x1, p);
      _.reflow(w), p += _.options.height;
    }
  }, r.prototype.backgroundBox = function() {
    for (var t = this.axes, e = t.length, i, a = 0; a < e; a++)
      for (var s = t[a], l = 0; l < e; l++) {
        var p = t[l];
        if (s.options.vertical !== p.options.vertical) {
          var h = s.lineBox().clone().wrap(p.lineBox());
          i ? i = i.wrap(h) : i = h;
        }
      }
    return i || this.box;
  }, r.prototype.chartsBoxes = function() {
    for (var t = this.panes, e = [], i = 0; i < t.length; i++)
      e.push(t[i].chartsBox());
    return e;
  }, r.prototype.addBackgroundPaths = function(t) {
    for (var e = this.chartsBoxes(), i = 0; i < e.length; i++)
      t.paths.push(H.fromRect(e[i].toRect()));
  }, r.prototype.backgroundContainsPoint = function(t) {
    for (var e = this.chartsBoxes(), i = 0; i < e.length; i++)
      if (e[i].containsPoint(t))
        return !0;
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this);
    var t = this.options.plotArea, e = t.opacity, i = t.background, a = t.border;
    a === void 0 && (a = {}), Dy(i) && (i = J, e = 0);
    var s = this._bgVisual = new to({
      fill: {
        color: i,
        opacity: e
      },
      stroke: {
        color: a.width ? a.color : "",
        width: a.width,
        dashType: a.dashType
      },
      zIndex: -1
    });
    this.addBackgroundPaths(s), this.appendVisual(s);
  }, r.prototype.pointsByCategoryIndex = function(t) {
    var e = this.charts, i = [];
    if (t !== null)
      for (var a = 0; a < e.length; a++) {
        var s = e[a];
        if (s.pane.options.name !== "_navigator") {
          var l = e[a].categoryPoints[t];
          if (l && l.length)
            for (var p = 0; p < l.length; p++) {
              var h = l[p];
              h && P(h.value) && h.value !== null && i.push(h);
            }
        }
      }
    return i;
  }, r.prototype.pointsBySeriesIndex = function(t) {
    return this.filterPoints(function(e) {
      return e.series.index === t;
    });
  }, r.prototype.pointsBySeriesName = function(t) {
    return this.filterPoints(function(e) {
      return e.series.name === t;
    });
  }, r.prototype.filterPoints = function(t) {
    for (var e = this.charts, i = [], a = 0; a < e.length; a++)
      for (var s = e[a], l = s.points, p = 0; p < l.length; p++) {
        var h = l[p];
        h && h.visible !== !1 && t(h) && i.push(h);
      }
    return i;
  }, r.prototype.findPoint = function(t) {
    for (var e = this.charts, i = 0; i < e.length; i++)
      for (var a = e[i], s = a.points, l = 0; l < s.length; l++) {
        var p = s[l];
        if (p && p.visible !== !1 && t(p))
          return p;
      }
  }, r.prototype.paneByPoint = function(t) {
    for (var e = this.panes, i = 0; i < e.length; i++) {
      var a = e[i];
      if (a.box.containsPoint(t))
        return a;
    }
  }, r.prototype.detachLabels = function() {
    var t = this.groupAxes(this.panes), e = t.x, i = t.y;
    this.detachAxisGroupLabels(i, e), this.detachAxisGroupLabels(e, i);
  }, r.prototype.detachAxisGroupLabels = function(t, e) {
    for (var i = this, a = 0, s = 0; s < t.length; s++) {
      var l = t[s], p = l.pane, h = ja(e, p) || e[0], c = s + a, u = i.createLabelAxis(l, c, h);
      if (u) {
        a++;
        var v = p.axes.indexOf(l) + a;
        p.appendAxisAt(u, v);
      }
    }
  }, r.prototype.createLabelAxis = function(t, e, i) {
    var a = t.options.labels, s = a.position, l = s !== Lp && s !== Gd, p = a.visible;
    if (l || p === !1)
      return null;
    var h = this.groupAxes(this.panes), c = i.options.vertical ? h.x : h.y, u = this.axisCrossingValues(i, c), v = s === Lp, f = i.range(), d = v ? f.max : f.min, m = j(u[e], f.min, f.max);
    if (m - d === 0)
      return null;
    u.splice(e + 1, 0, d), i.options.axisCrossingValues = u;
    var _ = t.clone();
    return t.clear(), _.options.name = void 0, _.options.line.visible = !1, _.options.crosshair = void 0, _.options.notes = void 0, _.options.plotBands = void 0, _;
  }, r;
}(rt);
function Iy(n) {
  return !n.pane.axes.some(
    function(r) {
      return r.options.vertical === n.options.vertical && r !== n && r.options.visible !== !1;
    }
  );
}
function za(n) {
  for (var r = n.length, o, t = 0; t < r; t++) {
    var e = n[t], i = e.options.visible !== !1;
    if (i || Iy(e)) {
      var a = i ? e.contentBox() : e.lineBox();
      o ? o.wrap(a) : o = a.clone();
    }
  }
  return o || new L();
}
function ja(n, r) {
  for (var o = 0; o < n.length; o++) {
    var t = n[o];
    if (t && t.pane === r)
      return t;
  }
}
function Dy(n) {
  return n === "" || n === null || n === "none" || n === "transparent" || !P(n);
}
var By = function(n) {
  return n.reduce(function(r, o) {
    return r.concat(o.axes);
  }, []);
};
O(pr, {
  series: [],
  plotArea: {
    margin: {}
  },
  background: "",
  border: {
    color: yt,
    width: 0
  },
  paneDefaults: {
    title: {}
  },
  legend: {
    inactiveItems: {
      labels: {
        color: "#919191"
      },
      markers: {
        color: "#919191"
      }
    }
  }
});
var Mo = {
  hover: function(n, r) {
    this._dispatchEvent(n, r, Vu);
  },
  click: function(n, r) {
    this._dispatchEvent(n, r, dy);
  }
}, zy = function(n) {
  function r(o, t, e) {
    n.call(this);
    var i = t.canonicalFields(o), a = t.valueFields(o), s = t.sourceFields(o, i), l = this._seriesFields = [], p = e.query(o.type), h = o.aggregate || p;
    this._series = o, this._binder = t;
    for (var c = 0; c < i.length; c++) {
      var u = i[c], v = void 0;
      if (le(h))
        v = h[u];
      else if (c === 0 || Z(u, a))
        v = h;
      else
        break;
      v && l.push({
        canonicalName: u,
        name: s[c],
        transform: vt(v) ? v : es[v]
      });
    }
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.aggregatePoints = function(t, e) {
    var i = this, a = this, s = a._series, l = a._seriesFields, p = this._bindPoints(t || []), h = p.dataItems[0], c = {};
    if (h && !Y(h) && !Ot(h)) {
      var u = function() {
      };
      u.prototype = h, c = new u();
    }
    for (var v = 0; v < l.length; v++) {
      var f = l[v], d = i._bindField(p.values, f.canonicalName), m = f.transform(d, s, p.dataItems, e);
      if (m !== null && le(m) && !P(m.length) && !(m instanceof Date)) {
        c = m;
        break;
      } else
        P(m) && jy(f.name, c, m);
    }
    return c;
  }, r.prototype._bindPoints = function(t) {
    for (var e = this, i = e._binder, a = e._series, s = [], l = [], p = 0; p < t.length; p++) {
      var h = t[p];
      s.push(i.bindPoint(a, h)), l.push(a.data[h]);
    }
    return {
      values: s,
      dataItems: l
    };
  }, r.prototype._bindField = function(t, e) {
    for (var i = [], a = t.length, s = 0; s < a; s++) {
      var l = t[s], p = l.valueFields, h = void 0;
      P(p[e]) ? h = p[e] : h = l.fields[e], i.push(h);
    }
    return i;
  }, r;
}(N);
function jy(n, r, o) {
  var t = r, e = n;
  if (n.indexOf(".") > -1) {
    for (var i = n.split("."); i.length > 1; )
      e = i.shift(), P(t[e]) || (t[e] = {}), t = t[e];
    e = i.shift();
  }
  t[e] = o;
}
var ar = function(n) {
  function r() {
    n.call(this), this._defaults = {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.register = function(t, e) {
    for (var i = this, a = 0; a < t.length; a++)
      i._defaults[t[a]] = e;
  }, r.prototype.query = function(t) {
    return this._defaults[t];
  }, r;
}(N);
ar.current = new ar();
var ss = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createLabel = function() {
    var t = this.options.labels, e = b({}, t, t.from), i = b({}, t, t.to);
    e.visible && (this.labelFrom = this._createLabel(e), this.append(this.labelFrom)), i.visible && (this.labelTo = this._createLabel(i), this.append(this.labelTo));
  }, r.prototype._createLabel = function(t) {
    var e = Ct(t), i = this.pointData(), a;
    return e ? a = e(i) : a = this.formatValue(t.format), new Jn(
      a,
      b(
        {
          vertical: this.options.vertical
        },
        t
      ),
      i
    );
  }, r.prototype.reflow = function(t) {
    this.render();
    var e = this, i = e.labelFrom, a = e.labelTo, s = e.value;
    this.box = t, i && (i.options.aboveAxis = s.from > s.to, i.reflow(t)), a && (a.options.aboveAxis = s.to > s.from, a.reflow(t)), this.note && this.note.reflow(t);
  }, r;
}(Ai);
ss.prototype.defaults = b({}, ss.prototype.defaults, {
  labels: {
    format: "{0} - {1}"
  },
  tooltip: {
    format: "{1}"
  }
});
var iv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointType = function() {
    return ss;
  }, r.prototype.pointValue = function(t) {
    return t.valueFields;
  }, r.prototype.formatPointValue = function(t, e) {
    return t.value.from === null && t.value.to === null ? "" : this.chartService.format.auto(e, t.value.from, t.value.to);
  }, r.prototype.plotRange = function(t) {
    return t ? [t.value.from, t.value.to] : 0;
  }, r.prototype.updateRange = function(t, e) {
    var i = e.series.axis, a = t.from, s = t.to, l = this.valueAxisRanges[i];
    t !== null && Y(a) && Y(s) && (l = this.valueAxisRanges[i] = l || { min: gt, max: xt }, l.min = Math.min(l.min, a), l.max = Math.max(l.max, a), l.min = Math.min(l.min, s), l.max = Math.max(l.max, s));
  }, r.prototype.aboveAxis = function(t) {
    var e = t.value;
    return e.from < e.to;
  }, r;
}(Si);
iv.prototype.plotLimits = ze.prototype.plotLimits;
var rh = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.aliasFor = function() {
    return this.parent;
  }, r;
}(Le), ov = "auto", Vy = "{0}", Ny = "{1}", ao = function(n) {
  function r(o, t) {
    n.call(this), this.value = o, this.options = t, this.aboveAxis = U(this.options.aboveAxis, !0), this.tooltipTracking = !0, this.initLabelsFormat();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    if (!this._rendered) {
      this._rendered = !0;
      var t = this.options, e = t.markers, i = t.labels, a = this.value, s = this.fromPoint = new rh(a, b({}, this.options, {
        labels: i.from,
        markers: e.from
      })), l = this.toPoint = new rh(a, b({}, this.options, {
        labels: i.to,
        markers: e.to
      }));
      this.copyFields(s), this.copyFields(l), this.append(s), this.append(l);
    }
  }, r.prototype.reflow = function(t) {
    this.render();
    var e = t.from, i = t.to;
    this.positionLabels(e, i), this.fromPoint.reflow(e), this.toPoint.reflow(i), this.box = this.fromPoint.markerBox().clone().wrap(this.toPoint.markerBox());
  }, r.prototype.createHighlight = function() {
    var t = new pt();
    return t.append(this.fromPoint.createHighlight()), t.append(this.toPoint.createHighlight()), t;
  }, r.prototype.highlightVisual = function() {
    return this.visual;
  }, r.prototype.highlightVisualArgs = function() {
    return {
      options: this.options,
      from: this.fromPoint.highlightVisualArgs(),
      to: this.toPoint.highlightVisualArgs()
    };
  }, r.prototype.tooltipAnchor = function() {
    var t = this.owner.pane.clipBox(), e = !t || t.overlaps(this.box);
    if (e) {
      var i = this.box, a = i.center(), s = Q, l, p, h;
      return this.options.vertical ? (l = a.x, p = i.y1 - ue, h = it) : (l = i.x2 + ue, p = a.y, h = $), {
        point: new F(l, p),
        align: {
          horizontal: s,
          vertical: h
        }
      };
    }
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.overlapsBox = function(t) {
    return this.box.overlaps(t);
  }, r.prototype.unclipElements = function() {
    this.fromPoint.unclipElements(), this.toPoint.unclipElements();
  }, r.prototype.initLabelsFormat = function() {
    var t = this.options.labels;
    t.format || ((!t.from || !t.from.format) && (t.from = Object.assign({}, t.from, {
      format: Vy
    })), (!t.to || !t.to.format) && (t.to = Object.assign({}, t.to, {
      format: Ny
    })));
  }, r.prototype.positionLabels = function(t, e) {
    var i = this.options, a = i.labels, s = i.vertical;
    if (a.position === ov) {
      var l, p;
      s ? e.y1 <= t.y1 ? (p = Pn, l = rs) : (p = rs, l = Pn) : e.x1 <= t.x1 ? (p = Q, l = et) : (p = et, l = Q), (!a.from || !a.from.position) && (this.fromPoint.options.labels.position = l), (!a.to || !a.to.position) && (this.toPoint.options.labels.position = p);
    }
  }, r.prototype.copyFields = function(t) {
    t.dataItem = this.dataItem, t.category = this.category, t.series = this.series, t.color = this.color, t.owner = this.owner;
  }, r;
}(rt);
b(ao.prototype, xe);
b(ao.prototype, wi);
ao.prototype.defaults = {
  markers: {
    visible: !1,
    background: J,
    size: kn,
    type: fe,
    border: {
      width: 2
    },
    opacity: 1
  },
  labels: {
    visible: !1,
    margin: ot(3),
    padding: ot(4),
    animation: {
      type: Cr,
      delay: ne
    },
    position: ov
  },
  notes: {
    label: {}
  },
  highlight: {
    markers: {
      border: {
        color: J,
        width: 2
      }
    },
    zIndex: Qc
  },
  tooltip: {
    format: "{0} - {1}"
  }
};
var Tl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createStrokeSegments = function() {
    return this.segmentsFromPoints(this.toGeometryPoints(this.toPoints()));
  }, r.prototype.stackSegments = function() {
    var t = this.fromSegments;
    return this.fromSegments || (t = this.fromSegments = this.segmentsFromPoints(this.toGeometryPoints(this.fromPoints().reverse()))), t;
  }, r.prototype.createStroke = function(t) {
    var e = new H(t), i = new H(t);
    e.segments.push.apply(e.segments, this.strokeSegments()), i.segments.push.apply(i.segments, this.stackSegments()), this.visual.append(e), this.visual.append(i);
  }, r.prototype.hasStackSegment = function() {
    return !0;
  }, r.prototype.fromPoints = function() {
    return this.linePoints.map(function(t) {
      return t.fromPoint;
    });
  }, r.prototype.toPoints = function() {
    return this.linePoints.map(function(t) {
      return t.toPoint;
    });
  }, r;
}(bi), Hy = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createStrokeSegments = function() {
    return this.createCurveSegments(this.toPoints());
  }, r.prototype.stackSegments = function() {
    var t = this.fromSegments;
    return this.fromSegments || (t = this.fromSegments = this.createCurveSegments(this.fromPoints().reverse())), t;
  }, r.prototype.createCurveSegments = function(t) {
    var e = new Wn();
    return e.process(this.toGeometryPoints(t));
  }, r;
}(Tl), nv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createStrokeSegments = function() {
    return this.segmentsFromPoints(this.calculateStepPoints(this.toPoints()));
  }, r.prototype.stackSegments = function() {
    var t = this.fromSegments;
    return this.fromSegments || (t = this.fromSegments = this.segmentsFromPoints(this.calculateStepPoints(this.fromPoints())), t.reverse()), t;
  }, r;
}(Tl);
b(nv.prototype, yl);
var av = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    n.prototype.render.call(this), this.renderSegments();
  }, r.prototype.pointType = function() {
    return ao;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.series, a = e.seriesIx, s = t.valueFields;
    if (!Yt(s.from) && !Yt(s.to))
      if (this.seriesMissingValues(i) === ir)
        s = {
          from: 0,
          to: 0
        };
      else
        return null;
    var l = this.pointOptions(i, a);
    l = this.evalPointOptions(l, s, e);
    var p = t.fields.color || i.color;
    vt(i.color) && (p = l.color);
    var h = new ao(s, l);
    return h.color = p, this.append(h), h;
  }, r.prototype.createSegment = function(t, e, i) {
    var a = (e.line || {}).style, s;
    return a === "smooth" ? s = Hy : a === "step" ? s = nv : s = Tl, new s(t, e, i);
  }, r.prototype.plotRange = function(t, e) {
    return t ? [t.value.from, t.value.to] : [e, e];
  }, r.prototype.valueSlot = function(t, e) {
    var i = t.getSlot(e[0], e[0], !this.options.clip), a = t.getSlot(e[1], e[1], !this.options.clip);
    if (i && a)
      return {
        from: i,
        to: a
      };
  }, r.prototype.pointSlot = function(t, e) {
    var i = e.from, a = e.to, s, l;
    return this.options.invertAxes ? (s = new L(i.x1, t.y1, i.x2, t.y2), l = new L(a.x1, t.y1, a.x2, t.y2)) : (s = new L(t.x1, i.y1, t.x2, i.y2), l = new L(t.x1, a.y1, t.x2, a.y2)), {
      from: s,
      to: l
    };
  }, r.prototype.addValue = function(t, e) {
    var i = t.valueFields;
    Y(i.from) || (i.from = i.to), Y(i.to) || (i.to = i.from), n.prototype.addValue.call(this, t, e);
  }, r.prototype.updateRange = function(t, e) {
    if (t !== null && Y(t.from) && Y(t.to)) {
      var i = e.series.axis, a = this.valueAxisRanges[i] = this.valueAxisRanges[i] || { min: gt, max: xt }, s = t.from, l = t.to;
      a.min = Math.min(a.min, s, l), a.max = Math.max(a.max, s, l);
    }
  }, r.prototype.formatPointValue = function(t, e) {
    var i = t.value;
    return this.chartService.format.auto(e, i.from, i.to);
  }, r.prototype.animationPoints = function() {
    for (var t = this.points, e = [], i = 0; i < t.length; i++) {
      var a = t[i];
      a && (e.push((a.fromPoint || {}).marker), e.push((a.toPoint || {}).marker));
    }
    return e.concat(this._segments);
  }, r;
}(ze);
b(av.prototype, _l, Qn);
var Fy = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = e.options, a = e.value, s = e.owner, l = s.seriesValueAxis(i), p = [], h = [], c = [], u = l.getSlot(a.low, a.high), v = l.getSlot(a.open, a.open), f = l.getSlot(a.close, a.close);
    v.x1 = f.x1 = u.x1 = t.x1, v.x2 = f.x2 = u.x2 = t.x2;
    var d = u.center().x;
    p.push([v.x1, v.y1]), p.push([d, v.y1]), h.push([d, f.y1]), h.push([f.x2, f.y1]), c.push([d, u.y1]), c.push([d, u.y2]), this.lines = [
      p,
      h,
      c
    ], this.box = u.clone().wrap(v.clone().wrap(f)), this.reflowNote();
  }, r.prototype.createBody = function() {
  }, r;
}(Ti), Uy = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointType = function() {
    return Fy;
  }, r;
}(ta), sv = function(n) {
  function r(o, t, e) {
    n.call(this), this.from = o, this.to = t, this.series = e;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.linePoints = function() {
    var t = this.from, e = this, i = e.from.box, a = e.to.box, s = [];
    if (t.isVertical) {
      var l = t.aboveAxis ? i.y1 : i.y2;
      s.push(
        [i.x1, l],
        [a.x2, l]
      );
    } else {
      var p = t.aboveAxis ? i.x2 : i.x1;
      s.push(
        [p, i.y1],
        [p, a.y2]
      );
    }
    return s;
  }, r.prototype.createVisual = function() {
    n.prototype.createVisual.call(this);
    var t = this.series.line || {}, e = H.fromPoints(this.linePoints(), {
      stroke: {
        color: t.color,
        width: t.width,
        opacity: t.opacity,
        dashType: t.dashType
      }
    });
    ae(e), this.visual.append(e);
  }, r;
}(rt);
O(sv, {
  animation: {
    type: Cr,
    delay: ne
  }
});
var $y = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    n.prototype.render.call(this), this.createSegments();
  }, r.prototype.traverseDataPoints = function(t) {
    for (var e = this, i = this.options.series, a = gl(i), s = !this.options.invertAxes, l = 0; l < i.length; l++)
      for (var p = i[l], h = 0, c = 0, u = 0; u < a; u++) {
        var v = ht.current.bindPoint(p, u), f = v.valueFields.value, d = v.fields.summary, m = h, _ = void 0;
        d ? d.toLowerCase() === "total" ? (v.valueFields.value = h, m = 0, _ = h) : (v.valueFields.value = c, _ = m - c, c = 0) : Y(f) && (c += f, h += f, _ = h), t(v, {
          category: e.categoryAxis.categoryAt(u),
          categoryIx: u,
          series: p,
          seriesIx: l,
          total: h,
          runningTotal: c,
          from: m,
          to: _,
          isVertical: s
        });
      }
  }, r.prototype.updateRange = function(t, e) {
    n.prototype.updateRange.call(this, { value: e.to }, e);
  }, r.prototype.aboveAxis = function(t) {
    return t.value >= 0;
  }, r.prototype.plotRange = function(t) {
    return [t.from, t.to];
  }, r.prototype.createSegments = function() {
    for (var t = this, e = this.options.series, i = this.seriesPoints, a = this.segments = [], s = 0; s < e.length; s++) {
      var l = e[s], p = i[s];
      if (p)
        for (var h = void 0, c = 0; c < p.length; c++) {
          var u = p[c];
          if (u && h) {
            var v = new sv(h, u, l);
            a.push(v), t.append(v);
          }
          h = u;
        }
    }
  }, r;
}(Si), ls = [wo, li, To, ci], ih = [Ao, hi].concat(ls), Ke = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function(t) {
    var e = this;
    if (this.namedCategoryAxes = {}, this.namedValueAxes = {}, this.valueAxisRangeTracker = new Ln(), t.length > 0) {
      this.invertAxes = Z(
        t[0].type,
        [
          ye,
          Ar,
          hi,
          li,
          ci,
          si,
          ai,
          pi
        ]
      );
      for (var i = 0; i < t.length; i++) {
        var a = t[i].stack;
        if (a && a.type === "100%") {
          e.stack100 = !0;
          break;
        }
      }
    }
  }, r.prototype.render = function(t) {
    t === void 0 && (t = this.panes), this.createCategoryAxes(t), this.aggregateCategories(t), this.createCategoryAxesLabels(t), this.createCharts(t), this.createValueAxes(t);
  }, r.prototype.removeAxis = function(t) {
    var e = t.options.name;
    n.prototype.removeAxis.call(this, t), t instanceof Me ? delete this.namedCategoryAxes[e] : (this.valueAxisRangeTracker.reset(e), delete this.namedValueAxes[e]), t === this.categoryAxis && delete this.categoryAxis, t === this.valueAxis && delete this.valueAxis;
  }, r.prototype.createCharts = function(t) {
    for (var e = this, i = this.groupSeriesByPane(), a = 0; a < t.length; a++) {
      var s = t[a], l = i[s.options.name || "default"] || [];
      e.addToLegend(l);
      var p = e.filterVisibleSeries(l);
      if (p)
        for (var h = e.groupSeriesByCategoryAxis(p), c = 0; c < h.length; c++)
          e.createChartGroup(h[c], s);
    }
  }, r.prototype.createChartGroup = function(t, e) {
    this.createAreaChart(
      ft(t, [wo, li]),
      e
    ), this.createRangeAreaChart(
      ft(t, [To, ci]),
      e
    ), this.createBarChart(
      ft(t, [or, ye]),
      e
    ), this.createRangeBarChart(
      ft(t, [Co, si]),
      e
    ), this.createBulletChart(
      ft(t, [Ar, ko]),
      e
    ), this.createCandlestickChart(
      ft(t, xi),
      e
    ), this.createBoxPlotChart(
      ft(t, [bo, pi]),
      e
    ), this.createOHLCChart(
      ft(t, So),
      e
    ), this.createWaterfallChart(
      ft(t, [Po, ai]),
      e
    ), this.createLineChart(
      ft(t, [Ao, hi]),
      e
    );
  }, r.prototype.aggregateCategories = function(t) {
    var e = this, i = this.srcSeries || this.series, a = [];
    this._currentPointsCache = {}, this._seriesPointsCache = this._seriesPointsCache || {};
    for (var s = 0; s < i.length; s++) {
      var l = i[s], p = e.seriesCategoryAxis(l), h = e.findPane(p.options.pane), c = yr(p.options.type, xr);
      (c || l.categoryField) && Z(h, t) ? l = e.aggregateSeries(l, p) : l = e.filterSeries(l, p), a.push(l);
    }
    this._seriesPointsCache = this._currentPointsCache, this._currentPointsCache = null, this.srcSeries = i, this.series = a;
  }, r.prototype.filterSeries = function(t, e) {
    var i = (t.data || {}).length;
    if (e._seriesMax = Math.max(e._seriesMax || 0, i), !(Y(e.options.min) || Y(e.options.max)))
      return t;
    var a = e.currentRangeIndices(), s = Z(t.type, ih), l = b({}, t);
    return l.data = (l.data || []).slice(a.min, a.max + 1), s && eh(l, a, i, function(p) {
      return {
        item: t.data[p],
        category: e.categoryAt(p, !0),
        categoryIx: p - a.min
      };
    }, function(p) {
      return P(t.data[p]);
    }), l;
  }, r.prototype.clearSeriesPointsCache = function() {
    this._seriesPointsCache = {};
  }, r.prototype.seriesSourcePoints = function(t, e) {
    var i = this, a = t.index + ";" + e.categoriesHash();
    if (this._seriesPointsCache[a])
      return this._currentPointsCache[a] = this._seriesPointsCache[a], this._seriesPointsCache[a];
    var s = e.options, l = s.srcCategories, p = yr(s.type, xr), h = t.data, c = p ? ev : Cn, u = [];
    p || e.mapCategories();
    for (var v = 0; v < h.length; v++) {
      var f = void 0;
      if (t.categoryField ? f = c(t.categoryField, h[v], i.chartService.intl) : f = l[v], P(f) && f !== null) {
        var d = e.totalIndex(f);
        u[d] = u[d] || { items: [], category: f }, u[d].items.push(v);
      }
    }
    return this._currentPointsCache[a] = u, u;
  }, r.prototype.aggregateSeries = function(t, e) {
    var i = t.data;
    if (!i.length)
      return t;
    for (var a = this.seriesSourcePoints(t, e), s = b({}, t), l = new zy(b({}, t), ht.current, ar.current), p = s.data = [], h = e.options.dataItems || [], c = e.currentRangeIndices(), u = function(d) {
      var m = d - c.min, _ = a[d];
      if (_ || (_ = a[d] = {}), _.categoryIx = m, !_.item) {
        var w = e.categoryAt(d, !0);
        _.category = w, _.item = l.aggregatePoints(_.items, w);
      }
      return _;
    }, v = c.min; v <= c.max; v++) {
      var f = u(v);
      p[f.categoryIx] = f.item, f.items && f.items.length && (h[f.categoryIx] = f.item);
    }
    return Z(s.type, ih) && eh(s, c, e.totalCount(), u, function(d) {
      return a[d];
    }), e.options.dataItems = h, s;
  }, r.prototype.appendChart = function(t, e) {
    var i = t.options.series, a = this.seriesCategoryAxis(i[0]), s = a.options.categories, l = Math.max(0, gl(i) - s.length);
    if (l > 0)
      for (s = a.options.categories = a.options.categories.slice(0); l--; )
        s.push("");
    this.valueAxisRangeTracker.update(t.valueAxisRanges), n.prototype.appendChart.call(this, t, e);
  }, r.prototype.seriesPaneName = function(t) {
    var e = this.options, i = t.axis, a = [].concat(e.valueAxis), s = qt(a, function(c) {
      return c.name === i;
    })[0], l = e.panes || [{}], p = (l[0] || {}).name || "default", h = (s || {}).pane || p;
    return h;
  }, r.prototype.seriesCategoryAxis = function(t) {
    var e = t.categoryAxis, i = e ? this.namedCategoryAxes[e] : this.categoryAxis;
    if (!i)
      throw new Error("Unable to locate category axis with name " + e);
    return i;
  }, r.prototype.stackableChartOptions = function(t, e) {
    var i = t.stack, a = i && i.type === "100%", s = e.options.clip;
    return {
      isStacked: i,
      isStacked100: a,
      clip: s
    };
  }, r.prototype.groupSeriesByCategoryAxis = function(t) {
    for (var e = [], i = {}, a = 0; a < t.length; a++) {
      var s = t[a].categoryAxis || "$$default$$";
      i.hasOwnProperty(s) || (i[s] = !0, e.push(s));
    }
    for (var l = [], p = 0; p < e.length; p++) {
      var h = e[p], c = Gy(t, h, p);
      c.length !== 0 && l.push(c);
    }
    return l;
  }, r.prototype.createBarChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new Si(this, Object.assign({
        series: t,
        invertAxes: this.invertAxes,
        gap: i.gap,
        spacing: i.spacing
      }, this.stackableChartOptions(i, e)));
      this.appendChart(a, e);
    }
  }, r.prototype.createRangeBarChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new iv(this, {
        series: t,
        invertAxes: this.invertAxes,
        gap: i.gap,
        spacing: i.spacing
      });
      this.appendChart(a, e);
    }
  }, r.prototype.createBulletChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new Al(this, {
        series: t,
        invertAxes: this.invertAxes,
        gap: i.gap,
        spacing: i.spacing,
        clip: e.options.clip
      });
      this.appendChart(a, e);
    }
  }, r.prototype.createLineChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new Kn(this, Object.assign({
        invertAxes: this.invertAxes,
        series: t
      }, this.stackableChartOptions(i, e)));
      this.appendChart(a, e);
    }
  }, r.prototype.createAreaChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new Ay(this, Object.assign({
        invertAxes: this.invertAxes,
        series: t
      }, this.stackableChartOptions(i, e)));
      this.appendChart(a, e);
    }
  }, r.prototype.createRangeAreaChart = function(t, e) {
    if (t.length !== 0) {
      var i = new av(this, {
        invertAxes: this.invertAxes,
        series: t,
        clip: e.options.clip
      });
      this.appendChart(i, e);
    }
  }, r.prototype.createOHLCChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new Uy(this, {
        invertAxes: this.invertAxes,
        gap: i.gap,
        series: t,
        spacing: i.spacing,
        clip: e.options.clip
      });
      this.appendChart(a, e);
    }
  }, r.prototype.createCandlestickChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new ta(this, {
        invertAxes: this.invertAxes,
        gap: i.gap,
        series: t,
        spacing: i.spacing,
        clip: e.options.clip
      });
      this.appendChart(a, e);
    }
  }, r.prototype.createBoxPlotChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new Cy(this, {
        invertAxes: this.invertAxes,
        gap: i.gap,
        series: t,
        spacing: i.spacing,
        clip: e.options.clip
      });
      this.appendChart(a, e);
    }
  }, r.prototype.createWaterfallChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = new $y(this, {
        series: t,
        invertAxes: this.invertAxes,
        gap: i.gap,
        spacing: i.spacing
      });
      this.appendChart(a, e);
    }
  }, r.prototype.axisRequiresRounding = function(t, e) {
    for (var i = this, a = ft(this.series, Iu), s = 0; s < this.series.length; s++) {
      var l = i.series[s];
      if (Z(l.type, ls)) {
        var p = l.line;
        p && p.style === Ji && a.push(l);
      }
    }
    for (var h = 0; h < a.length; h++) {
      var c = a[h].categoryAxis || "";
      if (c === t || !c && e === 0)
        return !0;
    }
  }, r.prototype.aggregatedAxis = function(t, e) {
    for (var i = this.series, a = 0; a < i.length; a++) {
      var s = i[a].categoryAxis || "";
      if ((s === t || !s && e === 0) && i[a].categoryField)
        return !0;
    }
  }, r.prototype.createCategoryAxesLabels = function() {
    for (var t = this.axes, e = 0; e < t.length; e++)
      t[e] instanceof Me && t[e].createLabels();
  }, r.prototype.createCategoryAxes = function(t) {
    for (var e = this, i = this.invertAxes, a = [].concat(this.options.categoryAxis), s = [], l = 0; l < a.length; l++) {
      var p = a[l], h = e.findPane(p.pane);
      if (Z(h, t)) {
        var c = p.name, u = p.categories;
        u === void 0 && (u = []), p = b({
          vertical: i,
          reverse: !i && e.chartService.rtl,
          axisCrossingValue: i ? gt : 0
        }, p), P(p.justified) || (p.justified = e.isJustified()), e.axisRequiresRounding(c, l) && (p.justified = !1);
        var v = void 0;
        if (rv(p, u[0]) ? v = new xo(p, e.chartService) : v = new Me(p, e.chartService), a[l].categories = v.options.srcCategories, c) {
          if (e.namedCategoryAxes[c])
            throw new Error("Category axis with name " + c + " is already defined");
          e.namedCategoryAxes[c] = v;
        }
        v.axisIndex = l, s.push(v), e.appendAxis(v);
      }
    }
    var f = this.categoryAxis || s[0];
    this.categoryAxis = f, i ? this.axisY = f : this.axisX = f;
  }, r.prototype.isJustified = function() {
    for (var t = this.series, e = 0; e < t.length; e++) {
      var i = t[e];
      if (!Z(i.type, ls))
        return !1;
    }
    return !0;
  }, r.prototype.createValueAxes = function(t) {
    var e = this, i = this.valueAxisRangeTracker, a = i.query(), s = [].concat(this.options.valueAxis), l = this.invertAxes, p = { vertical: !l, reverse: l && this.chartService.rtl }, h = [];
    this.stack100 && (p.roundToMajorUnit = !1, p.labels = { format: "P0" });
    for (var c = 0; c < s.length; c++) {
      var u = s[c], v = e.findPane(u.pane);
      if (Z(v, t)) {
        var f = u.name, d = yr(u.type, En) ? { min: 0.1, max: 1 } : { min: 0, max: 1 }, m = i.query(f) || a || d;
        c === 0 && m && a && (m.min = Math.min(m.min, a.min), m.max = Math.max(m.max, a.max));
        var _ = void 0;
        yr(u.type, En) ? _ = Gn : _ = oe;
        var w = new _(
          m.min,
          m.max,
          b({}, p, u),
          e.chartService
        );
        if (f) {
          if (e.namedValueAxes[f])
            throw new Error("Value axis with name " + f + " is already defined");
          e.namedValueAxes[f] = w;
        }
        w.axisIndex = c, h.push(w), e.appendAxis(w);
      }
    }
    var A = this.valueAxis || h[0];
    this.valueAxis = A, l ? this.axisX = A : this.axisY = A;
  }, r.prototype._dispatchEvent = function(t, e, i) {
    var a = t._eventCoordinates(e), s = new F(a.x, a.y), l = this.pointPane(s), p = [], h = [];
    if (l) {
      for (var c = l.axes, u = 0; u < c.length; u++) {
        var v = c[u];
        v.getValue ? pn(h, v.getValue(s)) : pn(p, v.getCategory(s));
      }
      p.length === 0 && pn(p, this.categoryAxis.getCategory(s)), p.length > 0 && h.length > 0 && t.trigger(i, {
        element: ge(e),
        originalEvent: e,
        category: ui(p),
        value: ui(h)
      });
    }
  }, r.prototype.pointPane = function(t) {
    for (var e = this.panes, i = 0; i < e.length; i++) {
      var a = e[i];
      if (a.contentBox.containsPoint(t))
        return a;
    }
  }, r.prototype.updateAxisOptions = function(t, e) {
    oh(this.options, t, e), oh(this.originalOptions, t, e);
  }, r;
}(pr);
function oh(n, r, o) {
  var t = r instanceof Me ? [].concat(n.categoryAxis) : [].concat(n.valueAxis);
  b(t[r.axisIndex], o);
}
function Gy(n, r, o) {
  return qt(n, function(t) {
    return o === 0 && !t.categoryAxis || t.categoryAxis === r;
  });
}
O(Ke, {
  categoryAxis: {},
  valueAxis: {}
});
b(Ke.prototype, Mo);
var Wy = function(n) {
  function r() {
    n.call(this), this._points = [];
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this._points = [];
  }, r.prototype.show = function(t, e) {
    var i = this, a = [].concat(t);
    this.hide();
    for (var s = 0; s < a.length; s++) {
      var l = a[s];
      l && l.toggleHighlight && l.hasHighlight() && (i.togglePointHighlight(l, !0, e), i._points.push(l));
    }
  }, r.prototype.togglePointHighlight = function(t, e, i) {
    var a = (t.options.highlight || {}).toggle;
    if (a) {
      var s = {
        category: t.category,
        series: t.series,
        dataItem: t.dataItem,
        value: t.value,
        stackValue: t.stackValue,
        preventDefault: Xy,
        visual: t.highlightVisual(),
        show: e
      };
      a(s), s._defaultPrevented || t.toggleHighlight(e, i);
    } else
      t.toggleHighlight(e, i);
  }, r.prototype.hide = function() {
    for (var t = this, e = this._points; e.length; )
      t.togglePointHighlight(e.pop(), !1);
  }, r.prototype.isHighlighted = function(t) {
    for (var e = this._points, i = 0; i < e.length; i++) {
      var a = e[i];
      if (t === a)
        return !0;
    }
    return !1;
  }, r;
}(N);
function Xy() {
  this._defaultPrevented = !0;
}
function lv(n, r) {
  var o = (r || "").toLowerCase(), t = n.event, e = o === "none" && !(t.ctrlKey || t.shiftKey || t.altKey) || t[o + "Key"];
  return e;
}
function Cl(n) {
  for (var r = {}, o = 0; o < n.length; o++) {
    var t = n[o];
    t.axis.options.name && (r[t.axis.options.name] = {
      min: t.range.min,
      max: t.range.max
    });
  }
  return r;
}
var pv = function(n) {
  function r(o, t) {
    n.call(this), this.plotArea = o, this.options = b({}, this.options, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.start = function(t) {
    return this._active = lv(t, this.options.key), this._active;
  }, r.prototype.move = function(t) {
    if (this._active) {
      var e = this.axisRanges = this._panAxes(t, D).concat(this._panAxes(t, B));
      if (e.length)
        return this.axisRanges = e, Cl(e);
    }
  }, r.prototype.end = function() {
    var t = this._active;
    return this._active = !1, t;
  }, r.prototype.pan = function() {
    var t = this, e = t.plotArea, i = t.axisRanges;
    if (i.length) {
      for (var a = 0; a < i.length; a++) {
        var s = i[a];
        e.updateAxisOptions(s.axis, s.range);
      }
      e.redraw(e.panes);
    }
  }, r.prototype.destroy = function() {
    delete this.plotArea;
  }, r.prototype._panAxes = function(t, e) {
    var i = this.plotArea, a = -t[e].delta, s = (this.options.lock || "").toLowerCase(), l = [];
    if (a !== 0 && (s || "").toLowerCase() !== e)
      for (var p = i.axes, h = 0; h < p.length; h++) {
        var c = p[h];
        if (e === D && !c.options.vertical || e === B && c.options.vertical) {
          var u = c.pan(a);
          u && (u.limitRange = !0, l.push({
            axis: c,
            range: u
          }));
        }
      }
    return l;
  }, r;
}(N);
pv.prototype.options = {
  key: "none",
  lock: "none"
};
var hv = function(n) {
  function r(o, t) {
    n.call(this), this.chart = o, this.options = b({}, this.options, t), this.createElement();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createElement = function() {
    var t = this._marquee = document.createElement("div");
    t.className = "k-marquee";
    var e = document.createElement("div");
    e.className = "k-marquee-color", t.appendChild(e);
  }, r.prototype.removeElement = function() {
    this._marquee.parentNode && this._marquee.parentNode.removeChild(this._marquee);
  }, r.prototype.setStyles = function(t) {
    ut(this._marquee, t);
  }, r.prototype.start = function(t) {
    if (lv(t, this.options.key)) {
      var e = this.chart, i = e._eventCoordinates(t), a = this._zoomPane = e._plotArea.paneByPoint(i), s = a ? a.chartsBox().clone() : null;
      if (a && s) {
        var l = this._elementOffset();
        return s.translate(l.left, l.top), this._zoomPaneClipBox = s, document.body.appendChild(this._marquee), this.setStyles({
          left: t.pageX + 1,
          top: t.pageY + 1,
          width: 0,
          height: 0
        }), !0;
      }
    }
    return !1;
  }, r.prototype._elementOffset = function() {
    var t = this.chart.element, e = ut(t, ["paddingLeft", "paddingTop"]), i = e.paddingLeft, a = e.paddingTop, s = ii(t);
    return {
      left: i + s.left,
      top: a + s.top
    };
  }, r.prototype.move = function(t) {
    var e = this._zoomPane;
    e && this.setStyles(this._selectionPosition(t));
  }, r.prototype.end = function(t) {
    var e = this._zoomPane;
    if (e) {
      var i = this._elementOffset(), a = this._selectionPosition(t);
      a.left -= i.left, a.top -= i.top;
      var s = { x: a.left, y: a.top }, l = { x: a.left + a.width, y: a.top + a.height };
      return this._updateAxisRanges(s, l), this.removeElement(), delete this._zoomPane, Cl(this.axisRanges);
    }
  }, r.prototype.zoom = function() {
    var t = this.axisRanges;
    if (t && t.length) {
      for (var e = this.chart._plotArea, i = 0; i < t.length; i++) {
        var a = t[i];
        e.updateAxisOptions(a.axis, a.range);
      }
      e.redraw(e.panes);
    }
  }, r.prototype.destroy = function() {
    this.removeElement(), delete this._marquee, delete this.chart;
  }, r.prototype._updateAxisRanges = function(t, e) {
    for (var i = (this.options.lock || "").toLowerCase(), a = [], s = this._zoomPane.axes, l = 0; l < s.length; l++) {
      var p = s[l], h = p.options.vertical;
      if (!(i === D && !h) && !(i === B && h) && P(p.axisIndex)) {
        var c = p.pointsRange(t, e);
        c && a.push({
          axis: p,
          range: c
        });
      }
    }
    this.axisRanges = a;
  }, r.prototype._selectionPosition = function(t) {
    var e = this._zoomPaneClipBox, i = {
      x: t.x.startLocation,
      y: t.y.startLocation
    }, a = t.x.location, s = t.y.location, l = (this.options.lock || "").toLowerCase(), p = Math.min(i.x, a), h = Math.min(i.y, s), c = Math.abs(i.x - a), u = Math.abs(i.y - s);
    return l === D && (p = e.x1, c = e.width()), l === B && (h = e.y1, u = e.height()), a > e.x2 && (c = e.x2 - i.x), a < e.x1 && (c = i.x - e.x1), s > e.y2 && (u = e.y2 - i.y), s < e.y1 && (u = i.y - e.y1), {
      left: Math.max(p, e.x1),
      top: Math.max(h, e.y1),
      width: c,
      height: u
    };
  }, r;
}(N);
hv.prototype.options = {
  key: "shift",
  lock: "none"
};
var Yy = 0.01, qy = 0.9, Zy = 0.3, Qy = function(n) {
  function r(o, t) {
    n.call(this), this.chart = o, this.options = b({
      rate: Zy
    }, this.options, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.updateRanges = function(t, e) {
    for (var i = this, a = (this.options.lock || "").toLowerCase(), s = [], l = this.chart._plotArea.axes, p = 0; p < l.length; p++) {
      var h = l[p], c = h.options.vertical;
      if (!(a === D && !c) && !(a === B && c) && h.zoomRange) {
        var u = j(i.options.rate, Yy, qy), v = h.zoomRange(-t * u, e);
        v && s.push({
          axis: h,
          range: v
        });
      }
    }
    return this.axisRanges = s, Cl(s);
  }, r.prototype.zoom = function() {
    var t = this.axisRanges, e = this.chart._plotArea;
    if (t && t.length && e.updateAxisOptions) {
      for (var i = 0; i < t.length; i++) {
        var a = t[i];
        e.updateAxisOptions(a.axis, a.range);
      }
      e.redraw(e.panes);
    }
  }, r.prototype.destroy = function() {
    delete this.chart;
  }, r;
}(N), Ky = function(n) {
  function r(o, t) {
    n.call(this, o), this.chartService = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    var t = this, e = t.children, i = t.options, a = i.vertical;
    this.visual = new ig(null, {
      spacing: a ? 0 : i.spacing,
      lineSpacing: a ? i.spacing : 0,
      orientation: a ? "vertical" : "horizontal",
      reverse: i.rtl,
      alignItems: a ? "start" : "center"
    });
    for (var s = 0; s < e.length; s++) {
      var l = e[s];
      l.reflow(new L()), l.renderVisual();
    }
  }, r.prototype.reflow = function(t) {
    this.visual.rect(t.toRect()), this.visual.reflow();
    var e = this.visual.clippedBBox();
    e ? this.box = Hn(e) : this.box = new L();
  }, r.prototype.renderVisual = function() {
    this.addVisual();
  }, r.prototype.createVisual = function() {
  }, r;
}(rt), Jy = function(n) {
  function r(o) {
    n.call(this, o), this.createContainer(), o.rtl ? (this.createLabel(), this.createMarker()) : (this.createMarker(), this.createLabel());
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createContainer = function() {
    this.container = new Nn({ vertical: !1, wrap: !1, align: $, spacing: this.options.spacing }), this.append(this.container);
  }, r.prototype.createMarker = function() {
    this.container.append(new tr(this.markerOptions()));
  }, r.prototype.markerOptions = function() {
    var t = this.options, e = t.markerColor;
    return b({}, t.markers, {
      background: e,
      border: {
        color: e
      }
    });
  }, r.prototype.createLabel = function() {
    var t = this.options, e = b({}, t.labels);
    this.container.append(new Qt(t.text, e));
  }, r.prototype.renderComplete = function() {
    n.prototype.renderComplete.call(this);
    var t = this.options.cursor || {}, e = this._itemOverlay = H.fromRect(this.container.box.toRect(), {
      fill: {
        color: J,
        opacity: 0
      },
      stroke: null,
      cursor: t.style || t
    });
    this.appendVisual(e);
  }, r.prototype.click = function(t, e) {
    var i = this.eventArgs(e);
    !t.trigger(uy, i) && e && e.type === "contextmenu" && e.preventDefault();
  }, r.prototype.over = function(t, e) {
    var i = this.eventArgs(e);
    return t.trigger(vy, i) || t._legendItemHover(i.seriesIndex, i.pointIndex), !0;
  }, r.prototype.out = function(t, e) {
    t._unsetActivePoint(), t.trigger(fy, this.eventArgs(e));
  }, r.prototype.eventArgs = function(t) {
    var e = this.options;
    return {
      element: ge(t),
      text: e.text,
      series: e.series,
      seriesIndex: e.series.index,
      pointIndex: e.pointIndex
    };
  }, r.prototype.renderVisual = function() {
    var t = this, e = this.options, i = e.visual;
    i ? (this.visual = i({
      active: e.active,
      series: e.series,
      sender: this.getSender(),
      pointIndex: e.pointIndex,
      options: {
        markers: this.markerOptions(),
        labels: e.labels
      },
      createVisual: function() {
        t.createVisual(), t.renderChildren(), t.renderComplete();
        var a = t.visual;
        return delete t.visual, a;
      }
    }), this.addVisual()) : n.prototype.renderVisual.call(this);
  }, r;
}(wr), nh = "horizontal", tm = "pointer", Jo = "custom", cv = function(n) {
  function r(o, t) {
    t === void 0 && (t = {}), n.call(this, o), this.chartService = t, Z(this.options.position, [tt, et, it, Q, Jo]) || (this.options.position = et), this.createContainers(), this.createLegendTitle(o.title), this.createItems();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createContainers = function() {
    var t = this.options, e = t.position, i = t.align, a = e, s = $;
    e === Jo ? a = Q : Z(e, [tt, it]) ? (i === "start" ? a = Q : i === "end" ? a = et : a = $, s = e) : i && (i === "start" ? s = tt : i === "end" && (s = it)), this.container = new wr({
      margin: t.margin,
      padding: t.padding,
      background: t.background,
      border: t.border,
      vAlign: s,
      align: a,
      zIndex: t.zIndex,
      shrinkToFit: !0
    }), this.hasTitle() ? this.itemsContainer = new wr({
      vAlign: s,
      align: a,
      zIndex: t.zIndex,
      shrinkToFit: !0
    }) : this.itemsContainer = this.container, this.append(this.container);
  }, r.prototype.createItems = function() {
    var t = this.getService(), e = this.options, i = this.isVertical(), a = new Ky({
      vertical: i,
      spacing: e.spacing,
      rtl: t.rtl
    }, t), s = e.items;
    e.reverse && (s = s.slice(0).reverse());
    for (var l = s.length, p = 0; p < l; p++) {
      var h = s[p];
      a.append(new Jy(b({}, {
        markers: e.markers,
        labels: e.labels,
        rtl: t.rtl
      }, e.item, h)));
    }
    a.render(), this.itemsContainer.append(a);
  }, r.prototype.isVertical = function() {
    var t = this.options, e = t.orientation, i = t.position, a = i === Jo && e !== nh || (P(e) ? e !== nh : Z(i, [Q, et]));
    return a;
  }, r.prototype.hasItems = function() {
    return this.container.children[0].children.length > 0;
  }, r.prototype.reflow = function(t) {
    var e = this.options, i = t.clone();
    if (!this.hasItems()) {
      this.box = i;
      return;
    }
    e.position === Jo ? (this.containerCustomReflow(i), this.box = i) : this.containerReflow(i), this.hasTitle() && this.title.reflow(new L(this.container.box.x1, this.title.box.y1, this.container.box.x2, this.title.box.y2));
  }, r.prototype.containerReflow = function(t) {
    var e = this, i = e.options, a = e.container, s = i.position, l = i.width, p = i.height, h = s === tt || s === it ? D : B, c = this.isVertical(), u = t.clone(), v = t.clone();
    (s === Q || s === et) && (v.y1 = u.y1 = 0), c && p ? (v.y2 = v.y1 + p, v.align(u, B, a.options.vAlign)) : !c && l && (v.x2 = v.x1 + l, v.align(u, D, a.options.align)), a.reflow(v), v = a.box;
    var f = v.clone();
    (i.offsetX || i.offsetY) && (v.translate(i.offsetX, i.offsetY), a.reflow(v)), f[h + 1] = t[h + 1], f[h + 2] = t[h + 2], this.box = f;
  }, r.prototype.containerCustomReflow = function(t) {
    var e = this, i = e.options, a = e.container, s = i.offsetX, l = i.offsetY, p = i.width, h = i.height, c = this.isVertical(), u = t.clone();
    c && h ? u.y2 = u.y1 + h : !c && p && (u.x2 = u.x1 + p), a.reflow(u), u = a.box, a.reflow(new L(
      s,
      l,
      s + u.width(),
      l + u.height()
    ));
  }, r.prototype.renderVisual = function() {
    this.hasItems() && n.prototype.renderVisual.call(this);
  }, r.prototype.createLegendTitle = function(t) {
    var e = b({}, {
      color: yt,
      position: tt,
      align: $
    }, t), i = e.text;
    if (!(!t || t.visible === !1)) {
      if (P(e) && e.visible) {
        var a = Ct(e);
        a ? i = a({ text: i }) : e.format && (i = this.chartService.format.auto(e.format, i));
      }
      this.title = new Qt(i, e), this.createTitleLayout(), this.appendTitleLayoutContent();
    }
  }, r.prototype.createTitleLayout = function() {
    this.layout = new Nn({
      vertical: !0,
      wrap: !1
    }), this.container.append(this.layout);
  }, r.prototype.hasTitle = function() {
    return !!(this.options.title && this.options.title.visible !== !1);
  }, r.prototype.appendTitleLayoutContent = function() {
    var t = this.options;
    t.title.position === it ? (this.layout.append(this.itemsContainer), this.layout.append(this.title)) : (this.layout.append(this.title), this.layout.append(this.itemsContainer));
  }, r;
}(rt);
O(cv, {
  position: et,
  items: [],
  offsetX: 0,
  offsetY: 0,
  margin: ot(5),
  padding: ot(5),
  border: {
    color: yt,
    width: 0
  },
  item: {
    cursor: tm,
    spacing: 6
  },
  spacing: 6,
  background: "",
  zIndex: 1,
  markers: {
    border: {
      width: 0
    },
    width: 15,
    height: 3,
    type: "rect",
    align: Q,
    vAlign: $
  }
});
var me = function(n) {
  function r() {
    n.call(this), this._registry = [];
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.register = function(t, e) {
    this._registry.push({
      type: t,
      seriesTypes: e
    });
  }, r.prototype.create = function(t, e, i) {
    for (var a = this._registry, s = a[0], l, p = 0; p < a.length; p++) {
      var h = a[p];
      if (l = ft(t, h.seriesTypes), l.length > 0) {
        s = h;
        break;
      }
    }
    return new s.type(l, e, i);
  }, r;
}(N);
me.current = new me();
var em = 3, rm = 0.1;
function Ue(n) {
  var r = document.createElement("div");
  return n && (r.className = n), r;
}
function ah(n) {
  for (var r = n; r && !_n(r, "k-handle"); )
    r = r.parentNode;
  return r;
}
var kl = function(n) {
  function r(o, t, e, i) {
    n.call(this);
    var a = o.element;
    this.options = b({}, this.options, e), this.chart = o, this.observer = i, this.chartElement = a, this.categoryAxis = t, this._dateAxis = this.categoryAxis instanceof xo, this.initOptions(), this.visible = this.options.visible && a.offsetHeight, this.visible && (this.createElements(), this.set(this._index(this.options.from), this._index(this.options.to)), this.bindEvents());
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.onPane = function(t) {
    return this.categoryAxis.pane === t;
  }, r.prototype.createElements = function() {
    var t = this.options, e = this.wrapper = Ue("k-selector k-pointer-events-none");
    ut(e, {
      top: t.offset.top,
      left: t.offset.left,
      width: t.width,
      height: t.height,
      direction: "ltr"
    });
    var i = this.selection = Ue("k-selection k-pointer-events-none");
    this.leftMask = Ue("k-mask k-pointer-events-none"), this.rightMask = Ue("k-mask k-pointer-events-none"), e.appendChild(this.leftMask), e.appendChild(this.rightMask), e.appendChild(i);
    var a = this.body = Ue("k-selection-bg k-pointer-events-none");
    i.appendChild(a);
    var s = this.leftHandle = Ue("k-handle k-left-handle k-pointer-events-auto"), l = this.rightHandle = Ue("k-handle k-right-handle k-pointer-events-auto");
    s.appendChild(Ue()), l.appendChild(Ue()), i.appendChild(s), i.appendChild(l), this.chartElement.appendChild(e);
    var p = ut(i, ["borderLeftWidth", "borderRightWidth", "height"]), h = ut(s, "height").height, c = ut(l, "height").height;
    t.selection = {
      border: {
        left: p.borderLeftWidth,
        right: p.borderRightWidth
      }
    }, ut(s, {
      top: (p.height - h) / 2
    }), ut(l, {
      top: (p.height - c) / 2
    }), e.style.cssText = e.style.cssText;
  }, r.prototype.bindEvents = function() {
    var t;
    this.options.mousewheel !== !1 && (this._mousewheelHandler = this._mousewheel.bind(this), Gi(this.chartElement, (t = {}, t[Rn] = this._mousewheelHandler, t))), this._domEvents = yo.create(this.chartElement, {
      stopPropagation: !0,
      // applicable for the jQuery UserEvents
      start: this._start.bind(this),
      move: this._move.bind(this),
      end: this._end.bind(this),
      tap: this._tap.bind(this),
      press: this._press.bind(this),
      gesturestart: this._gesturestart.bind(this),
      gesturechange: this._gesturechange.bind(this),
      gestureend: this._gestureend.bind(this)
    });
  }, r.prototype.initOptions = function() {
    var t = this, e = t.options, i = t.categoryAxis, a = i.pane.chartsBox(), s = this.chart.chartService.intl;
    this._dateAxis && b(e, {
      min: Rt(s, e.min),
      max: Rt(s, e.max),
      from: Rt(s, e.from),
      to: Rt(s, e.to)
    });
    var l = ut(this.chartElement, ["paddingLeft", "paddingTop"]), p = l.paddingLeft, h = l.paddingTop;
    this.options = b({}, {
      width: a.width(),
      height: a.height() + rm,
      //workaround for sub-pixel hover on the paths in chrome
      padding: {
        left: p,
        top: h
      },
      offset: {
        left: a.x1 + p,
        top: a.y1 + h
      },
      from: e.min,
      to: e.max
    }, e);
  }, r.prototype.destroy = function() {
    var t;
    this._domEvents && (this._domEvents.destroy(), delete this._domEvents), clearTimeout(this._mwTimeout), this._state = null, this.wrapper && (this._mousewheelHandler && (Wi(this.chartElement, (t = {}, t[Rn] = this._mousewheelHandler, t)), this._mousewheelHandler = null), this.chartElement.removeChild(this.wrapper), this.wrapper = null);
  }, r.prototype._rangeEventArgs = function(t) {
    return {
      axis: this.categoryAxis.options,
      from: this._value(t.from),
      to: this._value(t.to)
    };
  }, r.prototype._pointInPane = function(t, e) {
    var i = this.categoryAxis.pane.box, a = this.chart._toModelCoordinates(t, e);
    return i.containsPoint(a);
  }, r.prototype._start = function(t) {
    var e = this.options, i = ge(t);
    if (!(this._state || !i)) {
      var a = iu(t), s = this._pointInPane(a.x, a.y);
      if (s) {
        var l = ah(i), p = this.body.getBoundingClientRect(), h = !l && a.x >= p.x && a.x <= p.x + p.width && a.y >= p.y && a.y <= p.y + p.height;
        this.chart._unsetActivePoint(), this._state = {
          moveTarget: l,
          startLocation: t.x ? t.x.location : 0,
          inBody: h,
          range: {
            from: this._index(e.from),
            to: this._index(e.to)
          }
        };
        var c = this._rangeEventArgs({
          from: this._index(e.from),
          to: this._index(e.to)
        });
        this.trigger(is, c) && (this._state = null);
      }
    }
  }, r.prototype._press = function(t) {
    var e;
    this._state ? e = this._state.moveTarget : e = ah(ge(t)), e && mt(e, "k-handle-active");
  }, r.prototype._move = function(t) {
    if (this._state) {
      var e = this, i = e._state, a = e.options, s = e.categoryAxis, l = i.range, p = i.moveTarget, h = s.options.reverse, c = this._index(a.from), u = this._index(a.to), v = this._index(a.min), f = this._index(a.max), d = i.startLocation - t.x.location, m = { from: l.from, to: l.to }, _ = l.to - l.from, w = ut(this.wrapper, "width").width / (s.categoriesCount() - 1), A = Math.round(d / w) * (h ? -1 : 1);
      if (!(!p && !i.inBody)) {
        var T = p && _n(p, "k-left-handle"), k = p && _n(p, "k-right-handle");
        i.inBody ? (l.from = Math.min(
          Math.max(v, c - A),
          f - _
        ), l.to = Math.min(
          l.from + _,
          f
        )) : T && !h || k && h ? (l.from = Math.min(
          Math.max(v, c - A),
          f - 1
        ), l.to = Math.max(l.from + 1, l.to)) : (T && h || k && !h) && (l.to = Math.min(
          Math.max(v + 1, u - A),
          f
        ), l.from = Math.min(l.to - 1, l.from)), (l.from !== m.from || l.to !== m.to) && (this.move(l.from, l.to), this.trigger(qi, this._rangeEventArgs(l)));
      }
    }
  }, r.prototype._end = function() {
    if (this._state) {
      var t = this._state.moveTarget;
      t && Xs(t, "k-handle-active");
      var e = this._state.range;
      this.set(e.from, e.to), this.trigger(os, this._rangeEventArgs(e)), delete this._state;
    }
  }, r.prototype._tap = function(t) {
    var e = this, i = e.options, a = e.categoryAxis, s = this.chart._eventCoordinates(t), l = a.pointCategoryIndex(new F(s.x, a.box.y1)), p = this._index(i.from), h = this._index(i.to), c = this._index(i.min), u = this._index(i.max), v = h - p, f = p + v / 2, d = {}, m = t.event.which === 3, _ = Math.round(f - l);
    this._state || m || (this.chart._unsetActivePoint(), a.options.justified || _--, d.from = Math.min(
      Math.max(c, p - _),
      u - v
    ), d.to = Math.min(d.from + v, u), this._start(t), this._state && (this._state.range = d, this.trigger(qi, this._rangeEventArgs(d)), this._end()));
  }, r.prototype._mousewheel = function(t) {
    var e = this, i = Ys(t);
    if (this._start(t), this._state) {
      var a = this._state.range;
      t.preventDefault(), t.stopPropagation(), Math.abs(i) > 1 && (i *= em), this.options.mousewheel.reverse && (i *= -1), this.expand(i) && this.trigger(qi, {
        axis: this.categoryAxis.options,
        delta: i,
        originalEvent: t,
        from: this._value(a.from),
        to: this._value(a.to)
      }), this._mwTimeout && clearTimeout(this._mwTimeout), this._mwTimeout = setTimeout(function() {
        e._end();
      }, ns);
    }
  }, r.prototype._gesturestart = function(t) {
    var e = this.options, i = t.touches[0], a = this._pointInPane(i.pageX, i.pageY);
    if (a) {
      this._state = {
        range: {
          from: this._index(e.from),
          to: this._index(e.to)
        }
      };
      var s = this._rangeEventArgs(this._state.range);
      this.trigger(is, s) ? this._state = null : t.preventDefault();
    }
  }, r.prototype._gestureend = function() {
    this._state && (this.trigger(os, this._rangeEventArgs(this._state.range)), delete this._state);
  }, r.prototype._gesturechange = function(t) {
    if (this._state) {
      var e = this, i = e.chart, a = e._state, s = e.options, l = e.categoryAxis, p = a.range, h = i._toModelCoordinates(t.touches[0].x.location).x, c = i._toModelCoordinates(t.touches[1].x.location).x, u = Math.min(h, c), v = Math.max(h, c);
      t.preventDefault(), p.from = l.pointCategoryIndex(new F(u)) || s.min, p.to = l.pointCategoryIndex(new F(v)) || s.max, this.move(p.from, p.to), this.trigger(qi, this._rangeEventArgs(p));
    }
  }, r.prototype._index = function(t) {
    var e = t;
    return t instanceof Date && (e = this.categoryAxis.categoryIndex(t)), e;
  }, r.prototype._value = function(t) {
    var e = t;
    return this._dateAxis && (e = this.categoryAxis.categoryAt(t), e > this.options.max && (e = this.options.max)), e;
  }, r.prototype._slot = function(t) {
    var e = this.categoryAxis, i = this._index(t);
    return e.getSlot(i, i, !0);
  }, r.prototype.move = function(t, e) {
    var i = this.options, a = this.categoryAxis.options.reverse, s = i.offset, l = i.padding, p = i.selection.border, h = a ? e : t, c = a ? t : e, u = "x" + (a ? 2 : 1), v = this._slot(h), f = R(v[u] - s.left + l.left);
    ut(this.leftMask, {
      width: f
    }), ut(this.selection, {
      left: f
    }), v = this._slot(c);
    var d = R(i.width - (v[u] - s.left + l.left));
    ut(this.rightMask, {
      width: d
    });
    var m = i.width - d;
    m !== i.width && (m += p.right), ut(this.rightMask, {
      left: m
    }), ut(this.selection, {
      width: Math.max(i.width - (f + d) - p.right, 0)
    });
  }, r.prototype.set = function(t, e) {
    var i = this.options, a = this._index(i.min), s = this._index(i.max), l = j(this._index(t), a, s), p = j(this._index(e), l + 1, s);
    i.visible && this.move(l, p), i.from = this._value(l), i.to = this._value(p);
  }, r.prototype.expand = function(t) {
    var e = this.options, i = this._index(e.min), a = this._index(e.max), s = e.mousewheel.zoom, l = this._index(e.from), p = this._index(e.to), h = { from: l, to: p }, c = b({}, h);
    if (this._state && (h = this._state.range), s !== et && (h.from = j(
      j(l - t, 0, p - 1),
      i,
      a
    )), s !== Q && (h.to = j(
      j(p + t, h.from + 1, a),
      i,
      a
    )), h.from !== c.from || h.to !== c.to)
      return this.set(h.from, h.to), !0;
  }, r.prototype.zoom = function(t, e) {
    var i = this.options, a = this._index(i.min), s = this._index(i.max), l = this._index(i.from), p = this._index(i.to), h = { from: l, to: p }, c = b({}, h), u = this.categoryAxis.options, v = u.reverse, f = D + (v ? "2" : "1"), d = this.categoryAxis.lineBox(), m = Math.abs(d[f] - e[D]), _ = d.width(), w = R(m / _, 2), A = R(w * t), T = R((1 - w) * t);
    if (this._state && (h = this._state.range), h.from = j(
      j(l - A, 0, p - 1),
      a,
      s
    ), h.to = j(
      j(p + T, h.from + 1, s),
      a,
      s
    ), h.from !== c.from || h.to !== c.to)
      return this.set(h.from, h.to), !0;
  }, r.prototype.trigger = function(t, e) {
    return (this.observer || this.chart).trigger(t, e);
  }, r;
}(N);
O(kl, {
  visible: !0,
  mousewheel: {
    zoom: "both"
  },
  min: xt,
  max: gt
});
var im = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.show = function(t) {
    if (!(!t || !t.tooltipAnchor || this._current && this._current === t)) {
      var e = b({}, this.options, t.options.tooltip), i = t.tooltipAnchor();
      i ? (this._current = t, n.prototype.show.call(this, {
        point: t,
        anchor: i
      }, e, t)) : this.hide();
    }
  }, r.prototype.hide = function() {
    delete this._current, n.prototype.hide.call(this);
  }, r;
}(ra), Pl = function(n) {
  function r(o, t) {
    n.call(this, o.chartService, t), this.plotArea = o, this.formatService = o.chartService.format;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.showAt = function(t, e) {
    var i = qt(t, function(p) {
      var h = p.series.tooltip, c = h && h.visible === !1;
      return !c;
    });
    if (i.length > 0) {
      var a = i[0], s = this.plotArea.categoryAxis.getSlot(a.categoryIx), l = e ? this._slotAnchor(e, s) : this._defaultAnchor(a, s);
      this.show({
        anchor: l,
        shared: !0,
        points: t,
        category: a.category,
        categoryText: this.formatService.auto(this.options.categoryFormat, a.category),
        series: this.plotArea.series
      }, this.options);
    }
  }, r.prototype._slotAnchor = function(t, e) {
    var i = this.plotArea.categoryAxis, a = {
      horizontal: "left",
      vertical: "center"
    };
    return i.options.vertical || (t.x = e.center().x), {
      point: t,
      align: a
    };
  }, r.prototype._defaultAnchor = function(t, e) {
    var i = t.owner.pane.chartsBox(), a = this.plotArea.categoryAxis.options.vertical, s = i.center(), l = e.center(), p = {
      horizontal: "center",
      vertical: "center"
    }, h;
    return a ? h = new F(s.x, l.y) : h = new F(l.x, s.y), {
      point: h,
      align: p
    };
  }, r;
}(ra);
O(Pl, {
  categoryFormat: "{0:d}"
});
var uv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    var t = this, e = t.element, i = t.options, a = e.bbox();
    if (a) {
      this.origin = i.origin;
      var s = i.vertical ? B : D, l = this.fromScale = new q(1, 1);
      l[s] = ro, e.transform(
        wt().scale(l.x, l.y)
      );
    } else
      this.abort();
  }, r.prototype.step = function(t) {
    var e = ie(this.fromScale.x, 1, t), i = ie(this.fromScale.y, 1, t);
    this.element.transform(
      wt().scale(e, i, this.origin)
    );
  }, r.prototype.abort = function() {
    n.prototype.abort.call(this), this.element.transform(null);
  }, r;
}(pe);
O(uv, {
  duration: ne
});
De.current.register(ye, uv);
var vv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    var t = this.center = this.element.bbox().center();
    this.element.transform(
      wt().scale(ro, ro, t)
    );
  }, r.prototype.step = function(t) {
    this.element.transform(
      wt().scale(t, t, this.center)
    );
  }, r;
}(pe);
O(vv, {
  easing: "easeOutElastic"
});
De.current.register(_i, vv);
var fv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    this.fadeTo = this.element.opacity(), this.element.opacity(0);
  }, r.prototype.step = function(t) {
    this.element.opacity(t * this.fadeTo);
  }, r;
}(pe);
O(fv, {
  duration: 200,
  easing: "linear"
});
De.current.register(Cr, fv);
var dv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    this.element.transform(
      wt().scale(ro, ro, this.options.center)
    );
  }, r.prototype.step = function(t) {
    this.element.transform(
      wt().scale(t, t, this.options.center)
    );
  }, r;
}(pe);
O(dv, {
  easing: "easeOutElastic",
  duration: ne
});
De.current.register(Sr, dv);
var Ol = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    n.prototype.render.call(this), this.renderSegments();
  }, r.prototype.createSegment = function(t, e, i) {
    var a = e.style, s;
    return a === mi ? s = ml : s = Ur, new s(t, e, i);
  }, r.prototype.animationPoints = function() {
    var t = n.prototype.animationPoints.call(this);
    return t.concat(this._segments);
  }, r.prototype.createMissingValue = function(t, e) {
    if (e === ir) {
      var i = {
        x: t.x,
        y: t.y
      };
      return Yt(i.x) || (i.x = 0), Yt(i.y) || (i.y = 0), i;
    }
  }, r;
}(Ci);
b(Ol.prototype, _l);
var El = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function() {
    this.namedXAxes = {}, this.namedYAxes = {}, this.xAxisRangeTracker = new Ln(), this.yAxisRangeTracker = new Ln();
  }, r.prototype.render = function(t) {
    var e = this;
    t === void 0 && (t = this.panes);
    for (var i = this.groupSeriesByPane(), a = 0; a < t.length; a++) {
      var s = t[a], l = i[s.options.name || "default"] || [];
      e.addToLegend(l);
      var p = e.filterVisibleSeries(l);
      p && (e.createScatterChart(
        ft(p, vl),
        s
      ), e.createScatterLineChart(
        ft(p, fl),
        s
      ), e.createBubbleChart(
        ft(p, _i),
        s
      ));
    }
    this.createAxes(t);
  }, r.prototype.appendChart = function(t, e) {
    this.xAxisRangeTracker.update(t.xAxisRanges), this.yAxisRangeTracker.update(t.yAxisRanges), n.prototype.appendChart.call(this, t, e);
  }, r.prototype.removeAxis = function(t) {
    var e = t.options.name;
    n.prototype.removeAxis.call(this, t), t.options.vertical ? (this.yAxisRangeTracker.reset(e), delete this.namedYAxes[e]) : (this.xAxisRangeTracker.reset(e), delete this.namedXAxes[e]), t === this.axisX && delete this.axisX, t === this.axisY && delete this.axisY;
  }, r.prototype.seriesPaneName = function(t) {
    var e = this.options, i = t.xAxis, a = [].concat(e.xAxis), s = qt(a, function(f) {
      return f.name === i;
    })[0], l = t.yAxis, p = [].concat(e.yAxis), h = qt(p, function(f) {
      return f.name === l;
    })[0], c = e.panes || [{}], u = c[0].name || "default", v = (s || {}).pane || (h || {}).pane || u;
    return v;
  }, r.prototype.createScatterChart = function(t, e) {
    t.length > 0 && this.appendChart(
      new Ci(this, { series: t, clip: e.options.clip }),
      e
    );
  }, r.prototype.createScatterLineChart = function(t, e) {
    t.length > 0 && this.appendChart(
      new Ol(this, { series: t, clip: e.options.clip }),
      e
    );
  }, r.prototype.createBubbleChart = function(t, e) {
    t.length > 0 && this.appendChart(
      new qu(this, { series: t, clip: e.options.clip }),
      e
    );
  }, r.prototype.createXYAxis = function(t, e, i) {
    for (var a = t.name, s = e ? this.namedYAxes : this.namedXAxes, l = e ? this.yAxisRangeTracker : this.xAxisRangeTracker, p = b({ reverse: !e && this.chartService.rtl }, t, { vertical: e }), h = yr(p.type, En), c = l.query(), u = h ? { min: 0.1, max: 1 } : { min: 0, max: 1 }, v = l.query(a) || c || u, f = [p.min, p.max], d = this.series, m = 0; m < d.length; m++) {
      var _ = d[m], w = _[e ? "yAxis" : "xAxis"];
      if (w === p.name || i === 0 && !w) {
        var A = ht.current.bindPoint(_, 0).valueFields;
        f.push(A[e ? "y" : "x"]);
        break;
      }
    }
    i === 0 && c && (v.min = Math.min(v.min, c.min), v.max = Math.max(v.max, c.max));
    for (var T, k = 0; k < f.length; k++)
      if (f[k] instanceof Date) {
        T = !0;
        break;
      }
    var C;
    yr(p.type, xr) || !p.type && T ? C = Su : h ? C = Gn : C = oe;
    var z = new C(v.min, v.max, p, this.chartService);
    if (z.axisIndex = i, a) {
      if (s[a])
        throw new Error((e ? "Y" : "X") + " axis with name " + a + " is already defined");
      s[a] = z;
    }
    return this.appendAxis(z), z;
  }, r.prototype.createAxes = function(t) {
    for (var e = this, i = this.options, a = [].concat(i.xAxis), s = [], l = [].concat(i.yAxis), p = [], h = 0; h < a.length; h++) {
      var c = e.findPane(a[h].pane);
      Z(c, t) && s.push(e.createXYAxis(a[h], !1, h));
    }
    for (var u = 0; u < l.length; u++) {
      var v = e.findPane(l[u].pane);
      Z(v, t) && p.push(e.createXYAxis(l[u], !0, u));
    }
    this.axisX = this.axisX || s[0], this.axisY = this.axisY || p[0];
  }, r.prototype._dispatchEvent = function(t, e, i) {
    for (var a = t._eventCoordinates(e), s = new F(a.x, a.y), l = this.axes, p = l.length, h = [], c = [], u = 0; u < p; u++) {
      var v = l[u], f = v.options.vertical ? c : h, d = v.getValue(s);
      d !== null && f.push(d);
    }
    h.length > 0 && c.length > 0 && t.trigger(i, {
      element: ge(e),
      originalEvent: e,
      x: ui(h),
      y: ui(c)
    });
  }, r.prototype.updateAxisOptions = function(t, e) {
    var i = t.options.vertical, a = this.groupAxes(this.panes), s = (i ? a.y : a.x).indexOf(t);
    sh(this.options, s, i, e), sh(this.originalOptions, s, i, e);
  }, r;
}(pr);
function sh(n, r, o, t) {
  var e = [].concat(o ? n.yAxis : n.xAxis)[r];
  b(e, t);
}
O(El, {
  xAxis: {},
  yAxis: {}
});
b(El.prototype, Mo);
var ia = function(n) {
  function r(o, t, e) {
    n.call(this, e), this.value = o, this.sector = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    var t = this.options.labels, e = this.owner.chartService, i = this.value;
    if (!(this._rendered || this.visible === !1)) {
      this._rendered = !0;
      var a = Ct(t), s = this.pointData();
      if (a ? i = a(s) : t.format && (i = e.format.auto(t.format, i)), t.visible && (i || i === 0)) {
        if (t.position === $ || t.position === Mn)
          t.color || (t.color = qs(this.options.color)), t.background || (t.background = this.options.color);
        else {
          var l = e.theme.seriesDefaults.labels;
          t.color = t.color || l.color, t.background = t.background || l.background;
        }
        this.label = new Qt(i, b({}, t, {
          align: $,
          vAlign: "",
          animation: {
            type: Cr,
            delay: this.animationDelay
          }
        }), s), this.append(this.label);
      }
    }
  }, r.prototype.reflow = function(t) {
    this.render(), this.box = t, this.reflowLabel();
  }, r.prototype.reflowLabel = function() {
    var t = this, e = t.options.labels, i = t.label, a = this.sector.clone(), s = e.distance, l = a.middle();
    if (i) {
      var p = i.box.height(), h = i.box.width(), c;
      if (e.position === $)
        a.radius = Math.abs((a.radius - p) / 2) + p, c = a.point(l), i.reflow(new L(c.x, c.y - p / 2, c.x, c.y));
      else if (e.position === Mn)
        a.radius = a.radius - p / 2, c = a.point(l), i.reflow(new L(c.x, c.y - p / 2, c.x, c.y));
      else {
        var u;
        c = a.clone().expand(s).point(l), c.x >= a.center.x ? (u = c.x + h, i.orientation = et) : (u = c.x - h, i.orientation = Q), i.reflow(new L(u, c.y - p, c.x, c.y));
      }
    }
  }, r.prototype.createVisual = function() {
    var t = this, e = this, i = e.sector, a = e.options;
    if (n.prototype.createVisual.call(this), this.value)
      if (a.visual) {
        var s = (i.startAngle + 180) % 360, l = a.visual({
          category: this.category,
          dataItem: this.dataItem,
          value: this.value,
          series: this.series,
          percentage: this.percentage,
          center: new q(i.center.x, i.center.y),
          radius: i.radius,
          innerRadius: i.innerRadius,
          startAngle: s,
          endAngle: s + i.angle,
          options: a,
          sender: this.getSender(),
          createVisual: function() {
            var p = new pt();
            return t.createSegmentVisual(p), p;
          }
        });
        l && this.visual.append(l);
      } else
        this.createSegmentVisual(this.visual);
  }, r.prototype.createSegmentVisual = function(t) {
    var e = this, i = e.sector, a = e.options, s = a.border || {}, l = s.width > 0 ? {
      stroke: {
        color: s.color,
        width: s.width,
        opacity: s.opacity,
        dashType: s.dashType
      }
    } : {}, p = a.color, h = {
      color: p,
      opacity: a.opacity
    }, c = this.createSegment(i, b({
      fill: h,
      stroke: {
        opacity: a.opacity
      },
      zIndex: a.zIndex
    }, l));
    t.append(c), bl(a) && t.append(this.createGradientOverlay(c, {
      baseColor: p,
      fallbackFill: h
    }, b({
      center: [i.center.x, i.center.y],
      innerRadius: i.innerRadius,
      radius: i.radius,
      userSpace: !0
    }, a.overlay)));
  }, r.prototype.createSegment = function(t, e) {
    return e.singleSegment ? new Je(new ve(new q(t.center.x, t.center.y), t.radius), e) : oi.current.createRing(t, e);
  }, r.prototype.createAnimation = function() {
    var t = this, e = t.options, i = t.sector.center;
    b(e, {
      animation: {
        center: [i.x, i.y],
        delay: this.animationDelay
      }
    }), n.prototype.createAnimation.call(this);
  }, r.prototype.createHighlight = function(t) {
    var e = this.options.highlight || {}, i = e.border || {};
    return this.createSegment(this.sector, b({}, t, {
      fill: {
        color: e.color,
        opacity: e.opacity
      },
      stroke: {
        opacity: i.opacity,
        width: i.width,
        color: i.color
      }
    }));
  }, r.prototype.highlightVisual = function() {
    return this.visual.children[0];
  }, r.prototype.highlightVisualArgs = function() {
    var t = this.sector;
    return {
      options: this.options,
      radius: t.radius,
      innerRadius: t.innerRadius,
      center: new q(t.center.x, t.center.y),
      startAngle: t.startAngle,
      endAngle: t.angle + t.startAngle,
      visual: this.visual
    };
  }, r.prototype.tooltipAnchor = function() {
    var t = this.sector.clone().expand(ue), e = t.middle(), i = t.point(e);
    return {
      point: i,
      align: am(e + 180)
    };
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.pointData = function() {
    return {
      dataItem: this.dataItem,
      category: this.category,
      value: this.value,
      series: this.series,
      percentage: this.percentage
    };
  }, r;
}(rt), om = R(_t(30), nt), nm = R(_t(60), nt);
function am(n) {
  var r = _t(n), o = R(Math.sin(r), nt), t = R(Math.cos(r), nt), e;
  Math.abs(o) > nm ? e = $ : t < 0 ? e = et : e = Q;
  var i;
  return Math.abs(o) < om ? i = $ : o < 0 ? i = it : i = tt, {
    horizontal: e,
    vertical: i
  };
}
O(ia, {
  color: J,
  overlay: {
    gradient: "roundedBevel"
  },
  border: {
    width: 0.5
  },
  labels: {
    visible: !1,
    distance: 35,
    font: Yc,
    margin: ot(0.5),
    align: fe,
    zIndex: 1,
    position: Ir
  },
  animation: {
    type: Sr
  },
  highlight: {
    visible: !0,
    border: {
      width: 1
    }
  },
  visible: !0
});
b(ia.prototype, xe);
var gv = {
  createLegendItem: function(n, r, o) {
    var t = this.options.legend || {}, e = t.labels || {}, i = t.inactiveItems || {}, a = i.labels || {};
    if (o && o.visibleInLegend !== !1) {
      var s = o.visible !== !1, l = s ? Ct(e) : Ct(a) || Ct(e), p = o.category;
      l && (p = l({
        text: p,
        series: o.series,
        dataItem: o.dataItem,
        percentage: o.percentage,
        value: n
      }));
      var h, c;
      s ? (h = {}, c = r.color) : (h = {
        color: a.color,
        font: a.font
      }, c = (i.markers || {}).color), Yt(p) && p !== "" && this.legendItems.push({
        active: s,
        pointIndex: o.index,
        text: p,
        series: o.series,
        markerColor: c,
        labels: h
      });
    }
  }
}, sm = 70, Ro = function(n) {
  function r(o, t) {
    n.call(this, t), this.plotArea = o, this.chartService = o.chartService, this.points = [], this.legendItems = [], this.render();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this.traverseDataPoints(this.addValue.bind(this));
  }, r.prototype.traverseDataPoints = function(t) {
    var e = this, i = this, a = i.options, s = i.plotArea.options.seriesColors;
    s === void 0 && (s = []);
    for (var l = s.length, p = a.series, h = p.length, c = 0; c < h; c++) {
      var u = p[c], v = u.data, f = tv(u), d = f.total, m = f.points, _ = f.count, w = 360 / d, A = void 0;
      isFinite(w) || (A = 360 / _);
      var T = void 0;
      P(u.startAngle) ? T = u.startAngle : T = a.startAngle, c !== h - 1 && u.labels.position === Ir && (u.labels.position = $);
      for (var k = 0; k < m.length; k++) {
        var C = m[k];
        if (C) {
          var z = C.fields, V = C.value, G = C.visible, X = V !== 0 ? A || V * w : 0, W = v.length !== 1 && !!z.explode;
          vt(u.color) || (u.color = z.color || s[k % l]), t(V, new go(null, 0, 0, T, X), {
            owner: e,
            category: P(z.category) ? z.category : "",
            index: k,
            series: u,
            seriesIx: c,
            dataItem: v[k],
            percentage: d !== 0 ? V / d : 0,
            explode: W,
            visibleInLegend: z.visibleInLegend,
            visible: G,
            zIndex: h - c,
            animationDelay: e.animationDelay(k, c, h)
          }), G !== !1 && (T += X);
        }
      }
    }
  }, r.prototype.evalSegmentOptions = function(t, e, i) {
    var a = i.series;
    nr(t, {
      value: e,
      series: a,
      dataItem: i.dataItem,
      category: i.category,
      percentage: i.percentage
    }, { defaults: a._defaults, excluded: ["data", "content", "template", "visual", "toggle"] });
  }, r.prototype.addValue = function(t, e, i) {
    var a = b({}, i.series, { index: i.index });
    if (this.evalSegmentOptions(a, t, i), this.createLegendItem(t, a, i), i.visible !== !1) {
      var s = new ia(t, e, a);
      Object.assign(s, i), this.append(s), this.points.push(s);
    }
  }, r.prototype.reflow = function(t) {
    var e = this, i = e.options, a = e.points, s = e.seriesConfigs;
    s === void 0 && (s = []);
    var l = a.length, p = t.clone(), h = 5, c = Math.min(p.width(), p.height()), u = c / 2, v = c - c * 0.85, f = new L(p.x1, p.y1, p.x1 + c, p.y1 + c), d = f.center(), m = p.center(), _ = i.series.length, w = [], A = [], T = U(i.padding, v);
    this.targetBox = t, T = T > u - h ? u - h : T, f.translate(m.x - d.x, m.y - d.y);
    for (var k = u - T, C = new F(
      k + f.x1 + T,
      k + f.y1 + T
    ), z = 0; z < l; z++) {
      var V = a[z], G = V.sector, X = V.seriesIx;
      if (G.radius = k, G.center = C, s.length) {
        var W = s[X];
        G.innerRadius = W.innerRadius, G.radius = W.radius;
      }
      X === _ - 1 && V.explode && (G.center = G.clone().setRadius(G.radius * 0.15).point(G.middle())), V.reflow(f);
      var ct = V.label;
      ct && ct.options.position === Ir && X === _ - 1 && (ct.orientation === et ? A.push(ct) : w.push(ct));
    }
    w.length > 0 && (w.sort(this.labelComparator(!0)), this.leftLabelsReflow(w)), A.length > 0 && (A.sort(this.labelComparator(!1)), this.rightLabelsReflow(A)), this.box = f;
  }, r.prototype.leftLabelsReflow = function(t) {
    var e = this.distanceBetweenLabels(t);
    this.distributeLabels(e, t);
  }, r.prototype.rightLabelsReflow = function(t) {
    var e = this.distanceBetweenLabels(t);
    this.distributeLabels(e, t);
  }, r.prototype.distanceBetweenLabels = function(t) {
    var e = dt(this.points), i = e.sector, a = t.length - 1, s = i.radius + e.options.labels.distance, l = [], p = t[0].box, h = R(p.y1 - (i.center.y - s - p.height() - p.height() / 2));
    l.push(h);
    for (var c = 0; c < a; c++) {
      var u = t[c + 1].box;
      p = t[c].box, h = R(u.y1 - p.y2), l.push(h);
    }
    return h = R(i.center.y + s - t[a].box.y2 - t[a].box.height() / 2), l.push(h), l;
  }, r.prototype.distributeLabels = function(t, e) {
    for (var i = this, a = t.length, s, l, p, h = 0; h < a; h++)
      for (p = -t[h], s = l = h; p > 0 && (s >= 0 || l < a); )
        p = i._takeDistance(t, h, --s, p), p = i._takeDistance(t, h, ++l, p);
    this.reflowLabels(t, e);
  }, r.prototype._takeDistance = function(t, e, i, a) {
    var s = a;
    if (t[i] > 0) {
      var l = Math.min(t[i], s);
      s -= l, t[i] -= l, t[e] += l;
    }
    return s;
  }, r.prototype.reflowLabels = function(t, e) {
    var i = this, a = dt(this.points), s = a.sector, l = a.options.labels, p = e.length, h = l.distance, c = s.center.y - (s.radius + h) - e[0].box.height(), u;
    t[0] += 2;
    for (var v = 0; v < p; v++) {
      var f = e[v], d = f.box;
      c += t[v], u = i.hAlignLabel(
        d.x2,
        s.clone().expand(h),
        c,
        c + d.height(),
        f.orientation === et
      ), f.orientation === et ? (l.align !== fe && (u = s.radius + s.center.x + h), f.reflow(new L(u + d.width(), c, u, c))) : (l.align !== fe && (u = s.center.x - s.radius - h), f.reflow(new L(u - d.width(), c, u, c))), c += d.height();
    }
  }, r.prototype.createVisual = function() {
    var t = this, e = this, i = e.options.connectors, a = e.points, s = a.length, l = 4;
    n.prototype.createVisual.call(this), this._connectorLines = [];
    for (var p = 0; p < s; p++) {
      var h = a[p], c = h.sector, u = h.label, v = c.middle(), f = (h.options.connectors || {}).color || i.color;
      if (u) {
        var d = new H({
          stroke: {
            color: f,
            width: i.width
          },
          animation: {
            type: Cr,
            delay: h.animationDelay
          }
        });
        if (u.options.position === Ir) {
          var m = u.box, _ = c.center, w = c.point(v), A = new F(m.x1, m.center().y), T = void 0, k = void 0, C = void 0;
          w = c.clone().expand(i.padding).point(v), d.moveTo(w.x, w.y), u.orientation === et ? (k = new F(m.x1 - i.padding, m.center().y), C = lh(_, w, A, k), A = new F(k.x - l, k.y), C = C || A, C.x = Math.min(C.x, A.x), t.pointInCircle(C, c.center, c.radius + l) || C.x < c.center.x ? (T = c.center.x + c.radius + l, h.options.labels.align !== or ? T < A.x ? d.lineTo(T, w.y) : d.lineTo(w.x + l * 2, w.y) : d.lineTo(T, w.y), d.lineTo(A.x, k.y)) : (C.y = k.y, d.lineTo(C.x, C.y))) : (k = new F(m.x2 + i.padding, m.center().y), C = lh(_, w, A, k), A = new F(k.x + l, k.y), C = C || A, C.x = Math.max(C.x, A.x), t.pointInCircle(C, c.center, c.radius + l) || C.x > c.center.x ? (T = c.center.x - c.radius - l, h.options.labels.align !== or ? T > A.x ? d.lineTo(T, w.y) : d.lineTo(w.x - l * 2, w.y) : d.lineTo(T, w.y), d.lineTo(A.x, k.y)) : (C.y = k.y, d.lineTo(C.x, C.y))), d.lineTo(k.x, k.y), t._connectorLines.push(d), t.visual.append(d);
        }
      }
    }
  }, r.prototype.renderVisual = function() {
    if (n.prototype.renderVisual.call(this), au(this.options.series, function(l) {
      return l.autoFit;
    })) {
      var t = this.targetBox, e = this.box.center(), i = this.visual.bbox();
      if (!i)
        return;
      var a = i.bottomRight(), s = Math.min(
        (e.y - t.y1) / (e.y - i.origin.y),
        (t.y2 - e.y) / (a.y - e.y),
        (e.x - t.x1) / (e.x - i.origin.x),
        (t.x2 - e.x) / (a.x - e.x)
      );
      s < 1 && this.visual.transform(wt().scale(s, s, [e.x, e.y]));
    }
  }, r.prototype.labelComparator = function(t) {
    var e = t ? -1 : 1;
    return function(i, a) {
      var s = (i.parent.sector.middle() + 270) % 360, l = (a.parent.sector.middle() + 270) % 360;
      return (s - l) * e;
    };
  }, r.prototype.hAlignLabel = function(t, e, i, a, s) {
    var l = e.radius, p = e.center, h = p.x, c = p.y, u = Math.min(Math.abs(c - i), Math.abs(c - a));
    return u > l ? t : h + Math.sqrt(l * l - u * u) * (s ? 1 : -1);
  }, r.prototype.pointInCircle = function(t, e, i) {
    return Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2) < Math.pow(i, 2);
  }, r.prototype.formatPointValue = function(t, e) {
    return this.chartService.format.auto(e, t.value);
  }, r.prototype.animationDelay = function(t) {
    return t * sm;
  }, r.prototype.stackRoot = function() {
    return this;
  }, r;
}(rt);
function lh(n, r, o, t) {
  var e = (t.x - o.x) * (n.y - o.y) - (t.y - o.y) * (n.x - o.x), i = (t.y - o.y) * (r.x - n.x) - (t.x - o.x) * (r.y - n.y), a;
  if (i !== 0) {
    var s = e / i;
    a = new F(
      n.x + s * (r.x - n.x),
      n.y + s * (r.y - n.y)
    );
  }
  return a;
}
O(Ro, {
  startAngle: 90,
  connectors: {
    width: 2,
    color: "#939393",
    padding: 8
  },
  inactiveItems: {
    markers: {},
    labels: {}
  }
});
b(Ro.prototype, gv);
Ro.prototype.isStackRoot = !0;
var yv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this.createPieChart(this.series);
  }, r.prototype.createPieChart = function(t) {
    var e = t[0], i = new Ro(this, {
      series: t,
      padding: e.padding,
      startAngle: e.startAngle,
      connectors: e.connectors,
      legend: this.options.legend
    });
    this.appendChart(i);
  }, r.prototype.appendChart = function(t, e) {
    n.prototype.appendChart.call(this, t, e), Nr(this.options.legend.items, t.legendItems);
  }, r;
}(pr), oa = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflowLabel = function() {
    var t = this, e = t.options.labels, i = t.label, a = this.sector.clone(), s = a.middle();
    if (i) {
      var l = i.box.height();
      if (e.position === $) {
        a.radius -= (a.radius - a.innerRadius) / 2;
        var p = a.point(s);
        i.reflow(new L(p.x, p.y - l / 2, p.x, p.y));
      } else
        n.prototype.reflowLabel.call(this);
    }
  }, r.prototype.createSegment = function(t, e) {
    return oi.current.createRing(t, e);
  }, r;
}(ia);
O(oa, {
  overlay: {
    gradient: "roundedGlass"
  },
  labels: {
    position: $
  },
  animation: {
    type: Sr
  }
});
b(oa.prototype, xe);
var lm = 50, mv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.addValue = function(t, e, i) {
    var a = b({}, i.series, { index: i.index });
    if (this.evalSegmentOptions(a, t, i), this.createLegendItem(t, a, i), i.visible !== !1) {
      var s = new oa(t, e, a);
      Object.assign(s, i), this.append(s), this.points.push(s);
    }
  }, r.prototype.reflow = function(t) {
    var e = this, i = this.options, a = t.clone(), s = 5, l = Math.min(a.width(), a.height()), p = l / 2, h = l - l * 0.85, c = i.series, u = c.length, v = U(i.padding, h);
    v = v > p - s ? p - s : v;
    for (var f = p - v, d = 0, m, _ = 0; _ < u; _++) {
      var w = c[_];
      _ === 0 && P(w.holeSize) && (m = w.holeSize, f -= w.holeSize), P(w.size) ? f -= w.size : d++, P(w.margin) && _ !== u - 1 && (f -= w.margin);
    }
    if (!P(m)) {
      var A = (p - v) / (u + 0.75);
      m = A * 0.75, f -= m;
    }
    var T = m, k = 0, C, z;
    this.seriesConfigs = [];
    for (var V = 0; V < u; V++) {
      var G = c[V];
      C = U(G.size, f / d), T += k, z = T + C, e.seriesConfigs.push({ innerRadius: T, radius: z }), k = G.margin || 0, T = z;
    }
    n.prototype.reflow.call(this, t);
  }, r.prototype.animationDelay = function(t, e, i) {
    return t * lm + ne * (e + 1) / (i + 1);
  }, r;
}(Ro);
O(mv, {
  startAngle: 90,
  connectors: {
    width: 2,
    color: "#939393",
    padding: 8
  }
});
var pm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this.createDonutChart(this.series);
  }, r.prototype.createDonutChart = function(t) {
    var e = t[0], i = new mv(this, {
      series: t,
      padding: e.padding,
      connectors: e.connectors,
      legend: this.options.legend
    });
    this.appendChart(i);
  }, r;
}(yv), hm = 0.15, _v = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function() {
    this.valueAxisRangeTracker = new Ln();
  }, r.prototype.render = function() {
    this.addToLegend(this.series), this.createPolarAxis(), this.createCharts(), this.createValueAxis();
  }, r.prototype.alignAxes = function() {
    var t = this.valueAxis, e = t.range(), i = t.options.reverse ? e.max : e.min, a = t.getSlot(i), s = this.polarAxis.getSlot(0).center, l = t.box.translate(
      s.x - a.x1,
      s.y - a.y1
    );
    t.reflow(l);
  }, r.prototype.createValueAxis = function() {
    var t = this.valueAxisRangeTracker, e = t.query(), i = this.valueAxisOptions({
      roundToMajorUnit: !1,
      zIndex: -1
    }), a, s;
    i.type === En ? (a = Ou, s = { min: 0.1, max: 1 }) : (a = Pu, s = { min: 0, max: 1 });
    var l = t.query(name) || e || s;
    l && e && (l.min = Math.min(l.min, e.min), l.max = Math.max(l.max, e.max));
    var p = new a(
      l.min,
      l.max,
      i,
      this.chartService
    );
    this.valueAxis = p, this.appendAxis(p);
  }, r.prototype.reflowAxes = function() {
    var t = this, e = t.options.plotArea, i = t.valueAxis, a = t.polarAxis, s = t.box, l = Math.min(s.width(), s.height()) * hm, p = ot(e.padding || {}, l), h = s.clone().unpad(p), c = h.clone();
    c.y2 = c.y1 + Math.min(c.width(), c.height()), c.align(h, B, $);
    var u = c.clone().shrink(0, c.height() / 2);
    a.reflow(c), i.reflow(u);
    var v = i.lineBox().height() - i.box.height();
    i.reflow(i.box.unpad({ top: v })), this.axisBox = c, this.alignAxes(c);
  }, r.prototype.backgroundBox = function() {
    return this.box;
  }, r.prototype.detachLabels = function() {
  }, r;
}(pr), Ml = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointSlot = function(t, e) {
    var i = t.center.y - e.y1, a = F.onCircle(t.center, t.startAngle, i);
    return new L(a.x, a.y, a.x, a.y);
  }, r;
}(Ci);
O(Ml, {
  clip: !1
});
var na = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(Ol);
na.prototype.pointSlot = Ml.prototype.pointSlot;
O(na, {
  clip: !1
});
var cm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.fillToAxes = function(t) {
    var e = this._polarAxisCenter();
    t.lineTo(e.x, e.y);
  }, r.prototype._polarAxisCenter = function() {
    var t = this.parent.plotArea.polarAxis, e = t.box.center();
    return e;
  }, r.prototype.strokeSegments = function() {
    var t = this._strokeSegments;
    if (!t) {
      var e = this._polarAxisCenter(), i = new Wn(!1), a = this.points();
      a.push(e), t = this._strokeSegments = i.process(a), t.pop();
    }
    return t;
  }, r;
}(wl), um = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.fillToAxes = function(t) {
    var e = this.parent.plotArea.polarAxis, i = e.box.center(), a = new We([i.x, i.y]);
    t.segments.unshift(a), t.segments.push(a);
  }, r;
}(bi), vm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createSegment = function(t, e, i) {
    var a = (e.line || {}).style, s;
    return a === mi ? s = new cm(t, e, i) : s = new um(t, e, i), s;
  }, r.prototype.createMissingValue = function(t, e) {
    var i;
    return Yt(t.x) && e !== ni && (i = {
      x: t.x,
      y: t.y
    }, e === ir && (i.y = 0)), i;
  }, r.prototype.seriesMissingValues = function(t) {
    return t.missingValues || ir;
  }, r.prototype._hasMissingValuesGap = function() {
    for (var t = this, e = this.options.series, i = 0; i < e.length; i++)
      if (t.seriesMissingValues(e[i]) === Kp)
        return !0;
  }, r.prototype.sortPoints = function(t) {
    var e = this;
    if (t.sort(fm), this._hasMissingValuesGap())
      for (var i = 0; i < t.length; i++) {
        var a = t[i];
        if (a) {
          var s = a.value;
          !Yt(s.y) && e.seriesMissingValues(a.series) === Kp && delete t[i];
        }
      }
    return t;
  }, r;
}(na);
function fm(n, r) {
  return n.value.x - r.value.x;
}
var Rl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createPolarAxis = function() {
    var t = new ll(this.options.xAxis, this.chartService);
    this.polarAxis = t, this.axisX = t, this.appendAxis(t);
  }, r.prototype.valueAxisOptions = function(t) {
    return b(t, {
      majorGridLines: { type: mr },
      minorGridLines: { type: mr }
    }, this.options.yAxis);
  }, r.prototype.createValueAxis = function() {
    n.prototype.createValueAxis.call(this), this.axisY = this.valueAxis;
  }, r.prototype.appendChart = function(t, e) {
    this.valueAxisRangeTracker.update(t.yAxisRanges), pr.prototype.appendChart.call(this, t, e);
  }, r.prototype.createCharts = function() {
    var t = this.filterVisibleSeries(this.series), e = this.panes[0];
    this.createLineChart(
      ft(t, [cl]),
      e
    ), this.createScatterChart(
      ft(t, [ul]),
      e
    ), this.createAreaChart(
      ft(t, [hl]),
      e
    );
  }, r.prototype.createLineChart = function(t, e) {
    if (t.length !== 0) {
      var i = new na(this, { series: t });
      this.appendChart(i, e);
    }
  }, r.prototype.createScatterChart = function(t, e) {
    if (t.length !== 0) {
      var i = new Ml(this, { series: t });
      this.appendChart(i, e);
    }
  }, r.prototype.createAreaChart = function(t, e) {
    if (t.length !== 0) {
      var i = new vm(this, { series: t });
      this.appendChart(i, e);
    }
  }, r.prototype._dispatchEvent = function(t, e, i) {
    var a = t._eventCoordinates(e), s = new F(a.x, a.y), l = this.axisX.getValue(s), p = this.axisY.getValue(s);
    l !== null && p !== null && t.trigger(i, {
      element: ge(e),
      x: l,
      y: p
    });
  }, r.prototype.createCrosshairs = function() {
  }, r;
}(_v);
O(Rl, {
  xAxis: {},
  yAxis: {}
});
b(Rl.prototype, Mo);
function dm(n) {
  for (var r = [], o = 0; o < n.length; o++) {
    var t = n[o];
    r[t.seriesIx] = r[t.seriesIx] || [], r[t.seriesIx].push(t);
  }
  return r;
}
var Ll = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointSlot = function(t, e) {
    var i = t.center.y - e.y1, a = F.onCircle(t.center, t.middle(), i);
    return new L(a.x, a.y, a.x, a.y);
  }, r.prototype.renderSegments = function() {
    if (n.prototype.renderSegments.call(this), this._segments && this._segments.length > 1)
      for (var t = dm(this._segments), e = 0; e < t.length; e++) {
        var i = t[e];
        if (i && i.length > 1) {
          var a = i[0].linePoints[0], s = dt(i), l = dt(s.linePoints), p = a.categoryIx === 0, h = l.categoryIx === l.categoriesCount - 1;
          p && h && dt(i).linePoints.push(a);
        }
      }
  }, r.prototype.createSegment = function(t, e, i) {
    var a = e.style, s;
    a === mi ? s = ml : s = Ur;
    var l = new s(t, e, i), p = this.seriesMissingValues(e);
    return (t.length === e.data.length || p === ni) && (l.options.closed = !0), l;
  }, r;
}(Kn);
O(Ll, {
  clip: !1,
  limitPoints: !1
});
var gm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.fillToAxes = function() {
  }, r;
}(wl), ym = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.fillToAxes = function() {
  }, r;
}(bi), mm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createSegment = function(t, e, i, a) {
    var s = this.options.isStacked, l = (e.line || {}).style, p, h, c;
    return s && i > 0 && a && (h = a.linePoints.slice(0), p = a), l === mi ? (c = new gm(t, e, i, p, h), c.options.closed = !0) : (t.push(t[0]), c = new ym(t, e, i, p, h)), c;
  }, r.prototype.seriesMissingValues = function(t) {
    return t.missingValues || ir;
  }, r;
}(Ll), xv = function(n) {
  function r(o, t) {
    n.call(this, o, null, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(oa);
O(xv, {
  overlay: {
    gradient: "none"
  },
  labels: {
    distance: 10
  }
});
var wv = function(n) {
  function r(o) {
    n.call(this, o), this.forEach = o.rtl ? Wu : Gu;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = e.options, a = e.children, s = i.gap, l = i.spacing, p = a.length, h = p + s + l * (p - 1), c = t.angle / h, u = t.startAngle + c * (s / 2);
    this.forEach(a, function(v) {
      var f = t.clone();
      f.startAngle = u, f.angle = c, v.sector && (f.radius = v.sector.radius), v.reflow(f), v.sector = f, u += c + c * l;
    });
  }, r;
}(rt);
O(wv, {
  gap: 1,
  spacing: 0
});
var _m = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = e.options.reverse, a = e.children, s = a.length, l = i ? s - 1 : 0, p = i ? -1 : 1;
    this.box = new L();
    for (var h = l; h >= 0 && h < s; h += p) {
      var c = a[h].sector;
      c.startAngle = t.startAngle, c.angle = t.angle;
    }
  }, r;
}(rt), Il = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointType = function() {
    return xv;
  }, r.prototype.clusterType = function() {
    return wv;
  }, r.prototype.stackType = function() {
    return _m;
  }, r.prototype.categorySlot = function(t, e) {
    return t.getSlot(e);
  }, r.prototype.pointSlot = function(t, e) {
    var i = t.clone(), a = t.center.y;
    return i.radius = a - e.y1, i.innerRadius = a - e.y2, i;
  }, r.prototype.reflowPoint = function(t, e) {
    t.sector = e, t.reflow();
  }, r.prototype.createAnimation = function() {
    this.options.animation.center = this.box.toRect().center(), n.prototype.createAnimation.call(this);
  }, r;
}(Si);
Il.prototype.reflow = ze.prototype.reflow;
O(Il, {
  clip: !1,
  limitPoints: !1,
  animation: {
    type: "pie"
  }
});
var Dl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createPolarAxis = function() {
    var t = new eo(this.options.categoryAxis, this.chartService);
    this.polarAxis = t, this.categoryAxis = t, this.appendAxis(t), this.aggregateCategories(), this.createCategoryAxesLabels();
  }, r.prototype.valueAxisOptions = function(t) {
    return this._hasBarCharts && b(t, {
      majorGridLines: { type: mr },
      minorGridLines: { type: mr }
    }), this._isStacked100 && b(t, {
      roundToMajorUnit: !1,
      labels: { format: "P0" }
    }), b(t, this.options.valueAxis);
  }, r.prototype.aggregateCategories = function() {
    Ke.prototype.aggregateCategories.call(this, this.panes);
  }, r.prototype.createCategoryAxesLabels = function() {
    Ke.prototype.createCategoryAxesLabels.call(this, this.panes);
  }, r.prototype.filterSeries = function(t) {
    return t;
  }, r.prototype.createCharts = function() {
    var t = this.filterVisibleSeries(this.series), e = this.panes[0];
    this.createAreaChart(
      ft(t, [Yn]),
      e
    ), this.createLineChart(
      ft(t, [Zn]),
      e
    ), this.createBarChart(
      ft(t, [qn]),
      e
    );
  }, r.prototype.chartOptions = function(t) {
    var e = { series: t }, i = t[0];
    if (i) {
      var a = this.filterVisibleSeries(t), s = i.stack;
      e.isStacked = s && a.length > 1, e.isStacked100 = s && s.type === "100%" && a.length > 1, e.isStacked100 && (this._isStacked100 = !0);
    }
    return e;
  }, r.prototype.createAreaChart = function(t, e) {
    if (t.length !== 0) {
      var i = new mm(this, this.chartOptions(t));
      this.appendChart(i, e);
    }
  }, r.prototype.createLineChart = function(t, e) {
    if (t.length !== 0) {
      var i = new Ll(this, this.chartOptions(t));
      this.appendChart(i, e);
    }
  }, r.prototype.createBarChart = function(t, e) {
    if (t.length !== 0) {
      var i = t[0], a = this.chartOptions(t);
      a.gap = i.gap, a.spacing = i.spacing;
      var s = new Il(this, a);
      this.appendChart(s, e), this._hasBarCharts = !0;
    }
  }, r.prototype.seriesCategoryAxis = function() {
    return this.categoryAxis;
  }, r.prototype._dispatchEvent = function(t, e, i) {
    var a = t._eventCoordinates(e), s = new F(a.x, a.y), l = this.categoryAxis.getCategory(s), p = this.valueAxis.getValue(s);
    l !== null && p !== null && t.trigger(i, {
      element: ge(e),
      category: l,
      value: p
    });
  }, r.prototype.createCrosshairs = function() {
  }, r;
}(_v);
b(Dl.prototype, Mo, {
  appendChart: Ke.prototype.appendChart,
  aggregateSeries: Ke.prototype.aggregateSeries,
  seriesSourcePoints: Ke.prototype.seriesSourcePoints
});
O(Dl, {
  categoryAxis: {
    categories: []
  },
  valueAxis: {}
});
var Bl = function(n) {
  function r(o, t, e) {
    n.call(this, t), this.value = o, this.options.index = e.index;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this.points, i = this.children[0];
    this.box = new L(e[0].x, e[0].y, e[1].x, e[2].y), i && i.reflow(new L(t.x1, e[0].y, t.x2, e[2].y));
  }, r.prototype.createVisual = function() {
    var t = this, e = this.options, i;
    n.prototype.createVisual.call(this), e.visual ? i = e.visual({
      category: this.category,
      dataItem: this.dataItem,
      value: this.value,
      series: this.series,
      percentage: this.percentage,
      points: this.points,
      options: e,
      sender: this.getSender(),
      createVisual: function() {
        return t.createPath();
      }
    }) : i = this.createPath(), i && this.visual.append(i);
  }, r.prototype.createPath = function() {
    var t = this.options, e = t.border, i = H.fromPoints(this.points, {
      fill: {
        color: t.color,
        opacity: t.opacity
      },
      stroke: {
        color: e.color,
        opacity: e.opacity,
        width: e.width
      }
    }).close();
    return i;
  }, r.prototype.createHighlight = function(t) {
    return H.fromPoints(this.points, t);
  }, r.prototype.highlightVisual = function() {
    return this.visual.children[0];
  }, r.prototype.highlightVisualArgs = function() {
    var t = H.fromPoints(this.points).close();
    return {
      options: this.options,
      path: t
    };
  }, r.prototype.tooltipAnchor = function() {
    var t = this.box;
    return {
      point: new F(t.center().x, t.y1),
      align: {
        horizontal: "center",
        vertical: "top"
      }
    };
  }, r.prototype.formatValue = function(t) {
    var e = this;
    return e.owner.formatPointValue(e, t);
  }, r;
}(rt);
O(Bl, {
  color: J,
  border: {
    width: 1
  }
});
b(Bl.prototype, xe);
var aa = function(n) {
  function r(o, t) {
    n.call(this, t), this.plotArea = o, this.points = [], this.labels = [], this.legendItems = [], this.render();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.formatPointValue = function(t, e) {
    return this.chartService.format.auto(e, t.value);
  }, r.prototype.render = function() {
    var t = this, e = this, i = e.options, a = e.plotArea.options.seriesColors;
    a === void 0 && (a = []);
    var s = i.series[0], l = s.data;
    if (l)
      for (var p = tv(s), h = p.total, c = p.points, u = 0; u < c.length; u++) {
        var v = c[u];
        if (v) {
          var f = v.fields;
          vt(s.color) || (s.color = f.color || a[u % a.length]), f = b({
            index: u,
            owner: t,
            series: s,
            dataItem: l[u],
            percentage: v.value / h
          }, f, { visible: v.visible });
          var d = v.valueFields.value, m = t.createSegment(d, f), _ = t.createLabel(d, f);
          m && _ && m.append(_);
        }
      }
  }, r.prototype.evalSegmentOptions = function(t, e, i) {
    var a = i.series;
    nr(t, {
      value: e,
      series: a,
      dataItem: i.dataItem,
      index: i.index
    }, { defaults: a._defaults, excluded: ["data", "content", "template", "toggle", "visual"] });
  }, r.prototype.createSegment = function(t, e) {
    var i = b({}, e.series);
    if (this.evalSegmentOptions(i, t, e), this.createLegendItem(t, i, e), e.visible !== !1) {
      var a = new Bl(t, i, e);
      return Object.assign(a, e), this.append(a), this.points.push(a), a;
    }
  }, r.prototype.createLabel = function(t, e) {
    var i = e.series, a = e.dataItem, s = b({}, this.options.labels, i.labels), l = t;
    if (s.visible) {
      var p = Ct(s), h = {
        dataItem: a,
        value: t,
        percentage: e.percentage,
        category: e.category,
        series: i
      };
      p ? l = p(h) : s.format && (l = this.plotArea.chartService.format.auto(s.format, l)), s.color || (s.color = qs(i.color), s.background || (s.background = i.color)), this.evalSegmentOptions(s, t, e);
      var c = new Qt(l, b({
        vAlign: s.position
      }, s), h);
      return this.labels.push(c), c;
    }
  }, r.prototype.labelPadding = function() {
    for (var t = this.labels, e = { left: 0, right: 0 }, i = 0; i < t.length; i++) {
      var a = t[i], s = a.options.align;
      if (s !== $) {
        var l = t[i].box.width();
        s === Q ? e.left = Math.max(e.left, l) : e.right = Math.max(e.right, l);
      }
    }
    return e;
  }, r.prototype.dynamicSlopeReflow = function(t, e, i) {
    for (var a = this, s = a.options, l = a.points, p = l.length, h = l[0], c = h, u = 0; u < l.length; u++)
      l[u].percentage > c.percentage && (c = l[u]);
    for (var v = h.percentage / c.percentage * e, f = (e - v) / 2, d = 0, m = 0; m < p; m++) {
      var _ = l[m].percentage, w = l[m + 1], A = w ? w.percentage : _, T = l[m].points = [], k = s.dynamicHeight ? i * _ : i / p, C = void 0;
      _ ? C = (e - v * (A / _)) / 2 : C = A ? 0 : e / 2, C = j(C, 0, e), T.push(new q(t.x1 + f, t.y1 + d)), T.push(new q(t.x1 + e - f, t.y1 + d)), T.push(new q(t.x1 + e - C, t.y1 + k + d)), T.push(new q(t.x1 + C, t.y1 + k + d)), f = C, d += k + s.segmentSpacing, v = j(e - 2 * C, 0, e);
    }
  }, r.prototype.constantSlopeReflow = function(t, e, i) {
    for (var a = this, s = a.options, l = a.points, p = l.length, h = s.neckRatio <= 1, c = h ? s.neckRatio * e : e, u = h ? 0 : (e - e / s.neckRatio) / 2, v = h ? e : e - u * 2, f = (v - c) / 2, d = 0, m = 0; m < p; m++) {
      var _ = l[m].points = [], w = l[m].percentage, A = s.dynamicHeight ? f * w : f / p, T = s.dynamicHeight ? i * w : i / p;
      _.push(new q(t.x1 + u, t.y1 + d)), _.push(new q(t.x1 + e - u, t.y1 + d)), _.push(new q(t.x1 + e - u - A, t.y1 + T + d)), _.push(new q(t.x1 + u + A, t.y1 + T + d)), u += A, d += T + s.segmentSpacing;
    }
  }, r.prototype.reflow = function(t) {
    var e = this.points, i = e.length;
    if (i) {
      var a = this.options, s = t.clone().unpad(this.labelPadding()), l = s.height() - a.segmentSpacing * (i - 1), p = s.width();
      a.dynamicSlope ? this.dynamicSlopeReflow(s, p, l) : this.constantSlopeReflow(s, p, l);
      for (var h = 0; h < i; h++)
        e[h].reflow(t);
    }
  }, r;
}(rt);
O(aa, {
  neckRatio: 0.3,
  width: 300,
  dynamicSlope: !1,
  dynamicHeight: !0,
  segmentSpacing: 0,
  labels: {
    visible: !1,
    align: $,
    position: $,
    zIndex: 1
  }
});
b(aa.prototype, gv);
var xm = 1e6, wm = function(n) {
  function r(o, t) {
    t.dynamicSlope = !1, t.neckRatio = xm, n.call(this, o, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(aa), bm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this.createChart(aa, ft(this.series, [io])), this.createChart(wm, ft(this.series, [oo]));
  }, r.prototype.createChart = function(t, e) {
    var i = e[0];
    if (i) {
      var a = new t(this, {
        series: e,
        legend: this.options.legend,
        neckRatio: i.neckRatio,
        dynamicHeight: i.dynamicHeight,
        dynamicSlope: i.dynamicSlope,
        segmentSpacing: i.segmentSpacing,
        highlight: i.highlight
      });
      this.appendChart(a);
    }
  }, r.prototype.appendChart = function(t, e) {
    n.prototype.appendChart.call(this, t, e), Nr(this.options.legend.items, t.legendItems);
  }, r;
}(pr), Am = function(n, r) {
  r === void 0 && (r = 0.05);
  var o = Bd(n), t = 1 - r;
  return function(e) {
    var i = o.toHSL(), a = 100 - i.l, s = t - e;
    return i.l += Math.min(s * a, a), i.toCss();
  };
}, so = function(n) {
  function r(o, t) {
    n.call(this), this.options = t, this.color = t.color || J, this.value = o;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.render = function() {
    this._rendered || (this._rendered = !0, this.createMarker(), this.createLabel(), this.createNote());
  }, r.prototype.createLabel = function() {
    var t = this.options, e = t.labels;
    if (e.visible) {
      var i = this.pointData(), a = Ct(e), s, l = e.color;
      a ? s = a(i) : s = this.formatValue(e.format), l || (l = qs(this.color)), this.label = new Qt(
        s,
        b(
          {
            align: $,
            vAlign: $,
            margin: {
              left: 5,
              right: 5
            },
            zIndex: U(e.zIndex, this.series.zIndex)
          },
          e,
          {
            color: l
          }
        ),
        i
      ), this.append(this.label);
    }
  }, r.prototype.formatValue = function(t) {
    return this.owner.formatPointValue(this, t);
  }, r.prototype.reflow = function(t) {
    this.render();
    var e = this.label;
    this.box = t, e && e.reflow(this.markerBox()), this.note && this.note.reflow(t), this.marker.reflow(this.markerBox());
  }, r.prototype.markerBox = function() {
    var t = this.options, e = t.markers, i = e.border, a = this.box.toRect(), s = U(e.type, "rect"), l = s === Kc, p = U(i.width, l ? 1 : 0), h = Math.round(p / 2);
    if (e.size) {
      var c = a.center();
      a.size.width = a.size.height = e.size, a.origin.x = Math.round(c.x - a.size.width / 2), a.origin.y = Math.round(c.y - a.size.height / 2);
    }
    return a.size.width -= p, a.size.height -= p, a.origin.y += h + 0.5, a.origin.x += h + 0.5, Hn(a);
  }, r.prototype.markerBorder = function() {
    var t = this.options, e = t.markers, i = e.border, a = U(i.opacity, t.opacity);
    return {
      color: i.color || this.color,
      width: i.width,
      opacity: a,
      dashType: i.dashType
    };
  }, r.prototype.createMarker = function() {
    var t = this.options, e = t.markers, i = new tr({
      type: U(e.type, "rect"),
      width: e.size,
      height: e.size,
      rotation: e.rotation,
      background: this.color,
      border: this.markerBorder(),
      borderRadius: e.borderRadius,
      opacity: this.series.opacity || t.opacity,
      zIndex: U(t.zIndex, this.series.zIndex),
      animation: t.animation,
      visual: t.visual
    }, {
      dataItem: this.dataItem,
      value: this.value,
      series: this.series,
      category: this.category
    });
    this.marker = i, this.append(i);
  }, r.prototype.createHighlight = function(t) {
    var e = this.options, i = this.options.highlight.markers || this.options.markers, a = new tr({
      type: U(i.type, "rect"),
      width: i.size,
      height: i.size,
      rotation: i.rotation,
      background: i.color || this.color,
      border: this.markerBorder(),
      borderRadius: i.borderRadius,
      opacity: this.series.opacity || e.opacity,
      zIndex: U(e.zIndex, this.series.zIndex)
    });
    a.reflow(this.markerBox());
    var s = a.getElement();
    return s.options.fill = t.fill, s.options.stroke = t.stroke, s;
  }, r.prototype.highlightVisual = function() {
    return this.rectVisual;
  }, r.prototype.highlightVisualArgs = function() {
    return {
      options: this.options,
      rect: this.box.toRect(),
      visual: this.rectVisual
    };
  }, r.prototype.tooltipAnchor = function() {
    var t = this.box.center().x, e = this.box.y1 - ue;
    return {
      point: new F(t, e),
      align: {
        horizontal: $,
        vertical: it
      }
    };
  }, r.prototype.overlapsBox = function(t) {
    return this.box.overlaps(t);
  }, r.prototype.unclipElements = function() {
  }, r.prototype.pointData = function() {
    return {
      x: this.value.x,
      y: this.value.y,
      value: this.value.value,
      dataItem: this.dataItem,
      series: this.series
    };
  }, r;
}(rt);
b(so.prototype, xe);
b(so.prototype, wi);
so.prototype.defaults = {
  markers: {
    type: "rect",
    borderRadius: 4,
    border: {
      color: "transparent"
    }
  },
  padding: { top: 1 },
  labels: {
    visible: !1,
    padding: 3
  },
  opacity: 1,
  notes: {
    label: {}
  }
};
var zl = function(n) {
  function r(o, t) {
    n.call(this, t), this.plotArea = o, this.chartService = o.chartService, this._initFields(), this.render();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initFields = function() {
    this.points = [], this.seriesOptions = [], this.valueRange = { min: gt, max: xt }, this._evalSeries = [];
  }, r.prototype.render = function() {
    this.setRange(), this.traverseDataPoints(this.addValue.bind(this));
  }, r.prototype.setRange = function() {
    for (var t = this, e = this, i = e.options.series, a = 0; a < i.length; a++)
      for (var s = i[a], l = 0; l < s.data.length; l++) {
        var p = t._bindPoint(s, a, l), h = p.valueFields;
        P(h.value) && h.value !== null && (t.valueRange.min = Math.min(t.valueRange.min, h.value), t.valueRange.max = Math.max(t.valueRange.max, h.value));
      }
  }, r.prototype.addValue = function(t, e) {
    var i;
    t && P(t.value) && t.value !== null && (i = this.createPoint(t, e), i && Object.assign(i, e)), this.points.push(i);
  }, r.prototype.evalPointOptions = function(t, e, i) {
    var a = i.series, s = i.seriesIx, l = {
      defaults: a._defaults,
      excluded: [
        "data",
        "tooltip",
        "content",
        "template",
        "visual",
        "toggle",
        "drilldownSeriesFactory"
      ]
    }, p = this._evalSeries[s];
    P(p) || (this._evalSeries[s] = p = nr(t, {}, l, !0));
    var h = t;
    return p && (h = b({}, t), nr(h, {
      value: e,
      series: a,
      dataItem: i.dataItem,
      min: this.valueRange.min,
      max: this.valueRange.max
    }, l)), h;
  }, r.prototype.pointType = function() {
    return so;
  }, r.prototype.pointOptions = function(t, e) {
    var i = this.seriesOptions[e];
    if (!i) {
      var a = this.pointType().prototype.defaults;
      this.seriesOptions[e] = i = b({}, a, {
        markers: {
          opacity: t.opacity
        },
        tooltip: {
          format: this.options.tooltip.format
        },
        labels: {
          format: this.options.labels.format
        }
      }, t);
    }
    return i;
  }, r.prototype.createPoint = function(t, e) {
    var i = e.series, a = this.pointOptions(i, e.seriesIx), s = e.color || i.color;
    if (a = this.evalPointOptions(a, t, e), vt(i.color))
      s = a.color;
    else if (this.valueRange.max !== 0) {
      var l = Am(s);
      s = l(t.value / this.valueRange.max);
    }
    var p = new so(t, a);
    return p.color = s, this.append(p), p;
  }, r.prototype.seriesAxes = function(t) {
    var e = t.xAxis, i = t.yAxis, a = this.plotArea, s = e ? a.namedXAxes[e] : a.axisX, l = i ? a.namedYAxes[i] : a.axisY;
    if (!s)
      throw new Error("Unable to locate X axis with name " + e);
    if (!l)
      throw new Error("Unable to locate Y axis with name " + i);
    return { xAxis: s, yAxis: l };
  }, r.prototype.reflow = function(t) {
    var e = this, i = this.points, a = !this.options.clip, s = 0;
    this.traverseDataPoints(function(l, p) {
      var h = i[s++], c = e.seriesAxes(p.series), u = c.xAxis, v = c.yAxis, f = u.categoryIndex(l.x), d = v.categoryIndex(l.y), m = u.getSlot(f, f, a), _ = v.getSlot(d, d, a);
      if (h)
        if (m && _) {
          var w = e.pointSlot(m, _);
          h.reflow(w);
        } else
          h.visible = !1;
    }), this.box = t;
  }, r.prototype.pointSlot = function(t, e) {
    return new L(t.x1, e.y1, t.x2, e.y2);
  }, r.prototype.traverseDataPoints = function(t) {
    for (var e = this, i = this, a = i.options.series, s = 0; s < a.length; s++)
      for (var l = a[s], p = e.seriesAxes(l), h = p.xAxis, c = p.yAxis, u = h.currentRangeIndices(), v = c.currentRangeIndices(), f = 0; f < l.data.length; f++) {
        var d = e._bindPoint(l, s, f), m = d.valueFields, _ = d.fields, w = h.totalIndex(m.x), A = c.totalIndex(m.y), T = u.min <= w && w <= u.max, k = v.min <= A && A <= v.max;
        T && k && t(m, b({
          pointIx: f,
          series: l,
          seriesIx: s,
          dataItem: l.data[f],
          owner: e
        }, _));
      }
  }, r.prototype.formatPointValue = function(t, e) {
    var i = t.value;
    return this.chartService.format.auto(e, i.x, i.y, i.value);
  }, r.prototype.animationPoints = function() {
    for (var t = this.points, e = [], i = 0; i < t.length; i++)
      e.push((t[i] || {}).marker);
    return e;
  }, r;
}(rt);
O(zl, {
  series: [],
  tooltip: {
    format: "{0}, {1}: {2}"
  },
  labels: {
    format: "{2}"
  },
  clip: !0
});
b(zl.prototype, {
  _bindPoint: ze.prototype._bindPoint
});
var jl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initFields = function() {
    this.namedXAxes = {}, this.namedYAxes = {};
  }, r.prototype.render = function(t) {
    t === void 0 && (t = this.panes), this.bindCategories(), this.createAxes(t), this.createCharts(t), this.createAxisLabels();
  }, r.prototype.bindCategories = function() {
    for (var t = this, e = this.srcSeries || this.series, i = 0; i < e.length; i++) {
      for (var a = e[i], s = a.data || [], l = t.seriesAxes(a), p = l.xAxis, h = l.yAxis, c = Hp(p.categories || []), u = Hp(h.categories || []), v = 0; v < s.length; v++) {
        var f = ht.current.bindPoint(a, v).valueFields, d = f.x, m = f.y;
        c.has(d) || c.add(d), u.has(m) || u.add(m);
      }
      p.categories = c.values(), h.categories = u.values();
    }
  }, r.prototype.createCharts = function(t) {
    for (var e = this, i = this.groupSeriesByPane(), a = 0; a < t.length; a++) {
      var s = t[a], l = i[s.options.name || "default"] || [];
      e.addToLegend(l);
      var p = e.filterVisibleSeries(l);
      p && e.createHeatmapChart(
        ft(p, [pl]),
        s
      );
    }
  }, r.prototype.createHeatmapChart = function(t, e) {
    var i = new zl(this, {
      series: t
    });
    this.appendChart(i, e);
  }, r.prototype.seriesPaneName = function(t) {
    var e = this.options, i = t.xAxis, a = [].concat(e.xAxis), s = qt(a, function(f) {
      return f.name === i;
    })[0], l = t.yAxis, p = [].concat(e.yAxis), h = qt(p, function(f) {
      return f.name === l;
    })[0], c = e.panes || [{}], u = c[0].name || "default", v = (s || {}).pane || (h || {}).pane || u;
    return v;
  }, r.prototype.seriesAxes = function(t) {
    var e, i, a = this.options, s = [].concat(a.xAxis), l = t.xAxis;
    l ? e = s.find(function(c) {
      return c.name === l;
    }) : e = s[0];
    var p = [].concat(a.yAxis), h = t.yAxis;
    if (h ? i = p.find(function(c) {
      return c.name === h;
    }) : i = p[0], !e)
      throw new Error("Unable to locate X axis with name " + l);
    if (!i)
      throw new Error("Unable to locate Y axis with name " + h);
    return { xAxis: e, yAxis: i };
  }, r.prototype.createAxisLabels = function() {
    for (var t = this.axes, e = 0; e < t.length; e++)
      t[e].createLabels();
  }, r.prototype.createXYAxis = function(t, e, i) {
    for (var a = t.name, s = e ? this.namedYAxes : this.namedXAxes, l = Object.assign({
      axisCrossingValue: 0
    }, t, {
      vertical: e,
      reverse: e || this.chartService.rtl ? !t.reverse : t.reverse,
      justified: !1
    }), p = l.categories ? l.categories[0] : null, h = [l.min, l.max, p], c = this.series, u = 0; u < c.length; u++) {
      var v = c[u], f = v[e ? "yAxis" : "xAxis"];
      if (f === l.name || i === 0 && !f) {
        var d = ht.current.bindPoint(v, 0).valueFields;
        h.push(d[e ? "y" : "x"]);
        break;
      }
    }
    for (var m, _ = 0; _ < h.length; _++)
      if (h[_] instanceof Date) {
        m = !0;
        break;
      }
    var w;
    yr(l.type, xr) || !l.type && m ? w = xo : w = Me;
    var A = new w(l, this.chartService);
    if (A.axisIndex = i, a) {
      if (s[a])
        throw new Error((e ? "Y" : "X") + " axis with name " + a + " is already defined");
      s[a] = A;
    }
    return this.appendAxis(A), A.mapCategories(), A;
  }, r.prototype.createAxes = function(t) {
    for (var e = this, i = this.options, a = [].concat(i.xAxis), s = [], l = [].concat(i.yAxis), p = [], h = 0; h < a.length; h++) {
      var c = e.findPane(a[h].pane);
      Z(c, t) && s.push(e.createXYAxis(a[h], !1, h));
    }
    for (var u = 0; u < l.length; u++) {
      var v = e.findPane(l[u].pane);
      Z(v, t) && p.push(e.createXYAxis(l[u], !0, u));
    }
    this.axisX = this.axisX || s[0], this.axisY = this.axisY || p[0];
  }, r.prototype.removeAxis = function(t) {
    var e = t.options.name;
    n.prototype.removeAxis.call(this, t), t.options.vertical ? delete this.namedYAxes[e] : delete this.namedXAxes[e], t === this.axisX && delete this.axisX, t === this.axisY && delete this.axisY;
  }, r.prototype._dispatchEvent = function(t, e, i) {
    for (var a = t._eventCoordinates(e), s = new F(a.x, a.y), l = this.axes, p = l.length, h = [], c = [], u = 0; u < p; u++) {
      var v = l[u], f = v.options.vertical ? c : h;
      pn(f, v.getCategory(s));
    }
    h.length > 0 && c.length > 0 && t.trigger(i, {
      element: ge(e),
      originalEvent: e,
      x: ui(h),
      y: ui(c)
    });
  }, r.prototype.updateAxisOptions = function(t, e) {
    var i = t.options.vertical, a = this.groupAxes(this.panes), s = (i ? a.y : a.x).indexOf(t);
    ph(this.options, s, i, e), ph(this.originalOptions, s, i, e);
  }, r.prototype.crosshairOptions = function(t) {
    return Object.assign({}, t.options.crosshair, { zIndex: 0 });
  }, r;
}(pr);
function ph(n, r, o, t) {
  var e = [].concat(o ? n.yAxis : n.xAxis)[r];
  b(e, t);
}
O(jl, {
  xAxis: {},
  yAxis: {}
});
b(jl.prototype, Mo);
var Kt = "color", Zt = "first", Sm = "from", zt = "max", Vl = "min", hr = "noteText", Tm = "summary", Cm = "to";
me.current.register(Ke, [
  ye,
  or,
  Ao,
  hi,
  wo,
  li,
  xi,
  So,
  Ar,
  ko,
  bo,
  pi,
  Co,
  si,
  Po,
  ai,
  To,
  ci
]);
me.current.register(El, [
  vl,
  fl,
  _i
]);
me.current.register(yv, [Sr]);
me.current.register(pm, [On]);
me.current.register(bm, [io, oo]);
me.current.register(Rl, [hl, cl, ul]);
me.current.register(Dl, [Yn, qn, Zn]);
me.current.register(jl, [pl]);
ht.current.register(
  [ye, or, Ao, hi, wo, li],
  [Xt],
  [Be, Kt, hr, Ru, Lu, lr]
);
ht.current.register(
  [Co, si, To, ci],
  [Sm, Cm],
  [Be, Kt, hr, lr]
);
ht.current.register(
  [Po, ai],
  [Xt],
  [Be, Kt, hr, Tm, lr]
);
ht.current.register([hl, cl, ul], [D, B], [Kt, lr]);
ht.current.register([Yn, qn, Zn], [Xt], [Kt, lr]);
ht.current.register(
  [io, oo],
  [Xt],
  [Be, Kt, "visibleInLegend", "visible", lr]
);
ar.current.register(
  [ye, or, Ao, hi, wo, li, Po, ai],
  { value: zt, color: Zt, noteText: Zt, errorLow: Vl, errorHigh: zt }
);
ar.current.register(
  [Co, si, To, ci],
  { from: Vl, to: zt, color: Zt, noteText: Zt }
);
ar.current.register(
  [Yn, qn, Zn],
  { value: zt, color: Zt }
);
ht.current.register(
  [vl, fl, _i],
  [D, B],
  [Kt, hr, ly, py, hy, cy]
);
ht.current.register(
  [_i],
  [D, B, "size"],
  [Kt, Be, hr]
);
ht.current.register(
  [pl],
  [D, B, Xt],
  [Kt, hr]
);
ht.current.register(
  [xi, So],
  ["open", "high", "low", "close"],
  [Be, Kt, "downColor", hr]
);
ar.current.register(
  [xi, So],
  {
    open: zt,
    high: zt,
    low: Vl,
    close: zt,
    color: Zt,
    downColor: Zt,
    noteText: Zt
  }
);
ht.current.register(
  [bo, pi],
  ["lower", "q1", "median", "q3", "upper", "mean", "outliers"],
  [Be, Kt, hr, lr]
);
ar.current.register(
  [bo, pi],
  {
    lower: zt,
    q1: zt,
    median: zt,
    q3: zt,
    upper: zt,
    mean: zt,
    outliers: Zt,
    color: Zt,
    noteText: Zt
  }
);
ht.current.register(
  [Ar, ko],
  ["current", "target"],
  [Be, Kt, "visibleInLegend", hr, lr]
);
ar.current.register(
  [Ar, ko],
  { current: zt, target: zt, color: Zt, noteText: Zt }
);
ht.current.register(
  [Sr, On],
  [Xt],
  [Be, Kt, "explode", "visibleInLegend", "visible", lr]
);
var ps = [Be, Xt, D, B], Mr = "mousemove", hh = "contextmenu", ch = "mouseleave", km = 20, sa = function(n) {
  function r(o, t, e, i) {
    var a = this;
    i === void 0 && (i = {}), n.call(this), this.observers = [], this.addObserver(i.observer), this.chartService = new di(this, i), this.chartService.theme = e, this._initElement(o);
    var s = b({}, this.options, t);
    this._originalOptions = b({}, s), this._theme = e, this._initTheme(s, e), this._initHandlers(), this._initSurface(), this.bindCategories(), Lr.preloadFonts(t, function() {
      a.fontLoaded = !0, a._destroyed || (a.trigger("init"), a._redraw(), a._attachEvents());
    });
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initElement = function(t) {
    for (this._setElementClass(t), t.style.position = "relative"; t.firstChild; )
      t.removeChild(t.firstChild);
    this.element = t;
  }, r.prototype._setElementClass = function(t) {
    mt(t, "k-chart");
  }, r.prototype._initTheme = function(t, e) {
    for (var i = [], a = t.series || [], s = 0; s < a.length; s++)
      i.push(Object.assign({}, a[s]));
    t.series = i, Pm(t), this.applyDefaults(t, e), t.seriesColors === null && delete t.seriesColors, this.options = b({}, e, t), this.applySeriesColors();
  }, r.prototype.getSize = function() {
    var t = this.options.chartArea || {}, e = t.width ? parseInt(t.width, 10) : Math.floor(this.element.offsetWidth), i = t.height ? parseInt(t.height, 10) : Math.floor(this.element.offsetHeight);
    return {
      width: e,
      height: i
    };
  }, r.prototype.resize = function(t) {
    var e = this.getSize(), i = this._size, a = e.width > 0 || e.height > 0;
    t || a && (!i || e.width !== i.width || e.height !== i.height) ? (this._size = e, this._resize(e, t), this.trigger("resize", e)) : a && this._selections && au(this._selections, function(s) {
      return !s.visible;
    }) && (this._destroySelections(), this._setupSelection());
  }, r.prototype._resize = function() {
    this._noTransitionsRedraw();
  }, r.prototype.redraw = function(t) {
    if (this.applyDefaults(this.options), this.applySeriesColors(), t) {
      var e = this._model._plotArea, i = e.findPane(t);
      e.redraw(i);
    } else
      this._redraw();
  }, r.prototype.getAxis = function(t) {
    return Eu(t, this._plotArea.axes);
  }, r.prototype.findAxisByName = function(t) {
    return this.getAxis(t);
  }, r.prototype.findPaneByName = function(t) {
    for (var e = this._plotArea.panes, i = 0; i < e.length; i++)
      if (e[i].options.name === t)
        return new Tn(e[i]);
  }, r.prototype.findPaneByIndex = function(t) {
    var e = this._plotArea.panes;
    if (e[t])
      return new Tn(e[t]);
  }, r.prototype.plotArea = function() {
    return new ry(this._plotArea);
  }, r.prototype.toggleHighlight = function(t, e) {
    var i = this._plotArea, a = (i.srcSeries || i.series || [])[0], s;
    if (vt(e))
      s = i.filterPoints(e);
    else {
      var l, p;
      le(e) ? (l = e.series, p = e.category) : l = p = e, a.type === On ? s = uh(i.pointsBySeriesName(l), p) : Z(a.type, [Sr, io, oo]) ? s = uh((i.charts[0] || {}).points, p) : s = i.pointsBySeriesName(l);
    }
    s && this.togglePointsHighlight(t, s);
  }, r.prototype.togglePointsHighlight = function(t, e) {
    for (var i = this._highlight, a = 0; a < e.length; a++)
      i.togglePointHighlight(e[a], t);
  }, r.prototype.showTooltip = function(t) {
    var e = this._sharedTooltip(), i = this, a = i._tooltip, s = i._plotArea, l, p;
    if (vt(t) ? (l = s.findPoint(t), l && e && (p = l.categoryIx)) : e && P(t) && (p = s.categoryAxis.categoryIndex(t)), e) {
      if (p >= 0) {
        var h = this._plotArea.pointsByCategoryIndex(p);
        a.showAt(h);
      }
    } else
      l && a.show(l);
  }, r.prototype.hideTooltip = function() {
    this._tooltip.hide();
  }, r.prototype._initSurface = function() {
    var t = this.surface, e = this._surfaceWrap(), i = this.options.chartArea || {};
    i.width && Ye(e, { width: i.width }), i.height && Ye(e, { height: i.height }), !t || t.options.type !== this.options.renderAs ? (this._destroySurface(), this.surface = co.create(e, {
      type: this.options.renderAs
    }), this.surface.bind("mouseenter", this._surfaceMouseenterHandler), this.surface.bind("mouseleave", this._surfaceMouseleaveHandler)) : (this.surface.clear(), this.surface.resize());
  }, r.prototype._surfaceWrap = function() {
    return this.element;
  }, r.prototype._redraw = function() {
    var t = this._getModel();
    this._size = {
      width: t.options.width,
      height: t.options.height
    }, this._destroyView(), this._model = t, this._plotArea = t._plotArea, t.renderVisual(), this.options.transitions !== !1 && t.traverse(function(e) {
      e.animation && e.animation.setup();
    }), this._initSurface(), this.surface.draw(t.visual), this.options.transitions !== !1 && t.traverse(function(e) {
      e.animation && e.animation.play();
    }), this._tooltip = this._createTooltip(), this._highlight = new Wy(), this._setupSelection(), this._createPannable(), this._createZoomSelection(), this._createMousewheelZoom(), this.trigger(gy), fh(this._plotArea.panes), this._navState || this._cancelDomEvents();
  }, r.prototype.exportVisual = function(t) {
    var e;
    if (t && (t.width || t.height || t.options)) {
      var i = this.options, a = b({}, t.options, {
        chartArea: {
          width: t.width,
          height: t.height
        }
      });
      hs(this._originalOptions, a), this.options = b({}, this._originalOptions, a), this._initTheme(this.options, this._theme), this.bindCategories();
      var s = this._getModel();
      s.renderVisual(), fh(s._plotArea.panes), e = s.visual, this.options = i;
    } else
      e = this.surface.exportVisual();
    return e;
  }, r.prototype._sharedTooltip = function() {
    return this._plotArea instanceof Ke && this.options.tooltip && this.options.tooltip.shared;
  }, r.prototype._createPannable = function() {
    var t = this.options;
    t.pannable !== !1 && (this._pannable = new pv(this._plotArea, t.pannable));
  }, r.prototype._createZoomSelection = function() {
    var t = this.options.zoomable, e = (t || {}).selection;
    t !== !1 && e !== !1 && (this._zoomSelection = new hv(this, e));
  }, r.prototype._createMousewheelZoom = function() {
    var t = this.options.zoomable, e = (t || {}).mousewheel;
    t !== !1 && e !== !1 && (this._mousewheelZoom = new Qy(this, e));
  }, r.prototype._toggleDragZoomEvents = function() {
    var t = this.options.pannable, e = this.options.zoomable, i = (e || {}).selection, a = (e || {}).mousewheel, s = !t && (e === !1 || i === !1) && !this.requiresHandlers([Da, Xi, Yi]), l = (e === !1 || a === !1) && !this.requiresHandlers([Ni, Zr, Qr]), p = this.element;
    this._dragZoomEnabled && s && l ? (p.style.touchAction = this._touchAction || "", this._dragZoomEnabled = !1) : !this._dragZoomEnabled && !(s && l) && (p.style.touchAction = "none", this._dragZoomEnabled = !0), this._toggleDomEvents(!s, !l);
  }, r.prototype._toggleDomEvents = function(t, e) {
    var i = this.domEvents;
    i && (i.toggleDrag && i.toggleDrag(t), i.toggleZoom && i.toggleZoom(e));
  }, r.prototype._createTooltip = function() {
    var t = this, e = t.options.tooltip, i;
    return this._sharedTooltip() ? i = this._createSharedTooltip(e) : i = new im(this.chartService, e), i;
  }, r.prototype._createSharedTooltip = function(t) {
    return new Pl(this._plotArea, t);
  }, r.prototype.applyDefaults = function(t, e) {
    Om(t, e), Em(t, e);
  }, r.prototype.applySeriesColors = function() {
    for (var t = this.options, e = t.series, i = t.seriesColors || [], a = 0; a < e.length; a++) {
      var s = e[a], l = i[a % i.length], p = s._defaults;
      s.color = s.color || l, p && (p.color = p.color || l);
    }
  }, r.prototype._getModel = function() {
    var t = this.options, e = this._createPlotArea(), i = new cu(this._modelOptions());
    i.chart = this, i._plotArea = e;
    var a = Ki.buildTitle(t.title), s = Ki.buildTitle(t.subtitle, {
      align: t.title.align,
      position: t.title.position
    });
    return i.append.apply(i, Ki.orderTitles([a, s])), t.legend && t.legend.visible && i.append(new cv(e.options.legend, this.chartService)), i.append(e), i.reflow(), i;
  }, r.prototype._modelOptions = function() {
    var t = this.options, e = this.getSize();
    return b({
      transitions: t.transitions,
      width: e.width || Gs,
      height: e.height || qc
    }, t.chartArea);
  }, r.prototype._createPlotArea = function(t) {
    var e = this.options, i = me.current.create(t ? [] : e.series, e, this.chartService);
    return i;
  }, r.prototype._setupSelection = function() {
    for (var t = this, e = this, i = e._plotArea.axes, a = this._selections = [], s = 0; s < i.length; s++) {
      var l = i[s], p = l.options;
      if (l instanceof Me && p.select && !p.vertical) {
        var h = l.range(), c = new kl(
          t,
          l,
          b({ min: h.min, max: h.max }, p.select)
        );
        a.push(c);
      }
    }
  }, r.prototype._selectStart = function(t) {
    return this.trigger(is, t);
  }, r.prototype._select = function(t) {
    return this.trigger(qi, t);
  }, r.prototype._selectEnd = function(t) {
    return this.trigger(os, t);
  }, r.prototype._initHandlers = function() {
    this._clickHandler = this._click.bind(this), this._mousewheelHandler = this._mousewheel.bind(this), this._mouseleaveHandler = this._mouseleave.bind(this), this._surfaceMouseenterHandler = this._mouseover.bind(this), this._surfaceMouseleaveHandler = this._mouseout.bind(this), this._mousemove = $s(
      this._mousemove.bind(this),
      km
    );
  }, r.prototype.addObserver = function(t) {
    t && this.observers.push(t);
  }, r.prototype.removeObserver = function(t) {
    var e = this.observers.indexOf(t);
    e >= 0 && this.observers.splice(e, 1);
  }, r.prototype.requiresHandlers = function(t) {
    for (var e = this.observers, i = 0; i < e.length; i++)
      if (e[i].requiresHandlers(t))
        return !0;
  }, r.prototype.trigger = function(t, e) {
    e === void 0 && (e = {}), e.sender = this, t === Nu ? e.anchor.point = this._toDocumentCoordinates(e.anchor.point) : t === zu ? this._updateDrilldownPoint(e.point) : t === ju ? this._resetDrilldownPoint() : t === Du && this._startDrilldown(e.point);
    for (var i = this.observers, a = !1, s = 0; s < i.length; s++)
      i[s].trigger(t, e) && (a = !0);
    return a;
  }, r.prototype._attachEvents = function() {
    var t, e, i = this.element;
    this._touchAction = i.style.touchAction, Gi(i, (t = {}, t[hh] = this._clickHandler, t[Rn] = this._mousewheelHandler, t[ch] = this._mouseleaveHandler, t)), this._shouldAttachMouseMove() && Gi(i, (e = {}, e[Mr] = this._mousemove, e)), this.domEvents = yo.create(this.element, {
      start: this._start.bind(this),
      move: this._move.bind(this),
      end: this._end.bind(this),
      tap: this._tap.bind(this),
      gesturestart: this._gesturestart.bind(this),
      gesturechange: this._gesturechange.bind(this),
      gestureend: this._gestureend.bind(this)
    }), this._toggleDragZoomEvents();
  }, r.prototype._mouseleave = function(t) {
    this._hoveredPoint && (this._hoveredPoint.out(this, t), this._hoveredPoint = null), this._plotAreaHovered && (this._plotAreaHovered = !1, this.trigger(Ia)), this._hasInactiveOpacity() && this._activeChartInstance && (this._applySeriesOpacity(this._activeChartInstance.children, null, !0), this._updateSeriesOpacity(null, !0));
  }, r.prototype._cancelDomEvents = function() {
    this.domEvents && this.domEvents.cancel && this.domEvents.cancel();
  }, r.prototype._gesturestart = function(t) {
    this._mousewheelZoom && !this._stopChartHandlers(t) && (this._gestureDistance = t.distance, this._unsetActivePoint(), this.surface.suspendTracking());
  }, r.prototype._gestureend = function(t) {
    this._zooming && !this._stopChartHandlers(t) && (this.surface && this.surface.resumeTracking(), this._zooming = !1, this.trigger(Qr, {}));
  }, r.prototype._gesturechange = function(t) {
    var e = this._mousewheelZoom;
    if (e && !this._stopChartHandlers(t)) {
      t.preventDefault();
      var i = this._gestureDistance, a = -t.distance / i + 1;
      if (Math.abs(a) >= 0.1) {
        a = Math.round(a * 10), this._gestureDistance = t.distance;
        var s = { delta: a, axisRanges: Hi(this._plotArea.axes), originalEvent: t };
        if (this._zooming || !this.trigger(Ni, s)) {
          var l = this._eventCoordinates(t);
          this._zooming || (this._zooming = !0);
          var p = s.axisRanges = e.updateRanges(a, l);
          p && !this.trigger(Zr, s) && e.zoom();
        }
      }
    }
  }, r.prototype._mouseout = function(t) {
    if (t.element) {
      var e = this._drawingChartElement(t.element, t);
      e && e.leave && e.leave(this, t.originalEvent);
    }
  }, r.prototype._start = function(t) {
    var e = this._eventCoordinates(t);
    this._stopChartHandlers(t) || !this._plotArea.backgroundContainsPoint(e) || (this.requiresHandlers([Da, Xi, Yi]) && this._startNavigation(t, e, Da), this._pannable && this._pannable.start(t) && (this.surface.suspendTracking(), this._unsetActivePoint(), this._suppressHover = !0, this.chartService.panning = !0), this._zoomSelection && this._zoomSelection.start(t) && this.trigger(Ni, { axisRanges: Hi(this._plotArea.axes), originalEvent: t }));
  }, r.prototype._move = function(t) {
    var e = this, i = e._navState, a = e._pannable;
    if (!this._stopChartHandlers(t)) {
      if (a) {
        var s = a.move(t);
        s && !this.trigger(Xi, { axisRanges: s, originalEvent: t }) && a.pan();
      } else if (i) {
        for (var l = {}, p = i.axes, h = 0; h < p.length; h++) {
          var c = p[h], u = c.options.name;
          if (u) {
            var v = c.options.vertical ? t.y : t.x, f = v.startLocation - v.location;
            f !== 0 && (l[c.options.name] = c.translateRange(f));
          }
        }
        i.axisRanges = l, this.trigger(Xi, {
          axisRanges: l,
          originalEvent: t
        });
      }
      this._zoomSelection && this._zoomSelection.move(t);
    }
  }, r.prototype._end = function(t) {
    if (!this._stopChartHandlers(t)) {
      var e = this._pannable;
      if (e && e.end(t) ? (this.surface.resumeTracking(), this.trigger(Yi, {
        axisRanges: Hi(this._plotArea.axes),
        originalEvent: t
      }), this._suppressHover = !1, this.chartService.panning = !1) : this._endNavigation(t, Yi), this._zoomSelection) {
        var i = this._zoomSelection.end(t);
        i && !this.trigger(Zr, { axisRanges: i, originalEvent: t }) && (this._zoomSelection.zoom(), this.trigger(Qr, { axisRanges: i, originalEvent: t }));
      }
    }
  }, r.prototype._stopChartHandlers = function(t) {
    var e = this._selections || [];
    if (!e.length)
      return !1;
    var i = this._eventCoordinates(t), a = this._plotArea.paneByPoint(i);
    if (a) {
      for (var s = 0; s < e.length; s++)
        if (e[s].onPane(a))
          return !0;
    }
  }, r.prototype._mousewheelZoomRate = function() {
    var t = this.options.zoomable, e = (t || {}).mousewheel || {};
    return U(e.rate, _y);
  }, r.prototype._mousewheel = function(t) {
    var e = this, i = Ys(t), a = this._mousewheelZoom, s = this._eventCoordinates(t);
    if (!(this._stopChartHandlers(t) || !this._plotArea.backgroundContainsPoint(s)))
      if (a) {
        var l = { delta: i, axisRanges: Hi(this._plotArea.axes), originalEvent: t };
        (this._zooming || !this.trigger(Ni, l)) && (t.preventDefault(), this._zooming || (this._unsetActivePoint(), this.surface.suspendTracking(), this._zooming = !0), this._mwTimeout && clearTimeout(this._mwTimeout), l.axisRanges = a.updateRanges(i, s), l.axisRanges && !this.trigger(Zr, l) && a.zoom(), this._mwTimeout = setTimeout(function() {
          e.trigger(Qr, l), e._zooming = !1, e.surface && e.surface.resumeTracking();
        }, ns));
      } else {
        var p = this._navState;
        if (!p) {
          var h = this._startNavigation(t, s, Ni);
          h || (p = this._navState);
        }
        if (p) {
          var c = p.totalDelta || i;
          p.totalDelta = c + i;
          for (var u = this._navState.axes, v = {}, f = 0; f < u.length; f++) {
            var d = u[f], m = d.options.name;
            m && (v[m] = d.scaleRange(-c * e._mousewheelZoomRate(), s));
          }
          this.trigger(Zr, {
            delta: i,
            axisRanges: v,
            originalEvent: t
          }), this._mwTimeout && clearTimeout(this._mwTimeout), this._mwTimeout = setTimeout(function() {
            e._endNavigation(t, Qr);
          }, ns);
        }
      }
  }, r.prototype._startNavigation = function(t, e, i) {
    var a = this._model._plotArea, s = a.findPointPane(e), l = a.axes.slice(0);
    if (s) {
      var p = Hi(l), h = this.trigger(i, {
        axisRanges: p,
        originalEvent: t
      });
      h ? this._cancelDomEvents() : (this._suppressHover = !0, this._unsetActivePoint(), this._navState = {
        axisRanges: p,
        pane: s,
        axes: l
      });
    }
  }, r.prototype._endNavigation = function(t, e) {
    this._navState && (this.trigger(e, {
      axisRanges: this._navState.axisRanges,
      originalEvent: t
    }), this._suppressHover = !1, this._navState = null);
  }, r.prototype._getChartElement = function(t, e) {
    var i = this.surface.eventTarget(t);
    if (i)
      return this._drawingChartElement(i, t, e);
  }, r.prototype._drawingChartElement = function(t, e, i) {
    for (var a = t, s; a && !s; )
      s = a.chartElement, a = a.parent;
    if (s)
      return s.aliasFor && (s = s.aliasFor(e, this._eventCoordinates(e))), i && (s = s.closest(i), s && s.aliasFor && (s = s.aliasFor())), s;
  }, r.prototype._eventCoordinates = function(t) {
    var e = iu(t);
    return this._toModelCoordinates(e.x, e.y);
  }, r.prototype._elementPadding = function() {
    if (!this._padding) {
      var t = ut(this.element, ["paddingLeft", "paddingTop"]), e = t.paddingLeft, i = t.paddingTop;
      this._padding = {
        top: i,
        left: e
      };
    }
    return this._padding;
  }, r.prototype._toDocumentCoordinates = function(t) {
    var e = this._elementPadding(), i = ii(this.element);
    return {
      left: R(t.x + e.left + i.left),
      top: R(t.y + e.top + i.top)
    };
  }, r.prototype._toModelCoordinates = function(t, e) {
    var i = this.element, a = ii(i), s = this._elementPadding(), l = bg(i).invert(), p = new q(
      t - a.left - s.left,
      e - a.top - s.top
    ).transform(l);
    return new F(p.x, p.y);
  }, r.prototype._tap = function(t) {
    var e = this, i = this.surface.eventTarget(t), a = this._drawingChartElement(i, t), s = this._sharedTooltip();
    !this._startHover(i, t) && !s && this._unsetActivePoint(), s && this._trackSharedTooltip(this._eventCoordinates(t), t, !0), this._propagateClick(a, t), this.handlingTap = !0, setTimeout(function() {
      e.handlingTap = !1;
    }, 0);
  }, r.prototype._click = function(t) {
    var e = this._getChartElement(t);
    this._propagateClick(e, t);
  }, r.prototype._propagateClick = function(t, e) {
    for (var i = this, a = t; a; )
      a.click && a.click(i, e), a = a.parent;
  }, r.prototype._startHover = function(t, e) {
    if (this._suppressHover)
      return !1;
    var i = this._drawingChartElement(t, e, function(a) {
      return (a.hover || a.over) && !(a instanceof pr);
    });
    return this._showInactiveOpacity(i, e), i;
  }, r.prototype._displayTooltip = function(t) {
    var e = b({}, this.options.tooltip, t.options.tooltip);
    e.visible && this._tooltip.show(t);
  }, r.prototype._displayInactiveOpacity = function(t, e, i) {
    var a = this._activeChartInstance = this._chartInstanceFromPoint(t);
    if (a)
      if (e)
        this._updateSeriesOpacity(t), this._applySeriesOpacity(a.children, null, !0), this._applySeriesOpacity(a.children, t.series), this._highlight.show(i || t);
      else {
        var s;
        if (!a.supportsPointInactiveOpacity()) {
          this._highlight.show(t);
          return;
        }
        s = this._getInactivePoints(t, a), s && s.length && this._highlight.show(s, 1 - this._getInactiveOpacityForSeries(t.series));
      }
  }, r.prototype._getInactivePoints = function(t, e) {
    var i = this._getAllPointsOfType(e, t.constructor);
    return i.filter(function(a) {
      return a !== t;
    });
  }, r.prototype._getAllPointsOfType = function(t, e) {
    for (var i = this, a = [], s = 0; s < t.children.length; s++) {
      var l = t.children[s];
      l.constructor === e ? a.push(l) : l.children && l.children.length && (a = a.concat(i._getAllPointsOfType(l, e)));
    }
    return a;
  }, r.prototype._updateHoveredPoint = function(t, e) {
    var i = this._hoveredPoint;
    i && i !== t && (i.out(this, e), this._hoveredPoint = null), t && i !== t && t.over && (this._hoveredPoint = t, t.over(this, e));
  }, r.prototype._updateDrilldownPoint = function(t) {
    if (!(!t || !t.series)) {
      var e = ht.current.bindPoint(t.series, null, t.dataItem), i = e.fields;
      i.drilldown && (this._drilldownState = { cursor: this.element.style.cursor }, this.element.style.cursor = "pointer");
    }
  }, r.prototype._resetDrilldownPoint = function() {
    this._drilldownState && (this.element.style.cursor = this._drilldownState.cursor, this._drilldownState = null);
  }, r.prototype._startDrilldown = function(t) {
    if (!(!t || !t.series)) {
      var e = t.series, i = ht.current.bindPoint(e, null, t.dataItem), a = i.fields, s = a.drilldown;
      if (s) {
        var l = { series: e, point: t, value: s, sender: this };
        this.trigger(xy, l);
      }
    }
  }, r.prototype._updateSeriesOpacity = function(t, e) {
    for (var i = this, a = this._plotArea, s = a.series.length, l = 0; l < s; l++) {
      var p = a.series[l], h = i._getDefaultOpacityForSeries(p), c = i._getInactiveOpacityForSeries(p);
      !e && p !== t.series ? (p.defaultOpacity = h, p.opacity = c, p.line && (p.line.opacity = c)) : (p.opacity = h, p.line && (p.line.opacity = h));
    }
  }, r.prototype._applySeriesOpacity = function(t, e, i, a) {
    for (var s = this, l = 0; l < t.length; l++) {
      var p = t[l], h = p.series || a, c = h && (h.highlight || {}).visible;
      if (c && p.visual) {
        var u = a ? a.opacity : p.series.opacity;
        (h !== e || i) && p.visual.opacity(i ? 1 : u);
      }
      p.children && p.children.length && s._applySeriesOpacity(p.children, e, i, p.series);
    }
  }, r.prototype._chartInstanceFromPoint = function(t) {
    for (var e = t.parent; e && !e.plotArea; )
      e = e.parent;
    return e;
  }, r.prototype._showInactiveOpacity = function(t, e) {
    var i = this._activePoint, a = this._plotArea.series.length > 1, s = this._hasInactiveOpacity();
    return this._updateHoveredPoint(t, e), t && i !== t && t.hover && (this._activePoint = t, !this._sharedTooltip() && !t.hover(this, e) && (this._displayTooltip(t), s ? this._displayInactiveOpacity(t, a) : this._highlight.show(t))), t;
  }, r.prototype._hideInactiveOpacity = function(t) {
    var e = this._plotArea.series.length > 1, i = this._hasInactiveOpacity();
    i && (e && this._activeChartInstance && (this._updateSeriesOpacity(t, !0), this._applySeriesOpacity(this._activeChartInstance.children, null, !0), this._activeChartInstance = null), this._highlight && this._highlight.hide(), this._activePoint = null);
  }, r.prototype._hasInactiveOpacity = function() {
    var t = this.options.seriesDefaults.highlight.inactiveOpacity !== void 0, e = this.options.series.filter(function(i) {
      return i.highlight.inactiveOpacity !== void 0;
    }).length > 0;
    return t || e;
  }, r.prototype._getInactiveOpacityForSeries = function(t) {
    var e = this.options.seriesDefaults.highlight.inactiveOpacity, i = t.highlight.inactiveOpacity;
    return i || e || t.opacity || Ip;
  }, r.prototype._getDefaultOpacityForSeries = function(t) {
    return t.defaultOpacity || t.opacity || Ip;
  }, r.prototype._mouseover = function(t) {
    var e, i = this._startHover(t.element, t.originalEvent);
    i && i.tooltipTracking && !this._mouseMoveTrackHandler && !this._sharedTooltip() && (this._mouseMoveTrackHandler = this._mouseMoveTracking.bind(this), Gi(document, (e = {}, e[Mr] = this._mouseMoveTrackHandler, e)));
  }, r.prototype._mouseMoveTracking = function(t) {
    var e, i = this, a = i.options, s = i._tooltip, l = i._highlight, p = i._activePoint, h = this._eventCoordinates(t);
    if (this._plotArea.box.containsPoint(h)) {
      if (p && p.tooltipTracking && p.series && p.parent.getNearestPoint) {
        var c = p.parent.getNearestPoint(h.x, h.y, p.seriesIx);
        if (c && c !== p && (this._activePoint = c, !c.hover(this, t))) {
          var u = b({}, a.tooltip, c.options.tooltip);
          u.visible && s.show(c), l.show(c);
        }
      }
    } else
      Wi(document, (e = {}, e[Mr] = this._mouseMoveTrackHandler, e)), this._unsetActivePoint(), this._mouseMoveTrackHandler = null, this._hideInactiveOpacity(p);
  }, r.prototype._mousemove = function(t) {
    var e = this._eventCoordinates(t), i = this._plotArea;
    if (this._trackCrosshairs(e), i.hover) {
      var a = i.backgroundContainsPoint(e);
      a ? (this._plotAreaHovered = !0, this._plotArea.hover(this, t)) : this._plotAreaHovered && !a && (this._plotAreaHovered = !1, this.trigger(Ia));
    }
    this._sharedTooltip() && this._trackSharedTooltip(e, t);
  }, r.prototype._trackCrosshairs = function(t) {
    for (var e = this._plotArea.crosshairs, i = 0; i < e.length; i++) {
      var a = e[i];
      a.box.containsPoint(t) ? a.showAt(t) : a.hide();
    }
  }, r.prototype._trackSharedTooltip = function(t, e, i) {
    if (!this._suppressHover) {
      var a = this, s = a.options.tooltip, l = a._plotArea, p = a._plotArea.categoryAxis, h = a._tooltip, c = a._highlight;
      if (l.backgroundContainsPoint(t)) {
        var u = p.pointCategoryIndex(t);
        if (u !== this._tooltipCategoryIx || !this._sharedHighlight && i) {
          var v = l.pointsByCategoryIndex(u), f = v.map(function(m) {
            return m.eventArgs(e);
          }), d = f[0] || {};
          d.categoryPoints = f, v.length > 0 && !this.trigger(Bu, d) ? (s.visible && h.showAt(v, t), c.show(v), this._sharedHighlight = !0) : h.hide(), this._tooltipCategoryIx = u;
        } else
          i && this._sharedHighlight && (c.hide(), h.hide(), this._sharedHighlight = !1);
      } else
        this._sharedHighlight && (c.hide(), h.hide(), this._tooltipCategoryIx = null, this._sharedHighlight = !1);
    }
  }, r.prototype.hideElements = function(t) {
    var e = this._plotArea;
    this._mousemove.cancel(), e.hideCrosshairs(), this._unsetActivePoint(t);
  }, r.prototype._unsetActivePoint = function(t) {
    var e = this, i = e._tooltip, a = e._highlight;
    this._activePoint = null, this._hoveredPoint = null, i && !(t && t.keepTooltipOpen) && i.hide(), this._tooltipCategoryIx = null, this._sharedHighlight = !1, a && a.hide();
  }, r.prototype._deferRedraw = function() {
    this._redraw();
  }, r.prototype._clearRedrawTimeout = function() {
    this._redrawTimeout && (clearInterval(this._redrawTimeout), this._redrawTimeout = null);
  }, r.prototype.bindCategories = function() {
    for (var t = this, e = this.options, i = [].concat(e.categoryAxis), a = 0; a < i.length; a++) {
      var s = i[a];
      s.autoBind !== !1 && t.bindCategoryAxisFromSeries(s, a);
    }
  }, r.prototype.bindCategoryAxisFromSeries = function(t, e) {
    for (var i = this, a = this.options.series, s = a.length, l = new vo(), p = [], h = !1, c, u = 0; u < s; u++) {
      var v = a[u], f = v.categoryAxis === t.name || !v.categoryAxis && e === 0, d = v.data, m = d.length, _ = v.categoryField && f;
      if (h = _ || h, _ && m > 0) {
        c = rv(t, Cn(v.categoryField, d[0]));
        for (var w = c ? ev : Cn, A = 0; A < m; A++) {
          var T = d[A], k = w(v.categoryField, T, i.chartService.intl);
          (c || !l.get(k)) && (p.push([k, T]), c || l.set(k, !0));
        }
      }
    }
    if (p.length > 0) {
      c && (p = Rm(p, function(z, V) {
        return Br(z[0], V[0]);
      }));
      var C = Lm(p);
      t.categories = C[0];
    } else
      h && (t.categories = []);
  }, r.prototype._isBindable = function(t) {
    for (var e = ht.current.valueFields(t), i = !0, a = 0; a < e.length; a++) {
      var s = e[a];
      if (s === Xt ? s = "field" : s = s + "Field", !P(t[s])) {
        i = !1;
        break;
      }
    }
    return i;
  }, r.prototype._noTransitionsRedraw = function() {
    var t = this.options, e;
    t.transitions !== !1 && (t.transitions = !1, e = !0), this._redraw(), e && (t.transitions = !0);
  }, r.prototype._legendItemHover = function(t, e) {
    var i = this, a = i._plotArea, s = i._highlight, l = (a.srcSeries || a.series)[t], p;
    if (Z(l.type, [Sr, On, io, oo]) ? p = a.findPoint(function(u) {
      return u.series.index === t && u.index === e;
    }) : p = a.pointsBySeriesIndex(t), this._hasInactiveOpacity() && l.visible && p) {
      var h = a.series.length > 1, c = p.length ? p[0] : p;
      this._displayInactiveOpacity(c, h, p);
    } else
      s.show(p);
  }, r.prototype._shouldAttachMouseMove = function() {
    return this._plotArea.crosshairs.length || this._tooltip && this._sharedTooltip() || this.requiresHandlers([Vu, Ia]);
  }, r.prototype.updateMouseMoveHandler = function() {
    var t, e;
    Wi(this.element, (t = {}, t[Mr] = this._mousemove, t)), this._shouldAttachMouseMove() && Gi(this.element, (e = {}, e[Mr] = this._mousemove, e));
  }, r.prototype.applyOptions = function(t, e) {
    hs(this._originalOptions, t), this._originalOptions = b(this._originalOptions, t), this.options = b({}, this._originalOptions), e && (this._theme = e, this.chartService.theme = e), this._initTheme(this.options, this._theme), this._toggleDragZoomEvents();
  }, r.prototype.setOptions = function(t, e) {
    this.applyOptions(t, e), this.bindCategories(), this.redraw(), this.updateMouseMoveHandler();
  }, r.prototype.setDirection = function(t) {
    this.chartService.rtl = !!t, this.surface && this.surface.type === "svg" && this._destroySurface();
  }, r.prototype.setIntlService = function(t) {
    this.chartService.intl = t;
  }, r.prototype.noTransitionsRedraw = function() {
    this._noTransitionsRedraw();
  }, r.prototype.destroy = function() {
    var t, e;
    this._destroyed = !0, Wi(this.element, (t = {}, t[hh] = this._clickHandler, t[Rn] = this._mousewheelHandler, t[Mr] = this._mousemove, t[ch] = this._mouseleaveHandler, t)), this.domEvents && (this.domEvents.destroy(), delete this.domEvents), this._mouseMoveTrackHandler && Wi(document, (e = {}, e[Mr] = this._mouseMoveTrackHandler, e)), this._destroyView(), this._destroySurface(), this._clearRedrawTimeout();
  }, r.prototype._destroySurface = function() {
    var t = this.surface;
    t && (t.unbind("mouseenter", this._surfaceMouseenterHandler), t.unbind("mouseleave", this._surfaceMouseleaveHandler), t.destroy(), this.surface = null);
  }, r.prototype._destroySelections = function() {
    var t = this._selections;
    if (t)
      for (; t.length > 0; )
        t.shift().destroy();
  }, r.prototype._destroyView = function() {
    var t = this._model;
    t && (t.destroy(), this._model = null), this._unsetActivePoint(), this._resetDrilldownPoint(), this._destroySelections(), this._tooltip && this._tooltip.destroy(), this._highlight && this._highlight.destroy(), this._zoomSelection && (this._zoomSelection.destroy(), delete this._zoomSelection), this._pannable && (this._pannable.destroy(), delete this._pannable), this._mousewheelZoom && (this._mousewheelZoom.destroy(), delete this._mousewheelZoom);
  }, r;
}(N);
function Pm(n) {
  for (var r = ps, o = 0; o < r.length; o++) {
    var t = r[o] + "Axes";
    n[t] && (n[r[o] + "Axis"] = n[t], delete n[t]);
  }
}
function uh(n, r) {
  if (n) {
    for (var o = 0; o < n.length; o++)
      if (n[o].category === r)
        return [n[o]];
  }
}
function Om(n, r) {
  var o = (r || {}).axisDefaults || {}, t, e, i;
  function a(l) {
    var p = (l || {}).color || e.color, h = b(
      {},
      o,
      o[t],
      e,
      e[t],
      {
        line: { color: p },
        labels: { color: p },
        title: { color: p }
      },
      l
    );
    return delete h[t], h;
  }
  for (var s = 0; s < ps.length; s++)
    t = ps[s] + "Axis", e = n.axisDefaults || {}, i = [].concat(n[t]), i = i.map(a), n[t] = i.length > 1 ? i : i[0];
}
function Em(n, r) {
  var o = n.series, t = o.length, e = n.seriesDefaults, i = b({}, n.seriesDefaults), a = r ? b({}, r.seriesDefaults) : {}, s = b({}, a);
  vh(i), vh(s);
  for (var l = 0; l < t; l++) {
    var p = o[l].type || n.seriesDefaults.type, h = b(
      { data: [] },
      s,
      a[p],
      { tooltip: n.tooltip },
      i,
      e[p]
    );
    o[l]._defaults = h, o[l] = b({}, h, o[l]), o[l].data = o[l].data || [];
  }
}
function vh(n) {
  delete n.bar, delete n.column, delete n.rangeColumn, delete n.line, delete n.verticalLine, delete n.pie, delete n.donut, delete n.area, delete n.verticalArea, delete n.scatter, delete n.scatterLine, delete n.bubble, delete n.candlestick, delete n.ohlc, delete n.boxPlot, delete n.bullet, delete n.verticalBullet, delete n.polarArea, delete n.polarLine, delete n.radarArea, delete n.radarLine, delete n.waterfall;
}
function Hi(n) {
  for (var r = {}, o = 0; o < n.length; o++) {
    var t = n[o], e = t.options.name;
    e && (r[e] = t.range());
  }
  return r;
}
function Mm(n, r) {
  r === void 0 && (r = Br);
  for (var o = 1, t = n.length; o < t; o++)
    if (r(n[o], n[o - 1]) < 0) {
      n.sort(r);
      break;
    }
  return n;
}
function Rm(n, r) {
  r === void 0 && (r = Br);
  for (var o = Mm(n, r), t = o.length, e = t > 0 ? [o[0]] : [], i = 1; i < t; i++)
    r(o[i], dt(e)) !== 0 && e.push(o[i]);
  return e;
}
function Lm(n) {
  for (var r = n.length, o = [], t = 0; t < r; t++)
    for (var e = n[t], i = e.length, a = 0; a < i; a++)
      o[a] = o[a] || [], o[a].push(e[a]);
  return o;
}
var Im = ["data", "categories"];
function hs(n, r) {
  for (var o in r)
    if (!Z(o, Im) && r.hasOwnProperty(o)) {
      var t = r[o], e = n[o];
      if (P(e)) {
        var i = t === null;
        i || !P(t) ? (delete n[o], i && delete r[o]) : e && le(t) && le(e) && hs(e, t);
      }
    }
}
function fh(n) {
  for (var r = 0; r < n.length; r++)
    n[r].notifyRender();
}
O(sa, {
  renderAs: "",
  chartArea: {},
  legend: {
    visible: !0,
    labels: {}
  },
  categoryAxis: {},
  seriesDefaults: {
    type: or,
    data: [],
    highlight: {
      visible: !0
    },
    labels: {},
    negativeValues: {
      visible: !1
    }
  },
  series: [],
  seriesColors: null,
  tooltip: {
    visible: !1
  },
  transitions: !0,
  valueAxis: {},
  plotArea: {},
  title: {},
  xAxis: {},
  yAxis: {},
  panes: [{}],
  pannable: !1,
  zoomable: !1
});
var Dm = -2, Bm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._slotAnchor = function(t, e) {
    var i = this.plotArea.categoryAxis, a = i.options.vertical, s = a ? {
      horizontal: "left",
      vertical: "center"
    } : {
      horizontal: "center",
      vertical: "bottom"
    }, l;
    return a ? l = new F(this.plotArea.box.x2, e.center().y) : l = new F(e.center().x, Dm), {
      point: l,
      align: s
    };
  }, r.prototype._defaultAnchor = function(t, e) {
    return this._slotAnchor({}, e);
  }, r;
}(Pl), zm = 150, jm = 150, dh = [ye, Ar];
function gh(n) {
  for (var r = [], o = 0; o < n.length; o++) {
    var t = n[o];
    r[o] = t.style.display, t.style.display = "none";
  }
  return r;
}
function yh(n, r) {
  for (var o = 0; o < n.length; o++)
    n[o].style.display = r[o];
}
function mh(n) {
  return Y(n) ? [n] : n;
}
var Vm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._setElementClass = function(t) {
    mt(t, "k-sparkline");
  }, r.prototype._initElement = function(t) {
    n.prototype._initElement.call(this, t), this._initialWidth = Math.floor(Ye(t).width);
  }, r.prototype._resize = function() {
    var t = this.element, e = gh(t.childNodes);
    this._initialWidth = Math.floor(Ye(t).width), yh(t.childNodes, e), n.prototype._resize.call(this);
  }, r.prototype._modelOptions = function() {
    var t = this.options, e = this._surfaceWrap(), i = gh(e.childNodes), a = document.createElement("span");
    a.innerHTML = "&nbsp;", e.appendChild(a);
    var s = b({
      width: this._autoWidth,
      height: Ye(e).height,
      transitions: t.transitions
    }, t.chartArea, {
      inline: !0,
      align: !1
    });
    return Ye(e, {
      width: s.width,
      height: s.height
    }), e.removeChild(a), yh(e.childNodes, i), this.surface && this.surface.resize(), s;
  }, r.prototype._surfaceWrap = function() {
    if (!this.stage) {
      var t = this.stage = document.createElement("span");
      this.element.appendChild(t);
    }
    return this.stage;
  }, r.prototype._createPlotArea = function(t) {
    var e = n.prototype._createPlotArea.call(this, t);
    return this._autoWidth = this._initialWidth || this._calculateWidth(e), e;
  }, r.prototype._calculateWidth = function(t) {
    for (var e = this.options, i = ot(e.chartArea.margin), a = t.charts, s = this._surfaceWrap(), l = 0, p = 0; p < a.length; p++) {
      var h = a[p], c = (h.options.series || [])[0];
      if (c) {
        if (c.type === ye)
          return zm;
        if (c.type === Ar)
          return jm;
        if (c.type === Sr)
          return Ye(s).height;
        var u = h.categoryAxis;
        if (u) {
          var v = u.categoriesCount() * (!h.options.isStacked && Z(c.type, [or, ko]) ? h.seriesOptions.length : 1);
          l = Math.max(l, v);
        }
      }
    }
    var f = l * e.pointWidth;
    return f > 0 && (f += i.left + i.right), f;
  }, r.prototype._createSharedTooltip = function(t) {
    return new Bm(this._plotArea, t);
  }, r.normalizeOptions = function(t) {
    var e = mh(t);
    return Ot(e) ? e = { seriesDefaults: { data: e } } : e = b({}, e), e.series || (e.series = [{ data: mh(e.data) }]), b(e, {
      seriesDefaults: {
        type: e.type
      }
    }), (Z(e.series[0].type, dh) || Z(e.seriesDefaults.type, dh)) && (e = b({}, {
      categoryAxis: {
        crosshair: {
          visible: !1
        }
      }
    }, e)), e;
  }, r;
}(sa);
O(Vm, {
  chartArea: {
    margin: 2
  },
  axisDefaults: {
    visible: !1,
    majorGridLines: {
      visible: !1
    },
    valueAxis: {
      narrowRange: !0
    }
  },
  seriesDefaults: {
    type: "line",
    area: {
      line: {
        width: 0.5
      }
    },
    bar: {
      stack: !0
    },
    padding: 2,
    width: 0.5,
    overlay: {
      gradient: null
    },
    highlight: {
      visible: !1
    },
    border: {
      width: 0
    },
    markers: {
      size: 2,
      visible: !1
    }
  },
  tooltip: {
    visible: !0,
    shared: !0
  },
  categoryAxis: {
    crosshair: {
      visible: !0,
      tooltip: {
        visible: !1
      }
    }
  },
  legend: {
    visible: !1
  },
  transitions: !1,
  pointWidth: 5,
  panes: [{ clip: !1 }]
});
var Nm = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    this._initialOpacity = parseFloat(ut(this.element, "opacity").opacity);
  }, r.prototype.step = function(t) {
    ut(this.element, {
      opacity: String(ie(this._initialOpacity, 0, t))
    });
  }, r.prototype.abort = function() {
    n.prototype.abort.call(this), ut(this.element, {
      display: "none",
      opacity: String(this._initialOpacity)
    });
  }, r.prototype.cancel = function() {
    n.prototype.abort.call(this), ut(this.element, {
      opacity: String(this._initialOpacity)
    });
  }, r;
}(pe);
function Va(n, r) {
  var o = document.createElement("div");
  return o.className = n, r && (o.style.cssText = r), o;
}
var bv = function(n) {
  function r(o, t, e) {
    n.call(this), this.options = b({}, this.options, e), this.container = o, this.chartService = t;
    var i = ut(o, ["paddingLeft", "paddingTop"]);
    this.chartPadding = {
      top: i.paddingTop,
      left: i.paddingLeft
    }, this.createElements(), o.appendChild(this.element);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.createElements = function() {
    var t = this.element = Va("k-navigator-hint", "display: none; position: absolute; top: 1px; left: 1px;"), e = this.tooltip = Va("k-tooltip k-chart-tooltip"), i = this.scroll = Va("k-scroll");
    e.innerHTML = "&nbsp;", t.appendChild(e), t.appendChild(i);
  }, r.prototype.show = function(t, e, i) {
    var a = this, s = a.element, l = a.options, p = a.scroll, h = a.tooltip, c = at(st(t) + st(e - t) / 2), u = i.width() * 0.4, v = i.center().x - u, f = i.center().x, d = f - v, m = l.max - l.min, _ = d / m, w = c - l.min, A = this.chartService.intl.format(l.format, t, e), T = Ct(l);
    this.clearHideTimeout(), this._visible || (ut(s, {
      visibility: "hidden",
      display: "block"
    }), this._visible = !0), T && (A = T({
      from: t,
      to: e
    })), h.innerHTML = A, ut(h, {
      left: i.center().x - h.offsetWidth / 2,
      top: i.y1
    });
    var k = ut(h, ["marginTop", "borderTopWidth", "height"]);
    ut(p, {
      width: u,
      left: v + w * _,
      top: i.y1 + k.marginTop + k.borderTopWidth + k.height / 2
    }), ut(s, {
      visibility: "visible"
    });
  }, r.prototype.clearHideTimeout = function() {
    this._hideTimeout && clearTimeout(this._hideTimeout), this._hideAnimation && this._hideAnimation.cancel();
  }, r.prototype.hide = function() {
    var t = this;
    this.clearHideTimeout(), this._hideTimeout = setTimeout(function() {
      t._visible = !1, t._hideAnimation = new Nm(t.element), t._hideAnimation.setup(), t._hideAnimation.play();
    }, this.options.hideDelay);
  }, r.prototype.destroy = function() {
    this.clearHideTimeout(), this.container && this.container.removeChild(this.element), delete this.container, delete this.chartService, delete this.element, delete this.tooltip, delete this.scroll;
  }, r;
}(N);
O(bv, {
  format: "{0:d} - {1:d}",
  hideDelay: 500
});
var Ze = "_navigator", Ge = Ze, _h = "_default", Hm = 3, xh = function(n) {
  function r(o) {
    var t;
    n.call(this), this.chart = o;
    var e = this.options = b({}, this.options, o.options.navigator), i = e.select;
    i && (i.from = this.parseDate(i.from), i.to = this.parseDate(i.to)), P(e.hint.visible) || (e.hint.visible = e.visible), this.chartObserver = new de(this, (t = {}, t[Xi] = "_drag", t[Yi] = "_dragEnd", t[Zr] = "_zoom", t[Qr] = "_zoomEnd", t)), o.addObserver(this.chartObserver);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.parseDate = function(t) {
    return Rt(this.chart.chartService.intl, t);
  }, r.prototype.clean = function() {
    this.selection && (this.selection.destroy(), this.selection = null), this.hint && (this.hint.destroy(), this.hint = null);
  }, r.prototype.destroy = function() {
    this.chart && (this.chart.removeObserver(this.chartObserver), delete this.chart), this.clean();
  }, r.prototype.redraw = function() {
    this._redrawSelf(), this.initSelection();
  }, r.prototype.initSelection = function() {
    var t = this, e = t.chart, i = t.options, a = this.mainAxis(), s = a.roundedRange(), l = s.min, p = s.max, h = i.select, c = h.from, u = h.to, v = h.mousewheel, f = Fm(a);
    a.categoriesCount() !== 0 && (this.clean(), f.box = a.box, this.selection = new kl(e, f, {
      min: l,
      max: p,
      from: c || l,
      to: u || p,
      mousewheel: U(v, { zoom: "left" }),
      visible: i.visible
    }, new de(this, {
      selectStart: "_selectStart",
      select: "_select",
      selectEnd: "_selectEnd"
    })), i.hint.visible && (this.hint = new bv(e.element, e.chartService, {
      min: l,
      max: p,
      template: Ct(i.hint),
      format: i.hint.format
    })));
  }, r.prototype.setRange = function() {
    var t = this.chart._createPlotArea(!0), e = t.namedCategoryAxes[Ge], i = e.roundedRange(), a = i.min, s = i.max, l = this.options.select || {}, p = l.from || a;
    p < a && (p = a);
    var h = l.to || s;
    h > s && (h = s), this.options.select = b({}, l, {
      from: p,
      to: h
    }), this.filterAxes();
  }, r.prototype._redrawSelf = function(t) {
    var e = this.chart._plotArea;
    e && e.redraw(dt(e.panes), t);
  }, r.prototype.redrawSlaves = function() {
    var t = this.chart, e = t._plotArea, i = e.panes.filter(function(a) {
      return a.options.name !== Ze;
    });
    e.srcSeries = t.options.series, e.options.categoryAxis = t.options.categoryAxis, e.clearSeriesPointsCache(), e.redraw(i);
  }, r.prototype._drag = function(t) {
    var e = this, i = e.chart, a = e.selection, s = i._eventCoordinates(t.originalEvent), l = this.mainAxis(), p = l.roundedRange(), h = l.pane.box.containsPoint(s), c = i._plotArea.categoryAxis, u = t.axisRanges[c.options.name], v = this.options.select, f;
    if (!(!u || h || !a)) {
      v.from && v.to ? f = st(v.to) - st(v.from) : f = st(a.options.to) - st(a.options.from);
      var d = at(j(
        st(u.min),
        p.min,
        st(p.max) - f
      )), m = at(j(
        st(d) + f,
        st(p.min) + f,
        p.max
      ));
      this.options.select = { from: d, to: m }, this.options.liveDrag && (this.filterAxes(), this.redrawSlaves()), a.set(d, m), this.showHint(d, m);
    }
  }, r.prototype._dragEnd = function() {
    this.filterAxes(), this.filter(), this.redrawSlaves(), this.hint && this.hint.hide();
  }, r.prototype.readSelection = function() {
    var t = this, e = t.selection.options, i = e.from, a = e.to, s = t.options.select;
    s.from = i, s.to = a;
  }, r.prototype.filterAxes = function() {
    var t = this, e = t.options.select;
    e === void 0 && (e = {});
    for (var i = t.chart, a = i.options.categoryAxis, s = e.from, l = e.to, p = 0; p < a.length; p++) {
      var h = a[p];
      h.pane !== Ze && (h.min = s, h.max = l);
    }
  }, r.prototype.filter = function() {
    var t = this, e = t.chart, i = t.options.select;
    if (e.requiresHandlers(["navigatorFilter"])) {
      var a = this.mainAxis(), s = {
        from: i.from,
        to: i.to
      };
      if (a.options.type !== "category") {
        var l = new xo(b({
          baseUnit: "fit"
        }, e.options.categoryAxis[0], {
          categories: [i.from, i.to]
        }), e.chartService).options;
        s.from = Ht(l.min, -l.baseUnitStep, l.baseUnit), s.to = Ht(l.max, l.baseUnitStep, l.baseUnit);
      }
      this.chart.trigger("navigatorFilter", s);
    }
  }, r.prototype._zoom = function(t) {
    var e = this, i = e.chart._plotArea.categoryAxis, a = e.selection, s = e.options, l = s.select, p = s.liveDrag, h = this.mainAxis(), c = t.delta;
    if (a) {
      var u = h.categoryIndex(a.options.from), v = h.categoryIndex(a.options.to), f = this.chart._eventCoordinates(t.originalEvent);
      t.originalEvent.preventDefault(), Math.abs(c) > 1 && (c *= Hm), v - u > 1 ? (a.zoom(c, f), this.readSelection()) : (i.options.min = l.from, l.from = i.scaleRange(-t.delta * this.chart._mousewheelZoomRate(), f).min), p && (this.filterAxes(), this.redrawSlaves()), a.set(l.from, l.to), this.showHint(this.options.select.from, this.options.select.to);
    }
  }, r.prototype._zoomEnd = function(t) {
    this._dragEnd(t);
  }, r.prototype.showHint = function(t, e) {
    var i = this.chart._plotArea;
    this.hint && this.hint.show(t, e, i.backgroundBox());
  }, r.prototype._selectStart = function(t) {
    return this.chart._selectStart(t);
  }, r.prototype._select = function(t) {
    return this.showHint(t.from, t.to), this.chart._select(t);
  }, r.prototype._selectEnd = function(t) {
    return this.hint && this.hint.hide(), this.readSelection(), this.filterAxes(), this.filter(), this.redrawSlaves(), this.chart._selectEnd(t);
  }, r.prototype.mainAxis = function() {
    var t = this.chart._plotArea;
    if (t)
      return t.namedCategoryAxes[Ge];
  }, r.prototype.select = function(t, e) {
    var i = this.options.select;
    return t && e && (i.from = this.parseDate(t), i.to = this.parseDate(e), this.filterAxes(), this.filter(), this.redrawSlaves(), this.selection.set(t, e)), {
      from: i.from,
      to: i.to
    };
  }, r.setup = function(t, e) {
    if (t === void 0 && (t = {}), e === void 0 && (e = {}), !t.__navi) {
      t.__navi = !0;
      var i = b({}, e.navigator, t.navigator), a = t.panes = [].concat(t.panes), s = b({}, i.pane, { name: Ze });
      i.visible || (s.visible = !1, s.height = 0.1), t.navigator.position !== "top" ? a.push(s) : a.unshift(s), a.forEach(function(l) {
        return l.name = l.name || _h;
      }), r.attachAxes(t, i), r.attachSeries(t, i, e);
    }
  }, r.attachAxes = function(t, e) {
    var i = e.series || [], a = t.categoryAxis = [].concat(t.categoryAxis), s = t.valueAxis = [].concat(t.valueAxis), l = a.concat(s);
    l.forEach(function(v) {
      return v.pane = v.pane || _h;
    });
    var p = ft(i, Iu), h = p.length === 0, c = b({
      type: "date",
      pane: Ze,
      roundToBaseUnit: !h,
      justified: h,
      _collapse: !1,
      majorTicks: { visible: !0 },
      tooltip: { visible: !1 },
      labels: { step: 1 },
      autoBind: e.autoBindElements,
      autoBaseUnitSteps: {
        minutes: [1],
        hours: [1, 2],
        days: [1, 2],
        weeks: [],
        months: [1],
        years: [1]
      }
    }), u = e.categoryAxis;
    a.push(
      b({}, c, {
        maxDateGroups: 200
      }, u, {
        name: Ge,
        title: null,
        baseUnit: "fit",
        baseUnitStep: "auto",
        labels: { visible: !1 },
        majorTicks: { visible: !1 }
      }),
      b({}, c, u, {
        name: Ge + "_labels",
        maxDateGroups: 20,
        baseUnitStep: "auto",
        labels: { position: "" },
        plotBands: [],
        autoBaseUnitSteps: {
          minutes: []
        },
        _overlap: !0
      }),
      b({}, c, u, {
        name: Ge + "_ticks",
        maxDateGroups: 200,
        majorTicks: {
          width: 0.5
        },
        plotBands: [],
        title: null,
        labels: { visible: !1, mirror: !0 },
        _overlap: !0
      })
    ), s.push(b({
      name: Ge,
      pane: Ze,
      majorGridLines: {
        visible: !1
      },
      visible: !1
    }, e.valueAxis));
  }, r.attachSeries = function(t, e, i) {
    for (var a = t.series = t.series || [], s = [].concat(e.series || []), l = i.seriesColors, p = e.seriesDefaults, h = 0; h < s.length; h++)
      a.push(
        b({
          color: l[h % l.length],
          categoryField: e.dateField,
          visibleInLegend: !1,
          tooltip: {
            visible: !1
          }
        }, p, s[h], {
          axis: Ge,
          categoryAxis: Ge,
          autoBind: e.autoBindElements
        })
      );
  }, r;
}(N);
function wh() {
}
function Fm(n) {
  return wh.prototype = n, new wh();
}
var Um = 28, $m = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.applyDefaults = function(t, e) {
    var i = Ye(this.element).width || Gs, a = e, s = {
      seriesDefaults: {
        categoryField: t.dateField
      },
      axisDefaults: {
        categoryAxis: {
          name: "default",
          majorGridLines: {
            visible: !1
          },
          labels: {
            step: 2
          },
          majorTicks: {
            visible: !1
          },
          maxDateGroups: Math.floor(i / Um)
        }
      }
    };
    a && (a = b({}, a, s)), xh.setup(t, a), n.prototype.applyDefaults.call(this, t, a);
  }, r.prototype._setElementClass = function(t) {
    mt(t, "k-chart k-stockchart");
  }, r.prototype.setOptions = function(t) {
    this.destroyNavigator(), n.prototype.setOptions.call(this, t);
  }, r.prototype.noTransitionsRedraw = function() {
    var t = this.options.transitions;
    this.options.transitions = !1, this._fullRedraw(), this.options.transitions = t;
  }, r.prototype._resize = function() {
    this.noTransitionsRedraw();
  }, r.prototype._redraw = function() {
    var t = this.navigator;
    !this._dirty() && t && t.options.partialRedraw ? t.redrawSlaves() : this._fullRedraw();
  }, r.prototype._dirty = function() {
    var t = this.options, e = [].concat(t.series, t.navigator.series), i = qt(e, function(s) {
      return s && s.visible;
    }).length, a = this._seriesCount !== i;
    return this._seriesCount = i, a;
  }, r.prototype._fullRedraw = function() {
    var t = this.navigator;
    t || (t = this.navigator = new xh(this), this.trigger("navigatorCreated", { navigator: t })), t.clean(), t.setRange(), n.prototype._redraw.call(this), t.initSelection();
  }, r.prototype._trackSharedTooltip = function(t) {
    var e = this._plotArea, i = e.paneByPoint(t);
    i && i.options.name === Ze ? this._unsetActivePoint() : n.prototype._trackSharedTooltip.call(this, t);
  }, r.prototype.bindCategories = function() {
    n.prototype.bindCategories.call(this), this.copyNavigatorCategories();
  }, r.prototype.copyNavigatorCategories = function() {
    for (var t = [].concat(this.options.categoryAxis), e, i = 0; i < t.length; i++) {
      var a = t[i];
      a.name === Ge ? e = a.categories : e && a.pane === Ze && (a.categories = e);
    }
  }, r.prototype.destroyNavigator = function() {
    this.navigator && (this.navigator.destroy(), this.navigator = null);
  }, r.prototype.destroy = function() {
    this.destroyNavigator(), n.prototype.destroy.call(this);
  }, r.prototype._stopChartHandlers = function(t) {
    var e = this._eventCoordinates(t), i = this._plotArea.paneByPoint(e);
    return n.prototype._stopChartHandlers.call(this, t) || i && i.options.name === Ze;
  }, r.prototype._toggleDragZoomEvents = function() {
    this._dragZoomEnabled || (this.element.style.touchAction = "none", this._dragZoomEnabled = !0);
  }, r;
}(sa);
O($m, {
  dateField: "date",
  axisDefaults: {
    categoryAxis: {
      type: "date",
      baseUnit: "fit",
      justified: !0
    },
    valueAxis: {
      narrowRange: !0,
      labels: {
        format: "C"
      }
    }
  },
  navigator: {
    select: {},
    seriesDefaults: {
      markers: {
        visible: !1
      },
      tooltip: {
        visible: !1
      },
      highlight: {
        visible: !1
      },
      line: {
        width: 2
      }
    },
    hint: {},
    visible: !0
  },
  tooltip: {
    visible: !0
  },
  legend: {
    visible: !1
  }
});
var Lo = 150, Av = 250, Gm = "arrow", Sv = "arrowPointer", lo = "barPointer", Tv = 200, ei = 0.5, Cv = 200, kv = Math.PI / 180, _r = "inside", la = "linear", Na = "outside", Pv = "radialPointer", Ov = "radialRangePointer";
function Ev(n, r) {
  var o = n.getOrigin(), t = n.getSize(), e = ot(r);
  return n.setOrigin([o.x - e.left, o.y - e.top]), n.setSize([t.width + (e.left + e.right), t.height + (e.top + e.bottom)]), n;
}
var Wm = pt, bh = H, Xm = Gc;
function Mv(n, r) {
  var o = n.box, t = n.children[0].box, e = r.border || {}, i = r.background || "", a = bh.fromRect(new Pt([o.x1, o.y1], [o.width(), o.height()]), {
    stroke: {}
  }), s = new Xm(n.text, new q(t.x1, t.y1), {
    font: r.font,
    fill: { color: r.color }
  }), l = Ev(s.bbox().clone(), r.padding), p = bh.fromRect(l, {
    stroke: {
      color: e.width ? e.color : "",
      width: e.width,
      opacity: e.opacity,
      dashType: e.dashType,
      lineJoin: "round",
      lineCap: "round"
    },
    fill: {
      color: i
    }
  }), h = new Wm();
  return h.append(a), h.append(p), h.append(s), h;
}
function Rv(n, r, o) {
  var t = P(n.from) ? n.from : xt, e = P(n.to) ? n.to : gt;
  return n.from = Math.max(Math.min(e, t), r), n.to = Math.min(Math.max(e, t), o), n;
}
function Ah(n, r) {
  var o = ot(r);
  return o.left = -o.left, o.top = -o.top, o.right = -o.right, o.bottom = -o.bottom, Ev(n, o);
}
var Ym = 5, qm = H, Zm = co, Nl = function(n) {
  function r(o, t, e, i) {
    i === void 0 && (i = {}), n.call(this), this.element = o, this.theme = e, this.contextService = new di(this, i), this._originalOptions = b({}, this.options, t), this.options = b({}, this._originalOptions), this._initTheme(e), this.redraw();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this.surface && (this.surface.destroy(), this.surface = null), delete this.element, delete this.surfaceElement;
  }, r.prototype.value = function(t) {
    var e = this.pointers[0];
    if (arguments.length === 0)
      return e.value();
    e.value(t), this._setValueOptions(t);
  }, r.prototype._draw = function() {
    var t = this.surface;
    t.clear(), t.draw(this._visuals);
  }, r.prototype.exportVisual = function() {
    return this._visuals;
  }, r.prototype.allValues = function(t) {
    var e = this.pointers, i = [];
    if (arguments.length === 0) {
      for (var a = 0; a < e.length; a++)
        i.push(e[a].value());
      return i;
    }
    if (Ot(t))
      for (var s = 0; s < t.length; s++)
        Y(t[s]) && e[s].value(t[s]);
    this._setValueOptions(t);
  }, r.prototype._setValueOptions = function(t) {
    for (var e = [].concat(this.options.pointer), i = [].concat(t), a = 0; a < i.length; a++)
      e[a].value = i[a];
  }, r.prototype.resize = function() {
    this.noTransitionsRedraw();
  }, r.prototype.noTransitionsRedraw = function() {
    var t = this.options.transitions;
    this._toggleTransitions(!1), this.redraw(), this._toggleTransitions(t);
  }, r.prototype.redraw = function() {
    var t = this._surfaceSize(), e = new Pt([0, 0], [t.width, t.height]);
    this._initSurface(), this.gaugeArea = this._createGaugeArea(), this._createModel();
    var i = Ah(e.bbox(), this._gaugeAreaMargin);
    this.reflow(i);
  }, r.prototype.setOptions = function(t, e) {
    this._originalOptions = b(this._originalOptions, t), this.options = b({}, this._originalOptions), this._initTheme(e), this.redraw();
  }, r.prototype.setDirection = function(t) {
    this.contextService.rtl = !!t, this.surface && this.surface.type === "svg" && (this.surface.destroy(), this.surface = null);
  }, r.prototype.setIntlService = function(t) {
    this.contextService.intl = t;
  }, r.prototype._initTheme = function(t) {
    var e = t || this.theme || {};
    this.theme = e, this.options = b({}, e, this.options);
    var i = this.options, a = i.pointer;
    if (Ot(a)) {
      for (var s = [], l = 0; l < a.length; l++)
        s.push(b({}, e.pointer, a[l]));
      i.pointer = s;
    }
  }, r.prototype._createGaugeArea = function() {
    var t = this.options.gaugeArea, e = this.surface.size(), i = t.border || {}, a = new Pt([0, 0], [e.width, e.height]);
    this._gaugeAreaMargin = t.margin || Ym, i.width > 0 && (a = Ah(a, i.width));
    var s = qm.fromRect(a, {
      stroke: {
        color: i.width ? i.color : "",
        width: i.width,
        dashType: i.dashType,
        lineJoin: "round",
        lineCap: "round"
      },
      fill: {
        color: t.background
      }
    });
    return s;
  }, r.prototype._initSurface = function() {
    var t = this, e = t.options, i = t.surface, a = this._surfaceElement(), s = this._surfaceSize();
    Ye(a, s), !i || i.options.type !== e.renderAs ? (i && i.destroy(), this.surface = Zm.create(a, {
      type: e.renderAs
    })) : (this.surface.clear(), this.surface.resize());
  }, r.prototype._surfaceSize = function() {
    var t = this.options, e = this._getSize();
    return t.gaugeArea && b(e, t.gaugeArea), e;
  }, r.prototype._surfaceElement = function() {
    return this.surfaceElement || (this.surfaceElement = document.createElement("div"), this.element.appendChild(this.surfaceElement)), this.surfaceElement;
  }, r.prototype.getSize = function() {
    return this._getSize();
  }, r.prototype._getSize = function() {
    var t = this.element, e = this._defaultSize(), i = t.offsetWidth, a = t.offsetHeight;
    return i || (i = e.width), a || (a = e.height), { width: i, height: a };
  }, r.prototype._defaultSize = function() {
    return {
      width: Cv,
      height: Tv
    };
  }, r.prototype._toggleTransitions = function(t) {
    var e = this;
    this.options.transitions = t;
    for (var i = 0; i < this.pointers.length; i++)
      e.pointers[i].options.animation.transitions = t;
  }, r;
}(N);
O(Nl, {
  plotArea: {},
  theme: "default",
  renderAs: "",
  pointer: {},
  scale: {},
  gaugeArea: {}
});
var cs = H, Fi = pt, tn = q;
function Qm(n, r) {
  var o = n.position, t = n.tickX, e = n.tickY, i, a;
  n.vertical ? (i = new tn(t, o), a = new tn(t + r.size, o)) : (i = new tn(o, e), a = new tn(o, e + r.size));
  var s = new cs({
    stroke: {
      color: r.color,
      width: r.width
    }
  }).moveTo(i).lineTo(a);
  return s;
}
function Sh(n, r, o, t) {
  var e = r.length;
  if (t.visible)
    for (var i = o.mirror, a = o.lineBox, s = t.skip; s < e; s += t.step)
      s % t.skipUnit !== 0 && (o.tickX = i ? a.x2 : a.x2 - t.size, o.tickY = i ? a.y1 - t.size : a.y1, o.position = r[s], n.append(Qm(o, t)));
}
var Lv = function(n) {
  function r(o, t) {
    var e = o || {};
    !P(e.reverse) && e.vertical === !1 && (t || {}).rtl && (e = Object.assign({}, e, {
      reverse: !0
    })), n.call(this, 0, 1, e, t), this.options.minorUnit = this.options.minorUnit || this.options.majorUnit / 10;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initUserOptions = function(t) {
    var e = b({}, this.options, t);
    return e = b({}, e, { labels: { mirror: e.mirror } }), e.majorUnit = e.majorUnit || fo(e.min, e.max), e;
  }, r.prototype.initFields = function() {
  }, r.prototype.render = function() {
    var t = this.elements = new Fi(), e = this.renderLabels(), i = this.renderLine(), a = this.renderTicks(), s = this.renderRanges();
    return t.append(i, e, a, s), t;
  }, r.prototype.renderRanges = function() {
    for (var t = this, e = this.options, i = e.min, a = e.max, s = e.vertical, l = e.labels.mirror, p = e.ranges || [], h = new Fi(), c = p.length, u = e.rangeSize || e.minorTicks.size / 2, v = 0; v < c; v++) {
      var f = Rv(p[v], i, a), d = t.getSlot(f.from, f.to), m = s ? t.lineBox() : d, _ = s ? d : t.lineBox();
      s ? m.x1 -= u * (l ? -1 : 1) : _.y2 += u * (l ? -1 : 1), h.append(cs.fromRect(new Pt([m.x1, _.y1], [m.x2 - m.x1, _.y2 - _.y1]), {
        fill: { color: f.color, opacity: f.opacity },
        stroke: {}
      }));
    }
    return h;
  }, r.prototype.renderLabels = function() {
    for (var t = this, e = t.labels, i = t.options, a = new Fi(), s = 0; s < e.length; s++)
      a.append(Mv(e[s], i.labels));
    return a;
  }, r.prototype.renderLine = function() {
    var t = this.options.line, e = this.lineBox(), i = new Fi();
    if (t.width > 0 && t.visible) {
      var a = new cs({
        stroke: {
          color: t.color,
          dashType: t.dashType,
          width: t.width
        }
      });
      a.moveTo(e.x1, e.y1).lineTo(e.x2, e.y2), i.append(a);
    }
    return i;
  }, r.prototype.renderTicks = function() {
    var t = new Fi(), e = this.options, i = e.majorTicks.visible ? e.majorUnit : 0, a = {
      vertical: e.vertical,
      mirror: e.labels.mirror,
      lineBox: this.lineBox()
    };
    return Sh(t, this.getMajorTickPositions(), a, e.majorTicks), Sh(t, this.getMinorTickPositions(), a, b({}, {
      skipUnit: i / e.minorUnit
    }, e.minorTicks)), t;
  }, r;
}(oe);
O(Lv, {
  min: 0,
  max: 50,
  majorTicks: {
    size: 15,
    align: _r,
    color: yt,
    width: ei,
    visible: !0
  },
  minorTicks: {
    size: 10,
    align: _r,
    color: yt,
    width: ei,
    visible: !0
  },
  line: {
    width: ei
  },
  labels: {
    position: _r,
    padding: 2
  },
  mirror: !1,
  _alignLines: !1
});
var pa = function(n) {
  function r(o, t) {
    n.call(this);
    var e = o.options, i = e.min, a = e.max, s = this.options = b({}, this.options, t);
    s.fill = s.color, this.scale = o, P(s.value) ? s.value = j(s.value, i, a) : s.value = i;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.value = function(t) {
    var e = this.options, i = e.value;
    if (arguments.length === 0)
      return i;
    var a = this.scale.options, s = a.min, l = a.max;
    e._oldValue = P(e._oldValue) ? e.value : s, e.value = j(t, s, l), this.elements && this.repaint();
  }, r;
}(N);
O(pa, {
  color: yt
});
var Hl = function(n) {
  function r(o, t) {
    n.call(this, o, t), this.options = b({
      track: {
        visible: P(t.track)
      }
    }, this.options);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function() {
    var t = this, e = t.options, i = t.scale, a = i.options, s = a.mirror, l = a.vertical, p = i.lineBox(), h = e.track.size || e.size, c = e.size / 2, u = ot(e.margin), v = l ? u[s ? "left" : "right"] : u[s ? "bottom" : "top"], f, d, m;
    v = s ? -v : v, l ? (m = new L(
      p.x1 + v,
      p.y1,
      p.x1 + v,
      p.y2
    ), s ? m.x1 -= h : m.x2 += h, e.shape !== lo && (d = new L(
      p.x2 + v,
      p.y1 - c,
      p.x2 + v,
      p.y2 + c
    ), f = d)) : (m = new L(
      p.x1,
      p.y1 - v,
      p.x2,
      p.y1 - v
    ), s ? m.y2 += h : m.y1 -= h, e.shape !== lo && (d = new L(
      p.x1 - c,
      p.y1 - v,
      p.x2 + c,
      p.y1 - v
    ), f = d)), this.trackBox = m, this.pointerRangeBox = d, this.box = f || m.clone().pad(e.border.width);
  }, r.prototype.getElementOptions = function() {
    var t = this.options;
    return {
      fill: {
        color: t.color,
        opacity: t.opacity
      },
      stroke: P(t.border) ? {
        color: t.border.width ? t.border.color || t.color : "",
        width: t.border.width,
        dashType: t.border.dashType,
        opacity: t.opacity
      } : null
    };
  }, r.prototype._margin = function() {
    var t = this, e = t.scale, i = t.options, a = e.options, s = a.mirror, l = a.vertical, p = ot(i.margin), h = l ? p[s ? "left" : "right"] : p[s ? "bottom" : "top"];
    return h;
  }, r;
}(pa);
O(Hl, {
  shape: lo,
  track: {
    border: {
      width: 1
    }
  },
  color: yt,
  border: {
    width: 1
  },
  opacity: 1,
  margin: ot(3),
  animation: {
    type: lo
  },
  visible: !0
});
var Fl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    var t = this.options, e = t.margin, i = t.from, a = t.to, s = t.vertical, l = s ? "x1" : "y1";
    t.mirror === s ? (i[l] -= e, a[l] -= e) : (i[l] += e, a[l] += e);
    var p = this.fromScale = new q(i.x1, i.y1), h = this.toScale = new q(a.x1, a.y1);
    t.duration !== 0 && (t.duration = Math.max(p.distanceTo(h) / t.duration * 1e3, 1));
  }, r.prototype.step = function(t) {
    var e = ie(this.fromScale.x, this.toScale.x, t), i = ie(this.fromScale.y, this.toScale.y, t);
    this.element.transform(wt().translate(e, i));
  }, r;
}(pe);
O(Fl, {
  easing: la,
  duration: Av
});
De.current.register(Sv, Fl);
var Yr = q, Km = H, Jm = function(n) {
  function r(o, t) {
    n.call(this, o, t), P(this.options.size) || (this.options.size = this.scale.options.majorTicks.size * 0.6);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointerShape = function() {
    var t = this, e = t.scale, i = t.options.size, a = i / 2, s = e.options.mirror ? -1 : 1, l;
    return e.options.vertical ? l = [
      new Yr(0, 0 - a),
      new Yr(0 - s * i, 0),
      new Yr(0, 0 + a)
    ] : l = [
      new Yr(0 - a, 0),
      new Yr(0, 0 + s * i),
      new Yr(0 + a, 0)
    ], l;
  }, r.prototype.repaint = function() {
    var t = this, e = t.scale, i = t.options, a = new Fl(this.elements, b(i.animation, {
      vertical: e.options.vertical,
      mirror: e.options.mirror,
      margin: this._margin(i.margin),
      from: e.getSlot(i._oldValue),
      to: e.getSlot(i.value)
    }));
    i.animation.transitions === !1 && (a.options.duration = 0), a.setup(), a.play();
  }, r.prototype.render = function() {
    var t = this, e = t.scale, i = t.options, a = this.getElementOptions(), s = this.pointerShape(i.value);
    i.animation.type = Sv;
    var l = new Km({
      stroke: a.stroke,
      fill: a.fill
    }).moveTo(s[0]).lineTo(s[1]).lineTo(s[2]).close(), p = e.getSlot(i.value);
    return l.transform(wt().translate(p.x1, p.y1)), this.elements = l, l;
  }, r;
}(Hl), Ul = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setup = function() {
    var t = this.options, e = this.axis = t.vertical ? B : D, i = this.to = t.newPoints[0][e], a = this.from = t.oldPoints[0][e];
    t.duration !== 0 && (t.duration = Math.max(Math.abs(i - a) / t.speed * 1e3, 1)), this._set(a);
  }, r.prototype.step = function(t) {
    var e = ie(this.from, this.to, t);
    this._set(e);
  }, r.prototype._set = function(t) {
    var e = "set" + this.axis.toUpperCase(), i = this.options.newPoints;
    i[0][e](t), i[1][e](t);
  }, r;
}(pe);
O(Ul, {
  easing: la,
  speed: Av
});
De.current.register(lo, Ul);
var t_ = pt, Th = H, e_ = function(n) {
  function r(o, t) {
    n.call(this, o, t), P(this.options.size) || (this.options.size = this.scale.options.majorTicks.size * 0.3);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.pointerShape = function(t) {
    var e = this, i = e.scale, a = e.options, s = i.options, l = s.mirror, p = s.vertical, h = l === p ? -1 : 1, c = a.size * h, u = i.getSlot(i.options.min), v = i.getSlot(t), f = p ? B : D, d = p ? D : B, m = this._margin() * h, _ = new q();
    _[f] = u[f + "1"], _[d] = u[d + "1"];
    var w = new q();
    w[f] = v[f + "1"], w[d] = v[d + "1"], p ? (_.translate(m, 0), w.translate(m, 0)) : (_.translate(0, m), w.translate(0, m));
    var A = w.clone(), T = _.clone();
    return p ? (A.translate(c, 0), T.translate(c, 0)) : (A.translate(0, c), T.translate(0, c)), [_, w, A, T];
  }, r.prototype.repaint = function() {
    var t = this, e = t.scale, i = t.options, a = this.pointerShape(i.value), s = this.pointerPath, l = this.pointerShape(i._oldValue);
    s.moveTo(a[0]).lineTo(a[1]).lineTo(a[2]).lineTo(a[3]).close();
    var p = new Ul(s, b(i.animation, {
      reverse: e.options.reverse,
      vertical: e.options.vertical,
      oldPoints: [l[1], l[2]],
      newPoints: [a[1], a[2]]
    }));
    i.animation.transitions === !1 && (p.options.duration = 0), p.setup(), p.play();
  }, r.prototype.render = function() {
    var t = new t_(), e = this.getElementOptions();
    this.options.track.visible && t.append(this.renderTrack());
    var i = this.pointerPath = new Th({
      stroke: e.stroke,
      fill: e.fill
    });
    return t.append(i), this.elements = t, t;
  }, r.prototype.renderTrack = function() {
    var t = this.options.track, e = t.border || {}, i = this.trackBox.clone().pad(e.width || 0);
    return new Th.fromRect(i.toRect(), {
      fill: {
        color: t.color,
        opacity: t.opacity
      },
      stroke: {
        color: e.width ? e.color || t.color : "",
        width: e.width,
        dashType: e.dashType
      }
    });
  }, r;
}(Hl), r_ = 60, i_ = 60, o_ = pt, n_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this.pointers, i = t.origin.x, a = t.origin.y, s = new L(i, a, i + t.width(), a + t.height());
    this.scale.reflow(s), this._shrinkScaleWidth(s);
    for (var l = 0; l < e.length; l++)
      e[l].reflow();
    this.bbox = this._getBox(s), this._alignElements(), this._shrinkElements(), this._buildVisual(), this._draw();
  }, r.prototype._buildVisual = function() {
    var t = new o_(), e = this.scale.render(), i = this.pointers;
    t.append(this.gaugeArea), t.append(e);
    for (var a = 0; a < i.length; a++) {
      var s = i[a];
      t.append(s.render()), s.value(s.options.value);
    }
    this._visuals = t;
  }, r.prototype._createModel = function() {
    var t = this, e = this.options, i = this.scale = new Lv(e.scale, this.contextService);
    this.pointers = [];
    var a = e.pointer;
    a = Ot(a) ? a : [a];
    for (var s = 0; s < a.length; s++) {
      var l = b({}, a[s], {
        animation: {
          transitions: e.transitions
        }
      }), p = l.shape === Gm ? Jm : e_;
      t.pointers.push(new p(i, l));
    }
  }, r.prototype._defaultSize = function() {
    var t = this.options.scale.vertical;
    return {
      width: t ? r_ : Cv,
      height: t ? Tv : i_
    };
  }, r.prototype._getBox = function(t) {
    for (var e = this, i = e.scale, a = e.pointers, s = t.center(), l = a[0].box.clone().wrap(i.box), p = 0; p < a.length; p++)
      l.wrap(a[p].box.clone());
    var h;
    return i.options.vertical ? (h = l.width() / 2, l = new L(
      s.x - h,
      t.y1,
      s.x + h,
      t.y2
    )) : (h = l.height() / 2, l = new L(
      t.x1,
      s.y - h,
      t.x2,
      s.y + h
    )), l;
  }, r.prototype._alignElements = function() {
    for (var t = this, e = this, i = e.scale, a = e.pointers, s = i.box, l = a[0].box.clone().wrap(i.box), p = this.bbox, h = 0; h < a.length; h++)
      l.wrap(a[h].box.clone());
    var c;
    i.options.vertical ? (c = p.center().x - l.center().x, i.reflow(new L(
      s.x1 + c,
      p.y1,
      s.x2 + c,
      p.y2
    ))) : (c = p.center().y - l.center().y, i.reflow(new L(
      s.x1,
      s.y1 + c,
      s.x2,
      s.y2 + c
    )));
    for (var u = 0; u < a.length; u++)
      a[u].reflow(t.bbox);
  }, r.prototype._shrinkScaleWidth = function(t) {
    var e = this, i = e.scale;
    if (!i.options.vertical) {
      var a = i.contentBox().width() - t.width();
      a > 0 && (i.box.shrink(a, 0), i.box.alignTo(t, "center"), i.reflow(i.box));
    }
  }, r.prototype._shrinkElements = function() {
    for (var t = this, e = this, i = e.scale, a = e.pointers, s = i.box.clone(), l = i.options.vertical ? "y" : "x", p = a[0].box, h = 0; h < a.length; h++)
      p.wrap(a[h].box.clone());
    s[l + 1] += Math.max(s[l + 1] - p[l + 1], 0), s[l + 2] -= Math.max(p[l + 2] - s[l + 2], 0), i.reflow(s);
    for (var c = 0; c < a.length; c++)
      a[c].reflow(t.bbox);
  }, r;
}(Nl);
O(n_, {
  transitions: !0,
  gaugeArea: {
    background: ""
  },
  scale: {
    vertical: !0
  }
});
var en = 180, a_ = Zd, s_ = H, hn = pt;
function Ch(n, r, o, t) {
  var e = new hn(), i = n.center, a = n.getRadiusX();
  if (t.visible)
    for (var s = 0; s < r.length; s++) {
      var l = n.pointAt(r[s]), p = new q(i.x + a - t.size, i.y).rotate(r[s], i);
      e.append(new s_({
        stroke: {
          color: t.color,
          width: t.width
        }
      }).moveTo(l).lineTo(p));
    }
  return e;
}
function Ha(n, r, o, t) {
  return { from: n, to: r, color: o, opacity: t };
}
var $l = function(n) {
  function r(o, t) {
    n.call(this, 0, 1, o, t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initUserOptions = function(t) {
    var e = b({}, this.options, t);
    return e.majorUnit = e.majorUnit || fo(e.min, e.max), e.minorUnit = e.minorUnit || e.majorUnit / 10, e;
  }, r.prototype.initFields = function() {
  }, r.prototype.render = function(t, e) {
    var i = this.renderArc(t, e);
    this.bbox = i.bbox(), this.labelElements = this.renderLabels(), this.ticks = this.renderTicks(), this.ranges = this.renderRanges();
  }, r.prototype.reflow = function(t) {
    var e = t.center(), i = Math.min(t.height(), t.width()) / 2;
    if (P(this.bbox))
      this.bbox = this.arc.bbox(), this.radius(this.arc.getRadiusX()), this.repositionRanges(), this.renderLabels();
    else
      return this.render(e, i);
  }, r.prototype.slotAngle = function(t) {
    var e = this.options, i = e.min, a = e.max, s = e.reverse, l = e.startAngle, p = e.endAngle, h = p - l, c;
    return s ? c = p - (t - i) / (a - i) * h : c = (t - i) / (a - i) * h + l, c + en;
  }, r.prototype.hasRanges = function() {
    var t = this.options.ranges;
    return t && t.length;
  }, r.prototype.ticksSize = function() {
    var t = this.options, e = t.majorTicks, i = t.minorTicks, a = 0;
    return e.visible && (a = e.size), i.visible && (a = Math.max(i.size, a)), a;
  }, r.prototype.labelsCount = function() {
    var t = n.prototype.labelsCount.call(this), e = this.options, i = e.endAngle - e.startAngle;
    return i >= 360 && e.max % e.majorUnit === 0 && (t -= 1), t;
  }, r.prototype.renderLabels = function() {
    var t = this, e = this.options, i = this.arc.clone(), a = i.getRadiusX(), s = this.tickAngles(i, e.majorUnit), l = e.rangeSize = e.rangeSize || a * 0.1, p = new hn(), h = a * 0.05;
    P(e.rangeDistance) ? h = e.rangeDistance : e.rangeDistance = h;
    var c = e.labels, u = c.position === _r, v = P(this.labelElements);
    u && (a -= this.ticksSize(), this.hasRanges() && !v && (a -= l + h), i.setRadiusX(a).setRadiusY(a));
    for (var f = this.labels, d = f.length, m = ot(c.padding), _ = (m.left + m.right) / 2, w = (m.top + m.bottom) / 2, A = 0; A < d; A++) {
      var T = f[A], k = T.box.width() / 2, C = T.box.height() / 2, z = s[A], V = (z - en) * kv, G = i.pointAt(z), X = G.x + Math.cos(V) * (k + _) * (u ? 1 : -1), W = G.y + Math.sin(V) * (C + w) * (u ? 1 : -1);
      T.reflow(new L(X - k, W - C, X + k, W + C));
      var ct = new q(T.box.x1, T.box.y1), It = void 0;
      if (!v)
        It = Mv(T, e.labels), p.append(It);
      else {
        It = t.labelElements.children[A];
        var Gt = It.bbox().origin, Wt = It.transform() || wt();
        Wt.translate(ct.x - Gt.x, ct.y - Gt.y), It.transform(Wt);
      }
      t.bbox = Pt.union(t.bbox, It.bbox());
    }
    return p;
  }, r.prototype.repositionRanges = function() {
    var t = this.ranges.children;
    if (t.length > 0) {
      var e = this.options, i = e.rangeDistance, a = e.rangeSize, s = this.getRangeRadius();
      this.options.labels.position === _r && (s += a + i);
      for (var l = s + a / 2, p = 0; p < t.length; p++)
        t[p]._geometry.setRadiusX(l).setRadiusY(l);
      this.bbox = Pt.union(this.bbox, this.ranges.bbox());
    }
  }, r.prototype.renderRanges = function() {
    var t = this, e = this.rangeSegments(), i = e.length, a = new hn();
    if (i) {
      var s = this.options, l = s.rangeSize, p = s.reverse, h = s.rangeDistance, c = this.getRangeRadius();
      this.radius(this.radius() - l - h);
      for (var u = 0; u < i; u++) {
        var v = e[u], f = t.slotAngle(v[p ? "to" : "from"]), d = t.slotAngle(v[p ? "from" : "to"]);
        d - f !== 0 && a.append(t.createRange(f, d, c, v));
      }
    }
    return a;
  }, r.prototype.createRange = function(t, e, i, a) {
    var s = this.options.rangeSize, l = new ri(this.arc.center, {
      radiusX: i + s / 2,
      radiusY: i + s / 2,
      startAngle: t,
      endAngle: e
    });
    return new a_(l, {
      stroke: {
        width: s,
        color: a.color,
        opacity: a.opacity,
        lineCap: a.lineCap
      }
    });
  }, r.prototype.rangeSegments = function() {
    var t = this.options, e = t.ranges || [], i = e.length, a = [];
    if (i) {
      var s = t.min, l = t.max, p = t.rangePlaceholderColor;
      a.push(Ha(s, l, p));
      for (var h = 0; h < i; h++)
        for (var c = Rv(e[h], s, l), u = a.length, v = 0; v < u; v++) {
          var f = a[v];
          if (f.from <= c.from && c.from <= f.to) {
            a.push(Ha(c.from, c.to, c.color, c.opacity)), f.from <= c.to && c.to <= f.to && a.push(Ha(c.to, f.to, p, c.opacity)), f.to = c.from;
            break;
          }
        }
    }
    return a;
  }, r.prototype.getRangeRadius = function() {
    var t = this, e = t.arc, i = t.options, a = i.rangeSize, s = i.rangeDistance, l = i.majorTicks.size, p;
    return i.labels.position === Na ? p = e.getRadiusX() - l - s - a : p = e.getRadiusX() - a, p;
  }, r.prototype.renderArc = function(t, e) {
    var i = this.options, a = this.arc = new ri(t, {
      radiusX: e,
      radiusY: e,
      startAngle: i.startAngle + en,
      endAngle: i.endAngle + en
    });
    return a;
  }, r.prototype.renderTicks = function() {
    var t = this, e = t.arc, i = t.options, a = e.clone();
    this.majorTickAngles = this.tickAngles(e, i.majorUnit), this.majorTicks = Ch(a, this.majorTickAngles, i.majorUnit, i.majorTicks);
    var s = new hn();
    s.append(this.majorTicks);
    var l = i.majorTicks.size, p = i.minorTicks.size;
    if (this._tickDifference = l - p, i.labels.position === Na) {
      var h = a.getRadiusX();
      a.setRadiusX(h - l + p).setRadiusY(h - l + p);
    }
    return this.minorTickAngles = this.normalizeTickAngles(this.tickAngles(e, i.minorUnit)), this.minorTicks = Ch(a, this.minorTickAngles, i.minorUnit, i.minorTicks), s.append(this.minorTicks), s;
  }, r.prototype.normalizeTickAngles = function(t) {
    for (var e = this.options, i = e.majorUnit / e.minorUnit, a = t.length - 1; a >= 0; a--)
      a % i === 0 && t.splice(a, 1);
    return t;
  }, r.prototype.tickAngles = function(t, e) {
    var i = this.options, a = i.reverse, s = i.max - i.min, l = t.endAngle - t.startAngle, p = s / e, h = t.startAngle, c = l / p;
    a && (h += l, c = -c), l >= 360 && i.max % e === 0 && (p -= 1);
    for (var u = [], v = 0; v < p; v++)
      u.push(R(h, Tt)), h += c;
    return R(h) <= t.endAngle && u.push(h), u;
  }, r.prototype.radius = function(t) {
    if (t)
      this.arc.setRadiusX(t).setRadiusY(t), this.repositionTicks(this.majorTicks.children, this.majorTickAngles), this.repositionTicks(this.minorTicks.children, this.minorTickAngles, !0);
    else
      return this.arc.getRadiusX();
  }, r.prototype.repositionTicks = function(t, e, i) {
    var a = i && this._tickDifference || 0, s = this.arc, l = s.getRadiusX();
    i && this.options.labels.position === Na && a !== 0 && (s = this.arc.clone(), s.setRadiusX(l - a).setRadiusY(l - a));
    for (var p = 0; p < t.length; p++) {
      var h = s.pointAt(e[p]), c = t[p].segments, u = h.x - c[0].anchor().x, v = h.y - c[0].anchor().y;
      t[p].transform(new wt().translate(u, v));
    }
  }, r;
}(oe);
O($l, {
  min: 0,
  max: 100,
  majorTicks: {
    size: 15,
    align: _r,
    color: yt,
    width: ei,
    visible: !0
  },
  minorTicks: {
    size: 10,
    align: _r,
    color: yt,
    width: ei,
    visible: !0
  },
  startAngle: -30,
  endAngle: 210,
  labels: {
    position: _r,
    padding: 2
  }
});
var Gl = function(n) {
  function r(o, t) {
    n.call(this, o, t);
    var e = this.options;
    e.duration = Math.max(Math.abs(e.newAngle - e.oldAngle) / e.duration * 1e3, 1);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.step = function(t) {
    var e = this.options, i = ie(e.oldAngle, e.newAngle, t);
    this.element.transform(wt().rotate(i, e.center));
  }, r;
}(pe);
O(Gl, {
  easing: la,
  duration: Lo
});
De.current.register(Pv, Gl);
var l_ = 0.05, p_ = Je, h_ = pt, c_ = H, Iv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.setAngle = function(t) {
    this.elements.transform(wt().rotate(t, this.center));
  }, r.prototype.repaint = function() {
    var t = this, e = t.scale, i = t.options, a = e.slotAngle(i._oldValue), s = e.slotAngle(i.value);
    i.animation.transitions === !1 ? this.setAngle(s) : new Gl(this.elements, b(i.animation, {
      oldAngle: a,
      newAngle: s
    })).play();
  }, r.prototype.render = function() {
    var t = this, e = t.scale, i = t.options, a = new h_();
    return i.animation !== !1 && b(i.animation, {
      startAngle: 0,
      center: e.arc.center,
      reverse: e.options.reverse
    }), a.append(this._renderNeedle(), this._renderCap()), this.elements = a, this.setAngle(kv), a;
  }, r.prototype.reflow = function(t) {
    var e = this.center = t.center, i = j(this.options.length || 1, 0.1, 1.5), a = this.radius = t.getRadiusX() * i, s = this.capSize = Math.round(a * this.options.cap.size);
    this.bbox = Pt.fromPoints(
      new q(e.x - s, e.y - s),
      new q(e.x + s, e.y + s)
    );
  }, r.prototype._renderNeedle = function() {
    var t = this.scale.options.minorTicks.size, e = this.center, i = this.options.color, a = new c_({
      fill: { color: i },
      stroke: { color: i, width: ei }
    });
    return a.moveTo(e.x + this.radius - t, e.y).lineTo(e.x, e.y - this.capSize / 2).lineTo(e.x, e.y + this.capSize / 2).close(), a;
  }, r.prototype._renderCap = function() {
    var t = this.options, e = t.cap.color || t.color, i = new ve(this.center, this.capSize), a = new p_(i, {
      fill: { color: e },
      stroke: { color: e }
    });
    return a;
  }, r;
}(pa);
O(Iv, {
  cap: {
    size: l_
  },
  arrow: {
    width: 16,
    height: 14
  },
  animation: {
    type: Pv,
    duration: Lo
  }
});
var u_ = pt, Dv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.reflow = function(t) {
    var e = this, i = this.pointers;
    this.scale.reflow(t), this._initialPlotArea = this.scale.bbox;
    for (var a = 0; a < i.length; a++)
      i[a].reflow(e.scale.arc), e._initialPlotArea = Pt.union(e._initialPlotArea, i[a].bbox);
    this.fitScale(t), this.alignScale(t), this._buildVisual(this.gaugeArea, i, this.scale), this._draw();
  }, r.prototype._buildVisual = function(t, e, i) {
    var a = this._visuals = new u_();
    a.append(t), a.append(i.ticks), a.append(i.ranges), this._buildPointers(e), a.append(i.labelElements);
  }, r.prototype._buildPointers = function(t) {
    for (var e = this, i = 0; i < t.length; i++) {
      var a = t[i];
      a.render(), e._visuals.append(a.elements), a.value(a.options.value);
    }
  }, r.prototype.fitScale = function(t) {
    for (var e = this, i = this.scale.arc, a = this._initialPlotArea, s = Math.abs(this.getDiff(a, t)), l = R(s, Tt), p = R(-s, Tt), h, c, u, v, f, d = 0, m = 0; m++ < 100 && (d = f === u ? d + 1 : 0, !(d > 5 || l !== v && (h = e.getPlotBox(l, t, i), 0 <= h && h <= 2) || p !== v && (u = e.getPlotBox(p, t, i), 0 <= u && u <= 2) || (h > 0 && u > 0 ? v = l * 2 : h < 0 && u < 0 ? v = p * 2 : v = R((l + p) / 2 || 1, Tt), c = e.getPlotBox(v, t, i), 0 <= c && c <= 2))); )
      f = u, c > 0 ? (p = v, u = c) : (l = v, h = c);
  }, r.prototype.getPlotBox = function(t, e, i) {
    var a = this, s = this.scale, l = this.pointers, p = i.getRadiusX(), h = i.clone();
    h.setRadiusX(p + t).setRadiusY(p + t), s.arc = h, s.reflow(e), this.plotBbox = s.bbox;
    for (var c = 0; c < l.length; c++)
      l[c].reflow(h), a.plotBbox = Pt.union(a.plotBbox, l[c].bbox);
    return this.getDiff(this.plotBbox, e);
  }, r.prototype.getDiff = function(t, e) {
    return Math.min(e.width() - t.width(), e.height() - t.height());
  }, r.prototype.alignScale = function(t) {
    var e = this, i = this.plotBbox.center(), a = t.center(), s = i.x - a.x, l = i.y - a.y, p = this, h = p.scale, c = p.pointers;
    h.arc.center.x -= s, h.arc.center.y -= l, h.reflow(t);
    for (var u = 0; u < c.length; u++)
      c[u].reflow(h.arc), e.plotBbox = Pt.union(h.bbox, c[u].bbox);
  }, r.prototype._createModel = function() {
    var t = this, e = this.options, i = e.pointer, a = this.scale = new $l(e.scale, this.contextService);
    this.pointers = [];
    for (var s = Ot(i) ? i : [i], l = 0; l < s.length; l++) {
      var p = new Iv(a, b({}, s[l], {
        animation: {
          transitions: e.transitions
        }
      }));
      t.pointers.push(p);
    }
  }, r;
}(Nl);
O(Dv, {
  transitions: !0,
  gaugeArea: {
    background: ""
  }
});
var Bv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.rangeSegments = function() {
    var t = this.options, e = t.min, i = t.max, a = t.rangePlaceholderColor, s = t.rangeLineCap;
    return [{ from: e, to: i, color: a, lineCap: s }];
  }, r.prototype.hasRanges = function() {
    return !0;
  }, r.prototype.placeholderRangeAngle = function(t) {
    var e = this.ranges.children[0].geometry();
    this.options.reverse ? e.setEndAngle(t) : e.setStartAngle(t);
  }, r.prototype.addRange = function(t, e, i) {
    var a = this.options.reverse, s = this.slotAngle(a ? e : t), l = this.slotAngle(a ? t : e), p = this.createRange(s, l, this.getRangeRadius(), i);
    return this.ranges.append(p), p;
  }, r;
}($l);
O(Bv, {
  min: 0,
  max: 100,
  majorTicks: {
    visible: !1
  },
  minorTicks: {
    visible: !1
  },
  labels: {
    visible: !1
  },
  startAngle: 0,
  endAngle: 180,
  rangeLineCap: "round"
});
var v_ = 800, Wl = function(n) {
  function r(o, t) {
    n.call(this, o, t);
    var e = this.options, i = Math.abs(e.newAngle - e.oldAngle) / e.duration * 1e3;
    e.duration = j(i, Lo, v_);
    var a = o.elements.options.get("stroke.color"), s = o.currentColor();
    a !== s && (this.startColor = new Ee(a), this.color = new Ee(s));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.step = function(t) {
    var e = this, i = e.options, a = e.startColor, s = e.color, l = ie(i.oldAngle, i.newAngle, t);
    if (this.element.angle(l), s) {
      var p = R(ie(a.r, s.r, t)), h = R(ie(a.g, s.g, t)), c = R(ie(a.b, s.b, t));
      this.element.stroke(new Ee(p, h, c).toHex());
    }
  }, r;
}(pe);
O(Wl, {
  easing: la,
  duration: Lo
});
De.current.register(Ov, Wl);
var zv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.repaint = function() {
    var t = this, e = t.scale, i = t.options, a = e.slotAngle(i._oldValue), s = e.slotAngle(i.value);
    this.animation && this.animation.abort(), i.animation.transitions === !1 ? (this.angle(s), this.stroke(this.currentColor())) : (this.animation = new Wl(this, b(i.animation, {
      oldAngle: a,
      newAngle: s
    })), this.animation.play());
  }, r.prototype.angle = function(t) {
    var e = this.elements.geometry();
    this.scale.options.reverse ? e.setStartAngle(t) : e.setEndAngle(t), this.scale.placeholderRangeAngle(t);
  }, r.prototype.stroke = function(t) {
    this.elements.stroke(t);
  }, r.prototype.render = function() {
    if (!this.elements) {
      var t = this, e = t.scale, i = t.options;
      i.animation !== !1 && b(i.animation, {
        startAngle: 0,
        center: e.arc.center,
        reverse: e.options.reverse
      }), this.elements = e.addRange(e.options.min, this.options.value, {
        color: this.currentColor(),
        opacity: i.opacity,
        lineCap: e.options.rangeLineCap
      });
    }
  }, r.prototype.currentColor = function() {
    var t = this.scale.options, e = t.min, i = t.max, a = this.options, s = a.colors, l = a.color, p = a.value, h = Y(p) ? p : e;
    if (s)
      for (var c = 0; c < s.length; c++) {
        var u = s[c], v = u.color, f = u.from;
        f === void 0 && (f = e);
        var d = u.to;
        if (d === void 0 && (d = i), f <= h && h <= d)
          return v;
      }
    return l;
  }, r.prototype.reflow = function() {
    this.render(), this.bbox = this.elements.bbox();
  }, r;
}(pa);
O(zv, {
  animation: {
    type: Ov,
    duration: Lo
  }
});
var f_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initTheme = function(t) {
    n.prototype._initTheme.call(this, t), this.options.color = this.options.color || (this.theme.pointer || {}).color;
  }, r.prototype._createModel = function() {
    var t = this.options, e = this.scale = new Bv(t.scale, this.contextService), i = new zv(e, b({}, {
      colors: t.colors,
      color: t.color,
      value: t.value,
      opacity: t.opacity,
      animation: {
        transitions: t.transitions
      }
    }));
    this.pointers = [i];
  }, r.prototype._buildPointers = function(t) {
    for (var e = 0; e < t.length; e++) {
      var i = t[e];
      i.render(), i.value(i.options.value);
    }
  }, r.prototype._setValueOptions = function(t) {
    this.options.value = t;
  }, r.prototype.currentColor = function() {
    var t = this.pointers[0];
    if (t)
      return t.currentColor();
  }, r.prototype.centerLabelPosition = function(t, e) {
    var i = this.getSize(), a = this.scale.arc.center, s = a.x - t / 2, l = a.y - e / 2;
    if (t < i.width) {
      var p = s + t;
      s = Math.max(s, 0), p > i.width && (s -= p - i.width);
    }
    if (e < i.height) {
      var h = this.scale.bbox, c = h.bottomRight().y, u = l + e;
      l = Math.max(l, h.origin.y), u > c && (l -= u - c);
    }
    return {
      left: s,
      top: l
    };
  }, r;
}(Dv), d_ = 90;
(function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._createModel = function() {
    var t = this.options.scale;
    typeof t.startAngle != "number" && (t.startAngle = d_), t.endAngle = t.startAngle + 360, n.prototype._createModel.call(this);
  }, r;
})(f_);
var jv = 10, $r = function(n) {
  function r(o) {
    n.call(this), this.setOptions(o), this.initProperties();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
  }, r.prototype.setOptions = function(t) {
    this.options = Object.assign({}, this.options, t), this.quietZoneLength = this.options.addQuietZone ? 2 * this.options.quietZoneLength : 0;
  }, r.prototype.encode = function(t, e, i) {
    var a = P(t) ? String(t) : t;
    return this.initValue(a, e, i), this.options.addQuietZone && this.addQuietZone(), this.addData(), this.options.addQuietZone && this.addQuietZone(), {
      baseUnit: this.baseUnit,
      pattern: this.pattern
    };
  }, r.prototype.initValue = function() {
  }, r.prototype.addQuietZone = function() {
    this.pattern.push(this.options.quietZoneLength || jv);
  }, r.prototype.addData = function() {
  }, r.prototype.invalidCharacterError = function(t) {
    throw new Error('Character "' + t + '" is not valid for symbology ' + this.name + ".");
  }, r;
}(N);
O($r, {
  quietZoneLength: jv,
  addQuietZone: !0,
  addCheckSum: !0
});
var g_ = Object.assign, Vv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), g_(this, {
      name: "Code 11",
      characterMap: ["111121", "211121", "121121", "221111", "112121", "212111", "122111", "111221", "211211", "211111", "112111"],
      cCheckSumTotal: 10,
      kCheckSumTotal: 9,
      kCheckSumMinLength: 10,
      checkSumMod: 11,
      DASH_VALUE: 10,
      DASH: "-",
      START: "112211",
      STOP: "11221"
    });
  }, r.prototype.initValue = function(t, e) {
    this.pattern = [], this.value = t, this.width = e, this.totalUnits = 0;
  }, r.prototype.addData = function() {
    var t = this, e = this.value;
    this.addPattern(this.START);
    for (var i = 0; i < e.length; i++)
      t.addCharacter(e.charAt(i));
    this.options.addCheckSum && this.addCheckSum(), this.addPattern(this.STOP), this.setBaseUnit();
  }, r.prototype.setBaseUnit = function() {
    this.baseUnit = this.width / (this.totalUnits + this.quietZoneLength);
  }, r.prototype.addCheckSum = function() {
    var t = this.value, e = t.length, i = this.getWeightedSum(t, e, this.cCheckSumTotal) % this.checkSumMod;
    if (this.checksum = String(i), this.addPattern(this.characterMap[i]), e++, e >= this.kCheckSumMinLength) {
      var a = (i + this.getWeightedSum(t, e, this.kCheckSumTotal)) % this.checkSumMod;
      this.checksum += a, this.addPattern(this.characterMap[a]);
    }
  }, r.prototype.getWeightedSum = function(t, e, i) {
    for (var a = this, s = 0, l = 0; l < t.length; l++)
      s += a.weightedValue(a.getValue(t.charAt(l)), e, l, i);
    return s;
  }, r.prototype.weightedValue = function(t, e, i, a) {
    var s = (e - i) % a || a;
    return s * t;
  }, r.prototype.getValue = function(t) {
    if (isNaN(t))
      t !== this.DASH && this.invalidCharacterError(t);
    else
      return parseInt(t, 10);
    return this.DASH_VALUE;
  }, r.prototype.addCharacter = function(t) {
    var e = this.getValue(t), i = this.characterMap[e];
    this.addPattern(i);
  }, r.prototype.addPattern = function(t) {
    for (var e = this, i, a = 0; a < t.length; a++)
      i = parseInt(t.charAt(a), 10), e.pattern.push(i), e.totalUnits += i;
  }, r;
}($r);
O(Vv, {
  addCheckSum: !0
});
var Nv = Object.assign, Hv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Nv(this, {
      minBaseUnitLength: 0.7
    });
  }, r.prototype.addData = function() {
    var t = this, e = this.value;
    this.addStart();
    for (var i = 0; i < e.length; i++)
      t.addCharacter(e.charAt(i));
    this.options.addCheckSum && this.pushCheckSum(), this.addStop(), this.prepareValues();
  }, r.prototype.addCharacter = function(t) {
    var e = this.characterMap[t];
    e || this.invalidCharacterError(t), this.addBase(e);
  }, r.prototype.addBase = function() {
  }, r;
}($r), Xl = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Nv(this, {
      name: "Code 39",
      checkSumMod: 43,
      minRatio: 2.5,
      maxRatio: 3,
      gapWidth: 1,
      splitCharacter: "|",
      patternMappings: {
        b: "1|",
        w: "1|",
        B: "ratio|",
        W: "ratio|"
      },
      characterMap: {
        0: { pattern: "bwbWBwBwb", value: 0 },
        1: { pattern: "BwbWbwbwB", value: 1 },
        2: { pattern: "bwBWbwbwB", value: 2 },
        3: { pattern: "BwBWbwbwb", value: 3 },
        4: { pattern: "bwbWBwbwB", value: 4 },
        5: { pattern: "BwbWBwbwb", value: 5 },
        6: { pattern: "bwBWBwbwb", value: 6 },
        7: { pattern: "bwbWbwBwB", value: 7 },
        8: { pattern: "BwbWbwBwb", value: 8 },
        9: { pattern: "bwBWbwBwb", value: 9 },
        A: { pattern: "BwbwbWbwB", value: 10 },
        B: { pattern: "bwBwbWbwB", value: 11 },
        C: { pattern: "BwBwbWbwb", value: 12 },
        D: { pattern: "bwbwBWbwB", value: 13 },
        E: { pattern: "BwbwBWbwb", value: 14 },
        F: { pattern: "bwBwBWbwb", value: 15 },
        G: { pattern: "bwbwbWBwB", value: 16 },
        H: { pattern: "BwbwbWBwb", value: 17 },
        I: { pattern: "bwBwbWBwb", value: 18 },
        J: { pattern: "bwbwBWBwb", value: 19 },
        K: { pattern: "BwbwbwbWB", value: 20 },
        L: { pattern: "bwBwbwbWB", value: 21 },
        M: { pattern: "BwBwbwbWb", value: 22 },
        N: { pattern: "bwbwBwbWB", value: 23 },
        O: { pattern: "BwbwBwbWb", value: 24 },
        P: { pattern: "bwBwBwbWb", value: 25 },
        Q: { pattern: "bwbwbwBWB", value: 26 },
        R: { pattern: "BwbwbwBWb", value: 27 },
        S: { pattern: "bwBwbwBWb", value: 28 },
        T: { pattern: "bwbwBwBWb", value: 29 },
        U: { pattern: "BWbwbwbwB", value: 30 },
        V: { pattern: "bWBwbwbwB", value: 31 },
        W: { pattern: "BWBwbwbwb", value: 32 },
        X: { pattern: "bWbwBwbwB", value: 33 },
        Y: { pattern: "BWbwBwbwb", value: 34 },
        Z: { pattern: "bWBwBwbwb", value: 35 },
        "-": { pattern: "bWbwbwBwB", value: 36 },
        ".": { pattern: "BWbwbwBwb", value: 37 },
        " ": { pattern: "bWBwbwBwb", value: 38 },
        $: { pattern: "bWbWbWbwb", value: 39 },
        "/": { pattern: "bWbWbwbWb", value: 40 },
        "+": { pattern: "bWbwbWbWb", value: 41 },
        "%": { pattern: "bwbWbWbWb", value: 42 },
        START: { pattern: "bWbwBwBwb" }
      }
    });
  }, r.prototype.initValue = function(t, e, i) {
    this.width = e, this.height = i, this.value = t, this.dataLength = t.length, this.pattern = [], this.patternString = "";
  }, r.prototype.prepareValues = function() {
    var t = this, e = this.minBaseUnitLength, i = this.minRatio, a = Math.ceil(Math.max(0.15 * this.width, 24)), s, l = this.maxRatio;
    if (this.height < a)
      throw new Error("Insufficient height for Code39 encoding: the current height is " + this.height + "px and the minimum height is " + a + "px.");
    for (s = this.getBaseUnit(l); s < e && l > i; )
      l = parseFloat((l - 0.1).toFixed(1)), s = t.getBaseUnit(l);
    if (s < e) {
      var p = Math.ceil(this.getBaseWidth(i) * e);
      throw new Error("Insufficient width for Code39 encoding: the current width is " + this.width + 'px and the minimum width for value "' + this.value + '" is ' + p + "px.");
    }
    this.ratio = l, this.baseUnit = s, this.patternString = this.patternString.substring(0, this.patternString.length - 1), this.pattern = this.pattern.concat(this.patternString.replace(/ratio/g, l).split(this.splitCharacter));
  }, r.prototype.getBaseUnit = function(t) {
    return this.width / this.getBaseWidth(t);
  }, r.prototype.getBaseWidth = function(t) {
    var e = 3 * (t + 2);
    return this.quietZoneLength + e * (this.dataLength + 2) + this.gapWidth * (this.dataLength + 1);
  }, r.prototype.addStart = function() {
    this.addPattern(this.characterMap.START.pattern), this.addCharacterGap();
  }, r.prototype.addBase = function(t) {
    this.addPattern(t.pattern), this.addCharacterGap();
  }, r.prototype.addStop = function() {
    this.addPattern(this.characterMap.START.pattern);
  }, r.prototype.addPattern = function(t) {
    for (var e = this, i = 0; i < t.length; i++)
      e.patternString += e.patternMappings[t.charAt(i)];
  }, r.prototype.addCharacterGap = function() {
    this.patternString += this.gapWidth + this.splitCharacter;
  }, r;
}(Hv);
O(Xl, {
  addCheckSum: !1
});
var Fv = {
  addCharacter: function(r) {
    this.characterMap[r] ? this.addBase(this.characterMap[r]) : r.charCodeAt(0) > 127 ? this.invalidCharacterError(r) : this.addExtended(r.charCodeAt(0));
  },
  addExtended: function(r) {
    for (var o = this, t, e = 0; e < this.extendedMappings.length; e++)
      if (t = o.extendedMappings[e].call(o, r), t) {
        for (var i = 0; i < t.length; i++) {
          var a = t[i];
          o.addBase(a);
        }
        o.dataLength += t.length - 1;
        return;
      }
  },
  extendedMappings: [
    function(n) {
      if (97 <= n && n <= 122)
        return [this.characterMap[this.shiftCharacters[0]], this.characterMap[String.fromCharCode(n - 32)]];
    },
    function(n) {
      if (33 <= n && n <= 58)
        return [this.characterMap[this.shiftCharacters[1]], this.characterMap[String.fromCharCode(n + 32)]];
    },
    function(n) {
      if (1 <= n && n <= 26)
        return [this.characterMap[this.shiftCharacters[2]], this.characterMap[String.fromCharCode(n + 64)]];
    },
    function(n) {
      var r = this, o, t;
      if (!this.specialAsciiCodes[n])
        t = Math.floor(n / 32) * 6 + (n - 27) % 32 + 64, o = [this.characterMap[this.shiftCharacters[3]], this.characterMap[String.fromCharCode(t)]];
      else {
        o = [];
        for (var e = 0; e < this.specialAsciiCodes[n].length; e++)
          o.push(r.characterMap[r.shiftCharacters[3]]), o.push(r.characterMap[r.specialAsciiCodes[n][e]]);
      }
      return o;
    }
  ],
  specialAsciiCodes: {
    0: ["U"],
    64: ["V"],
    96: ["W"],
    127: ["T", "X", "Y", "Z"]
  },
  shiftValuesAsciiCodes: {
    39: 36,
    40: 47,
    41: 43,
    42: 37
  },
  characterMap: {
    "+": !1,
    "/": !1,
    $: !1,
    "%": !1
  },
  shiftCharacters: ["SHIFT0", "SHIFT1", "SHIFT2", "SHIFT3"]
}, y_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), b(this, Fv, {
      name: "Code 39 extended",
      characterMap: {
        SHIFT0: { pattern: "bWbwbWbWb", value: 41 },
        SHIFT1: { pattern: "bWbWbwbWb", value: 40 },
        SHIFT2: { pattern: "bWbWbWbwb", value: 39 },
        SHIFT3: { pattern: "bwbWbWbWb", value: 42 }
      }
    });
  }, r;
}(Xl), m_ = Object.assign, Uv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), m_(this, {
      name: "Code 93",
      cCheckSumTotal: 20,
      kCheckSumTotal: 15,
      checkSumMod: 47,
      characterMap: {
        0: { pattern: "131112", value: 0 },
        1: { pattern: "111213", value: 1 },
        2: { pattern: "111312", value: 2 },
        3: { pattern: "111411", value: 3 },
        4: { pattern: "121113", value: 4 },
        5: { pattern: "121212", value: 5 },
        6: { pattern: "121311", value: 6 },
        7: { pattern: "111114", value: 7 },
        8: { pattern: "131211", value: 8 },
        9: { pattern: "141111", value: 9 },
        A: { pattern: "211113", value: 10 },
        B: { pattern: "211212", value: 11 },
        C: { pattern: "211311", value: 12 },
        D: { pattern: "221112", value: 13 },
        E: { pattern: "221211", value: 14 },
        F: { pattern: "231111", value: 15 },
        G: { pattern: "112113", value: 16 },
        H: { pattern: "112212", value: 17 },
        I: { pattern: "112311", value: 18 },
        J: { pattern: "122112", value: 19 },
        K: { pattern: "132111", value: 20 },
        L: { pattern: "111123", value: 21 },
        M: { pattern: "111222", value: 22 },
        N: { pattern: "111321", value: 23 },
        O: { pattern: "121122", value: 24 },
        P: { pattern: "131121", value: 25 },
        Q: { pattern: "212112", value: 26 },
        R: { pattern: "212211", value: 27 },
        S: { pattern: "211122", value: 28 },
        T: { pattern: "211221", value: 29 },
        U: { pattern: "221121", value: 30 },
        V: { pattern: "222111", value: 31 },
        W: { pattern: "112122", value: 32 },
        X: { pattern: "112221", value: 33 },
        Y: { pattern: "122121", value: 34 },
        Z: { pattern: "123111", value: 35 },
        "-": { pattern: "121131", value: 36 },
        ".": { pattern: "311112", value: 37 },
        " ": { pattern: "311211", value: 38 },
        $: { pattern: "321111", value: 39 },
        "/": { pattern: "112131", value: 40 },
        "+": { pattern: "113121", value: 41 },
        "%": { pattern: "211131", value: 42 },
        SHIFT0: { pattern: "122211", value: 46 },
        SHIFT1: { pattern: "311121", value: 45 },
        SHIFT2: { pattern: "121221", value: 43 },
        SHIFT3: { pattern: "312111", value: 44 },
        START: { pattern: "111141" },
        TERMINATION_BAR: "1"
      }
    });
  }, r.prototype.initValue = function(t, e, i) {
    this.value = t, this.width = e, this.height = i, this.pattern = [], this.values = [], this.dataLength = t.length;
  }, r.prototype.prepareValues = function() {
    var t = Math.ceil(Math.max(0.15 * this.width, 24));
    if (this.height < t)
      throw new Error("Insufficient height for Code93 encoding: the current height is " + this.height + "px, the minimum required height is " + t + "px.");
    if (this.setBaseUnit(), this.baseUnit < this.minBaseUnitLength) {
      var e = Math.ceil(this.minBaseUnitLength * (this.width / this.baseUnit));
      throw new Error("Insufficient width for Code93 encoding: the current width is " + this.width + 'px and the minimum required width for value "' + this.value + '" is ' + e + "px.");
    }
  }, r.prototype.setBaseUnit = function() {
    var t = 2;
    this.baseUnit = this.width / (9 * (this.dataLength + 2 + t) + this.quietZoneLength + 1);
  }, r.prototype.addStart = function() {
    var t = this.characterMap.START.pattern;
    this.addPattern(t);
  }, r.prototype.addStop = function() {
    this.addStart(), this.pattern.push(this.characterMap.TERMINATION_BAR);
  }, r.prototype.addBase = function(t) {
    this.addPattern(t.pattern), this.values.push(t.value);
  }, r.prototype.pushCheckSum = function() {
    var t = this, e = this._getCheckValues(), i;
    this.checksum = e.join("");
    for (var a = 0; a < e.length; a++)
      i = t.characterMap[t._findCharacterByValue(e[a])], t.addPattern(i.pattern);
  }, r.prototype._getCheckValues = function() {
    var t = this, e = this.values, i = e.length, a = 0, s, l, p;
    for (p = i - 1; p >= 0; p--)
      a += t.weightedValue(e[p], i - p, t.cCheckSumTotal);
    for (s = a % this.checkSumMod, a = this.weightedValue(s, 1, this.kCheckSumTotal), p = i - 1; p >= 0; p--)
      a += t.weightedValue(e[p], i - p + 1, t.kCheckSumTotal);
    return l = a % this.checkSumMod, [s, l];
  }, r.prototype._findCharacterByValue = function(t) {
    var e = this;
    for (var i in e.characterMap)
      if (e.characterMap[i].value === t)
        return i;
  }, r.prototype.weightedValue = function(t, e, i) {
    return (e % i || i) * t;
  }, r.prototype.addPattern = function(t) {
    for (var e = this, i, a = 0; a < t.length; a++)
      i = parseInt(t.charAt(a), 10), e.pattern.push(i);
  }, r;
}(Hv), __ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), b(this, Fv, {
      name: "Code 93 extended",
      pushCheckSum: function() {
        var t = this, e = this._getCheckValues(), i;
        this.checksum = e.join("");
        for (var a = 0; a < e.length; a++)
          if (i = e[a], t.shiftValuesAsciiCodes[i])
            t.addExtended(t.shiftValuesAsciiCodes[i]);
          else {
            var s = t._findCharacterByValue(i);
            t.addPattern(t.characterMap[s].pattern);
          }
      }
    });
  }, r;
}(Uv), x_ = /^\d+$/, w_ = Object.assign, b_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), w_(this, {
      name: "Postnet",
      START: "2",
      VALID_CODE_LENGTHS: [5, 9, 11],
      DIGIT_SEPARATOR: "-",
      characterMap: ["22111", "11122", "11212", "11221", "12112", "12121", "12211", "21112", "21121", "21211"]
    });
  }, r.prototype.initValue = function(t, e, i) {
    this.height = i, this.width = e, this.baseHeight = i / 2, this.value = t.replace(new RegExp(this.DIGIT_SEPARATOR, "g"), ""), this.pattern = [], this.validate(this.value), this.checkSum = 0, this.setBaseUnit();
  }, r.prototype.addData = function() {
    var t = this, e = this.value;
    this.addPattern(this.START);
    for (var i = 0; i < e.length; i++)
      t.addCharacter(e.charAt(i));
    this.options.addCheckSum && this.addCheckSum(), this.addPattern(this.START), this.pattern.pop();
  }, r.prototype.addCharacter = function(t) {
    var e = this.characterMap[t];
    this.checkSum += parseInt(t, 10), this.addPattern(e);
  }, r.prototype.addCheckSum = function() {
    this.checksum = (10 - this.checkSum % 10) % 10, this.addCharacter(this.checksum);
  }, r.prototype.setBaseUnit = function() {
    var t = 3;
    this.baseUnit = this.width / ((this.value.length + 1) * 10 + t + this.quietZoneLength);
  }, r.prototype.validate = function(t) {
    if (x_.test(t) || this.invalidCharacterError(t.match(/[^0-9]/)[0]), !Z(t.length, this.VALID_CODE_LENGTHS))
      throw new Error("Invalid value length. Valid lengths for the Postnet symbology are " + this.VALID_CODE_LENGTHS.join(",") + ".");
  }, r.prototype.addPattern = function(t) {
    for (var e = this, i, a = 0; a < t.length; a++)
      i = e.height - e.baseHeight * t.charAt(a), e.pattern.push({ width: 1, y1: i, y2: e.height }), e.pattern.push(1);
  }, r;
}($r), us = /^\d+$/, A_ = /^[a-z0-9]+$/i, we = Object.assign, ha = function(n) {
  function r(o) {
    n.call(this), this.encoding = o, this.initProperties();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
  }, r.prototype.addStart = function() {
  }, r.prototype.is = function() {
  }, r.prototype.isCode = function() {
    return !1;
  }, r.prototype.move = function() {
  }, r.prototype.pushState = function() {
  }, r;
}(N), $v = function(n) {
  function r(o, t) {
    n.call(this, o), this.states = t, this._initMoves(t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), b(this, {
      FNC4: "FNC4",
      SHIFT: 98
    });
  }, r.prototype.addStart = function() {
    this.encoding.addPattern(this.START);
  }, r.prototype.is = function(t, e) {
    var i = t.charCodeAt(e);
    return this.isCode(i);
  }, r.prototype.move = function(t) {
    for (var e = 0; !this._moves[e].call(this, t) && e < this._moves.length; )
      e++;
  }, r.prototype.pushState = function(t) {
    var e = this, i = this.states, a = t.value, s = a.length, l;
    if (Z("C", i)) {
      var p = a.substr(t.index).match(/\d{4,}/g);
      p && (s = a.indexOf(p[0], t.index));
    }
    for (; (l = t.value.charCodeAt(t.index)) >= 0 && this.isCode(l) && t.index < s; )
      e.encoding.addPattern(e.getValue(l)), t.index++;
  }, r.prototype._initMoves = function(t) {
    this._moves = [], Z(this.FNC4, t) && this._moves.push(this._moveFNC), Z(this.shiftKey, t) && this._moves.push(this._shiftState), this._moves.push(this._moveState);
  }, r.prototype._moveFNC = function(t) {
    if (t.fnc)
      return t.fnc = !1, t.previousState === this.key;
  }, r.prototype._shiftState = function(t) {
    if (t.previousState === this.shiftKey && (t.index + 1 >= t.value.length || this.encoding[this.shiftKey].is(t.value, t.index + 1)))
      return this.encoding.addPattern(this.SHIFT), t.shifted = !0, !0;
  }, r.prototype._moveState = function() {
    return this.encoding.addPattern(this.MOVE), !0;
  }, r;
}(ha), ki = {};
ki.A = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      key: "A",
      shiftKey: "B",
      MOVE: 101,
      START: 103
    });
  }, r.prototype.isCode = function(t) {
    return 0 <= t && t < 96;
  }, r.prototype.getValue = function(t) {
    return t < 32 ? t + 64 : t - 32;
  }, r;
}($v);
ki.B = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      key: "B",
      shiftKey: "A",
      MOVE: 100,
      START: 104
    });
  }, r.prototype.isCode = function(t) {
    return 32 <= t && t < 128;
  }, r.prototype.getValue = function(t) {
    return t - 32;
  }, r;
}($v);
ki.C = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      key: "C",
      MOVE: 99,
      START: 105
    });
  }, r.prototype.addStart = function() {
    this.encoding.addPattern(this.START);
  }, r.prototype.is = function(t, e) {
    var i = vs(t, e, 4);
    return (e + 4 <= t.length || t.length === 2) && us.test(i);
  }, r.prototype.move = function() {
    this.encoding.addPattern(this.MOVE);
  }, r.prototype.pushState = function(t) {
    for (var e = this, i; (i = vs(t.value, t.index, 2)) && us.test(i) && i.length === 2; )
      e.encoding.addPattern(parseInt(i, 10)), t.index += 2;
  }, r.prototype.getValue = function(t) {
    return t;
  }, r;
}(ha);
ki.FNC4 = function(n) {
  function r(o, t) {
    n.call(this, o), this._initSubStates(t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      key: "FNC4",
      dependentStates: ["A", "B"]
    });
  }, r.prototype.addStart = function(t) {
    var e = t.value.charCodeAt(0) - 128, i = this._getSubState(e);
    this.encoding[i].addStart();
  }, r.prototype.is = function(t, e) {
    var i = t.charCodeAt(e);
    return this.isCode(i);
  }, r.prototype.isCode = function(t) {
    return 128 <= t && t < 256;
  }, r.prototype.pushState = function(t) {
    var e = this, i = this._initSubState(t), a = this.encoding, s = i.value.length, l;
    if (t.index += s, s < 3)
      for (; i.index < s; i.index++)
        l = i.value.charCodeAt(i.index), i.state = e._getSubState(l), i.previousState !== i.state && (i.previousState = i.state, a[i.state].move(i)), a.addPattern(a[i.state].MOVE), a.addPattern(a[i.state].getValue(l));
    else
      i.state !== i.previousState && a[i.state].move(i), this._pushStart(i), a.pushData(i, this.subStates), t.index < t.value.length && this._pushStart(i);
    t.fnc = !0, t.state = i.state;
  }, r.prototype._pushStart = function(t) {
    this.encoding.addPattern(this.encoding[t.state].MOVE), this.encoding.addPattern(this.encoding[t.state].MOVE);
  }, r.prototype._initSubState = function(t) {
    var e = {
      value: this._getAll(t.value, t.index),
      index: 0
    };
    return e.state = this._getSubState(e.value.charCodeAt(0)), e.previousState = t.previousState === this.key ? e.state : t.previousState, e;
  }, r.prototype._initSubStates = function(t) {
    var e = this;
    this.subStates = [];
    for (var i = 0; i < t.length; i++)
      Z(t[i], e.dependentStates) && e.subStates.push(t[i]);
  }, r.prototype._getSubState = function(t) {
    for (var e = this, i = 0; i < this.subStates.length; i++)
      if (e.encoding[e.subStates[i]].isCode(t))
        return e.subStates[i];
  }, r.prototype._getAll = function(t, e) {
    for (var i, a = "", s = e; (i = t.charCodeAt(s++)) && this.isCode(i); )
      a += String.fromCharCode(i - 128);
    return a;
  }, r;
}(ha);
ki.FNC1 = function(n) {
  function r(o, t) {
    n.call(this, o), this.states = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      key: "FNC1",
      startState: "C",
      startAI: "(",
      endAI: ")",
      dependentStates: ["C", "B"],
      applicationIdentifiers: {
        22: { max: 29, type: "alphanumeric" },
        402: { length: 17 },
        7004: { max: 4, type: "alphanumeric" },
        242: { max: 6, type: "alphanumeric" },
        8020: { max: 25, type: "alphanumeric" },
        703: { min: 3, max: 30, type: "alphanumeric" },
        8008: { min: 8, max: 12, type: "alphanumeric" },
        253: { min: 13, max: 17, type: "alphanumeric" },
        8003: { min: 14, max: 30, type: "alphanumeric" },
        multiKey: [{
          ids: ["15", "17", "8005", "8100"],
          ranges: [
            [11, 13],
            [310, 316],
            [320, 336],
            [340, 369]
          ],
          type: { length: 6 }
        }, {
          ids: ["240", "241", "250", "251", "400", "401", "403", "7002", "8004", "8007", "8110"],
          ranges: [[90 - 99]],
          type: { max: 30, type: "alphanumeric" }
        }, {
          ids: ["7001"],
          ranges: [[410, 414]],
          type: { length: 13 }
        }, {
          ids: ["10", "21", "254", "420", "8002"],
          type: { max: 20, type: "alphanumeric" }
        }, {
          ids: ["00", "8006", "8017", "8018"],
          type: { length: 18 }
        }, {
          ids: ["01", "02", "8001"],
          type: { length: 14 }
        }, {
          ids: ["422"],
          ranges: [
            [424, 426]
          ],
          type: { length: 3 }
        }, {
          ids: ["20", "8102"],
          type: { length: 2 }
        }, {
          ids: ["30", "37"],
          type: { max: 8, type: "alphanumeric" }
        }, {
          ids: ["390", "392"],
          type: { max: 15, type: "alphanumeric" }
        }, {
          ids: ["421", "423"],
          type: { min: 3, max: 15, type: "alphanumeric" }
        }, {
          ids: ["391", "393"],
          type: { min: 3, max: 18, type: "alphanumeric" }
        }, {
          ids: ["7003", "8101"],
          type: { length: 10 }
        }]
      },
      START: 102
    });
  }, r.prototype.addStart = function() {
    this.encoding[this.startState].addStart();
  }, r.prototype.is = function() {
    return Z(this.key, this.states);
  }, r.prototype.pushState = function(t) {
    var e = this, i = this.encoding, a = t.value.replace(/\s/g, ""), s = new RegExp("[" + this.startAI + this.endAI + "]", "g"), l = t.index, p = {
      state: this.startState
    }, h, c, u;
    i.addPattern(this.START);
    for (var v = !0; v; ) {
      if (p.index = 0, u = a.charAt(l) === e.startAI ? 2 : 0, h = u > 0 ? e.getBySeparator(a, l) : e.getByLength(a, l), h.ai.length)
        c = l + u + h.id.length + h.ai.length;
      else if (c = a.indexOf(e.startAI, l + 1), c < 0) {
        if (l + h.ai.max + h.id.length + u < a.length)
          throw new Error("Separators are required after variable length identifiers");
        c = a.length;
      }
      if (p.value = a.substring(l, c).replace(s, ""), e.validate(h, p.value), i.pushData(p, e.dependentStates), c >= a.length)
        break;
      l = c, p.state !== e.startState && (i[e.startState].move(p), p.state = e.startState), h.ai.length || i.addPattern(e.START);
    }
    t.index = t.value.length;
  }, r.prototype.validate = function(t, e) {
    var i = e.substr(t.id.length), a = t.ai;
    if (!a.type && !us.test(i))
      throw new Error("Application identifier " + t.id + " is numeric only but contains non numeric character(s).");
    if (a.type === "alphanumeric" && !A_.test(i))
      throw new Error("Application identifier " + t.id + " is alphanumeric only but contains non alphanumeric character(s).");
    if (a.length && a.length !== i.length)
      throw new Error("Application identifier " + t.id + " must be " + a.length + " characters long.");
    if (a.min && a.min > i.length)
      throw new Error("Application identifier " + t.id + " must be at least " + a.min + " characters long.");
    if (a.max && a.max < i.length)
      throw new Error("Application identifier " + t.id + " must be at most " + a.max + " characters long.");
  }, r.prototype.getByLength = function(t, e) {
    for (var i = this, a, s, l = 2; l <= 4; l++)
      if (a = vs(t, e, l), s = i.getApplicationIdentifier(a) || i.getApplicationIdentifier(a.substring(0, a.length - 1)), s)
        return {
          id: a,
          ai: s
        };
    this.unsupportedAIError(a);
  }, r.prototype.unsupportedAIError = function(t) {
    throw new Error("'" + t + "' is not a supported Application Identifier");
  }, r.prototype.getBySeparator = function(t, e) {
    var i = t.indexOf(this.startAI, e), a = t.indexOf(this.endAI, i), s = t.substring(i + 1, a), l = this.getApplicationIdentifier(s) || this.getApplicationIdentifier(s.substr(s.length - 1));
    return l || this.unsupportedAIError(s), {
      ai: l,
      id: s
    };
  }, r.prototype.getApplicationIdentifier = function(t) {
    var e = this.applicationIdentifiers, i = e.multiKey;
    if (e[t])
      return e[t];
    for (var a = 0; a < i.length; a++) {
      if (i[a].ids && Z(t, i[a].ids))
        return i[a].type;
      if (i[a].ranges) {
        for (var s = i[a].ranges, l = 0; l < s.length; l++)
          if (s[l][0] <= t && t <= s[l][1])
            return i[a].type;
      }
    }
  }, r;
}(ha);
var Io = function(n) {
  function r(o) {
    n.call(this, o), this._initStates();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      characterMap: [
        212222,
        222122,
        222221,
        121223,
        121322,
        131222,
        122213,
        122312,
        132212,
        221213,
        221312,
        231212,
        112232,
        122132,
        122231,
        113222,
        123122,
        123221,
        223211,
        221132,
        221231,
        213212,
        223112,
        312131,
        311222,
        321122,
        321221,
        312212,
        322112,
        322211,
        212123,
        212321,
        232121,
        111323,
        131123,
        131321,
        112313,
        132113,
        132311,
        211313,
        231113,
        231311,
        112133,
        112331,
        132131,
        113123,
        113321,
        133121,
        313121,
        211331,
        231131,
        213113,
        213311,
        213131,
        311123,
        311321,
        331121,
        312113,
        312311,
        332111,
        314111,
        221411,
        431111,
        111224,
        111422,
        121124,
        121421,
        141122,
        141221,
        112214,
        112412,
        122114,
        122411,
        142112,
        142211,
        241211,
        221114,
        413111,
        241112,
        134111,
        111242,
        121142,
        121241,
        114212,
        124112,
        124211,
        411212,
        421112,
        421211,
        212141,
        214121,
        412121,
        111143,
        111341,
        131141,
        114113,
        114311,
        411113,
        411311,
        113141,
        114131,
        311141,
        411131,
        211412,
        211214,
        211232,
        2331112
      ],
      STOP: 106
    });
  }, r.prototype._initStates = function() {
    for (var t = this, e = 0; e < this.states.length; e++)
      t[t.states[e]] = new ki[t.states[e]](t, t.states);
  }, r.prototype.initValue = function(t, e, i) {
    this.pattern = [], this.value = t, this.width = e, this.height = i, this.checkSum = 0, this.totalUnits = 0, this.index = 0, this.position = 1;
  }, r.prototype.addData = function() {
    var t = {
      value: this.value,
      index: 0,
      state: ""
    };
    this.value.length !== 0 && (t.state = t.previousState = this.getNextState(t, this.states), this.addStart(t), this.pushData(t, this.states), this.addCheckSum(), this.addStop(), this.setBaseUnit());
  }, r.prototype.pushData = function(t, e) {
    for (var i = this, a = !0; a && (i[t.state].pushState(t), !(t.index >= t.value.length)); )
      if (!t.shifted)
        t.previousState = t.state, t.state = i.getNextState(t, e), i[t.state].move(t);
      else {
        var s = t.state;
        t.state = t.previousState, t.previousState = s, t.shifted = !1;
      }
  }, r.prototype.addStart = function(t) {
    this[t.state].addStart(t), this.position = 1;
  }, r.prototype.addCheckSum = function() {
    this.checksum = this.checkSum % 103, this.addPattern(this.checksum);
  }, r.prototype.addStop = function() {
    this.addPattern(this.STOP);
  }, r.prototype.setBaseUnit = function() {
    this.baseUnit = this.width / (this.totalUnits + this.quietZoneLength);
  }, r.prototype.addPattern = function(t) {
    for (var e = this, i = this.characterMap[t].toString(), a, s = 0; s < i.length; s++)
      a = parseInt(i.charAt(s), 10), e.pattern.push(a), e.totalUnits += a;
    this.checkSum += t * this.position++;
  }, r.prototype.getNextState = function(t, e) {
    for (var i = this, a = 0; a < e.length; a++)
      if (i[e[a]].is(t.value, t.index))
        return e[a];
    this.invalidCharacterError(t.value.charAt(t.index));
  }, r;
}($r), S_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      name: "Code 128 A",
      states: ["A"]
    });
  }, r;
}(Io), T_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      name: "Code 128 B",
      states: ["B"]
    });
  }, r;
}(Io), C_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      name: "Code 128 C",
      states: ["C"]
    });
  }, r;
}(Io), k_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      name: "Code 128",
      states: ["C", "B", "A", "FNC4"]
    });
  }, r;
}(Io), P_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), we(this, {
      name: "Code GS1-128",
      states: ["FNC1", "C", "B"]
    });
  }, r;
}(Io);
function vs(n, r, o) {
  return n.substring(r, r + o);
}
var Do = Object.assign, ca = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Do(this, {
      characterMap: [
        "12121212",
        "12121221",
        "12122112",
        "12122121",
        "12211212",
        "12211221",
        "12212112",
        "12212121",
        "21121212",
        "21121221"
      ],
      START: "21",
      STOP: "121",
      checkSumType: "",
      checkSums: L_
    });
  }, r.prototype.initValue = function(t, e) {
    this.pattern = [], this.value = t, this.checkSumLength = 0, this.width = e;
  }, r.prototype.setBaseUnit = function() {
    var t = 7;
    this.baseUnit = this.width / (12 * (this.value.length + this.checkSumLength) + this.quietZoneLength + t);
  }, r.prototype.addData = function() {
    var t = this, e = this.value;
    this.addPattern(this.START);
    for (var i = 0; i < e.length; i++)
      t.addCharacter(e.charAt(i));
    this.options.addCheckSum && this.addCheckSum(), this.addPattern(this.STOP), this.setBaseUnit();
  }, r.prototype.addCharacter = function(t) {
    var e = this.characterMap[t];
    e || this.invalidCharacterError(t), this.addPattern(e);
  }, r.prototype.addPattern = function(t) {
    for (var e = this, i = 0; i < t.length; i++)
      e.pattern.push(parseInt(t.charAt(i), 10));
  }, r.prototype.addCheckSum = function() {
    var t = this, e = this.checkSums[this.checkSumType], i = e.call(this.checkSums, this.value);
    this.checksum = i.join("");
    for (var a = 0; a < i.length; a++)
      t.checkSumLength++, t.addPattern(t.characterMap[i[a]]);
  }, r;
}($r), O_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Do(this, {
      name: "MSI Modulo10",
      checkSumType: "Modulo10"
    });
  }, r;
}(ca), E_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Do(this, {
      name: "MSI Modulo11",
      checkSumType: "Modulo11"
    });
  }, r;
}(ca), M_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Do(this, {
      name: "MSI Modulo10 Modulo10",
      checkSumType: "Modulo10Modulo10"
    });
  }, r;
}(ca), R_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Do(this, {
      name: "MSI Modulo11 Modulo10",
      checkSumType: "Modulo11Modulo10"
    });
  }, r;
}(ca), L_ = {
  Modulo10: function(r) {
    var o = [0, ""], t = r.length % 2, e, i, a;
    for (e = 0; e < r.length; e++)
      o[(e + t) % 2] += parseInt(r.charAt(e), 10);
    for (a = o[0], i = (o[1] * 2).toString(), e = 0; e < i.length; e++)
      a += parseInt(i.charAt(e), 10);
    return [(10 - a % 10) % 10];
  },
  Modulo11: function(r) {
    for (var o = 0, t = 11, e = r.length, i, a, s = 0; s < e; s++)
      i = ((e - s) % 6 || 6) + 1, o += i * r.charAt(s);
    return a = (t - o % t) % t, a !== 10 ? [a] : [1, 0];
  },
  Modulo11Modulo10: function(r) {
    var o = this.Modulo11(r), t;
    return t = r + o[0], o.concat(this.Modulo10(t));
  },
  Modulo10Modulo10: function(r) {
    var o = this.Modulo10(r), t;
    return t = r + o[0], o.concat(this.Modulo10(t));
  }
}, I_ = Object.assign, Gv = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), I_(this, {
      name: "EAN 13",
      keyTable: [
        "000000",
        "001011",
        "001101",
        "001110",
        "010011",
        "011001",
        "011100",
        "010101",
        "010110",
        "011010"
      ],
      characterMap: {
        digits: [
          [3, 2, 1, 1],
          [2, 2, 2, 1],
          [2, 1, 2, 2],
          [1, 4, 1, 1],
          [1, 1, 3, 2],
          [1, 2, 3, 1],
          [1, 1, 1, 4],
          [1, 3, 1, 2],
          [1, 2, 1, 3],
          [3, 1, 1, 2]
        ],
        start: [1, 1, 1],
        middle: [1, 1, 1, 1, 1]
      }
    });
  }, r.prototype.initValue = function(t, e, i) {
    var a = String(t);
    if (a.length !== 12 || /\D/.test(a))
      throw new Error('The value of the "EAN13" encoding should be 12 symbols');
    this.pattern = [], this.options.height = i, this.baseUnit = e / (95 + this.quietZoneLength), this.value = a, this.checksum = this.calculateChecksum(), this.leftKey = a[0], this.leftPart = a.substr(1, 6), this.rightPart = a.substr(7) + this.checksum;
  }, r.prototype.addData = function() {
    this.addPieces(this.characterMap.start), this.addSide(this.leftPart, this.leftKey), this.addPieces(this.characterMap.middle), this.addSide(this.rightPart), this.addPieces(this.characterMap.start);
  }, r.prototype.addSide = function(t, e) {
    for (var i = this, a = 0; a < t.length; a++)
      e && parseInt(i.keyTable[e].charAt(a), 10) ? i.addPieces(Array.prototype.slice.call(i.characterMap.digits[t.charAt(a)]).reverse(), !0) : i.addPieces(i.characterMap.digits[t.charAt(a)], !0);
  }, r.prototype.addPieces = function(t, e) {
    for (var i = this, a = 0; a < t.length; a++)
      e ? i.pattern.push({
        y1: 0,
        y2: i.options.height * 0.95,
        width: t[a]
      }) : i.pattern.push(t[a]);
  }, r.prototype.calculateChecksum = function() {
    for (var t = 0, e = 0, i = this.value.split("").reverse().join(""), a = 0; a < i.length; a++)
      a % 2 ? e += parseInt(i.charAt(a), 10) : t += parseInt(i.charAt(a), 10);
    var s = (10 - (3 * t + e) % 10) % 10;
    return s;
  }, r;
}($r), D_ = Object.assign, B_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), D_(this, {
      name: "EAN 8"
    });
  }, r.prototype.initValue = function(t, e, i) {
    if (t.length !== 7 || /\D/.test(t))
      throw new Error("Invalid value provided");
    this.value = t, this.options.height = i, this.checksum = this.calculateChecksum(this.value), this.leftPart = this.value.substr(0, 4), this.rightPart = this.value.substr(4) + this.checksum, this.pattern = [], this.baseUnit = e / (67 + this.quietZoneLength);
  }, r;
}(Gv), Ie = {
  code11: Vv,
  code39: Xl,
  code39extended: y_,
  code93: Uv,
  code93extended: __,
  code128: k_,
  code128a: S_,
  code128b: T_,
  code128c: C_
};
Ie["gs1-128"] = P_;
Ie.msimod10 = O_;
Ie.msimod11 = E_;
Ie.msimod1010 = M_;
Ie.msimod1110 = R_;
Ie.postnet = b_;
Ie.ean8 = B_;
Ie.ean13 = Gv;
function Wv(n, r) {
  var o = n.style.display;
  r === "canvas" && (n.style.display = "block");
  var t = {
    width: n.clientWidth,
    height: n.clientHeight
  };
  return n.style.display = o, t;
}
var z_ = 300, j_ = 100, V_ = function(n) {
  function r(o, t, e) {
    e === void 0 && (e = hu), n.call(this), this.options = b({}, this.options, t), this.element = o, this.onError = e, this._initElement(), this._initSurface(), this._setOptions(t), t && P(t.value) && this.redraw();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this._destroySurface();
  }, r.prototype._initElement = function() {
    mt(this.element, "k-barcode");
  }, r.prototype._initSurface = function() {
    var t = this, e = t.options, i = t.surface;
    (!i || i.options.type !== e.renderAs) && (this._destroySurface(), this._initSurfaceElement(), this.surface = this._createSurface());
  }, r.prototype._createSurface = function() {
    return co.create(this.surfaceElement, {
      type: this.options.renderAs
    });
  }, r.prototype._destroySurface = function() {
    this.surface && (this.surface.destroy(), this.surface = null, this._destroySurfaceElement());
  }, r.prototype._initSurfaceElement = function() {
    this.surfaceElement || (this.surfaceElement = document.createElement("div"), this.surfaceElement.style.position = "relative", this.element.appendChild(this.surfaceElement));
  }, r.prototype._destroySurfaceElement = function() {
    this.surfaceElement && this.surfaceElement.parentNode && (this.surfaceElement.parentNode.removeChild(this.surfaceElement), this.surfaceElement = null);
  }, r.prototype.setOptions = function(t) {
    this._setOptions(t), this._initSurface(), this.redraw();
  }, r.prototype.redraw = function() {
    var t = this._getSize();
    this.surface.clear(), this.surface.setSize({
      width: t.width,
      height: t.height
    }), this.createVisual(), this.surface.draw(this.visual);
  }, r.prototype.getSize = function() {
    return {
      width: this.element.offsetWidth,
      height: this.element.offsetHeight
    };
  }, r.prototype._resize = function() {
    this.redraw();
  }, r.prototype.createVisual = function() {
    this.visual = this._render();
  }, r.prototype._render = function() {
    var t = this.options, e = t.value, i = t.text, a = ot(i.margin), s = this._getSize(), l = t.border || {}, p = this.encoding, h = new L(0, 0, s.width, s.height).unpad(l.width).unpad(t.padding), c = h.height(), u, v, f, d = new pt();
    this.contentBox = h, d.append(this._getBackground(s)), i.visible && (f = $c(e, { font: i.font }).height, c -= f + a.top + a.bottom);
    try {
      u = p.encode(e, h.width(), c);
    } catch (m) {
      return this.onError(m), d;
    }
    return i.visible && (v = e, t.checksum && P(p.checksum) && (v += " " + p.checksum), d.append(this._getText(v))), this.barHeight = c, this._bandsGroup = this._getBands(u.pattern, u.baseUnit), d.append(this._bandsGroup), d;
  }, r.prototype.exportVisual = function() {
    return this._render();
  }, r.prototype._getSize = function() {
    var t = this.element, e = Wv(t, this.options.renderAs), i = new Us(z_, j_);
    return e.width > 0 && (i.width = e.width), e.height > 0 && (i.height = e.height), this.options.width && (i.width = this.options.width), this.options.height && (i.height = this.options.height), i;
  }, r.prototype.value = function(t) {
    if (!P(t))
      return this.options.value;
    this.options.value = String(t), this.redraw();
  }, r.prototype._getBands = function(t, e) {
    for (var i = this, a = this.contentBox, s = a.x1, l, p, h = new pt(), c = 0; c < t.length; c++) {
      if (p = le(t[c]) ? t[c] : {
        width: t[c],
        y1: 0,
        y2: i.barHeight
      }, l = p.width * e, c % 2) {
        var u = Pt.fromPoints(
          new q(s, p.y1 + a.y1),
          new q(s + l, p.y2 + a.y1)
        ), v = H.fromRect(u, {
          fill: {
            color: i.options.color
          },
          stroke: null
        });
        h.append(v);
      }
      s += l;
    }
    return h;
  }, r.prototype._getBackground = function(t) {
    var e = this.options, i = e.border || {}, a = new L(0, 0, t.width, t.height).unpad(i.width / 2), s = H.fromRect(a.toRect(), {
      fill: {
        color: e.background
      },
      stroke: {
        color: i.width ? i.color : "",
        width: i.width,
        dashType: i.dashType
      }
    });
    return s;
  }, r.prototype._getText = function(t) {
    var e = this.options.text, i = this._textbox = new Qt(t, {
      font: e.font,
      color: e.color,
      align: "center",
      vAlign: "bottom",
      margin: e.margin
    });
    return i.reflow(this.contentBox), i.renderVisual(), i.visual;
  }, r.prototype._setOptions = function(t) {
    if (this.type = (t.type || this.options.type).toLowerCase(), this.type === "upca" && (this.type = "ean13", t.value = "0" + t.value), this.type === "upce" && (this.type = "ean8", t.value = "0" + t.value), !Ie[this.type])
      throw new Error("Encoding '" + this.type + "' is not supported.");
    this.encoding = new Ie[this.type](), this.options = b({}, this.options, t);
  }, r;
}(N);
O(V_, {
  name: "Barcode",
  renderAs: "svg",
  value: "",
  type: "code39",
  checksum: !1,
  width: 0,
  height: 0,
  color: "black",
  background: "white",
  text: {
    visible: !0,
    font: "16px Consolas, Monaco, Sans Mono, monospace, sans-serif",
    color: "black",
    margin: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    }
  },
  border: {
    width: 0,
    dashType: "solid",
    color: "black"
  },
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
});
var Pi = Object.assign;
function Xv(n, r) {
  for (var o = [], t = 0; t < n.length; )
    o.push(n.substring(t, t + r)), t += r;
  return o;
}
function $t(n, r) {
  var o = Number(n).toString(2);
  return o.length < r && (o = new Array(r - o.length + 1).join(0) + o), o;
}
function In(n) {
  return parseInt(n, 2);
}
var N_ = function(n) {
  function r(o) {
    n.call(this), this.matrix = o, this.row = o.length - 1, this.column = o.length - 1, this.startColumn = this.column, this.dir = -1, this.c = 0;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.move = function() {
    this.row += this.dir * this.c, this.c ^= 1, this.column = this.startColumn - this.c;
  }, r.prototype.getNextCell = function() {
    for (var t = this; this.matrix[this.row][this.column] !== void 0; )
      t.move(), (t.row < 0 || t.row >= t.matrix.length) && (t.dir = -t.dir, t.startColumn -= t.startColumn !== 8 ? 2 : 3, t.column = t.startColumn, t.row = t.dir < 0 ? t.matrix.length - 1 : 0);
    return {
      row: this.row,
      column: this.column
    };
  }, r.prototype.getNextRemainderCell = function() {
    if (this.move(), this.matrix[this.row][this.column] === void 0)
      return {
        row: this.row,
        column: this.column
      };
  }, r;
}(N), Yv = function(n) {
  function r(o, t) {
    n.call(this), this.dataString = o, this.version = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(N), H_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.getEncodingResult = function(t, e) {
    var i = Sx(t), a = Tx(i), s = Zv(a, e), l = Cx(i, s);
    return new Yv(l, s);
  }, r;
}(N), Yl = function(n) {
  function r() {
    n.call(this), this.initProperties();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    Pi(this, {
      modeIndicator: "",
      bitsInCharacterCount: []
    });
  }, r.prototype.getVersionIndex = function(t) {
    return t < 10 ? 0 : t > 26 ? 2 : 1;
  }, r.prototype.getBitsCharacterCount = function(t) {
    return this.bitsInCharacterCount[this.getVersionIndex(t || 40)];
  }, r.prototype.getModeCountString = function(t, e) {
    return this.modeIndicator + $t(t, this.getBitsCharacterCount(e));
  }, r.prototype.encode = function() {
  }, r.prototype.getStringBitsLength = function() {
  }, r.prototype.getValue = function() {
  }, r;
}(N), F_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Pi(this, {
      bitsInCharacterCount: [10, 12, 14],
      modeIndicator: "0001"
    });
  }, r.prototype.getValue = function(t) {
    return parseInt(t, 10);
  }, r.prototype.encode = function(t, e) {
    var i = this, a = Xv(t, 3), s = i.getModeCountString(t.length, e), l;
    for (l = 0; l < a.length - 1; l++)
      s += $t(a[l], 10);
    return s + $t(a[l], 1 + 3 * a[l].length);
  }, r.prototype.getStringBitsLength = function(t, e) {
    var i = t % 3;
    return 4 + this.getBitsCharacterCount(e) + 10 * Math.floor(t / 3) + 3 * i + (i === 0 ? 0 : 1);
  }, r;
}(Yl), U_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Pi(this, {
      characters: {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        A: 10,
        B: 11,
        C: 12,
        D: 13,
        E: 14,
        F: 15,
        G: 16,
        H: 17,
        I: 18,
        J: 19,
        K: 20,
        L: 21,
        M: 22,
        N: 23,
        O: 24,
        P: 25,
        Q: 26,
        R: 27,
        S: 28,
        T: 29,
        U: 30,
        V: 31,
        W: 32,
        X: 33,
        Y: 34,
        Z: 35,
        " ": 36,
        $: 37,
        "%": 38,
        "*": 39,
        "+": 40,
        "-": 41,
        ".": 42,
        "/": 43,
        ":": 44
      },
      bitsInCharacterCount: [9, 11, 13],
      modeIndicator: "0010"
    });
  }, r.prototype.getValue = function(t) {
    return this.characters[t];
  }, r.prototype.encode = function(t, e) {
    var i = this, a = Xv(t, 2), s = this.getModeCountString(t.length, e), l, p;
    for (p = 0; p < a.length - 1; p++)
      l = 45 * i.getValue(a[p].charAt(0)) + i.getValue(a[p].charAt(1)), s += $t(l, 11);
    return l = a[p].length === 2 ? 45 * this.getValue(a[p].charAt(0)) + this.getValue(a[p].charAt(1)) : this.getValue(a[p].charAt(0)), s + $t(l, 1 + 5 * a[p].length);
  }, r.prototype.getStringBitsLength = function(t, e) {
    return 4 + this.getBitsCharacterCount(e) + 11 * Math.floor(t / 2) + 6 * (t % 2);
  }, r;
}(Yl), $_ = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), Pi(this, {
      bitsInCharacterCount: [8, 16, 16],
      modeIndicator: "0100"
    });
  }, r.prototype.getValue = function(t) {
    var e = t.charCodeAt(0);
    if (e <= 127 || 160 <= e && e <= 255)
      return e;
    throw new Error('Unsupported character in QR Code: "' + t + '".');
  }, r.prototype.encode = function(t, e) {
    for (var i = this, a = i.getModeCountString(t.length, e), s = 0; s < t.length; s++)
      a += $t(i.getValue(t.charAt(s)), 8);
    return a;
  }, r.prototype.getStringBitsLength = function(t, e) {
    return 4 + this.getBitsCharacterCount(e) + 8 * t;
  }, r;
}(Yl), G_ = "numeric", W_ = "alphanumeric", X_ = "byte", Oi = {};
Oi[G_] = new F_();
Oi[W_] = new U_();
Oi[X_] = new $_();
var Y_ = "byte", q_ = function(n) {
  function r() {
    n.call(this), this.initProperties(), this.mode = Oi[this.encodingMode];
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    Pi(this, {
      encodingMode: Y_,
      utfBOM: "111011111011101110111111",
      initialModeCountStringLength: 20,
      ranges: [128, 2048, 65536, 2097152, 67108864]
    });
  }, r.prototype.getEncodingResult = function(t, e) {
    var i = this.encode(t), a = this.getDataCodewordsCount(i), s = Zv(a, e), l = this.mode.getModeCountString(i.length / 8, s) + i;
    return new Yv(l, s);
  }, r.prototype.getDataCodewordsCount = function(t) {
    var e = t.length, i = Math.ceil((this.initialModeCountStringLength + e) / 8);
    return i;
  }, r.prototype.encode = function(t) {
    for (var e = this, i = this.utfBOM, a = 0; a < t.length; a++)
      i += e.encodeCharacter(t.charCodeAt(a));
    return i;
  }, r.prototype.encodeCharacter = function(t) {
    var e = this.getBytesCount(t), i = e - 1, a = "";
    if (e === 1)
      a = $t(t, 8);
    else {
      for (var s = 8 - e, l = 0; l < i; l++)
        a = $t(t >> l * 6 & 63 | 128, 8) + a;
      a = (t >> i * 6 | 255 >> s << s).toString(2) + a;
    }
    return a;
  }, r.prototype.getBytesCount = function(t) {
    for (var e = this.ranges, i = 0; i < e.length; i++)
      if (t < e[i])
        return i + 1;
  }, r;
}(N), Zi = [{
  L: {
    groups: [
      [1, 19]
    ],
    totalDataCodewords: 19,
    errorCodewordsPerBlock: 7
  },
  M: {
    groups: [
      [1, 16]
    ],
    totalDataCodewords: 16,
    errorCodewordsPerBlock: 10
  },
  Q: {
    groups: [
      [1, 13]
    ],
    totalDataCodewords: 13,
    errorCodewordsPerBlock: 13
  },
  H: {
    groups: [
      [1, 9]
    ],
    totalDataCodewords: 9,
    errorCodewordsPerBlock: 17
  }
}, {
  L: {
    groups: [
      [1, 34]
    ],
    totalDataCodewords: 34,
    errorCodewordsPerBlock: 10
  },
  M: {
    groups: [
      [1, 28]
    ],
    totalDataCodewords: 28,
    errorCodewordsPerBlock: 16
  },
  Q: {
    groups: [
      [1, 22]
    ],
    totalDataCodewords: 22,
    errorCodewordsPerBlock: 22
  },
  H: {
    groups: [
      [1, 16]
    ],
    totalDataCodewords: 16,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [1, 55]
    ],
    totalDataCodewords: 55,
    errorCodewordsPerBlock: 15
  },
  M: {
    groups: [
      [1, 44]
    ],
    totalDataCodewords: 44,
    errorCodewordsPerBlock: 26
  },
  Q: {
    groups: [
      [2, 17]
    ],
    totalDataCodewords: 34,
    errorCodewordsPerBlock: 18
  },
  H: {
    groups: [
      [2, 13]
    ],
    totalDataCodewords: 26,
    errorCodewordsPerBlock: 22
  }
}, {
  L: {
    groups: [
      [1, 80]
    ],
    totalDataCodewords: 80,
    errorCodewordsPerBlock: 20
  },
  M: {
    groups: [
      [2, 32]
    ],
    totalDataCodewords: 64,
    errorCodewordsPerBlock: 18
  },
  Q: {
    groups: [
      [2, 24]
    ],
    totalDataCodewords: 48,
    errorCodewordsPerBlock: 26
  },
  H: {
    groups: [
      [4, 9]
    ],
    totalDataCodewords: 36,
    errorCodewordsPerBlock: 16
  }
}, {
  L: {
    groups: [
      [1, 108]
    ],
    totalDataCodewords: 108,
    errorCodewordsPerBlock: 26
  },
  M: {
    groups: [
      [2, 43]
    ],
    totalDataCodewords: 86,
    errorCodewordsPerBlock: 24
  },
  Q: {
    groups: [
      [2, 15],
      [2, 16]
    ],
    totalDataCodewords: 62,
    errorCodewordsPerBlock: 18
  },
  H: {
    groups: [
      [2, 11],
      [2, 12]
    ],
    totalDataCodewords: 46,
    errorCodewordsPerBlock: 22
  }
}, {
  L: {
    groups: [
      [2, 68]
    ],
    totalDataCodewords: 136,
    errorCodewordsPerBlock: 18
  },
  M: {
    groups: [
      [4, 27]
    ],
    totalDataCodewords: 108,
    errorCodewordsPerBlock: 16
  },
  Q: {
    groups: [
      [4, 19]
    ],
    totalDataCodewords: 76,
    errorCodewordsPerBlock: 24
  },
  H: {
    groups: [
      [4, 15]
    ],
    totalDataCodewords: 60,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [2, 78]
    ],
    totalDataCodewords: 156,
    errorCodewordsPerBlock: 20
  },
  M: {
    groups: [
      [4, 31]
    ],
    totalDataCodewords: 124,
    errorCodewordsPerBlock: 18
  },
  Q: {
    groups: [
      [2, 14],
      [4, 15]
    ],
    totalDataCodewords: 88,
    errorCodewordsPerBlock: 18
  },
  H: {
    groups: [
      [4, 13],
      [1, 14]
    ],
    totalDataCodewords: 66,
    errorCodewordsPerBlock: 26
  }
}, {
  L: {
    groups: [
      [2, 97]
    ],
    totalDataCodewords: 194,
    errorCodewordsPerBlock: 24
  },
  M: {
    groups: [
      [2, 38],
      [2, 39]
    ],
    totalDataCodewords: 154,
    errorCodewordsPerBlock: 22
  },
  Q: {
    groups: [
      [4, 18],
      [2, 19]
    ],
    totalDataCodewords: 110,
    errorCodewordsPerBlock: 22
  },
  H: {
    groups: [
      [4, 14],
      [2, 15]
    ],
    totalDataCodewords: 86,
    errorCodewordsPerBlock: 26
  }
}, {
  L: {
    groups: [
      [2, 116]
    ],
    totalDataCodewords: 232,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [3, 36],
      [2, 37]
    ],
    totalDataCodewords: 182,
    errorCodewordsPerBlock: 22
  },
  Q: {
    groups: [
      [4, 16],
      [4, 17]
    ],
    totalDataCodewords: 132,
    errorCodewordsPerBlock: 20
  },
  H: {
    groups: [
      [4, 12],
      [4, 13]
    ],
    totalDataCodewords: 100,
    errorCodewordsPerBlock: 24
  }
}, {
  L: {
    groups: [
      [2, 68],
      [2, 69]
    ],
    totalDataCodewords: 274,
    errorCodewordsPerBlock: 18
  },
  M: {
    groups: [
      [4, 43],
      [1, 44]
    ],
    totalDataCodewords: 216,
    errorCodewordsPerBlock: 26
  },
  Q: {
    groups: [
      [6, 19],
      [2, 20]
    ],
    totalDataCodewords: 154,
    errorCodewordsPerBlock: 24
  },
  H: {
    groups: [
      [6, 15],
      [2, 16]
    ],
    totalDataCodewords: 122,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [4, 81]
    ],
    totalDataCodewords: 324,
    errorCodewordsPerBlock: 20
  },
  M: {
    groups: [
      [1, 50],
      [4, 51]
    ],
    totalDataCodewords: 254,
    errorCodewordsPerBlock: 30
  },
  Q: {
    groups: [
      [4, 22],
      [4, 23]
    ],
    totalDataCodewords: 180,
    errorCodewordsPerBlock: 28
  },
  H: {
    groups: [
      [3, 12],
      [8, 13]
    ],
    totalDataCodewords: 140,
    errorCodewordsPerBlock: 24
  }
}, {
  L: {
    groups: [
      [2, 92],
      [2, 93]
    ],
    totalDataCodewords: 370,
    errorCodewordsPerBlock: 24
  },
  M: {
    groups: [
      [6, 36],
      [2, 37]
    ],
    totalDataCodewords: 290,
    errorCodewordsPerBlock: 22
  },
  Q: {
    groups: [
      [4, 20],
      [6, 21]
    ],
    totalDataCodewords: 206,
    errorCodewordsPerBlock: 26
  },
  H: {
    groups: [
      [7, 14],
      [4, 15]
    ],
    totalDataCodewords: 158,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [4, 107]
    ],
    totalDataCodewords: 428,
    errorCodewordsPerBlock: 26
  },
  M: {
    groups: [
      [8, 37],
      [1, 38]
    ],
    totalDataCodewords: 334,
    errorCodewordsPerBlock: 22
  },
  Q: {
    groups: [
      [8, 20],
      [4, 21]
    ],
    totalDataCodewords: 244,
    errorCodewordsPerBlock: 24
  },
  H: {
    groups: [
      [12, 11],
      [4, 12]
    ],
    totalDataCodewords: 180,
    errorCodewordsPerBlock: 22
  }
}, {
  L: {
    groups: [
      [3, 115],
      [1, 116]
    ],
    totalDataCodewords: 461,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [4, 40],
      [5, 41]
    ],
    totalDataCodewords: 365,
    errorCodewordsPerBlock: 24
  },
  Q: {
    groups: [
      [11, 16],
      [5, 17]
    ],
    totalDataCodewords: 261,
    errorCodewordsPerBlock: 20
  },
  H: {
    groups: [
      [11, 12],
      [5, 13]
    ],
    totalDataCodewords: 197,
    errorCodewordsPerBlock: 24
  }
}, {
  L: {
    groups: [
      [5, 87],
      [1, 88]
    ],
    totalDataCodewords: 523,
    errorCodewordsPerBlock: 22
  },
  M: {
    groups: [
      [5, 41],
      [5, 42]
    ],
    totalDataCodewords: 415,
    errorCodewordsPerBlock: 24
  },
  Q: {
    groups: [
      [5, 24],
      [7, 25]
    ],
    totalDataCodewords: 295,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [11, 12],
      [7, 13]
    ],
    totalDataCodewords: 223,
    errorCodewordsPerBlock: 24
  }
}, {
  L: {
    groups: [
      [5, 98],
      [1, 99]
    ],
    totalDataCodewords: 589,
    errorCodewordsPerBlock: 24
  },
  M: {
    groups: [
      [7, 45],
      [3, 46]
    ],
    totalDataCodewords: 453,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [15, 19],
      [2, 20]
    ],
    totalDataCodewords: 325,
    errorCodewordsPerBlock: 24
  },
  H: {
    groups: [
      [3, 15],
      [13, 16]
    ],
    totalDataCodewords: 253,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [1, 107],
      [5, 108]
    ],
    totalDataCodewords: 647,
    errorCodewordsPerBlock: 28
  },
  M: {
    groups: [
      [10, 46],
      [1, 47]
    ],
    totalDataCodewords: 507,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [1, 22],
      [15, 23]
    ],
    totalDataCodewords: 367,
    errorCodewordsPerBlock: 28
  },
  H: {
    groups: [
      [2, 14],
      [17, 15]
    ],
    totalDataCodewords: 283,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [5, 120],
      [1, 121]
    ],
    totalDataCodewords: 721,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [9, 43],
      [4, 44]
    ],
    totalDataCodewords: 563,
    errorCodewordsPerBlock: 26
  },
  Q: {
    groups: [
      [17, 22],
      [1, 23]
    ],
    totalDataCodewords: 397,
    errorCodewordsPerBlock: 28
  },
  H: {
    groups: [
      [2, 14],
      [19, 15]
    ],
    totalDataCodewords: 313,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [3, 113],
      [4, 114]
    ],
    totalDataCodewords: 795,
    errorCodewordsPerBlock: 28
  },
  M: {
    groups: [
      [3, 44],
      [11, 45]
    ],
    totalDataCodewords: 627,
    errorCodewordsPerBlock: 26
  },
  Q: {
    groups: [
      [17, 21],
      [4, 22]
    ],
    totalDataCodewords: 445,
    errorCodewordsPerBlock: 26
  },
  H: {
    groups: [
      [9, 13],
      [16, 14]
    ],
    totalDataCodewords: 341,
    errorCodewordsPerBlock: 26
  }
}, {
  L: {
    groups: [
      [3, 107],
      [5, 108]
    ],
    totalDataCodewords: 861,
    errorCodewordsPerBlock: 28
  },
  M: {
    groups: [
      [3, 41],
      [13, 42]
    ],
    totalDataCodewords: 669,
    errorCodewordsPerBlock: 26
  },
  Q: {
    groups: [
      [15, 24],
      [5, 25]
    ],
    totalDataCodewords: 485,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [15, 15],
      [10, 16]
    ],
    totalDataCodewords: 385,
    errorCodewordsPerBlock: 28
  }
}, {
  L: {
    groups: [
      [4, 116],
      [4, 117]
    ],
    totalDataCodewords: 932,
    errorCodewordsPerBlock: 28
  },
  M: {
    groups: [
      [17, 42]
    ],
    totalDataCodewords: 714,
    errorCodewordsPerBlock: 26
  },
  Q: {
    groups: [
      [17, 22],
      [6, 23]
    ],
    totalDataCodewords: 512,
    errorCodewordsPerBlock: 28
  },
  H: {
    groups: [
      [19, 16],
      [6, 17]
    ],
    totalDataCodewords: 406,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [2, 111],
      [7, 112]
    ],
    totalDataCodewords: 1006,
    errorCodewordsPerBlock: 28
  },
  M: {
    groups: [
      [17, 46]
    ],
    totalDataCodewords: 782,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [7, 24],
      [16, 25]
    ],
    totalDataCodewords: 568,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [34, 13]
    ],
    totalDataCodewords: 442,
    errorCodewordsPerBlock: 24
  }
}, {
  L: {
    groups: [
      [4, 121],
      [5, 122]
    ],
    totalDataCodewords: 1094,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [4, 47],
      [14, 48]
    ],
    totalDataCodewords: 860,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [11, 24],
      [14, 25]
    ],
    totalDataCodewords: 614,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [16, 15],
      [14, 16]
    ],
    totalDataCodewords: 464,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [6, 117],
      [4, 118]
    ],
    totalDataCodewords: 1174,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [6, 45],
      [14, 46]
    ],
    totalDataCodewords: 914,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [11, 24],
      [16, 25]
    ],
    totalDataCodewords: 664,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [30, 16],
      [2, 17]
    ],
    totalDataCodewords: 514,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [8, 106],
      [4, 107]
    ],
    totalDataCodewords: 1276,
    errorCodewordsPerBlock: 26
  },
  M: {
    groups: [
      [8, 47],
      [13, 48]
    ],
    totalDataCodewords: 1e3,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [7, 24],
      [22, 25]
    ],
    totalDataCodewords: 718,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [22, 15],
      [13, 16]
    ],
    totalDataCodewords: 538,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [10, 114],
      [2, 115]
    ],
    totalDataCodewords: 1370,
    errorCodewordsPerBlock: 28
  },
  M: {
    groups: [
      [19, 46],
      [4, 47]
    ],
    totalDataCodewords: 1062,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [28, 22],
      [6, 23]
    ],
    totalDataCodewords: 754,
    errorCodewordsPerBlock: 28
  },
  H: {
    groups: [
      [33, 16],
      [4, 17]
    ],
    totalDataCodewords: 596,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [8, 122],
      [4, 123]
    ],
    totalDataCodewords: 1468,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [22, 45],
      [3, 46]
    ],
    totalDataCodewords: 1128,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [8, 23],
      [26, 24]
    ],
    totalDataCodewords: 808,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [12, 15],
      [28, 16]
    ],
    totalDataCodewords: 628,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [3, 117],
      [10, 118]
    ],
    totalDataCodewords: 1531,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [3, 45],
      [23, 46]
    ],
    totalDataCodewords: 1193,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [4, 24],
      [31, 25]
    ],
    totalDataCodewords: 871,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [11, 15],
      [31, 16]
    ],
    totalDataCodewords: 661,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [7, 116],
      [7, 117]
    ],
    totalDataCodewords: 1631,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [21, 45],
      [7, 46]
    ],
    totalDataCodewords: 1267,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [1, 23],
      [37, 24]
    ],
    totalDataCodewords: 911,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [19, 15],
      [26, 16]
    ],
    totalDataCodewords: 701,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [5, 115],
      [10, 116]
    ],
    totalDataCodewords: 1735,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [19, 47],
      [10, 48]
    ],
    totalDataCodewords: 1373,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [15, 24],
      [25, 25]
    ],
    totalDataCodewords: 985,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [23, 15],
      [25, 16]
    ],
    totalDataCodewords: 745,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [13, 115],
      [3, 116]
    ],
    totalDataCodewords: 1843,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [2, 46],
      [29, 47]
    ],
    totalDataCodewords: 1455,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [42, 24],
      [1, 25]
    ],
    totalDataCodewords: 1033,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [23, 15],
      [28, 16]
    ],
    totalDataCodewords: 793,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [17, 115]
    ],
    totalDataCodewords: 1955,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [10, 46],
      [23, 47]
    ],
    totalDataCodewords: 1541,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [10, 24],
      [35, 25]
    ],
    totalDataCodewords: 1115,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [19, 15],
      [35, 16]
    ],
    totalDataCodewords: 845,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [17, 115],
      [1, 116]
    ],
    totalDataCodewords: 2071,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [14, 46],
      [21, 47]
    ],
    totalDataCodewords: 1631,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [29, 24],
      [19, 25]
    ],
    totalDataCodewords: 1171,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [11, 15],
      [46, 16]
    ],
    totalDataCodewords: 901,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [13, 115],
      [6, 116]
    ],
    totalDataCodewords: 2191,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [14, 46],
      [23, 47]
    ],
    totalDataCodewords: 1725,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [44, 24],
      [7, 25]
    ],
    totalDataCodewords: 1231,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [59, 16],
      [1, 17]
    ],
    totalDataCodewords: 961,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [12, 121],
      [7, 122]
    ],
    totalDataCodewords: 2306,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [12, 47],
      [26, 48]
    ],
    totalDataCodewords: 1812,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [39, 24],
      [14, 25]
    ],
    totalDataCodewords: 1286,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [22, 15],
      [41, 16]
    ],
    totalDataCodewords: 986,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [6, 121],
      [14, 122]
    ],
    totalDataCodewords: 2434,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [6, 47],
      [34, 48]
    ],
    totalDataCodewords: 1914,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [46, 24],
      [10, 25]
    ],
    totalDataCodewords: 1354,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [2, 15],
      [64, 16]
    ],
    totalDataCodewords: 1054,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [17, 122],
      [4, 123]
    ],
    totalDataCodewords: 2566,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [29, 46],
      [14, 47]
    ],
    totalDataCodewords: 1992,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [49, 24],
      [10, 25]
    ],
    totalDataCodewords: 1426,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [24, 15],
      [46, 16]
    ],
    totalDataCodewords: 1096,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [4, 122],
      [18, 123]
    ],
    totalDataCodewords: 2702,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [13, 46],
      [32, 47]
    ],
    totalDataCodewords: 2102,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [48, 24],
      [14, 25]
    ],
    totalDataCodewords: 1502,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [42, 15],
      [32, 16]
    ],
    totalDataCodewords: 1142,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [20, 117],
      [4, 118]
    ],
    totalDataCodewords: 2812,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [40, 47],
      [7, 48]
    ],
    totalDataCodewords: 2216,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [43, 24],
      [22, 25]
    ],
    totalDataCodewords: 1582,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [10, 15],
      [67, 16]
    ],
    totalDataCodewords: 1222,
    errorCodewordsPerBlock: 30
  }
}, {
  L: {
    groups: [
      [19, 118],
      [6, 119]
    ],
    totalDataCodewords: 2956,
    errorCodewordsPerBlock: 30
  },
  M: {
    groups: [
      [18, 47],
      [31, 48]
    ],
    totalDataCodewords: 2334,
    errorCodewordsPerBlock: 28
  },
  Q: {
    groups: [
      [34, 24],
      [34, 25]
    ],
    totalDataCodewords: 1666,
    errorCodewordsPerBlock: 30
  },
  H: {
    groups: [
      [20, 15],
      [61, 16]
    ],
    totalDataCodewords: 1276,
    errorCodewordsPerBlock: 30
  }
}], kh = "0000", Z_ = "numeric", Ph = "alphanumeric", Q_ = "byte", ql = { 1: 0 }, dr = { 0: 1 }, K_ = {
  15: 20,
  16: 20,
  18: 24,
  19: 24,
  22: 20,
  24: 22,
  26: 24,
  28: 20,
  30: 20,
  31: 24,
  32: 28,
  33: 24,
  36: 18,
  37: 22,
  39: 20,
  40: 24
}, Fa = [1, 0, 1, 1, 1], J_ = [1, 0, 1], tx = { L: "01", M: "00", Q: "11", H: "10" }, ex = "101010000010010", rx = "10100110111", ix = "1111100100101", ox = ["11101100", "00010001"], nx = 93, fs = [
  function(n, r) {
    return (n + r) % 2 === 0;
  },
  function(n, r) {
    return n % 2 === 0;
  },
  function(n, r) {
    return r % 3 === 0;
  },
  function(n, r) {
    return (n + r) % 3 === 0;
  },
  function(n, r) {
    return (Math.floor(n / 2) + Math.floor(r / 3)) % 2 === 0;
  },
  function(n, r) {
    return n * r % 2 + n * r % 3 === 0;
  },
  function(n, r) {
    return (n * r % 2 + n * r % 3) % 2 === 0;
  },
  function(n, r) {
    return ((n + r) % 2 + n * r % 3) % 2 === 0;
  }
], ax = /^\d+/, qv = "A-Z0-9 $%*+./:-", sx = "A-Z $%*+./:-", lx = new RegExp("^[" + sx + "]+"), Oh = new RegExp("^[" + qv + "]+"), Eh = new RegExp("^[^" + qv + "]+"), px = 8, hx = 5, cx = 8, ux = 17, vx = 9, fx = 16, ds = [[1, 0], [1, 25, 0]];
function Vt(n, r, o, t) {
  for (var e = 0; e < n.length; e++)
    n[e][o][t] = r;
}
function Mh(n, r, o, t) {
  for (var e = 0; e < fs.length; e++)
    n[e][o][t] = fs[e](o, t) ? r ^ 1 : parseInt(r, 10);
}
function dx(n, r) {
  for (var o = new N_(n[0]), t, e, i, a = 0; a < r.length; a++)
    for (t = r[a], e = 0; t.length > 0; ) {
      for (var s = 0; s < t.length; s++)
        for (var l = 0; l < 8; l++)
          i = o.getNextCell(), Mh(n, t[s][e].charAt(l), i.row, i.column);
      for (e++; t[0] && e === t[0].length; )
        t.splice(0, 1);
    }
  for (; i = o.getNextRemainderCell(); )
    Mh(n, 0, i.row, i.column);
}
function gx(n, r) {
  for (var o = r * 8, t = 0, e = 0, i = n; i.length < o && t < kh.length; )
    i += kh.charAt(t++);
  for (i.length % 8 !== 0 && (i += new Array(9 - i.length % 8).join("0")); i.length < o; )
    i += ox[e], e ^= 1;
  return i;
}
function yx() {
  var n, r;
  for (r = 1; r < 255; r++)
    n = dr[r - 1] * 2, n > 255 && (n = n ^ 285), dr[r] = n, ql[n] = r;
  n = dr[r - 1] * 2 ^ 285, dr[r] = n, dr[-1] = 0;
}
function mx(n, r) {
  for (var o = [], t = n.length - 2, e = t; e >= 0; e--)
    o[e] = n[e] ^ r[e];
  return o;
}
function _x(n, r) {
  for (var o = [], t = 0; t < n.length; t++)
    for (var e = 0; e < r.length; e++)
      o[t + e] === void 0 ? o[t + e] = (n[t] + (r[e] >= 0 ? r[e] : 0)) % 255 : o[t + e] = ql[dr[o[t + e]] ^ dr[(n[t] + r[e]) % 255]];
  return o;
}
function xx() {
  for (var n = 68, r = 2; r <= n; r++) {
    var o = ds[r - 1], t = [r, 0];
    ds[r] = _x(o, t);
  }
}
yx();
xx();
function wx(n, r) {
  var o = [], t = n.length - 1;
  do
    o[t] = dr[(n[t] + r) % 255], t--;
  while (n[t] !== void 0);
  return o;
}
function bx(n, r) {
  var o = ds[r - 1], t = new Array(r).concat(n), e = new Array(t.length - o.length).concat(o), i = n.length, a = [], s, l;
  for (l = 0; l < i; l++)
    s = wx(e, ql[t[t.length - 1]]), e.splice(0, 1), t = mx(s, t);
  for (l = t.length - 1; l >= 0; l--)
    a[r - 1 - l] = $t(t[l], 8);
  return a;
}
function Ax(n, r) {
  for (var o = 0, t = [], e = [], i, a = r.groups, s, l, p, h, c = 0; c < a.length; c++) {
    l = a[c][0];
    for (var u = 0; u < l; u++) {
      s = a[c][1], i = [], p = [];
      for (var v = 1; v <= s; v++)
        h = n.substring(o, o + 8), i.push(h), p[s - v] = In(h), o += 8;
      t.push(i), e.push(bx(
        p,
        r.errorCodewordsPerBlock
      ));
    }
  }
  return [t, e];
}
function Rh(n, r, o, t, e) {
  var i = ax.exec(n), a = i ? i[0] : "", s = lx.exec(n), l = s ? s[0] : "", p = Oh.exec(n), h = p ? p[0] : "", c, u;
  return a && (a.length >= r || n.length === a.length || a.length >= o && !Oh.test(n.charAt(a.length))) ? (c = Z_, u = a) : h && (n.length === h.length || h.length >= t || e === Ph) ? (c = Ph, u = a || l) : (c = Q_, h ? u = h + Eh.exec(n.substring(h.length))[0] : u = Eh.exec(n)[0]), {
    mode: c,
    modeString: u
  };
}
function Sx(n) {
  var r = [], o, t = 0, e = n;
  for (r.push(Rh(e, px, hx, cx, o)), o = r[0].mode, e = e.substr(r[0].modeString.length); e.length > 0; ) {
    var i = Rh(e, ux, vx, fx, o);
    i.mode !== o ? (o = i.mode, r.push(i), t++) : r[t].modeString += i.modeString, e = e.substr(i.modeString.length);
  }
  return r;
}
function Tx(n) {
  for (var r = 0, o, t = 0; t < n.length; t++)
    o = Oi[n[t].mode], r += o.getStringBitsLength(n[t].modeString.length);
  return Math.ceil(r / 8);
}
function Zv(n, r) {
  var o = 0, t = Zi.length - 1, e = Math.floor(Zi.length / 2);
  do
    n < Zi[e][r].totalDataCodewords ? t = e : o = e, e = o + Math.floor((t - o) / 2);
  while (t - o > 1);
  return n <= Zi[o][r].totalDataCodewords ? e + 1 : t + 1;
}
function Cx(n, r) {
  for (var o = "", t, e = 0; e < n.length; e++)
    t = Oi[n[e].mode], o += t.encode(n[e].modeString, r);
  return o;
}
function kx(n) {
  var r = In(n), o, t = "";
  if (r === 0)
    return "101010000010010";
  o = Qv(In(n), rx, 15);
  for (var e = 0; e < o.length; e++)
    t += o.charAt(e) ^ ex.charAt(e);
  return t;
}
function Qv(n, r, o) {
  var t = In(r), e = r.length - 1, i = n << e, a = o - e, s = $t(n, a), l = Px(i, t);
  return l = s + $t(l, e), l;
}
function Px(n, r) {
  var o = r.toString(2).length, t = n.toString(2).length, e = n;
  do
    e ^= r << t - o, t = e.toString(2).length;
  while (t >= o);
  return e;
}
function Qi(n, r) {
  return parseInt(n.charAt(r), 10);
}
function Ox(n) {
  for (var r = [], o = 17 + 4 * n, t = 0; t < fs.length; t++) {
    r[t] = new Array(o);
    for (var e = 0; e < o; e++)
      r[t][e] = new Array(o);
  }
  return r;
}
function Lh(n, r) {
  var o = n[0], t, e, i = 0, a = r.length;
  for (t = 0, e = 8; t <= 8; t++)
    t !== 6 && Vt(n, Qi(r, a - 1 - i++), t, e);
  for (t = 8, e = 7; e >= 0; e--)
    e !== 6 && Vt(n, Qi(r, a - 1 - i++), t, e);
  for (i = 0, e = o.length - 1, t = 8; e >= o.length - 8; e--)
    Vt(n, Qi(r, a - 1 - i++), t, e);
  for (Vt(n, 1, o.length - 8, 8), t = o.length - 7, e = 8; t < o.length; t++)
    Vt(n, Qi(r, a - 1 - i++), t, e);
}
function Ex(n) {
  return Qv(n, ix, 18);
}
function Ih(n, r) {
  for (var o = n[0], t = o.length, e = 0, i = t - 11, a = t - 11, s = 0, l, p, h, c = 0; c < r.length; c++)
    l = Math.floor(c / 3), p = c % 3, h = Qi(r, r.length - c - 1), Vt(n, h, e + l, i + p), Vt(n, h, a + p, s + l);
}
function cn(n, r, o, t) {
  for (var e = r.length + 2, i = r.length + 1, a, s = 0; s < r.length; s++)
    for (var l = s; l < e - s; l++)
      a = r[s], Vt(n, a, o + l, t + s), Vt(n, a, o + s, t + l), Vt(n, a, o + i - l, t + i - s), Vt(n, a, o + i - s, t + i - l);
}
function Ua(n, r, o, t) {
  var e = o, i = t, a = n[0];
  do
    Vt(n, 0, e, t), Vt(n, 0, o, i), e += r[0], i += r[1];
  while (e >= 0 && e < a.length);
}
function Mx(n) {
  var r = n[0].length;
  cn(n, Fa, 0, 0), Ua(n, [-1, -1], 7, 7), cn(n, Fa, r - 7, 0), Ua(n, [1, -1], r - 8, 7), cn(n, Fa, 0, r - 7), Ua(n, [-1, 1], 7, r - 8);
}
function Rx(n, r) {
  if (!(r < 2)) {
    var o = n[0], t = o.length, e = Math.floor(r / 7), i = [6], a, s, l = 0;
    for ((a = K_[r]) ? s = (t - 13 - a) / e : a = s = (t - 13) / (e + 1), i.push(i[l++] + a); i[l] + s < t; )
      i.push(i[l++] + s);
    for (var p = 0; p < i.length; p++)
      for (var h = 0; h < i.length; h++)
        o[i[p]][i[h]] === void 0 && cn(n, J_, i[p] - 2, i[h] - 2);
  }
}
function Lx(n) {
  for (var r = 6, o = 6, t = 1, e = n[0].length, i = 8; i < e - 8; i++)
    Vt(n, t, r, i), Vt(n, t, i, o), t ^= 1;
}
function Ix(n) {
  var r = [], o = [], t = [], e = [], i = [], a, s, l = 0, p = 1, h = n[0].length;
  for (s = 0; s < n.length; s++)
    r[s] = 0, t[s] = 0, i[s] = [0, 0], e[s] = [0, 0], o[s] = [];
  for (var c = 0; c < h; c++)
    for (var u = 0; u < h; u++)
      for (var v = 0; v < n.length; v++)
        a = n[v], t[v] += parseInt(a[c][u], 10), o[v][l] === a[c][u] && c + 1 < h && u - 1 >= 0 && a[c + 1][u] === o[v][l] && a[c + 1][u - 1] === o[v][l] && (r[v] += 3), Dh(v, e, r, l, a[c][u]), Dh(v, e, r, p, a[u][c]), Bh(v, r, o, a[c][u], i, l), Bh(v, r, o, a[u][c], i, p);
  var f = h * h, d, m = Number.MAX_VALUE;
  for (s = 0; s < r.length; s++)
    r[s] += Dx(t[s], f), r[s] < m && (m = r[s], d = s);
  return d;
}
function Dh(n, r, o, t, e) {
  r[n][t] = (r[n][t] << 1 ^ e) % 128, r[n][t] === nx && (o[n] += 40);
}
function Bh(n, r, o, t, e, i) {
  o[n][i] === t ? e[n][i]++ : (o[n][i] = t, e[n][i] >= 5 && (r[n] += 3 + e[n][i] - 5), e[n][i] = 1);
}
function Dx(n, r) {
  var o = Math.floor(n / r * 100), t = o % 5, e = Math.abs(o - t - 50), i = Math.abs(o + 5 - t - 50), a = 10 * Math.min(e / 5, i / 5);
  return a;
}
function Bx(n) {
  return n && n.toLowerCase().indexOf("utf_8") >= 0 ? new q_() : new H_();
}
function zx(n, r, o) {
  var t = Bx(o), e = t.getEncodingResult(n, r), i = e.version, a = Zi[i - 1][r], s = gx(e.dataString, a.totalDataCodewords), l = Ax(s, a), p = Ox(i);
  Mx(p), Rx(p, i), Lx(p), i >= 7 && Ih(p, $t(0, 18)), Lh(p, $t(0, 15)), dx(p, l);
  var h = Ix(p), c = p[h];
  i >= 7 && Ih([c], Ex(i));
  var u = tx[r] + $t(h, 3);
  return Lh([c], kx(u)), c;
}
var Ui = Math.round, jx = [[0, 1], [1, 1], [1, 2], [2, 2], [2, 1], [3, 1], [3, 0], [2, 0], [2, -1], [1, -1], [1, 0]], zh = [[0, 1], [1, 1], [1, 0]], Xe = {
  DEFAULT_SIZE: 200,
  QUIET_ZONE_LENGTH: 4,
  DEFAULT_ERROR_CORRECTION_LEVEL: "L",
  DEFAULT_BACKGROUND: "#fff",
  DEFAULT_DARK_MODULE_COLOR: "#000",
  MIN_BASE_UNIT_SIZE: 1,
  DEFAULT_LOGO_SIZE: 7
}, Vx = function(n) {
  function r(o, t, e) {
    e === void 0 && (e = hu), n.call(this), this.options = b({}, this.options, t), this.element = o, this.wrapper = this.element, this.onError = e, this._initElement(), this._initSurface(), this.setOptions(t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this._destroySurface();
  }, r.prototype._initElement = function() {
    mt(this.element, "k-qrcode");
  }, r.prototype._initSurface = function() {
    var t = this, e = t.options, i = t.surface;
    (!i || i.options.type !== e.renderAs) && (this._destroySurface(), this._initSurfaceElement(), this.surface = this._createSurface());
  }, r.prototype._createSurface = function() {
    return co.create(this.surfaceElement, {
      type: this.options.renderAs
    });
  }, r.prototype._destroySurface = function() {
    this.surface && (this.surface.destroy(), this.surface = null, this._destroySurfaceElement());
  }, r.prototype._initSurfaceElement = function() {
    this.surfaceElement || (this.surfaceElement = document.createElement("div"), this.surfaceElement.style.position = "relative", this.element.appendChild(this.surfaceElement));
  }, r.prototype._destroySurfaceElement = function() {
    this.surfaceElement && this.surfaceElement.parentNode && (this.surfaceElement.parentNode.removeChild(this.surfaceElement), this.surfaceElement = null);
  }, r.prototype.redraw = function() {
    var t = this._getSize();
    this.surface.clear(), this.surface.setSize({
      width: t,
      height: t
    }), this.createVisual(), this.surface.draw(this.visual);
  }, r.prototype.getSize = function() {
    var t = this.element, e = t.clientWidth, i = t.clientHeight, a = { width: 0, height: 0 };
    return e > 0 && (a.width = e), i && (a.height = i), a;
  }, r.prototype._resize = function() {
    this.redraw();
  }, r.prototype.createVisual = function() {
    this.visual = this._render();
  }, r.prototype.exportVisual = function() {
    return this._render();
  }, r.prototype._render = function() {
    var t = this._value, e, i = this.options.border || {}, a = this.options.padding || 0, s = i.width || 0, l, p, h, c, u;
    i.width = s;
    var v = new pt();
    try {
      t && (p = zx(t, this.options.errorCorrection, this.options.encoding), h = this._getSize(), u = h - 2 * (s + a), e = this._calculateBaseUnit(u, p.length), c = p.length * e, l = s + a + (u - c) / 2, v.append(this._renderBackground(h, i)), v.append(this._renderMatrix(p, e, l)), this._hasCustomLogo() ? v.append(this._renderLogo(h, e)) : this._isSwiss() && v.append(this._renderSwissCode(h, e)));
    } catch (f) {
      this.onError(f);
    }
    return v;
  }, r.prototype._renderLogo = function(t, e) {
    var i, a, s = Ui(t / 2), l = this._getLogoSize(e * Xe.DEFAULT_LOGO_SIZE), p = this.options.overlay.imageUrl, h = {
      x: s - l.width / 2,
      y: s - l.height / 2
    };
    return a = new Pt(
      new q(h.x, h.y),
      new Us(l.width, l.height)
    ), i = new zd(p, a), i;
  }, r.prototype._renderSwissCode = function(t, e) {
    var i = this._getLogoSize(e * Xe.DEFAULT_LOGO_SIZE);
    i = Math.max(i.width, i.height);
    var a = i / 4, s = a / 2, l = t / 2, p = {}, h = new pt();
    return p.x = p.y = Math.ceil(l - e - i / 2), h.append(this._renderShape(p, Math.ceil(i + e * 2), zh, "#fff")), p.x = p.y = l - i / 2, h.append(this._renderShape(p, i, zh, this.options.color)), p.x = l + s - i / 2, p.y = l + s + a - i / 2, h.append(this._renderShape(p, a, jx, "#fff")), h;
  }, r.prototype._renderShape = function(t, e, i, a) {
    var s = new to({
      fill: {
        color: a
      },
      stroke: null
    });
    s.moveTo(t.x, t.y);
    for (var l = 0; l < i.length; l++)
      s.lineTo(t.x + e * i[l][0], t.y + e * i[l][1]);
    return s.close(), s;
  }, r.prototype._getSize = function() {
    var t;
    if (this.options.size)
      t = parseInt(this.options.size, 10);
    else {
      var e = this.element, i = Wv(e, this.options.renderAs), a = Math.min(i.width, i.height);
      a > 0 ? t = a : t = Xe.DEFAULT_SIZE;
    }
    return t;
  }, r.prototype._calculateBaseUnit = function(t, e) {
    var i = Math.floor(t / e);
    if (i < Xe.MIN_BASE_UNIT_SIZE) {
      var a = Math.ceil(e * Xe.MIN_BASE_UNIT_SIZE);
      this.onError(new Error(
        "Insufficient size for QR Code: the current size is " + t + "px and the minimum size is " + a + "px."
      ));
    } else
      i * e >= t && i - 1 >= Xe.MIN_BASE_UNIT_SIZE && i--;
    return i;
  }, r.prototype._renderMatrix = function(t, e, i) {
    for (var a = new to({
      fill: {
        color: this.options.color
      },
      stroke: null
    }), s = 0; s < t.length; s++)
      for (var l = i + s * e, p = 0; p < t.length; ) {
        for (; t[s][p] === 0 && p < t.length; )
          p++;
        if (p < t.length) {
          for (var h = p; t[s][p] === 1; )
            p++;
          var c = Ui(i + h * e), u = Ui(l), v = Ui(i + p * e), f = Ui(l + e);
          a.moveTo(c, u).lineTo(c, f).lineTo(v, f).lineTo(v, u).close();
        }
      }
    return a;
  }, r.prototype._renderBackground = function(t, e) {
    var i = new L(0, 0, t, t).unpad(e.width / 2), a = H.fromRect(i.toRect(), {
      fill: {
        color: this.options.background
      },
      stroke: {
        color: e.color,
        width: e.width
      }
    });
    return a;
  }, r.prototype.setOptions = function(t) {
    var e = t || {};
    this.options = Pi(this.options, e), t.value !== void 0 && (this._value = String(this.options.value)), this._initSurface(), this.redraw();
  }, r.prototype.value = function(t) {
    if (t === void 0)
      return this._value;
    this._value = String(t), this.redraw();
  }, r.prototype._hasCustomLogo = function() {
    return !!this.options.overlay.imageUrl;
  }, r.prototype._isSwiss = function() {
    return this.options.overlay.type === "swiss";
  }, r.prototype._getLogoSize = function(t) {
    var e = this.options.overlay.width, i = this.options.overlay.height;
    return !e && !i ? e = i = t : e && !i ? i = e : !e && i && (e = i), {
      width: e,
      height: i
    };
  }, r;
}(N);
O(Vx, {
  name: "QRCode",
  renderAs: "svg",
  encoding: "ISO_8859_1",
  value: "",
  errorCorrection: Xe.DEFAULT_ERROR_CORRECTION_LEVEL,
  background: Xe.DEFAULT_BACKGROUND,
  color: Xe.DEFAULT_DARK_MODULE_COLOR,
  size: "",
  padding: 0,
  border: {
    color: "",
    width: 0
  },
  overlay: {
    type: "image",
    imageUrl: "",
    width: 0,
    height: 0
  }
});
var Nx = {
  a: 6378137,
  // Semi-major radius
  b: 6356752314245179e-9,
  // Semi-minor radius
  f: 0.0033528106647474805,
  // Flattening
  e: 0.08181919084262149
  // Eccentricity
}, gs = {
  WGS84: Nx
};
function ke(n) {
  return n * n;
}
var Tr = Math, Hx = Tr.abs, jh = Tr.atan, rn = Tr.atan2, ur = Tr.cos, $e = Tr.sin, Vh = Tr.tan, At = function(n) {
  function r(o, t) {
    n.call(this), this.initProperties(), arguments.length === 1 ? (this.lat = o[0], this.lng = o[1]) : (this.lat = o, this.lng = t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    b(this, {
      DISTANCE_ITERATIONS: 100,
      DISTANCE_CONVERGENCE: 1e-12,
      DISTANCE_PRECISION: 2,
      FORMAT: "{0:N6}{1:N6}"
    });
  }, r.prototype.toArray = function() {
    return [
      this.lat,
      this.lng
    ];
  }, r.prototype.equals = function(t) {
    return t && t.lat === this.lat && t.lng === this.lng;
  }, r.prototype.clone = function() {
    return new r(this.lat, this.lng);
  }, r.prototype.round = function(t) {
    return this.lng = R(this.lng, t), this.lat = R(this.lat, t), this;
  }, r.prototype.wrap = function() {
    return this.lng = this.lng % 180, this.lat = this.lat % 90, this;
  }, r.prototype.distanceTo = function(t, e) {
    return this.greatCircleTo(t, e).distance;
  }, r.prototype.destination = function(t, e, i) {
    var a = _t(e), s = i || gs.WGS84, l = _t(this.lat), p = _t(this.lng), h = t / s.a, c = Tr.asin($e(l) * ur(h) + ur(l) * $e(h) * ur(a)), u = p + rn($e(a) * $e(h) * ur(l), ur(h) - $e(l) * $e(c));
    return new r(gr(c), gr(u));
  }, r.prototype.greatCircleTo = function(t, e) {
    var i = this, a = r.create(a), s = e || gs.WGS84;
    if (!a || this.clone().round(8).equals(a.clone().round(8)))
      return {
        distance: 0,
        azimuthFrom: 0,
        azimuthTo: 0
      };
    for (var l = s.a, p = s.b, h = s.f, c = _t(a.lng - this.lng), u = jh((1 - h) * Vh(_t(this.lat))), v = $e(u), f = ur(u), d = jh((1 - h) * Vh(_t(a.lat))), m = $e(d), _ = ur(d), w = c, A, T = this.DISTANCE_ITERATIONS, k = !1, C, z, V, G, X, W, ct; !k && T-- > 0; ) {
      C = $e(w), z = ur(w), V = Tr.sqrt(ke(_ * C) + ke(f * m - v * _ * z)), X = v * m + f * _ * z, ct = rn(V, X);
      var It = f * _ * C / V;
      G = 1 - ke(It), W = 0, G !== 0 && (W = X - 2 * v * m / G), A = w;
      var Gt = h / 16 * G * (4 + h * (4 - 3 * G));
      w = c + (1 - Gt) * h * It * (ct + Gt * V * (W + Gt * X * (-1 + 2 * ke(W)))), k = Hx(w - A) <= i.DISTANCE_CONVERGENCE;
    }
    var Wt = G * (ke(l) - ke(p)) / ke(p), ga = 1 + Wt / 16384 * (4096 + Wt * (-768 + Wt * (320 - 175 * Wt))), Wr = Wt / 1024 * (256 + Wt * (-128 + Wt * (74 - 47 * Wt))), ya = Wr * V * (W + Wr / 4 * (X * (-1 + 2 * ke(W)) - Wr / 6 * W * (-3 + 4 * ke(V)) * (-3 + 4 * ke(W)))), jo = rn(_ * C, f * m - v * _ * z), ma = rn(f * C, -v * _ + f * m * z);
    return {
      distance: R(p * ga * (ct - ya), this.DISTANCE_PRECISION),
      azimuthFrom: gr(jo),
      azimuthTo: gr(ma)
    };
  }, r.prototype.toString = function() {
    return String(this.lat) + "," + String(this.lng);
  }, r.fromLngLat = function(t) {
    return new r(t[1], t[0]);
  }, r.fromLatLng = function(t) {
    return new r(t[0], t[1]);
  }, r.create = function(t, e) {
    if (P(t))
      return t instanceof r ? t.clone() : arguments.length === 1 && t.length === 2 ? r.fromLatLng(t) : new r(t, e);
  }, r;
}(N), kr = Math, ys = kr.atan, Kv = kr.exp, Nh = kr.pow, Hh = kr.sin, Jv = kr.log, tf = kr.tan, ef = q, ua = kr.PI, ms = ua / 2, rf = ua / 4, Fx = ua / 180, Ux = gs.WGS84, Zl = function(n) {
  function r(o) {
    n.call(this), this.initProperties(), this._initOptions(o);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype.initProperties = function() {
    b(this, {
      MAX_LNG: 180,
      MAX_LAT: 85.0840590501,
      INVERSE_ITERATIONS: 15,
      INVERSE_CONVERGENCE: 1e-12
    });
  }, r.prototype.forward = function(t, e) {
    var i = this, a = i.options, s = a.datum, l = s.a, p = a.centralMeridian, h = j(t.lat, -i.MAX_LAT, i.MAX_LAT), c = e ? j(t.lng, -i.MAX_LNG, i.MAX_LNG) : t.lng, u = _t(c - p) * l, v = i._projectLat(h);
    return new ef(u, v);
  }, r.prototype._projectLat = function(t) {
    var e = this.options.datum, i = e.e, a = e.a, s = _t(t), l = tf(rf + s / 2), p = i * Hh(s), h = Nh((1 - p) / (1 + p), i / 2);
    return a * Jv(l * h);
  }, r.prototype.inverse = function(t, e) {
    var i = this, a = i.options, s = a.datum, l = s.a, p = a.centralMeridian, h = t.x / (Fx * l) + p, c = j(i._inverseY(t.y), -i.MAX_LAT, i.MAX_LAT);
    return e && (h = j(h, -i.MAX_LNG, i.MAX_LNG)), new At(c, h);
  }, r.prototype._inverseY = function(t) {
    var e = this, i = e.options.datum, a = i.a, s = i.e, l = s / 2, p = Kv(-t / a), h = ms - 2 * ys(p), c;
    for (c = 0; c <= e.INVERSE_ITERATIONS; c++) {
      var u = s * Hh(h), v = Nh((1 - u) / (1 + u), l), f = ms - 2 * ys(p * v) - h;
      if (h += f, kr.abs(f) <= e.INVERSE_CONVERGENCE)
        break;
    }
    return gr(h);
  }, r;
}(N);
O(Zl, {
  centralMeridian: 0,
  datum: Ux
});
var $x = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.initProperties = function() {
    n.prototype.initProperties.call(this), b(this, {
      MAX_LAT: 85.0511287798
    });
  }, r.prototype._projectLat = function(t) {
    var e = this.options.datum.a, i = _t(t), a = tf(rf + i / 2);
    return e * Jv(a);
  }, r.prototype._inverseY = function(t) {
    var e = this.options.datum.a, i = Kv(-t / e);
    return gr(ms - 2 * ys(i));
  }, r;
}(Zl), Gx = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.forward = function(t) {
    return new ef(t.lng, t.lat);
  }, r.prototype.inverse = function(t) {
    return new At(t.y, t.x);
  }, r;
}(N), Wx = function(n) {
  function r() {
    n.call(this);
    var o = this, t = o._proj = new $x(), e = this.c = 2 * ua * t.options.datum.a;
    this._tm = wt().translate(0.5, 0.5).scale(1 / e, -1 / e), this._itm = wt().scale(e, -e).translate(-0.5, -0.5);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.toPoint = function(t, e, i) {
    var a = this._proj.forward(t, i);
    return a.transform(this._tm).scale(e || 1);
  }, r.prototype.toLocation = function(t, e, i) {
    var a = t.clone().scale(1 / (e || 1)).transform(this._itm);
    return this._proj.inverse(a, i);
  }, r;
}(N);
(function(n) {
  function r() {
    n.call(this), this._proj = new Zl();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.toPoint = function(t) {
    return this._proj.forward(t);
  }, r.prototype.toLocation = function(t) {
    return this._proj.inverse(t);
  }, r;
})(N);
(function(n) {
  function r() {
    n.call(this), this._proj = new Gx();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.toPoint = function(t) {
    return this._proj.forward(t);
  }, r.prototype.toLocation = function(t) {
    return this._proj.inverse(t);
  }, r;
})(N);
var Fh = Object.defineProperty, jr = function(n) {
  var r = document.createElement("div");
  return r.innerHTML = n, r.firstChild;
}, Xx = function(n, r) {
  var o = document.createElement("div");
  for (o.innerHTML = n; o.childNodes.length > 0; )
    r.appendChild(o.childNodes[0]);
}, po = function(n) {
  for (; n.firstChild; )
    n.removeChild(n.firstChild);
}, Uh = function(n, r) {
  r.insertBefore(n, r.firstChild);
}, Yx = function(n, r) {
  for (n.appendChild(r); n.firstChild !== r; )
    r.appendChild(n.firstChild);
}, of = function(n) {
  var r = n.replace(/([a-z][A-Z])/g, function(o) {
    return o.charAt(0) + "-" + o.charAt(1).toLowerCase();
  });
  return r;
}, $h = function(n) {
  var r;
  return n && String(n).endsWith("px") ? r = n : r = String(n) + "px", r;
}, nf = function(n) {
  var r = !1, o, t = [], e = {
    wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
    fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
    android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
    iphone: /(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,
    ipad: /(iPad).*OS\s+(\d+)[\._]([\d_]+)/,
    meego: /(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,
    webos: /(webOS)\/(\d+)\.(\d+(\.\d+)?)/,
    blackberry: /(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,
    playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
    windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
    tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
    sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,
    ffos: /(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/
  }, i = {
    ios: /^i(phone|pad|pod)$/i,
    android: /^android|fire$/i,
    blackberry: /^blackberry|playbook/i,
    windows: /windows/,
    wp: /wp/,
    flat: /sailfish|ffos|tizen/i,
    meego: /meego/
  }, a = {
    tablet: /playbook|ipad|fire/i
  }, s = {
    omini: /Opera\sMini/i,
    omobile: /Opera\sMobi/i,
    firefox: /Firefox|Fennec/i,
    mobilesafari: /version\/.*safari/i,
    ie: /MSIE|Windows\sPhone/i,
    chrome: /chrome|crios/i,
    webkit: /webkit/i
  };
  for (var l in e)
    if (e.hasOwnProperty(l) && (t = n.match(e[l]), t)) {
      if (l === "windows" && "plugins" in navigator)
        return !1;
      r = {}, r.device = l, r.tablet = $a(l, a, !1), r.browser = $a(n, s, "default"), r.name = $a(l, i), r[r.name] = !0, r.majorVersion = t[2], r.minorVersion = (t[3] || "0").replace("_", "."), o = r.minorVersion.replace(".", "").substr(0, 2), r.flatVersion = r.majorVersion + o + new Array(3 - (o.length < 3 ? o.length : 2)).join("0");
      break;
    }
  return r;
};
function $a(n, r, o) {
  for (var t in r)
    if (r.hasOwnProperty(t) && r[t].test(n))
      return t;
  return o !== void 0 ? o : n;
}
var qx = function(n) {
  var r = nf(n);
  return r.ios || r.android;
}, Zx = function(n) {
  var r = !1, o = [], t = {
    edge: /(edge)[ \/]([\w.]+)/i,
    webkit: /(chrome|crios)[ \/]([\w.]+)/i,
    safari: /(webkit)[ \/]([\w.]+)/i,
    opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
    msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
    mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
  };
  for (var e in t)
    if (t.hasOwnProperty(e) && (o = n.match(t[e]), o)) {
      r = {}, r[e] = !0, r[o[1].toLowerCase().split(" ")[0].split("/")[0]] = !0, r.version = parseInt(document.documentMode || o[2], 10);
      break;
    }
  return r;
}, Ql = function() {
  var n = {
    down: "touchstart mousedown",
    move: "mousemove touchmove",
    up: "mouseup touchend touchcancel",
    cancel: "mouseleave touchcancel"
  }, r = Gr();
  return r.touch && (r.mobileOS.ios || r.mobileOS.android) ? n = {
    down: "touchstart",
    move: "touchmove",
    up: "touchend touchcancel",
    cancel: "touchcancel"
  } : r.pointers ? n = {
    down: "pointerdown",
    move: "pointermove",
    up: "pointerup",
    cancel: "pointercancel pointerleave"
  } : r.msPointers && (n = {
    down: "MSPointerDown",
    move: "MSPointerMove",
    up: "MSPointerUp",
    cancel: "MSPointerCancel MSPointerLeave"
  }), n;
}, Gr = function() {
  var n = nf(navigator.userAgent), r = Zx(navigator.userAgent), o = r.chrome, t = r.crios, e = r.mozilla, i = r.safari, a = {};
  a.mobileOS = n, a.touch = "ontouchstart" in window, a.pointers = !o && !t && !e && !i && window.PointerEvent, a.msPointers = !o && window.MSPointerEvent, a.mouseAndTouchPresent = a.touch && !(a.mobileOS.ios || a.mobileOS.android), a.eventCapture = document.documentElement.addEventListener;
  var s = document.createElement("table"), l = a.transitions = !1, p = a.transforms = !1, h = "string";
  return ["Moz", "webkit", "O", "ms"].forEach(function(c) {
    var u = typeof s.style[c + "Transition"] === h;
    if (u || typeof s.style[c + "Transform"] === h) {
      var v = c.toLowerCase();
      return p = {
        css: v !== "ms" ? "-" + v + "-" : "",
        prefix: c,
        event: v === "o" || v === "webkit" ? v : ""
      }, u && (l = p, l.event = l.event ? l.event + "TransitionEnd" : "transitionend"), !1;
    }
  }), s = null, a.transforms = p, a.transitions = l, a.delayedClick = function() {
    if (a.touch) {
      if (a.mobileOS.ios)
        return !0;
      if (a.mobileOS.android) {
        if (!a.browser.chrome)
          return !0;
        if (a.browser.version < 32)
          return !1;
        var c = document.querySelector("meta[name=viewport]"), u = c ? c.getAttribute("content") : "";
        return !u.match(/user-scalable=no/i);
      }
    }
    return !1;
  }, a;
}, Qx = function(n, r) {
  if (!r)
    return !1;
  for (var o = r.parentNode; o !== null; ) {
    if (o === n)
      return !0;
    o = o.parentNode;
  }
  return !1;
}, Kx = function(n, r) {
  return n === r || Qx(n, r);
}, lt = function(n, r) {
  return n.bind(r);
};
function Jx(n) {
  return typeof n == "string";
}
var jt = function(n, r, o, t, e) {
  t1(n, r, o, t, e);
}, t1 = function(n, r, o, t, e) {
  var i = Ot(r) ? r : (r || "").split(" ");
  i.forEach(function(a) {
    e1(n, a, o, t, e);
  });
}, e1 = function(n, r, o, t, e) {
  var i = t, a;
  o && vt(o) && !t ? i = o : o && Jx(o) && vt(i) && (a = o), n.addEventListener(r, function(s) {
    var l = s.target ? s.target.closest(a) : null;
    if (!a || a && s.target && l) {
      var p = a ? l : s.currentTarget;
      Fh(s, "currentTarget", { value: p }), Fh(s, "delegateTarget", { value: n }), i(s);
    }
  }, !!e);
}, Ut = function(n, r, o, t, e) {
  r1(n, r, o, t);
}, r1 = function(n, r, o, t) {
  var e = Ot(r) ? r : (r || "").split(" ");
  e.forEach(function(i) {
    i1(n, i, o, t);
  });
}, i1 = function(n, r, o, t) {
  n.removeEventListener(r, o, !!t);
}, re = function(n) {
  var r = Ql();
  function o(i) {
    return r[i] || i;
  }
  var t = /([^ ]+)/g, e = n.replace(t, o);
  return e;
}, va = function(n, r) {
  var o = n.prototype;
  o.events ? r.forEach(function(t) {
    o.events.indexOf(t) < 0 && o.events.push(t);
  }) : o.events = r;
}, o1 = function(n) {
  var r = n.originalEvent || n, o = r.wheelDeltaY, t;
  return r.wheelDelta ? (o === void 0 || o) && (t = r.wheelDelta) : r.detail && r.axis === r.VERTICAL_AXIS && (t = -r.detail * 10), t;
}, sr = function() {
  return Number(/* @__PURE__ */ new Date());
}, Gh = function() {
}, Wh = function(n) {
  var r = [];
  if (n)
    for (var o = of(n).split("-"), t = 0; t < o.length; t++)
      r.push("k-pos-" + o[t]);
  return r.join(" ");
}, Xh = "string", Yh = "function", n1 = function() {
  this._defaultPrevented = !0;
}, a1 = function() {
  return this._defaultPrevented === !0;
}, be = function(n) {
  function r() {
    n.call(this), this._events = {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this.unbind();
  }, r.prototype.bind = function(t, e, i) {
    var a = this, s, l = typeof t === Xh ? [t] : t || [], p, h, c, u = typeof e === Yh, v;
    if (e === void 0) {
      for (s in t)
        a.bind(s, t[s]);
      return a;
    }
    var f = function() {
      var d = l[s];
      c = u ? e : e[d], c && (i && (h = c, c = function() {
        a.unbind(d, c), h.apply(a, arguments);
      }, c.original = h), v = a._events[d] = a._events[d] || [], v.push(c));
    };
    for (s = 0, p = l.length; s < p; s++)
      f();
    return a;
  }, r.prototype.one = function(t, e) {
    return this.bind(t, e, !0);
  }, r.prototype.first = function(t, e) {
    var i = this, a, s = typeof t === Xh ? [t] : t, l, p, h = typeof e === Yh, c;
    for (a = 0, l = s.length; a < l; a++) {
      var u = s[a];
      p = h ? e : e[u], p && (c = i._events[u] = i._events[u] || [], c.unshift(p));
    }
    return i;
  }, r.prototype.trigger = function(t, e) {
    var i = this, a = i._events[t], s, l;
    if (a) {
      var p = e || {};
      for (p.sender = i, p._defaultPrevented = !1, p.preventDefault = n1, p.isDefaultPrevented = a1, a = a.slice(), s = 0, l = a.length; s < l; s++)
        a[s].call(i, p);
      return p._defaultPrevented === !0;
    }
    return !1;
  }, r.prototype.unbind = function(t, e) {
    var i = this, a = i._events[t], s;
    if (t === void 0)
      i._events = {};
    else if (a)
      if (e)
        for (s = a.length - 1; s >= 0; s--)
          (a[s] === e || a[s].original === e) && a.splice(s, 1);
      else
        i._events[t] = [];
    return i;
  }, r.prototype._setEvents = function(t) {
    for (var e = this, i = (this.events || []).length, a = 0; a < i; a++) {
      var s = e.events[a];
      e.options[s] && t[s] && (e.unbind(s, e.options[s]), e._events && e._events[s] && delete e._events[s]);
    }
    this.bind(this.events, t);
  }, r;
}(N), af = function(n) {
  function r(o, t) {
    n.call(this), this.element = o, this._initOptions(t), this.items = [], mt(this.element, "k-widget k-attribution");
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype.filter = function(t, e) {
    this._extent = t, this._zoom = e, this._render();
  }, r.prototype.add = function(t) {
    var e = t;
    P(t) && (typeof t == "string" && (e = {
      text: t
    }), this.items.push(e), this._render());
  }, r.prototype.remove = function(t) {
    for (var e = this, i = [], a = 0; a < this.items.length; a++) {
      var s = e.items[a];
      s.text !== t && i.push(s);
    }
    this.items = i, this._render();
  }, r.prototype.clear = function() {
    this.items = [], po(this.element);
  }, r.prototype._render = function() {
    for (var t = this, e = [], i = 0; i < this.items.length; i++) {
      var a = t.items[i], s = t._itemText(a);
      s !== "" && e.push(s);
    }
    if (e.length > 0) {
      po(this.element);
      var l = e.join(this.options.separator);
      Xx(l, this.element), this.showElement();
    } else
      this.hideElement();
  }, r.prototype.hideElement = function() {
    this.element.style.display = "none";
  }, r.prototype.showElement = function() {
    this.element.style.display = "";
  }, r.prototype._itemText = function(t) {
    var e = "", i = this._inZoomLevel(t.minZoom, t.maxZoom), a = this._inArea(t.extent);
    return i && a && (e += t.text), e;
  }, r.prototype._inZoomLevel = function(t, e) {
    var i = !0, a = U(t, -Number.MAX_VALUE), s = U(e, Number.MAX_VALUE);
    return i = this._zoom > a && this._zoom < s, i;
  }, r.prototype._inArea = function(t) {
    var e = !0;
    return t && (e = t.contains(this._extent)), e;
  }, r;
}(be);
O(af, {
  name: "Attribution",
  separator: "&nbsp;|&nbsp;"
});
var sf = "pan", s1 = {
  up: {
    className: "k-navigator-n",
    iconClass: "k-i-caret-alt-up"
  },
  down: {
    className: "k-navigator-s",
    iconClass: "k-i-caret-alt-down"
  },
  right: {
    className: "k-navigator-e",
    iconClass: "k-i-caret-alt-right"
  },
  left: {
    className: "k-navigator-w",
    iconClass: "k-i-caret-alt-left"
  }
};
function on(n, r) {
  var o = '<button class="k-button k-button-square k-rounded-full k-button-flat k-button-flat-base k-icon-button ' + s1[n].className + '" aria-label="move ' + n + '">' + Kr({ icon: "caret-alt-" + n, iconClass: "k-button-icon", svgIcons: r.svgIcons, type: r.type }) + "</button>";
  return jr(o);
}
var Kl = function(n) {
  function r(o, t) {
    n.call(this), this.element = o, this._initOptions(t);
    var e = on("up", t.icons), i = on("right", t.icons), a = on("down", t.icons), s = on("left", t.icons);
    this.element.appendChild(e), this.element.appendChild(i), this.element.appendChild(a), this.element.appendChild(s), mt(this.element, "k-widget k-navigator"), jt(this.element, "click", ".k-button", lt(this._click, this));
    var l = this.element.parentNode.closest("[data-role]");
    this._keyroot = l || this.element, this._tabindex(this._keyroot), this._keydownHandler = lt(this._keydown, this), jt(this._keyroot, "keydown", this._keydownHandler);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this.dispose();
  }, r.prototype.dispose = function() {
    Ut(this._keyroot, "keydown", this._keydownHandler);
  }, r.prototype._tabindex = function(t) {
    var e = t || this.wrapper || this.element, i = this.element, a = "tabindex", s = e.getAttribute(a) || i.getAttribute(a);
    i.removeAttribute(a), e.setAttribute(a, isNaN(s) ? 0 : s);
  }, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype._pan = function(t, e) {
    var i = this.options.panStep;
    this.trigger(sf, {
      x: t * i,
      y: e * i
    });
  }, r.prototype._click = function(t) {
    var e = 0, i = 0, a = t.currentTarget;
    a.matches(".k-navigator-n") ? i = 1 : a.matches(".k-navigator-s") ? i = -1 : a.matches(".k-navigator-e") ? e = 1 : a.matches(".k-navigator-w") && (e = -1), this._pan(e, i), t.preventDefault();
  }, r.prototype._keydown = function(t) {
    switch (t.which) {
      case Jr.UP:
        this._pan(0, 1), t.preventDefault();
        break;
      case Jr.DOWN:
        this._pan(0, -1), t.preventDefault();
        break;
      case Jr.RIGHT:
        this._pan(1, 0), t.preventDefault();
        break;
      case Jr.LEFT:
        this._pan(-1, 0), t.preventDefault();
        break;
    }
  }, r;
}(be);
O(Kl, {
  name: "Navigator",
  panStep: 1
});
va(Kl, [
  sf
]);
function qh(n, r, o) {
  var t = '<button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-icon-button k-zoom-' + n + '" title="zoom-' + n + '" aria-label="zoom-' + n + '">' + Kr({ icon: r, iconClass: "k-button-icon", svgIcons: o.svgIcons, type: o.type }) + "</button>";
  return jr(t);
}
var l1 = 187, p1 = 189, h1 = 61, c1 = 173, lf = "change", Jl = function(n) {
  function r(o, t, e) {
    n.call(this), this.element = o, this._initOptions(t);
    var i = qh("in", "plus", e), a = qh("out", "minus", e);
    this.element.appendChild(i), this.element.appendChild(a), mt(this.element, "k-widget k-zoom-control k-button-group k-group-horizontal"), this._clickHandler = this._click.bind(this), jt(this.element, "click", ".k-button", this._clickHandler);
    var s = this.element.parentNode.closest("[data-role]");
    this._keyroot = s || this.element, this._tabindex(this._keyroot), this._keydownHandler = this._keydown.bind(this), jt(this._keyroot, "keydown", this._keydownHandler);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this.element && Ut(this.element, "click", this._clickHandler), this._keyroot && Ut(this._keyroot, "keydown", this._keydownHandler);
  }, r.prototype._tabindex = function(t) {
    var e = t || this.wrapper || this.element, i = this.element, a = "tabindex", s = e.getAttribute(a) || i.getAttribute(a);
    i.removeAttribute(a), e.setAttribute(a, isNaN(s) ? 0 : s);
  }, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype._change = function(t) {
    var e = this.options.zoomStep;
    this.trigger(lf, { delta: t * e });
  }, r.prototype._click = function(t) {
    var e = t.currentTarget, i = 1;
    _n(e, "k-zoom-out") && (i = -1), this._change(i), t.preventDefault();
  }, r.prototype._keydown = function(t) {
    switch (t.which) {
      case Jr.NUMPAD_PLUS:
      case l1:
      case h1:
        this._change(1);
        break;
      case Jr.NUMPAD_MINUS:
      case p1:
      case c1:
        this._change(-1);
        break;
    }
  }, r;
}(be);
O(Jl, {
  name: "ZoomControl",
  zoomStep: 1
});
va(Jl, [
  lf
]);
var pf = Math, Zh = pf.max, Qh = pf.min, un = function(n) {
  function r(t, e) {
    n.call(this);
    var i = At.create(t), a = At.create(e);
    i.lng + 180 > a.lng + 180 && i.lat + 90 < a.lat + 90 ? (this.se = i, this.nw = a) : (this.se = a, this.nw = i);
  }
  n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r;
  var o = { World: { configurable: !0 } };
  return r.prototype.contains = function(e) {
    var i = this.nw, a = this.se, s = U(e.lng, e[1]), l = U(e.lat, e[0]);
    return e && s + 180 >= i.lng + 180 && s + 180 <= a.lng + 180 && l + 90 >= a.lat + 90 && l + 90 <= i.lat + 90;
  }, r.prototype.center = function() {
    var e = this.nw, i = this.se, a = e.lng + (i.lng - e.lng) / 2, s = e.lat + (i.lat - e.lat) / 2;
    return new At(s, a);
  }, r.prototype.containsAny = function(e) {
    for (var i = this, a = !1, s = 0; s < e.length; s++)
      a = a || i.contains(e[s]);
    return a;
  }, r.prototype.include = function(e) {
    var i = this.nw, a = this.se, s = U(e.lng, e[1]), l = U(e.lat, e[0]);
    i.lng = Qh(i.lng, s), i.lat = Zh(i.lat, l), a.lng = Zh(a.lng, s), a.lat = Qh(a.lat, l);
  }, r.prototype.includeAll = function(e) {
    for (var i = this, a = 0; a < e.length; a++)
      i.include(e[a]);
  }, r.prototype.edges = function() {
    var e = this.nw, i = this.se;
    return {
      nw: this.nw,
      ne: new At(e.lat, i.lng),
      se: this.se,
      sw: new At(i.lat, e.lng)
    };
  }, r.prototype.toArray = function() {
    var e = this.nw, i = this.se;
    return [
      e,
      new At(e.lat, i.lng),
      i,
      new At(i.lat, e.lng)
    ];
  }, r.prototype.overlaps = function(e) {
    return this.containsAny(e.toArray()) || e.containsAny(this.toArray());
  }, r.create = function(e, i) {
    if (e instanceof r)
      return e;
    if (e && i)
      return new r(e, i);
    if (e && e.length === 4 && !i)
      return new r([
        e[0],
        e[1]
      ], [
        e[2],
        e[3]
      ]);
  }, o.World.get = function() {
    return new r([90, -180], [-90, 180]);
  }, Object.defineProperties(r, o), r;
}(N), u1 = "showTooltip", v1 = "hideTooltip", Kh = "centerChange", f1 = "zoomChange", d1 = "init", hf = function(n) {
  function r(t, e) {
    n.call(this), this.widgetService = t, this.options = b({}, this.options, e), this.offset = { x: 0, y: 0 };
  }
  n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r;
  var o = { anchor: { configurable: !0 } };
  return r.prototype.show = function(e, i) {
    this.location !== i.location && (this.anchor = e, this.location = i.location, this.widgetService.notify(
      u1,
      Object.assign({ anchor: this.anchor }, i)
    ), this.visible = !0);
  }, r.prototype.hide = function() {
    this.widgetService && this.widgetService.notify(v1), this.visible = !1, this.location = null;
  }, o.anchor.get = function() {
    return this._anchor;
  }, o.anchor.set = function(t) {
    var e = this.widgetService.widget._toDocumentCoordinates({
      x: t.left - this.offset.x,
      y: t.top - this.offset.y
    });
    this._anchor = {
      left: e.left,
      top: e.top
    };
  }, r.prototype.destroy = function() {
    this.widgetService = null;
  }, Object.defineProperties(r.prototype, o), r;
}(N);
O(hf, {
  border: {
    width: 1
  },
  opacity: 1
});
var tp = function(n) {
  function r(o, t) {
    n.call(this), this.support = Gr(), this._initOptions(t), this.map = o;
    var e = document.createElement("div");
    mt(e, "k-layer"), e.style.zIndex = this.options.zIndex, e.style.opacity = this.options.opacity, this.element = e, o.scrollElement.appendChild(this.element), this._beforeReset = this._beforeReset.bind(this), this._reset = this._reset.bind(this), this._resize = this._resize.bind(this), this._panEnd = this._panEnd.bind(this), this._activate(), this._updateAttribution();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this._deactivate();
  }, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype.show = function() {
    this.reset(), this._activate(), this._applyExtent(!0);
  }, r.prototype.hide = function() {
    this._deactivate(), this._setVisibility(!1);
  }, r.prototype.reset = function() {
    this._beforeReset(), this._reset();
  }, r.prototype._reset = function() {
    this._applyExtent();
  }, r.prototype._beforeReset = function() {
  }, r.prototype._resize = function() {
  }, r.prototype._panEnd = function() {
    this._applyExtent();
  }, r.prototype._applyExtent = function() {
    var t = this.options, e = this.map.zoom(), i = !P(t.minZoom) || e >= t.minZoom, a = !P(t.maxZoom) || e <= t.maxZoom, s = un.create(t.extent), l = !s || s.overlaps(this.map.extent());
    this._setVisibility(i && a && l);
  }, r.prototype._setVisibility = function(t) {
    this.element.style.display = t ? "" : "none";
  }, r.prototype._activate = function() {
    var t = this.map;
    this._deactivate(), t.bind("beforeReset", this._beforeReset), t.bind("reset", this._reset), t.bind("resize", this._resize), t.bind("panEnd", this._panEnd);
  }, r.prototype._deactivate = function() {
    var t = this.map;
    t.unbind("beforeReset", this._beforeReset), t.unbind("reset", this._reset), t.unbind("resize", this._resize), t.unbind("panEnd", this._panEnd);
  }, r.prototype._updateAttribution = function() {
    var t = this.map.attribution;
    t && t.add(this.options.attribution);
  }, r.prototype._readData = function() {
    var t = this.options.data || [];
    return t;
  }, r.prototype._hasData = function() {
    return this._data && this._data.length > 0;
  }, r.prototype._layerIndex = function() {
    var t = this.map.layers || [];
    return t.indexOf(this);
  }, r;
}(N), vr = Math, _s = q;
function Jh(n) {
  return vt(n) ? n : uo.compile(n);
}
function g1(n) {
  return new _s(R(n.x), R(n.y));
}
function tc(n) {
  var r = n;
  return typeof n != "string" && (r += "px"), r;
}
var cf = function(n) {
  function r(o, t) {
    n.call(this, o, t), typeof this.options.subdomains == "string" && (this.options.subdomains = this.options.subdomains.split(""));
    var e = this._viewType();
    this._view = new e(this.element, this.options);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    n.prototype.destroy.call(this), this._view.destroy(), this._view = null;
  }, r.prototype._beforeReset = function() {
    var t = this.map, e = t.locationToLayer(t.extent().nw).round();
    this._view.viewOrigin(e);
  }, r.prototype._reset = function() {
    n.prototype._reset.call(this), this._updateView(), this._view.reset();
  }, r.prototype._viewType = function() {
    return y1;
  }, r.prototype._activate = function() {
    n.prototype._activate.call(this), this.support.mobileOS || (this._pan || (this._pan = $s(this._render.bind(this), 100)), this.map.bind("pan", this._pan));
  }, r.prototype._deactivate = function() {
    n.prototype._deactivate.call(this), this._pan && this.map.unbind("pan", this._pan);
  }, r.prototype._updateView = function() {
    var t = this._view, e = this.map, i = e.extent(), a = {
      nw: e.locationToLayer(i.nw).round(),
      se: e.locationToLayer(i.se).round()
    };
    t.center(e.locationToLayer(e.center())), t.extent(a), t.zoom(e.zoom());
  }, r.prototype._resize = function() {
    this._render();
  }, r.prototype._panEnd = function(t) {
    n.prototype._panEnd.call(this, t), this._render();
  }, r.prototype._render = function() {
    this._updateView(), this._view.render();
  }, r;
}(tp);
O(cf, {
  tileSize: 256,
  subdomains: ["a", "b", "c"],
  urlTemplate: "",
  zIndex: 1
});
var y1 = function(n) {
  function r(o, t) {
    n.call(this), this.element = o, this._initOptions(t), this.pool = new vf();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype.center = function(t) {
    this._center = t;
  }, r.prototype.extent = function(t) {
    this._extent = t;
  }, r.prototype.viewOrigin = function(t) {
    this._viewOrigin = t;
  }, r.prototype.zoom = function(t) {
    this._zoom = t;
  }, r.prototype.pointToTileIndex = function(t) {
    return new _s(vr.floor(t.x / this.options.tileSize), vr.floor(t.y / this.options.tileSize));
  }, r.prototype.tileCount = function() {
    var t = this.size(), e = this.pointToTileIndex(this._extent.nw), i = this._extent.nw, a = this.indexToPoint(e).translate(-i.x, -i.y);
    return {
      x: vr.ceil((vr.abs(a.x) + t.width) / this.options.tileSize),
      y: vr.ceil((vr.abs(a.y) + t.height) / this.options.tileSize)
    };
  }, r.prototype.size = function() {
    var t = this._extent.nw, e = this._extent.se, i = e.clone().translate(-t.x, -t.y);
    return {
      width: i.x,
      height: i.y
    };
  }, r.prototype.indexToPoint = function(t) {
    var e = t.x, i = t.y;
    return new _s(e * this.options.tileSize, i * this.options.tileSize);
  }, r.prototype.subdomainText = function() {
    var t = this.options.subdomains;
    return t[this.subdomainIndex++ % t.length];
  }, r.prototype.destroy = function() {
    po(this.element), this.pool.empty();
  }, r.prototype.reset = function() {
    this.pool.reset(), this.subdomainIndex = 0, this.render();
  }, r.prototype.render = function() {
    var t = this, e = this.tileCount(), i = this.pointToTileIndex(this._extent.nw), a, s, l;
    for (s = 0; s < e.x; s++)
      for (l = 0; l < e.y; l++)
        a = t.createTile({
          x: i.x + s,
          y: i.y + l
        }), a.visible || a.show();
  }, r.prototype.createTile = function(t) {
    var e = this.tileOptions(t), i = this.pool.get(this._center, e);
    return i.element.parentNode || this.element.append(i.element), i;
  }, r.prototype.tileOptions = function(t) {
    var e = this.wrapIndex(t), i = this.indexToPoint(t), a = this._viewOrigin, s = i.clone().translate(-a.x, -a.y);
    return {
      index: e,
      currentIndex: t,
      point: i,
      offset: g1(s),
      zoom: this._zoom,
      size: this.options.tileSize,
      subdomain: this.subdomainText(),
      urlTemplate: this.options.urlTemplate,
      errorUrlTemplate: this.options.errorUrlTemplate
    };
  }, r.prototype.wrapIndex = function(t) {
    var e = vr.pow(2, this._zoom);
    return {
      x: this.wrapValue(t.x, e),
      y: j(t.y, 0, e - 1)
    };
  }, r.prototype.wrapValue = function(t, e) {
    var i = vr.abs(t) % e, a = t;
    return t >= 0 ? a = i : a = e - (i === 0 ? e : i), a;
  }, r;
}(N), uf = function(n) {
  function r(o, t) {
    n.call(this), this.id = o, this.visible = !0, this._initOptions(t), this.createElement(), this.show();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    var t = this.element, e = t ? t.parentNode : null;
    t && (e && e.removeChild(t), this.element = null);
  }, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype.createElement = function() {
    var t = document.createElement("img"), e = this.options.size + "px";
    t.style.position = "absolute", t.style.display = "block", t.style.width = t.style.maxWidth = e, t.style.height = t.style.maxHeight = e, this.element = t;
  }, r.prototype.show = function() {
    var t = this.element;
    t.style.top = tc(this.options.offset.y), t.style.left = tc(this.options.offset.x);
    var e = this.url();
    e && t.setAttribute("src", e), t.style.visibility = "visible", this.visible = !0;
  }, r.prototype.hide = function() {
    this.element.style.visibility = "hidden", this.visible = !1;
  }, r.prototype.url = function() {
    var t = Jh(this.options.urlTemplate);
    return t(this.urlOptions());
  }, r.prototype.errorUrl = function() {
    var t = Jh(this.options.errorUrlTemplate);
    return t(this.urlOptions());
  }, r.prototype.urlOptions = function() {
    var t = this.options;
    return {
      zoom: t.zoom,
      subdomain: t.subdomain,
      z: t.zoom,
      x: t.index.x,
      y: t.index.y,
      s: t.subdomain,
      quadkey: t.quadkey,
      q: t.quadkey,
      culture: t.culture,
      c: t.culture
    };
  }, r;
}(N);
O(uf, {
  urlTemplate: "",
  errorUrlTemplate: ""
});
var vf = function(n) {
  function r() {
    n.call(this), this._items = [];
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.get = function(t, e) {
    return this._items.length >= this.options.maxSize && this._remove(t), this._create(e);
  }, r.prototype.empty = function() {
    for (var t = this._items, e = 0; e < t.length; e++)
      t[e].destroy();
    this._items = [];
  }, r.prototype.reset = function() {
    for (var t = this._items, e = 0; e < t.length; e++)
      t[e].hide();
  }, r.prototype._create = function(t) {
    for (var e = this._items, i, a = gg(t.point.toString() + t.offset.toString() + t.zoom + t.urlTemplate), s = 0; s < e.length; s++)
      if (e[s].id === a) {
        i = e[s];
        break;
      }
    return i ? i.show() : (i = new uf(a, t), this._items.push(i)), i;
  }, r.prototype._remove = function(t) {
    for (var e = this._items, i = -1, a = -1, s = 0; s < e.length; s++) {
      var l = e[s].options.point.distanceTo(t);
      l > i && !e[s].visible && (a = s, i = l);
    }
    a !== -1 && (e[a].destroy(), e.splice(a, 1));
  }, r;
}(N);
O(vf, {
  maxSize: 100
});
var Vr = Object.assign, ho = "change", m1 = function(n) {
  function r(o, t) {
    n.call(this);
    var e = this, i = o[0] || o;
    e.capture = !1;
    var a = Ql();
    i.addEventListener ? (a.down.split(" ").forEach(function(s) {
      i.addEventListener(s, lt(e._press, e), !0);
    }), a.up.split(" ").forEach(function(s) {
      i.addEventListener(s, lt(e._release, e), !0);
    })) : (a.down.split(" ").forEach(function(s) {
      i.attachEvent(s, lt(e._press, e));
    }), a.up.split(" ").forEach(function(s) {
      i.attachEvent(s, lt(e._release, e));
    })), e.bind([
      "press",
      "release"
    ], t || {});
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.captureNext = function() {
    this.capture = !0;
  }, r.prototype.cancelCapture = function() {
    this.capture = !1;
  }, r.prototype._press = function(t) {
    var e = this;
    e.trigger("press"), e.capture && t.preventDefault();
  }, r.prototype._release = function(t) {
    var e = this;
    e.trigger("release"), e.capture && (t.preventDefault(), e.cancelCapture());
  }, r;
}(be), ec = function(n) {
  function r(o) {
    n.call(this);
    var t = this;
    t.forcedEnabled = !1, Vr(t, o), t.scale = 1, t.horizontal ? (t.measure = "offsetWidth", t.scrollSize = "scrollWidth", t.axis = "x") : (t.measure = "offsetHeight", t.scrollSize = "scrollHeight", t.axis = "y");
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.makeVirtual = function() {
    Vr(this, {
      virtual: !0,
      forcedEnabled: !0,
      _virtualMin: 0,
      _virtualMax: 0
    });
  }, r.prototype.virtualSize = function(t, e) {
    (this._virtualMin !== t || this._virtualMax !== e) && (this._virtualMin = t, this._virtualMax = e, this.update());
  }, r.prototype.outOfBounds = function(t) {
    return t > this.max || t < this.min;
  }, r.prototype.forceEnabled = function() {
    this.forcedEnabled = !0;
  }, r.prototype.getSize = function() {
    return this.container[this.measure];
  }, r.prototype.getTotal = function() {
    return this.element[this.scrollSize];
  }, r.prototype.rescale = function(t) {
    this.scale = t;
  }, r.prototype.update = function(t) {
    var e = this, i = e.virtual ? e._virtualMax : e.getTotal(), a = i * e.scale, s = e.getSize();
    i === 0 && !e.forcedEnabled || (e.max = e.virtual ? -e._virtualMin : 0, e.size = s, e.total = a, e.min = Math.min(e.max, s - a), e.minScale = s / i, e.centerOffset = (a - s) / 2, e.enabled = e.forcedEnabled || a > s, t || e.trigger(ho, e));
  }, r;
}(be), _1 = function(n) {
  function r(o) {
    n.call(this);
    var t = this;
    t.x = new ec(Vr({
      horizontal: !0
    }, o)), t.y = new ec(Vr({
      horizontal: !1
    }, o)), t.container = o.container, t.forcedMinScale = o.minScale, t.maxScale = o.maxScale || 100, t.bind(ho, o);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.rescale = function(t) {
    this.x.rescale(t), this.y.rescale(t), this.refresh();
  }, r.prototype.centerCoordinates = function() {
    return {
      x: Math.min(0, -this.x.centerOffset),
      y: Math.min(0, -this.y.centerOffset)
    };
  }, r.prototype.refresh = function() {
    var t = this;
    t.x.update(), t.y.update(), t.enabled = t.x.enabled || t.y.enabled, t.minScale = t.forcedMinScale || Math.min(t.x.minScale, t.y.minScale), t.fitScale = Math.max(t.x.minScale, t.y.minScale), t.trigger(ho);
  }, r;
}(be), rc = function(n) {
  function r(o) {
    n.call(this), Vr(this, o);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.outOfBounds = function() {
    return this.dimension.outOfBounds(this.movable[this.axis]);
  }, r.prototype.dragMove = function(t) {
    var e = this, i = e.dimension, a = e.axis, s = e.movable, l = s[a] + t;
    if (i.enabled) {
      var p = t;
      (l < i.min && t < 0 || l > i.max && t > 0) && (p *= e.resistance), s.translateAxis(a, p), e.trigger(ho, e);
    }
  }, r;
}(be), x1 = function(n) {
  function r(o) {
    n.call(this);
    var t = this, e, i, a, s;
    Vr(t, {
      elastic: !0
    }, o), a = t.elastic ? 0.5 : 0, s = t.movable, t.x = e = new rc({
      axis: "x",
      dimension: t.dimensions.x,
      resistance: a,
      movable: s
    }), t.y = i = new rc({
      axis: "y",
      dimension: t.dimensions.y,
      resistance: a,
      movable: s
    }), t.userEvents.bind([
      "press",
      "move",
      "end",
      "gesturestart",
      "gesturechange"
    ], {
      gesturestart: function(p) {
        t.gesture = p, t.offset = ii(t.dimensions.container);
      },
      press: function(p) {
        var h = p.event.target.closest("a");
        h && h.matches("[data-navigate-on-press=true]") && p.sender.cancel();
      },
      gesturechange: function(p) {
        var h = t.gesture, c = h.center, u = p.center, v = p.distance / h.distance, f = t.dimensions.minScale, d = t.dimensions.maxScale, m;
        s.scale <= f && v < 1 && (v += (1 - v) * 0.8), s.scale * v >= d && (v = d / s.scale);
        var _ = s.x + t.offset.left, w = s.y + t.offset.top;
        m = {
          x: (_ - c.x) * v + u.x - _,
          y: (w - c.y) * v + u.y - w
        }, s.scaleWith(v), e.dragMove(m.x), i.dragMove(m.y), t.dimensions.rescale(s.scale), t.gesture = p, p.preventDefault();
      },
      move: function(p) {
        p.event.target.tagName.match(/textarea|input/i) || (e.dimension.enabled || i.dimension.enabled ? (e.dragMove(p.x.delta), i.dragMove(p.y.delta), p.preventDefault()) : p.touch.skip());
      },
      end: function(p) {
        p.preventDefault();
      }
    });
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r;
}(N), ic = function(n, r, o) {
  return "translate3d(" + n + "px," + r + "px,0) scale(" + o + ")";
}, ep = function(n) {
  function r(o) {
    n.call(this);
    var t = this;
    t.support = Gr(), this.transformStyle = this.support.transitions.prefix + "Transform", t.element = o, t.element.style.webkitTransformOrigin = "left top", t.x = 0, t.y = 0, t.scale = 1;
    var e = ic(t.x, t.y, t.scale);
    t.element.style[this.transformStyle] = e, t._saveCoordinates(e);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.translateAxis = function(t, e) {
    this[t] += e, this.refresh();
  }, r.prototype.scaleTo = function(t) {
    this.scale = t, this.refresh();
  }, r.prototype.scaleWith = function(t) {
    this.scale *= t, this.refresh();
  }, r.prototype.translate = function(t) {
    this.x += t.x, this.y += t.y, this.refresh();
  }, r.prototype.moveAxis = function(t, e) {
    this[t] = e, this.refresh();
  }, r.prototype.moveTo = function(t) {
    Vr(this, t), this.refresh();
  }, r.prototype.refresh = function() {
    var t = this, e = t.x, i = t.y, a;
    t.round && (e = Math.round(e), i = Math.round(i)), a = ic(e, i, t.scale), a !== t.coordinates && (t.element.style[this.transformStyle] = a, t._saveCoordinates(a), t.trigger(ho));
  }, r.prototype._saveCoordinates = function(t) {
    this.coordinates = t;
  }, r;
}(be), xs = pt, rp = function(n) {
  function r(o, t) {
    n.call(this, o, t), this._pan = lt(this._pan, this), this.surface = co.create(this.element, {
      width: o.scrollElement.clientWidth,
      height: o.scrollElement.clientHeight
    }), this._initRoot(), this.movable = new ep(this.surface.element), this._markers = [], this._click = this._handler("shapeClick"), this.surface.bind("click", this._click), this._mouseleave = this._handler("shapeMouseLeave"), this.surface.bind("mouseleave", this._mouseleave), this.surface.bind("mouseenter", this._mouseenter.bind(this));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    n.prototype.destroy.call(this), this.surface.destroy();
  }, r.prototype._reset = function() {
    n.prototype._reset.call(this), this._translateSurface(), this._data = this._readData(), this._hasData() && this._load(this._data);
  }, r.prototype._initRoot = function() {
    this._root = new xs(), this.surface.draw(this._root);
  }, r.prototype._beforeReset = function() {
    this.surface.clear(), this._initRoot();
  }, r.prototype._resize = function() {
    this.surface.size(this.map.size());
  }, r.prototype._readData = function() {
    var t = n.prototype._readData.call(this);
    return t.type === "FeatureCollection" ? t.features : t.type === "GeometryCollection" ? t.geometries : t;
  }, r.prototype._load = function(t) {
    var e = this;
    this._data = t, this._clearMarkers(), this._loader || (this._loader = new w1(this.map, this.options.style, this));
    for (var i = new xs(), a = 0; a < t.length; a++) {
      var s = e._loader.parse(t[a]);
      s && i.append(s);
    }
    this._root.clear(), this._root.append(i);
  }, r.prototype.shapeCreated = function(t) {
    var e = !1;
    if (t instanceof Je && this.map.options.renderPointsAsMarkers && (e = P(this._createMarker(t))), !e) {
      var i = {
        layer: this,
        shape: t
      };
      e = this.map.trigger("shapeCreated", i);
    }
    return e;
  }, r.prototype.featureCreated = function(t) {
    t.layer = this, this.map.trigger("shapeFeatureCreated", t);
  }, r.prototype._createMarker = function(t) {
    var e = this.map.markers.bind({
      location: t.location
    }, t.dataItem);
    return e && this._markers.push(e), e;
  }, r.prototype._clearMarkers = function() {
    for (var t = this, e = 0; e < this._markers.length; e++)
      t.map.markers.remove(t._markers[e]);
    this._markers = [];
  }, r.prototype._pan = function() {
    this._panning || (this._panning = !0, this.surface.suspendTracking());
  }, r.prototype._panEnd = function(t) {
    n.prototype._panEnd.call(this, t), this._translateSurface(), this.surface.resumeTracking(), this._panning = !1;
  }, r.prototype._translateSurface = function() {
    var t = this.map, e = t.locationToView(t.extent().nw);
    this.surface.translate && (this.surface.translate(e), this.movable.moveTo({
      x: e.x,
      y: e.y
    }));
  }, r.prototype._eventArgs = function(t) {
    return {
      layer: this,
      layerIndex: this._layerIndex(),
      shape: t.element,
      shapeIndex: (this._data || []).indexOf(t.element.dataItem),
      originalEvent: t.originalEvent
    };
  }, r.prototype._handler = function(t) {
    var e = this;
    return function(i) {
      i.element && e.map.trigger(t, e._eventArgs(i));
    };
  }, r.prototype._mouseenter = function(t) {
    if (t.element) {
      this.map.trigger("shapeMouseEnter", this._eventArgs(t));
      var e = t.element, i = this._tooltipAnchor(t);
      this.map._tooltip.show(i, this._tooltipContext(e));
    }
  }, r.prototype._tooltipContext = function(t) {
    return {
      type: "shape",
      layerIndex: this._layerIndex(),
      className: "k-map-shape-tooltip",
      dataItem: t.dataItem,
      location: t.location
    };
  }, r.prototype._tooltipAnchor = function(t) {
    var e = this.map.eventOffset(t.originalEvent);
    return {
      top: e.y,
      left: e.x
    };
  }, r.prototype._activate = function() {
    n.prototype._activate.call(this), this._panHandler = lt(this._pan, this), this.map.bind("pan", this.panHandler);
  }, r.prototype._deactivate = function() {
    n.prototype._deactivate.call(this), this.map.unbind("pan", this._panHandler);
  }, r;
}(tp);
O(rp, {
  autoBind: !0,
  zIndex: 100
});
var w1 = function(n) {
  function r(o, t, e) {
    n.call(this), this.observer = e, this.locator = o, this.style = t;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.parse = function(t) {
    var e = new xs(), i = !0;
    return t.type === "Feature" ? (i = !1, this._loadGeometryTo(e, t.geometry, t), this._featureCreated(e, t)) : this._loadGeometryTo(e, t, t), i && e.children.length < 2 && (e = e.children[0]), e;
  }, r.prototype._shapeCreated = function(t) {
    var e = !1;
    return this.observer && this.observer.shapeCreated && (e = this.observer.shapeCreated(t)), e;
  }, r.prototype._featureCreated = function(t, e) {
    this.observer && this.observer.featureCreated && this.observer.featureCreated({
      group: t,
      dataItem: e,
      properties: e.properties
    });
  }, r.prototype._loadGeometryTo = function(t, e, i) {
    var a = this, s = e.coordinates, l, p;
    switch (e.type) {
      case "LineString":
        p = this._loadPolygon(t, [s], i), this._setLineFill(p);
        break;
      case "MultiLineString":
        for (l = 0; l < s.length; l++)
          p = a._loadPolygon(t, [s[l]], i), a._setLineFill(p);
        break;
      case "Polygon":
        this._loadPolygon(t, s, i);
        break;
      case "MultiPolygon":
        for (l = 0; l < s.length; l++)
          a._loadPolygon(t, s[l], i);
        break;
      case "Point":
        this._loadPoint(t, s, i);
        break;
      case "MultiPoint":
        for (l = 0; l < s.length; l++)
          a._loadPoint(t, s[l], i);
        break;
    }
  }, r.prototype._setLineFill = function(t) {
    var e = t.segments;
    (e.length < 4 || !e[0].anchor().equals(dt(e).anchor())) && (t.options.fill = null);
  }, r.prototype._loadShape = function(t, e) {
    return this._shapeCreated(e) || t.append(e), e;
  }, r.prototype._loadPolygon = function(t, e, i) {
    var a = this._buildPolygon(e);
    return a.dataItem = i, a.location = this.locator.viewToLocation(a.bbox().center()), this._loadShape(t, a);
  }, r.prototype._buildPolygon = function(t) {
    for (var e = this, i = t.length > 1 ? to : H, a = new i(this.style), s = 0; s < t.length; s++)
      for (var l = 0; l < t[s].length; l++) {
        var p = e.locator.locationToView(At.fromLngLat(t[s][l]));
        l === 0 ? a.moveTo(p.x, p.y) : a.lineTo(p.x, p.y);
      }
    return a;
  }, r.prototype._loadPoint = function(t, e, i) {
    var a = At.fromLngLat(e), s = this.locator.locationToView(a), l = new ve(s, 10), p = new Je(l, this.style);
    return p.dataItem = i, p.location = a, this._loadShape(t, p);
  }, r;
}(N), ff = function(n) {
  function r() {
    n.apply(this, arguments);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._readData = function() {
    var t = this.options.data || [];
    return t;
  }, r.prototype._load = function(t) {
    var e = this;
    if (this._data = t, this.surface.clear(), t.length !== 0) {
      var i = this.options, a = Qe(i.valueField), s = t.slice(0);
      s.sort(function(w, A) {
        return a(A) - a(w);
      });
      for (var l = this._scaleType(), p, h = Qe(this.options.locationField), c = 0; c < s.length; c++) {
        var u = s[c], v = h(u), f = a(u);
        if (P(v) && P(f)) {
          p || (p = new l([
            0,
            f
          ], [
            i.minSize,
            i.maxSize
          ])), v = At.create(v);
          var d = e.map.locationToView(v), m = p.map(f), _ = e._createSymbol({
            center: d,
            size: m,
            style: i.style,
            dataItem: u,
            location: v
          });
          _.dataItem = u, _.location = v, _.value = f, e._drawSymbol(_);
        }
      }
    }
  }, r.prototype._scaleType = function() {
    var t = this.options.scale;
    return vt(t) ? t : A1[t];
  }, r.prototype._createSymbol = function(t) {
    var e = this.options.symbol;
    return vt(e) || (e = S1[e]), e(t);
  }, r.prototype._drawSymbol = function(t) {
    var e = {
      layer: this,
      shape: t
    }, i = this.map.trigger("shapeCreated", e);
    i || this.surface.draw(t);
  }, r.prototype._tooltipContext = function(t) {
    return {
      type: "bubble",
      layerIndex: this._layerIndex(),
      className: "k-map-bubble-tooltip",
      dataItem: t.dataItem,
      location: t.location,
      value: t.value
    };
  }, r.prototype._tooltipAnchor = function(t) {
    var e = t.element, i = e.bbox().center();
    return {
      top: i.y,
      left: i.x
    };
  }, r;
}(rp);
O(ff, {
  // autoBind: true,
  locationField: "location",
  valueField: "value",
  minSize: 0,
  maxSize: 100,
  scale: "sqrt",
  symbol: "circle",
  // ensure bubble layers are displayed over tile and shape layers
  zIndex: 200
});
var b1 = function(n) {
  function r(o, t) {
    n.call(this), this._domain = o, this._range = t;
    var e = Math.sqrt(o[1]) - Math.sqrt(o[0]), i = t[1] - t[0];
    this._ratio = i / e;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.map = function(t) {
    var e = (Math.sqrt(t) - Math.sqrt(this._domain[0])) * this._ratio;
    return this._range[0] + e;
  }, r;
}(N), A1 = {
  sqrt: b1
}, S1 = {
  circle: function(n) {
    var r = new ve(n.center, n.size / 2);
    return new Je(r, n.style);
  },
  square: function(n) {
    var r = new H(n.style), o = n.size / 2, t = n.center;
    return r.moveTo(t.x - o, t.y - o).lineTo(t.x + o, t.y - o).lineTo(t.x + o, t.y + o).lineTo(t.x - o, t.y + o).close(), r;
  }
}, oc = "click", nc = "mouseenter", ac = "mouseleave", T1 = Object.assign, df = "k-marker", ws = "." + df, ip = function(n) {
  function r(o, t) {
    n.call(this, o, t), this._markerClickHandler = lt(this._markerClick, this), jt(this.element, oc, ws, this._markerClickHandler), this.items = [], this._load(this._readData());
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    n.prototype.destroy.call(this), Ut(this.element, oc, this._markerClickHandler), this.clear();
  }, r.prototype.add = function(t) {
    var e = this;
    if (Ot(t))
      for (var i = 0; i < t.length; i++)
        e._addOne(t[i]);
    else
      return this._addOne(t);
  }, r.prototype.remove = function(t) {
    t.destroy();
    var e = (this.items || []).indexOf(t);
    e > -1 && this.items.splice(e, 1);
  }, r.prototype.clear = function() {
    for (var t = this, e = 0; e < this.items.length; e++)
      t.items[e].destroy();
    this.items = [];
  }, r.prototype.update = function(t) {
    var e = t.location();
    if (e) {
      t.showAt(this.map.locationToView(e));
      var i = {
        marker: t,
        layer: this
      };
      this.map.trigger("markerActivate", i);
    }
  }, r.prototype._reset = function() {
    var t = this;
    n.prototype._reset.call(this);
    for (var e = this.items, i = 0; i < e.length; i++)
      t.update(e[i]);
  }, r.prototype.bind = function(t, e) {
    var i = sc.create(t, this.options);
    i.dataItem = e;
    var a = {
      marker: i,
      layer: this
    }, s = this.map.trigger("markerCreated", a);
    if (!s)
      return this.add(i), i;
  }, r.prototype._addOne = function(t) {
    var e = sc.create(t, this.options);
    return e.addTo(this), e;
  }, r.prototype._readData = function() {
    var t = this.options.data || [];
    return t;
  }, r.prototype._load = function(t) {
    var e = this;
    this._data = t, this.clear();
    for (var i = Qe(this.options.locationField), a = Qe(this.options.titleField), s = 0; s < t.length; s++) {
      var l = t[s];
      e.bind({
        location: i(l),
        title: a(l)
      }, l);
    }
  }, r.prototype._markerClick = function(t) {
    var e = t.currentTarget._kendoNode, i = {
      layer: this,
      layerIndex: this._layerIndex(),
      marker: e,
      markerIndex: (this.items || []).indexOf(e),
      originalEvent: t
    };
    this.map.trigger("markerClick", i);
  }, r.prototype._markerMouseEnter = function(t) {
    var e = this._createMarkerEventArgs(t);
    this.map.trigger("markerMouseEnter", e);
  }, r.prototype._markerMouseLeave = function(t) {
    var e = this._createMarkerEventArgs(t);
    this.map.trigger("markerMouseLeave", e);
  }, r.prototype._createMarkerEventArgs = function(t) {
    var e = t.marker, i = T1({}, {
      layer: this,
      layerIndex: this._layerIndex(),
      marker: e,
      markerIndex: (this.items || []).indexOf(e)
    }, t);
    return i;
  }, r;
}(tp);
O(ip, {
  zIndex: 1e3,
  autoBind: !0,
  locationField: "location",
  titleField: "title",
  template: ""
});
var sc = function(n) {
  function r(o) {
    n.call(this), this.options = o || {};
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    this.layer = null, this.unbindEvents(), this.hide();
  }, r.prototype.addTo = function(t) {
    this.layer = t.markers || t, this.layer.items.push(this), this.layer.update(this);
  }, r.prototype.location = function(t) {
    return t ? (this.options.location = At.create(t).toArray(), this.layer && this.layer.update(this), this) : At.create(this.options.location);
  }, r.prototype.showAt = function(t) {
    this.render(), this._anchor = { left: Math.round(t.x), top: Math.round(t.y) }, this.element.style.left = $h(this._anchor.left), this.element.style.top = $h(this._anchor.top);
  }, r.prototype.hide = function() {
    this.element && (this.element.remove(), this.element = null);
  }, r.prototype.bindEvents = function() {
    this.element && (this._mouseEnterHandler = lt(this._mouseEnter, this), jt(this.element, nc, ws, this._mouseEnterHandler), this._mouseLeaveHandler = lt(this._mouseLeave, this), jt(this.element, ac, ws, this._mouseLeaveHandler));
  }, r.prototype.unbindEvents = function() {
    this.element && (Ut(this.element, nc, this._mouseEnterHandler), Ut(this.element, ac, this._mouseLeaveHandler));
  }, r.prototype.render = function() {
    if (!this.element) {
      var t = this.options, e = this.layer, i = document.createElement("span");
      if (mt(i, df), this.options.template) {
        var a = this._compileTemplate(this.options.template), s = a(this.dataItem), l = jr(s);
        i.appendChild(l);
      } else if (t.svgIcon)
        Kr(i, { icon: t.svgIcon, iconClass: "k-icon-xxl", svgIcons: this.options.icons.svgIcons, type: "svg" });
      else {
        var p = { icon: "map-marker", iconClass: "k-icon-xxl", svgIcons: this.options.icons.svgIcons, type: this.options.icons.type };
        t.shape ? t.shape === "pinTarget" ? (p.icon = "map-marker-target", Kr(i, p)) : t.shape === "pin" ? Kr(i, p) : mt(i, "k-icon k-icon-xxl k-i-marker-" + of(t.shape || "pin")) : Kr(i, p);
      }
      t.title && i.setAttribute("title", t.title);
      var h = t.attributes || {};
      Object.keys(h).forEach(function(c) {
        i.setAttribute(c, h[c]);
      }), i._kendoNode = this, i.style.zIndex = t.zIndex, this.element = i, e && e.element.appendChild(this.element), this.bindEvents();
    }
  }, r.prototype._mouseEnter = function(t) {
    var e = this._createEventArgs(t);
    this.layer._markerMouseEnter(e), this.layer.map._tooltip.show({
      top: this._anchor.top - this.element.offsetHeight,
      left: this._anchor.left
    }, this._tooltipContext());
  }, r.prototype._tooltipContext = function() {
    return {
      type: "marker",
      layerIndex: this.layer._layerIndex(),
      className: "k-map-marker-tooltip",
      dataItem: this.dataItem,
      title: this.options.title,
      location: this.location()
    };
  }, r.prototype._mouseLeave = function(t) {
    var e = this._createEventArgs(t);
    this.layer._markerMouseLeave(e);
  }, r.prototype._createEventArgs = function(t) {
    var e = {
      marker: this,
      originalEvent: t
    };
    return e;
  }, r.prototype._compileTemplate = function(t) {
    return uo.compile(t, {
      paramName: "dataItem",
      useWithBlock: !1
    });
  }, r.create = function(t, e) {
    return t instanceof r ? t : new r(b({}, e, t));
  }, r;
}(N), C1 = Object.assign;
function lc(n) {
  window.requestAnimationFrame(n);
}
var fa = function(n) {
  function r() {
    n.call(this);
    var o = this;
    o._tickProxy = lt(o._tick, o), o._started = !1;
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.tick = function() {
  }, r.prototype.done = function() {
  }, r.prototype.onEnd = function() {
  }, r.prototype.onCancel = function() {
  }, r.prototype.start = function() {
    this.enabled() && (this.done() ? this.onEnd() : (this._started = !0, lc(this._tickProxy)));
  }, r.prototype.enabled = function() {
    return !0;
  }, r.prototype.cancel = function() {
    this._started = !1, this.onCancel();
  }, r.prototype._tick = function() {
    var t = this;
    t._started && (t.tick(), t.done() ? (t._started = !1, t.onEnd()) : lc(t._tickProxy));
  }, r;
}(N), pc = function(n) {
  function r(o) {
    n.call(this), C1(this, o);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.done = function() {
    return this.timePassed() >= this.duration;
  }, r.prototype.timePassed = function() {
    return Math.min(this.duration, sr() - this.startDate);
  }, r.prototype.moveTo = function(t) {
    var e = this, i = e.movable;
    e.initial = i[e.axis], e.delta = t.location - e.initial, e.duration = typeof t.duration == "number" ? t.duration : 300, e.tick = e._easeProxy(t.ease), e.startDate = sr(), e.start();
  }, r.prototype._easeProxy = function(t) {
    var e = this;
    return function() {
      e.movable.moveAxis(e.axis, t(e.timePassed(), e.initial, e.delta, e.duration));
    };
  }, r.easeOutExpo = function(t, e, i, a) {
    return t === a ? e + i : i * (-Math.pow(2, -10 * t / a) + 1) + e;
  }, r;
}(fa), vn = Object.assign, k1 = function(n) {
  n.preventDefault();
}, hc = 800, P1 = 300, cc = 0, gf = "press", yf = "hold", uc = "select", mf = "start", bs = "move", As = "end", vc = "cancel", Dn = "tap", _f = "doubleTap", xf = "release", O1 = "gesturestart", fc = "gesturechange", dc = "gestureend", gc = "gesturetap", E1 = {
  api: 0,
  touch: 0,
  mouse: 9,
  pointer: 9
};
function M1(n, r) {
  var o = n.x.location, t = n.y.location, e = r.x.location, i = r.y.location, a = o - e, s = t - i;
  return {
    center: {
      x: (o + e) / 2,
      y: (t + i) / 2
    },
    distance: Math.sqrt(a * a + s * s)
  };
}
function yc(n) {
  var r = Gr(), o = [], t = n.originalEvent || n, e = n.currentTarget, i = 0, a, s, l;
  if (n.api)
    o.push({
      id: 2,
      event: n,
      target: n.target,
      currentTarget: n.target,
      location: n,
      type: "api"
    });
  else if (n.type.match(/touch/))
    for (s = t ? t.changedTouches : [], a = s.length; i < a; i++)
      l = s[i], o.push({
        location: l,
        event: n,
        target: l.target,
        currentTarget: e,
        id: l.identifier,
        type: "touch"
      });
  else
    r.pointers || r.msPointers ? o.push({
      location: t,
      event: n,
      target: n.target,
      currentTarget: e,
      id: t.pointerId,
      type: "pointer"
    }) : o.push({
      id: 1,
      event: n,
      target: n.target,
      currentTarget: e,
      location: n,
      type: "mouse"
    });
  return o;
}
var mc = function(n) {
  function r(o, t) {
    n.call(this);
    var e = this;
    e.support = Gr(), e.invalidZeroEvents = this.support.mobileOS && this.support.mobileOS.android, e.axis = o, e._updateLocationData(t), e.startLocation = e.location, e.velocity = e.delta = 0, e.timeStamp = sr();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.move = function(t) {
    var e = this, i = t["page" + e.axis], a = sr(), s = a - e.timeStamp || 1;
    !i && this.invalidZeroEvents || (e.delta = i - e.location, e._updateLocationData(t), e.initialDelta = i - e.startLocation, e.velocity = e.delta / s, e.timeStamp = a);
  }, r.prototype._updateLocationData = function(t) {
    var e = this, i = e.axis;
    e.location = t["page" + i], e.client = t["client" + i], e.screen = t["screen" + i];
  }, r;
}(N), R1 = function(n) {
  function r(o, t, e) {
    n.call(this), vn(this, {
      x: new mc("X", e.location),
      y: new mc("Y", e.location),
      type: e.type,
      useClickAsTap: o.useClickAsTap,
      threshold: o.threshold || E1[e.type],
      userEvents: o,
      target: t,
      currentTarget: e.currentTarget,
      initialTouch: e.target,
      id: e.id,
      pressEvent: e,
      _clicks: o._clicks,
      supportDoubleTap: o.supportDoubleTap,
      _moved: !1,
      _finished: !1
    });
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.press = function() {
    this._holdTimeout = setTimeout(lt(this._hold, this), this.userEvents.minHold), this._trigger(gf, this.pressEvent);
  }, r.prototype._tap = function(t) {
    var e = this;
    e.userEvents._clicks++, e.userEvents._clicks === 1 && (e._clickTimeout = setTimeout(function() {
      e.userEvents._clicks === 1 ? e._trigger(Dn, t) : e._trigger(_f, t), e.userEvents._clicks = 0;
    }, P1));
  }, r.prototype._hold = function() {
    this._trigger(yf, this.pressEvent);
  }, r.prototype.move = function(t) {
    var e = this, i = t.type !== "api" && e.userEvents._shouldNotMove;
    if (!(e._finished || i)) {
      if (e.x.move(t.location), e.y.move(t.location), !e._moved) {
        if (e._withinIgnoreThreshold())
          return;
        if (!Ss.current || Ss.current === e.userEvents)
          e._start(t);
        else
          return e.dispose();
      }
      e._finished || e._trigger(bs, t);
    }
  }, r.prototype.end = function(t) {
    this.endTime = sr(), !this._finished && (this._finished = !0, this._trigger(xf, t), this._moved ? this._trigger(As, t) : this.useClickAsTap || (this.supportDoubleTap ? this._tap(t) : this._trigger(Dn, t)), clearTimeout(this._holdTimeout), this.dispose());
  }, r.prototype.dispose = function() {
    var t = this.userEvents, e = t.touches || [];
    this._finished = !0, this.pressEvent = null, clearTimeout(this._holdTimeout);
    var i = e.indexOf(this);
    e.splice(i, 1);
  }, r.prototype.skip = function() {
    this.dispose();
  }, r.prototype.cancel = function() {
    this.dispose();
  }, r.prototype.isMoved = function() {
    return this._moved;
  }, r.prototype._start = function(t) {
    clearTimeout(this._holdTimeout), this.startTime = sr(), this._moved = !0, this._trigger(mf, t);
  }, r.prototype._trigger = function(t, e) {
    var i = this, a = e.event, s = {
      touch: i,
      x: i.x,
      y: i.y,
      target: i.target,
      event: a
    };
    i.userEvents.notify(t, s) && a.preventDefault();
  }, r.prototype._withinIgnoreThreshold = function() {
    var t = this.x.initialDelta, e = this.y.initialDelta;
    return Math.sqrt(t * t + e * e) <= this.threshold;
  }, r;
}(N);
function _c(n) {
  for (var r = Ql(), o = r.up.split(" "), t = 0, e = o.length; t < e; t++)
    n(o[t]);
}
var Ss = function(n) {
  function r(o, t) {
    n.call(this);
    var e = this, i, a = Gr();
    this.support = a, t = t || {}, this.options = t, i = e.filter = t.filter, e.threshold = t.threshold || cc, e.minHold = t.minHold || hc, e.touches = [], e._maxTouches = t.multiTouch ? 2 : 1, e.allowSelection = t.allowSelection, e.captureUpIfMoved = t.captureUpIfMoved, e.useClickAsTap = !t.fastTap && !a.delayedClick(), e._clicks = 0, e.supportDoubleTap = t.supportDoubleTap;
    var s = !a.touch || a.mouseAndTouchPresent;
    if (vn(e, {
      element: o,
      surface: t.global && s ? o.ownerDocument.documentElement : t.surface || o,
      stopPropagation: t.stopPropagation,
      pressed: !1
    }), this._surfaceMoveHandler = lt(this._move, this), jt(e.surface, re("move"), this._surfaceMoveHandler), this._surfaceEndHandler = lt(this._end, this), jt(e.surface, re("up cancel"), this._surfaceEndHandler), this._elementStartHandler = lt(this._start, this), jt(o, re("down"), i, this._elementStartHandler), e.useClickAsTap && (this._elementClickHandler = lt(this._click, this), jt(o, re("click"), i, this._elementClickHandler)), a.pointers || a.msPointers)
      if (a.browser.version < 11) {
        var l = "pinch-zoom double-tap-zoom";
        o.style["-ms-touch-action"] = t.touchAction && t.touchAction !== "none" ? l + " " + t.touchAction : l;
      } else
        o.style["touch-action"] = t.touchAction || "none";
    if (t.preventDragEvent && (this._elementDragStartHandler = k1, jt(o, re("dragstart"), this._elementDragStartHandler)), this._elementSelectHandler = lt(this._select, this), jt(o, re("mousedown"), i, this._elementSelectHandler), e.captureUpIfMoved && a.eventCapture) {
      var p = e.surface, h = lt(e.preventIfMoving, e);
      _c(function(c) {
        p.addEventListener(c, h, !0);
      });
    }
    e.bind([
      gf,
      yf,
      Dn,
      _f,
      mf,
      bs,
      As,
      xf,
      vc,
      O1,
      fc,
      dc,
      gc,
      uc
    ], t);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.preventIfMoving = function(t) {
    this._isMoved() && t.preventDefault();
  }, r.prototype.destroy = function() {
    var t = this, e = this.options, i = this.element;
    if (!t._destroyed) {
      if (t._destroyed = !0, t.captureUpIfMoved && this.support.eventCapture) {
        var a = t.surface;
        _c(function(s) {
          a.removeEventListener(s, t.preventIfMoving);
        });
      }
      Ut(t.surface, re("move"), this._surfaceMoveHandler), Ut(t.surface, re("up cancel"), this._surfaceEndHandler), Ut(i, re("down"), this._elementStartHandler), t.useClickAsTap && Ut(i, re("click"), this._elementClickHandler), e.preventDragEvent && Ut(i, re("dragstart"), this._elementDragStartHandler), Ut(i, re("mousedown"), this._elementSelectHandler), t._disposeAll(), t.unbind(), delete t.surface, delete t.element, delete t.currentTarget;
    }
  }, r.prototype.capture = function() {
    r.current = this;
  }, r.prototype.cancel = function() {
    this._disposeAll(), this.trigger(vc);
  }, r.prototype.notify = function(t, e) {
    var i = this, a = i.touches, s = t;
    if (this._isMultiTouch()) {
      switch (s) {
        case bs:
          s = fc;
          break;
        case As:
          s = dc;
          break;
        case Dn:
          s = gc;
          break;
      }
      vn(e, {
        touches: a
      }, M1(a[0], a[1]));
    }
    return this.trigger(s, vn(e, {
      type: s
    }));
  }, r.prototype.press = function(t, e, i) {
    this._apiCall("_start", t, e, i);
  }, r.prototype.move = function(t, e) {
    this._apiCall("_move", t, e);
  }, r.prototype.end = function(t, e) {
    this._apiCall("_end", t, e);
  }, r.prototype._isMultiTouch = function() {
    return this.touches.length > 1;
  }, r.prototype._maxTouchesReached = function() {
    return this.touches.length >= this._maxTouches;
  }, r.prototype._disposeAll = function() {
    for (var t = this.touches; t.length > 0; )
      t.pop().dispose();
  }, r.prototype._isMoved = function() {
    return qt(this.touches, function(t) {
      return t.isMoved();
    }).length;
  }, r.prototype._select = function(t) {
    (!this.allowSelection || this.trigger(uc, { event: t })) && t.preventDefault();
  }, r.prototype._start = function(t) {
    var e = this, i = 0, a = e.filter, s, l = yc(t), p = l.length, h, c = t.which;
    if (!(c && c > 1 || e._maxTouchesReached()))
      for (r.current = null, e.currentTarget = t.currentTarget, e.stopPropagation && t.stopPropagation(); i < p && !e._maxTouchesReached(); i++)
        h = l[i], a ? s = h.currentTarget : s = e.element, !(s && s.length === 0) && (h = new R1(e, s, h), e.touches.push(h), h.press(), e._isMultiTouch() && e.notify("gesturestart", {}));
  }, r.prototype._move = function(t) {
    this._eachTouch("move", t);
  }, r.prototype._end = function(t) {
    this._eachTouch("end", t);
  }, r.prototype._click = function(t) {
    var e = {
      touch: {
        initialTouch: t.target,
        target: t.currentTarget,
        endTime: sr(),
        x: {
          location: t.pageX,
          client: t.clientX
        },
        y: {
          location: t.pageY,
          client: t.clientY
        }
      },
      x: t.pageX,
      y: t.pageY,
      target: t.currentTarget,
      event: t,
      type: "tap"
    };
    this.trigger("tap", e) && t.preventDefault();
  }, r.prototype._eachTouch = function(t, e) {
    var i = this, a = {}, s = yc(e), l = i.touches, p, h, c, u;
    for (p = 0; p < l.length; p++)
      h = l[p], a[h.id] = h;
    for (p = 0; p < s.length; p++)
      c = s[p], u = a[c.id], u && u[t](c);
  }, r.prototype._apiCall = function(t, e, i, a) {
    this[t]({
      api: !0,
      pageX: e,
      pageY: i,
      clientX: e,
      clientY: i,
      target: a || this.element,
      stopPropagation: Gh,
      preventDefault: Gh
    });
  }, r.defaultThreshold = function(t) {
    cc = t;
  }, r.minHold = function(t) {
    hc = t;
  }, r;
}(be), vi = Object.assign, Rr = Math.abs, L1 = 500, I1 = 0.7, D1 = 0.96, B1 = 10, Ga = 55, z1 = 0.5, xc = 5, j1 = "pull", fn = "change", V1 = "resize", wf = "scroll", N1 = 2, H1 = function(n) {
  function r(o) {
    n.call(this, o);
    var t = this;
    vi(t, o), t.userEvents.bind("gestureend", t.start.bind(this)), t.tapCapture.bind("press", t.cancel.bind(this));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.enabled = function() {
    return this.movable.scale < this.dimensions.minScale;
  }, r.prototype.done = function() {
    return this.dimensions.minScale - this.movable.scale < 0.01;
  }, r.prototype.tick = function() {
    var t = this.movable;
    t.scaleWith(1.1), this.dimensions.rescale(t.scale);
  }, r.prototype.onEnd = function() {
    var t = this.movable;
    t.scaleTo(this.dimensions.minScale), this.dimensions.rescale(t.scale);
  }, r;
}(fa), F1 = function(n) {
  function r(o) {
    n.call(this);
    var t = this;
    vi(t, o, {
      transition: new pc({
        axis: o.axis,
        movable: o.movable,
        onEnd: function() {
          t._end();
        }
      })
    }), t.tapCapture.bind("press", function() {
      t.cancel();
    }), t.userEvents.bind("end", lt(t.start, t)), t.userEvents.bind("gestureend", lt(t.start, t)), t.userEvents.bind("tap", lt(t.onEnd, t));
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.onCancel = function() {
    this.transition.cancel();
  }, r.prototype.freeze = function(t) {
    var e = this;
    e.cancel(), e._moveTo(t);
  }, r.prototype.onEnd = function() {
    var t = this;
    t.paneAxis.outOfBounds() ? t._snapBack() : t._end();
  }, r.prototype.done = function() {
    return Rr(this.velocity) < 1;
  }, r.prototype.start = function(t) {
    var e = this, i;
    e.dimension.enabled && (e.paneAxis.outOfBounds() ? e.transition._started ? (e.transition.cancel(), e.velocity = Math.min(t.touch[e.axis].velocity * e.velocityMultiplier, Ga), n.prototype.start.call(this)) : e._snapBack() : (i = t.touch.id === N1 ? 0 : t.touch[e.axis].velocity, e.velocity = Math.max(Math.min(i * e.velocityMultiplier, Ga), -Ga), e.tapCapture.captureNext(), n.prototype.start.call(this)));
  }, r.prototype.tick = function() {
    var t = this, e = t.dimension, i = t.paneAxis.outOfBounds() ? z1 : t.friction, a = t.velocity *= i, s = t.movable[t.axis] + a;
    !t.elastic && e.outOfBounds(s) && (s = Math.max(Math.min(s, e.max), e.min), t.velocity = 0), t.movable.moveAxis(t.axis, s);
  }, r.prototype._end = function() {
    this.tapCapture.cancelCapture(), this.end();
  }, r.prototype._snapBack = function() {
    var t = this, e = t.dimension, i = t.movable[t.axis] > e.max ? e.max : e.min;
    t._moveTo(i);
  }, r.prototype._moveTo = function(t) {
    this.transition.moveTo({
      location: t,
      duration: L1,
      ease: pc.easeOutExpo
    });
  }, r;
}(fa), U1 = function(n) {
  function r(o) {
    n.call(this, o);
    var t = this;
    vi(t, o, {
      origin: {},
      destination: {},
      offset: {}
    });
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.tick = function() {
    this._updateCoordinates(), this.moveTo(this.origin);
  }, r.prototype.done = function() {
    return Rr(this.offset.y) < xc && Rr(this.offset.x) < xc;
  }, r.prototype.onEnd = function() {
    this.moveTo(this.destination), this.callback && this.callback.call();
  }, r.prototype.setCoordinates = function(t, e) {
    this.offset = {}, this.origin = t, this.destination = e;
  }, r.prototype.setCallback = function(t) {
    t && vt(t) ? this.callback = t : t = void 0;
  }, r.prototype._updateCoordinates = function() {
    this.offset = {
      x: (this.destination.x - this.origin.x) / 4,
      y: (this.destination.y - this.origin.y) / 4
    }, this.origin = {
      y: this.origin.y + this.offset.y,
      x: this.origin.x + this.offset.x
    };
  }, r;
}(fa), $1 = function(n) {
  function r(o) {
    n.call(this);
    var t = this, e = o.axis === "x", i = e ? "horizontal" : "vertical", a = jr('<div class="km-touch-scrollbar km-' + i + '-scrollbar" />');
    vi(t, o, {
      element: a,
      elementSize: 0,
      movable: new ep(a),
      scrollMovable: o.movable,
      alwaysVisible: o.alwaysVisible,
      size: e ? "width" : "height"
    }), t.scrollMovable.bind(fn, t.refresh.bind(t)), t.container.appendChild(a), o.alwaysVisible && t.show();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.refresh = function() {
    var t = this, e = t.axis, i = t.dimension, a = i.size, s = t.scrollMovable, l = a / i.total, p = Math.round(-s[e] * l), h = Math.round(a * l);
    l >= 1 ? this.element.style.display = "none" : this.element.style.display = "", p + h > a ? h = a - p : p < 0 && (h += p, p = 0), t.elementSize !== h && (t.element.style[t.size] = h + "px", t.elementSize = h), t.movable.moveAxis(e, p);
  }, r.prototype.show = function() {
    this.element.style.opacity = I1, this.element.style.visibility = "visible";
  }, r.prototype.hide = function() {
    this.alwaysVisible || (this.element.style.opacity = 0);
  }, r;
}(N), op = function(n) {
  function r(o, t) {
    n.call(this);
    var e = this;
    this.element = o, this._initOptions(t);
    var i = qx(navigator.userAgent);
    e._native = e.options.useNative && i;
    var a = jr('<div class="km-scroll-header"/>');
    if (e._native) {
      mt(o, "km-native-scroller"), Uh(a, o), vi(e, {
        scrollElement: o,
        fixedContainer: o.children[0]
      });
      return;
    }
    o.style.overflow = "hidden", mt(o, "km-scroll-wrapper");
    var s = jr('<div class="km-scroll-container"/>');
    Yx(o, s), Uh(a, o);
    var l = o.children[1], p = new m1(o), h = new ep(l), c = new _1({
      element: l,
      container: o,
      forcedEnabled: e.options.zoom
    }), u = this.options.avoidScrolling, v = new Ss(o, {
      touchAction: "pan-y",
      fastTap: !0,
      allowSelection: !0,
      preventDragEvent: !0,
      captureUpIfMoved: !0,
      multiTouch: e.options.zoom,
      supportDoubleTap: e.options.supportDoubleTap,
      start: function(w) {
        c.refresh();
        var A = Rr(w.x.velocity), T = Rr(w.y.velocity), k = A * 2 >= T, C = Kx(e.fixedContainer, w.event.target), z = T * 2 >= A;
        !C && !u(w) && e.enabled && (c.x.enabled && k || c.y.enabled && z) ? v.capture() : v.cancel();
      }
    }), f = new x1({
      movable: h,
      dimensions: c,
      userEvents: v,
      elastic: e.options.elastic
    }), d = new H1({
      movable: h,
      dimensions: c,
      userEvents: v,
      tapCapture: p
    }), m = new U1({
      moveTo: function(w) {
        e.scrollTo(w.x, w.y);
      }
    });
    h.bind(fn, function() {
      e.scrollTop = -h.y, e.scrollLeft = -h.x, e.trigger(wf, {
        scrollTop: e.scrollTop,
        scrollLeft: e.scrollLeft
      });
    }), e.options.mousewheelScrolling && (this._wheelScrollHandler = this._wheelScroll.bind(this), jt(o, "wheel", this._wheelScrollHandler)), vi(e, {
      movable: h,
      dimensions: c,
      zoomSnapBack: d,
      animatedScroller: m,
      userEvents: v,
      pane: f,
      tapCapture: p,
      pulled: !1,
      enabled: !0,
      scrollElement: l,
      scrollTop: 0,
      scrollLeft: 0,
      fixedContainer: o.children[0]
    }), e._initAxis("x"), e._initAxis("y"), e._wheelEnd = function() {
      e._wheel = !1, e.userEvents.end(0, e._wheelY);
    }, c.refresh(), e.options.pullToRefresh && e._initPullToRefresh();
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype._wheelScroll = function(t) {
    if (!t.ctrlKey) {
      this._wheel || (this._wheel = !0, this._wheelY = 0, this.userEvents.press(0, this._wheelY)), clearTimeout(this._wheelTimeout), this._wheelTimeout = setTimeout(this._wheelEnd, 50);
      var e = o1(t);
      e && (this._wheelY += e, this.userEvents.move(0, this._wheelY)), t.preventDefault();
    }
  }, r.prototype.makeVirtual = function() {
    this.dimensions.y.makeVirtual();
  }, r.prototype.virtualSize = function(t, e) {
    this.dimensions.y.virtualSize(t, e);
  }, r.prototype.height = function() {
    return this.dimensions.y.size;
  }, r.prototype.scrollHeight = function() {
    return this.scrollElement.scrollHeight;
  }, r.prototype.scrollWidth = function() {
    return this.scrollElement.scrollWidth;
  }, r.prototype._resize = function() {
    this._native || this.contentResized();
  }, r.prototype.setOptions = function(t) {
    var e = this;
    this._initOptions(t), t.pullToRefresh && e._initPullToRefresh();
  }, r.prototype.reset = function() {
    this._native ? this.scrollElement.scrollTop(0) : (this.movable.moveTo({
      x: 0,
      y: 0
    }), this._scale(1));
  }, r.prototype.contentResized = function() {
    this.dimensions.refresh(), this.pane.x.outOfBounds() && this.movable.moveAxis("x", this.dimensions.x.min), this.pane.y.outOfBounds() && this.movable.moveAxis("y", this.dimensions.y.min);
  }, r.prototype.zoomOut = function() {
    var t = this.dimensions;
    t.refresh(), this._scale(t.fitScale), this.movable.moveTo(t.centerCoordinates());
  }, r.prototype.enable = function() {
    this.enabled = !0;
  }, r.prototype.disable = function() {
    this.enabled = !1;
  }, r.prototype.scrollTo = function(t, e) {
    this._native ? (this.scrollElement.scrollLeft(Rr(t)), this.scrollElement.scrollTop(Rr(e))) : (this.dimensions.refresh(), this.movable.moveTo({
      x: t,
      y: e
    }));
  }, r.prototype.animatedScrollTo = function(t, e, i) {
    var a, s;
    this._native ? this.scrollTo(t, e) : (a = {
      x: this.movable.x,
      y: this.movable.y
    }, s = {
      x: t,
      y: e
    }, this.animatedScroller.setCoordinates(a, s), this.animatedScroller.setCallback(i), this.animatedScroller.start());
  }, r.prototype.pullHandled = function() {
  }, r.prototype.destroy = function() {
    var t = this.element;
    Ut(t, "wheel", this._wheelScrollHandler), this.userEvents && this.userEvents.destroy();
  }, r.prototype._scale = function(t) {
    this.dimensions.rescale(t), this.movable.scaleTo(t);
  }, r.prototype._initPullToRefresh = function() {
  }, r.prototype._dragEnd = function() {
  }, r.prototype._paneChange = function() {
  }, r.prototype._initAxis = function(t) {
    var e = this, i = e.movable, a = e.dimensions[t], s = e.tapCapture, l = e.pane[t], p = new $1({
      axis: t,
      movable: i,
      dimension: a,
      container: e.element,
      alwaysVisible: e.options.visibleScrollHints
    });
    a.bind(fn, function() {
      p.refresh();
    }), l.bind(fn, function() {
      p.show();
    }), e[t + "inertia"] = new F1({
      axis: t,
      paneAxis: l,
      movable: i,
      tapCapture: s,
      userEvents: e.userEvents,
      dimension: a,
      elastic: e.options.elastic,
      friction: e.options.friction || D1,
      velocityMultiplier: e.options.velocityMultiplier || B1,
      end: function() {
        p.hide(), e.trigger("scrollEnd", {
          axis: t,
          scrollTop: e.scrollTop,
          scrollLeft: e.scrollLeft
        });
      }
    });
  }, r;
}(be);
O(op, {
  name: "Scroller",
  zoom: !1,
  pullOffset: 140,
  visibleScrollHints: !1,
  elastic: !0,
  useNative: !1,
  mousewheelScrolling: !0,
  avoidScrolling: function() {
    return !1;
  },
  pullToRefresh: !1,
  messages: {
    pullTemplate: "Pull to refresh",
    releaseTemplate: "Release to refresh",
    refreshTemplate: "Refreshing"
  }
});
va(op, [
  j1,
  wf,
  V1
]);
var bf = function(r, o) {
  o === void 0 && (o = {}), this.sender = o.sender || r, this.widget = r, this.rtl = !!o.rtl;
};
bf.prototype.notify = function(r, o) {
  this.widget && this.widget.trigger(r, o);
};
var fr = Math, wc = fr.min, Wa = fr.pow, bc = q, dn = "marker", nn = "location", G1 = 0.9, W1 = 0.93, Ac = "wheel", X1 = 50, Y1 = 5, q1 = 1, Af = {
  bubble: ff,
  shape: rp,
  tile: cf
};
Af[dn] = ip;
var Sf = function(n) {
  function r(o, t, e, i) {
    t === void 0 && (t = {}), e === void 0 && (e = {}), i === void 0 && (i = {}), n.call(this), this._init(o, t, e, i);
  }
  return n && (r.__proto__ = n), r.prototype = Object.create(n && n.prototype), r.prototype.constructor = r, r.prototype.destroy = function() {
    var t = this;
    this.scroller.destroy(), this._tooltip && this._tooltip.destroy(), this.navigator && this.navigator.destroy(), this.attribution && this.attribution.destroy(), this.zoomControl && this.zoomControl.destroy(), Ot(this.markers) ? this.markers.forEach(function(i) {
      i.destroy();
    }) : this.markers.destroy();
    for (var e = 0; e < this.layers.length; e++)
      t.layers[e].destroy();
    Ut(this.element, Ac, this._mousewheelHandler), n.prototype.destroy.call(this);
  }, r.prototype._init = function(t, e, i, a) {
    e === void 0 && (e = {}), a === void 0 && (a = {}), this.support = Gr(), this.context = a, this.initObserver(a), this.initServices(a), this._notifyObserver(d1), this._initOptions(e), this._setEvents(e), this.crs = new Wx(), this._initElement(t), this._viewOrigin = this._getOrigin(), this._tooltip = this._createTooltip(), this._initScroller(), this._initMarkers(), this._initControls(), this._initLayers(), this._reset();
    var s = $s(this._mousewheel.bind(this), X1);
    this._mousewheelHandler = function(l) {
      l.preventDefault(), s(l);
    }, jt(this.element, Ac, this._mousewheelHandler);
  }, r.prototype._initOptions = function(t) {
    this.options = b({}, this.options, t);
  }, r.prototype._initElement = function(t) {
    this.element = t, mt(t, "k-map"), t.style.position = "relative", t.setAttribute("data-role", "map"), po(t);
    var e = jr("<div />");
    this.element.appendChild(e);
  }, r.prototype.initServices = function(t) {
    t === void 0 && (t = {}), this.widgetService = new bf(this, t);
  }, r.prototype.initObserver = function(t) {
    t === void 0 && (t = {}), this.observers = [], this.addObserver(t.observer);
  }, r.prototype.addObserver = function(t) {
    t && this.observers.push(t);
  }, r.prototype.removeObserver = function(t) {
    var e = this.observers.indexOf(t);
    e >= 0 && this.observers.splice(e, 1);
  }, r.prototype.requiresHandlers = function(t) {
    for (var e = this.observers, i = 0; i < e.length; i++)
      if (e[i].requiresHandlers(t))
        return !0;
  }, r.prototype.trigger = function(t, e) {
    e === void 0 && (e = {}), e.sender = this;
    for (var i = this.observers, a = !1, s = 0; s < i.length; s++)
      i[s].trigger(t, e) && (a = !0);
    return a || n.prototype.trigger.call(this, t, e), a;
  }, r.prototype._notifyObserver = function(t, e) {
    e === void 0 && (e = {}), e.sender = this;
    for (var i = this.observers, a = !1, s = 0; s < i.length; s++)
      i[s].trigger(t, e) && (a = !0);
    return a;
  }, r.prototype.zoom = function(t) {
    var e = this.options, i;
    if (P(t)) {
      var a = fr.round(j(t, e.minZoom, e.maxZoom));
      e.zoom !== a && (e.zoom = a, this.widgetService.notify(f1, { zoom: e.zoom }), this._reset()), i = this;
    } else
      i = e.zoom;
    return i;
  }, r.prototype.center = function(t) {
    var e;
    if (t) {
      var i = At.create(t), a = At.create(this.options.center);
      i.equals(a) || (this.options.center = i.toArray(), this.widgetService.notify(Kh, { center: this.options.center }), this._reset()), e = this;
    } else
      e = At.create(this.options.center);
    return e;
  }, r.prototype.extent = function(t) {
    var e;
    return t ? (this._setExtent(t), e = this) : e = this._getExtent(), e;
  }, r.prototype.setOptions = function(t) {
    t === void 0 && (t = {});
    var e = this.element;
    this.destroy(), po(e), this._init(e, t, {}, this.context), this._reset();
  }, r.prototype.locationToLayer = function(t, e) {
    var i = !this.options.wraparound, a = At.create(t);
    return this.crs.toPoint(a, this._layerSize(e), i);
  }, r.prototype.layerToLocation = function(t, e) {
    var i = !this.options.wraparound, a = bc.create(t);
    return this.crs.toLocation(a, this._layerSize(e), i);
  }, r.prototype.locationToView = function(t) {
    var e = At.create(t), i = this.locationToLayer(this._viewOrigin), a = this.locationToLayer(e);
    return a.translateWith(i.scale(-1));
  }, r.prototype.viewToLocation = function(t, e) {
    var i = this.locationToLayer(this._getOrigin(), e), a = bc.create(t), s = a.clone().translateWith(i);
    return this.layerToLocation(s, e);
  }, r.prototype.eventOffset = function(t) {
    var e, i, a = ii(this.element);
    if (t.x && t.x[nn] || t.y && t.y[nn])
      e = t.x[nn] - a.left, i = t.y[nn] - a.top;
    else {
      var s = t.originalEvent || t;
      e = U(s.pageX, s.clientX) - a.left, i = U(s.pageY, s.clientY) - a.top;
    }
    var l = new q(e, i);
    return l;
  }, r.prototype.eventToView = function(t) {
    var e = this.eventOffset(t);
    return this.locationToView(this.viewToLocation(e));
  }, r.prototype.eventToLayer = function(t) {
    return this.locationToLayer(this.eventToLocation(t));
  }, r.prototype.eventToLocation = function(t) {
    var e = this.eventOffset(t);
    return this.viewToLocation(e);
  }, r.prototype.viewSize = function() {
    var t = this.element, e = this._layerSize(), i = t.clientWidth;
    return this.options.wraparound || (i = wc(e, i)), {
      width: i,
      height: wc(e, t.clientHeight)
    };
  }, r.prototype.exportVisual = function() {
    return this._reset(), !1;
  }, r.prototype.hideTooltip = function() {
    this._tooltip && this._tooltip.hide();
  }, r.prototype._setOrigin = function(t, e) {
    var i = this.viewSize(), a, s = this._origin = At.create(t);
    return a = this.locationToLayer(s, e), a.x += i.width / 2, a.y += i.height / 2, this.options.center = this.layerToLocation(a, e).toArray(), this.widgetService.notify(Kh, { center: this.options.center }), this;
  }, r.prototype._getOrigin = function(t) {
    var e = this.viewSize(), i;
    return (t || !this._origin) && (i = this.locationToLayer(this.center()), i.x -= e.width / 2, i.y -= e.height / 2, this._origin = this.layerToLocation(i)), this._origin;
  }, r.prototype._setExtent = function(t) {
    var e = this, i = un.create(t), a = i.se.clone();
    this.options.wraparound && a.lng < 0 && t.nw.lng > 0 && (a.lng = 180 + (180 + a.lng));
    var s = new un(i.nw, a);
    this.center(s.center());
    var l = this.element.clientWidth, p = this.element.clientHeight, h;
    for (h = this.options.maxZoom; h >= this.options.minZoom; h--) {
      var c = e.locationToLayer(s.nw, h), u = e.locationToLayer(s.se, h), v = fr.abs(u.x - c.x), f = fr.abs(u.y - c.y);
      if (v <= l && f <= p)
        break;
    }
    this.zoom(h);
  }, r.prototype._getExtent = function() {
    var t = this._getOrigin(), e = this.locationToLayer(t), i = this.viewSize();
    e.x += i.width, e.y += i.height;
    var a = this.layerToLocation(e);
    return new un(t, a);
  }, r.prototype._zoomAround = function(t, e) {
    this._setOrigin(this.layerToLocation(t, e), e), this.zoom(e);
  }, r.prototype._initControls = function() {
    var t = this.options.controls;
    t.attribution && this._createAttribution(t.attribution), this.support.mobileOS || (t.navigator && this._createNavigator(t.navigator), t.zoom && this._createZoomControl(t.zoom));
  }, r.prototype._createControlElement = function(t, e) {
    var i = t.position || e, a = "." + Wh(i).replace(" ", "."), s = this.element.querySelector(".k-map-controls" + a) || [];
    if (s.length === 0) {
      var l = document.createElement("div");
      mt(l, "k-map-controls " + Wh(i)), s = l, this.element.appendChild(s);
    }
    var p = document.createElement("div");
    return s.appendChild(p), p;
  }, r.prototype._createAttribution = function(t) {
    var e = this._createControlElement(t, "bottomRight");
    this.attribution = new af(e, t);
  }, r.prototype._createNavigator = function(t) {
    var e = this._createControlElement(t, "topLeft"), i = this.navigator = new Kl(e, b({}, t, { icons: this.options.icons }));
    this._navigatorPan = this._navigatorPan.bind(this), i.bind("pan", this._navigatorPan), this._navigatorCenter = this._navigatorCenter.bind(this), i.bind("center", this._navigatorCenter);
  }, r.prototype._navigatorPan = function(t) {
    var e = this.scroller, i = e.scrollLeft + t.x, a = e.scrollTop - t.y, s = this._virtualSize, l = this.element.clientWidth, p = this.element.clientHeight;
    i = j(i, s.x.min, s.x.max - l), a = j(a, s.y.min, s.y.max - p), this.scroller.one("scroll", lt(this._scrollEnd, this)), this.scroller.scrollTo(-i, -a);
  }, r.prototype._navigatorCenter = function() {
    this.center(this.options.center);
  }, r.prototype._createZoomControl = function(t) {
    var e = this._createControlElement(t, "topLeft"), i = this.zoomControl = new Jl(e, t, this.options.icons);
    this._zoomControlChange = this._zoomControlChange.bind(this), i.bind("change", this._zoomControlChange);
  }, r.prototype._zoomControlChange = function(t) {
    this.trigger("zoomStart", { originalEvent: t }) || (this.zoom(this.zoom() + t.delta), this.trigger("zoomEnd", {
      originalEvent: t
    }));
  }, r.prototype._initScroller = function() {
    var t = this.support.mobileOS ? W1 : G1, e = this.options.zoomable !== !1, i = this.scroller = new op(this.element.children[0], {
      friction: t,
      velocityMultiplier: Y1,
      zoom: e,
      mousewheelScrolling: !1,
      supportDoubleTap: !0
    });
    i.bind("scroll", lt(this._scroll, this)), i.bind("scrollEnd", lt(this._scrollEnd, this)), i.userEvents.bind("gesturestart", lt(this._scaleStart, this)), i.userEvents.bind("gestureend", lt(this._scale, this)), i.userEvents.bind("doubleTap", lt(this._doubleTap, this)), i.userEvents.bind("tap", lt(this._tap, this)), this.scrollElement = i.scrollElement;
  }, r.prototype._initLayers = function() {
    for (var t = this, e = this.options.layers, i = this.layers = [], a = 0; a < e.length; a++) {
      var s = e[a], l = t._createLayer(s);
      i.push(l);
    }
  }, r.prototype._createLayer = function(t) {
    var e = t.type || "shape", i = this.options.layerDefaults[e], a = e === dn ? b({}, this.options.markerDefaults, t, { icons: this.options.icons }) : b({}, i, t), s = Af[e], l = new s(this, a);
    return e === dn && (this.markers = l), l;
  }, r.prototype._createTooltip = function() {
    return new hf(this.widgetService, this.options.tooltip);
  }, r.prototype._initMarkers = function() {
    var t = (this.options.layers || []).filter(function(e) {
      return e && e.type === dn;
    });
    t.length > 0 || (this.markers = new ip(this, b({}, this.options.markerDefaults, { icons: this.options.icons })), this.markers.add(this.options.markers));
  }, r.prototype._scroll = function(t) {
    var e = this.locationToLayer(this._viewOrigin).round(), i = t.sender.movable, a = new q(i.x, i.y).scale(-1).scale(1 / i.scale);
    e.x += a.x, e.y += a.y, this._scrollOffset = a, this._tooltip.offset = a, this.hideTooltip(), this._setOrigin(this.layerToLocation(e)), this.trigger("pan", {
      originalEvent: t,
      origin: this._getOrigin(),
      center: this.center()
    });
  }, r.prototype._scrollEnd = function(t) {
    !this._scrollOffset || !this._panComplete() || (this._scrollOffset = null, this._panEndTimestamp = sr(), this.trigger("panEnd", {
      originalEvent: t,
      origin: this._getOrigin(),
      center: this.center()
    }));
  }, r.prototype._panComplete = function() {
    return sr() - (this._panEndTimestamp || 0) > 50;
  }, r.prototype._scaleStart = function(t) {
    if (this.trigger("zoomStart", { originalEvent: t })) {
      var e = t.touches[1];
      e && e.cancel();
    }
  }, r.prototype._scale = function(t) {
    var e = this.scroller.movable.scale, i = this._scaleToZoom(e), a = new q(t.center.x, t.center.y), s = this.viewToLocation(a, i), l = this.locationToLayer(s, i), p = l.translate(-a.x, -a.y);
    this._zoomAround(p, i), this.trigger("zoomEnd", {
      originalEvent: t
    });
  }, r.prototype._scaleToZoom = function(t) {
    var e = this._layerSize() * t, i = e / this.options.minSize, a = fr.log(i) / fr.log(2);
    return fr.round(a);
  }, r.prototype._reset = function() {
    this.attribution && this.attribution.filter(this.center(), this.zoom()), this._viewOrigin = this._getOrigin(!0), this._resetScroller(), this.hideTooltip(), this.trigger("beforeReset"), this.trigger("reset");
  }, r.prototype._resetScroller = function() {
    var t = this.scroller, e = t.dimensions.x, i = t.dimensions.y, a = this._layerSize(), s = this.extent().nw, l = this.locationToLayer(s).round();
    t.movable.round = !0, t.reset(), t.userEvents.cancel();
    var p = this.zoom();
    t.dimensions.forcedMinScale = Wa(2, this.options.minZoom - p), t.dimensions.maxScale = Wa(2, this.options.maxZoom - p);
    var h = {
      min: -l.x,
      max: a - l.x
    }, c = {
      min: -l.y,
      max: a - l.y
    };
    if (this.options.wraparound && (h.max = 20 * a, h.min = -h.max), this.options.pannable === !1) {
      var u = this.viewSize();
      h.min = c.min = 0, h.max = u.width, c.max = u.height;
    }
    e.makeVirtual(), i.makeVirtual(), e.virtualSize(h.min, h.max), i.virtualSize(c.min, c.max), this._virtualSize = {
      x: h,
      y: c
    };
  }, r.prototype._renderLayers = function() {
  }, r.prototype._layerSize = function(t) {
    var e = U(t, this.options.zoom);
    return this.options.minSize * Wa(2, e);
  }, r.prototype._tap = function(t) {
    if (this._panComplete()) {
      var e = this.eventOffset(t);
      this.hideTooltip(), this.trigger("click", {
        originalEvent: t,
        location: this.viewToLocation(e)
      });
    }
  }, r.prototype._doubleTap = function(t) {
    var e = this.options;
    if (e.zoomable !== !1 && !this.trigger("zoomStart", { originalEvent: t })) {
      var i = this.zoom() + q1, a = this.eventOffset(t), s = this.viewToLocation(a), l = this.locationToLayer(s, i), p = l.translate(-a.x, -a.y);
      this._zoomAround(p, i), this.trigger("zoomEnd", {
        originalEvent: t
      });
    }
  }, r.prototype._mousewheel = function(t) {
    var e = Ys(t) > 0 ? -1 : 1, i = this.options, a = this.zoom(), s = j(a + e, i.minZoom, i.maxZoom);
    if (i.zoomable !== !1 && s !== a && !this.trigger("zoomStart", { originalEvent: t })) {
      var l = this.eventOffset(t), p = this.viewToLocation(l), h = this.locationToLayer(p, s), c = h.translate(-l.x, -l.y);
      this._zoomAround(c, s), this.trigger("zoomEnd", {
        originalEvent: t
      });
    }
  }, r.prototype._toDocumentCoordinates = function(t) {
    var e = ii(this.element);
    return {
      left: R(t.x + e.left),
      top: R(t.y + e.top)
    };
  }, r;
}(be);
O(Sf, {
  name: "Map",
  controls: {
    attribution: !0,
    navigator: {
      panStep: 100
    },
    zoom: !0
  },
  layers: [],
  layerDefaults: {
    shape: {
      style: {
        fill: {
          color: "#fff"
        },
        stroke: {
          color: "#aaa",
          width: 0.5
        }
      }
    },
    bubble: {
      style: {
        fill: {
          color: "#fff",
          opacity: 0.5
        },
        stroke: {
          color: "#aaa",
          width: 0.5
        }
      }
    },
    marker: {
      shape: "pinTarget",
      tooltip: {
        position: "top"
      }
    }
  },
  center: [
    0,
    0
  ],
  icons: {
    type: "font",
    svgIcons: {}
  },
  zoom: 3,
  minSize: 256,
  minZoom: 1,
  maxZoom: 19,
  markers: [],
  markerDefaults: {
    shape: "pinTarget",
    tooltip: {
      position: "top"
    }
  },
  wraparound: !0,
  // If set to true, GeoJSON layer "Point" features will be rendered as markers.
  // Otherwise, the points will be rendered as circles.
  // Defaults to `true` for KUI/jQuery, `false` everywhere else.
  renderPointsAsMarkers: !1
});
va(Sf, [
  "beforeReset",
  "click",
  "markerActivate",
  "markerClick",
  "markerCreated",
  // Events for implementing custom tooltips.
  "markerMouseEnter",
  "markerMouseLeave",
  "pan",
  "panEnd",
  "reset",
  "shapeClick",
  "shapeCreated",
  "shapeFeatureCreated",
  "shapeMouseEnter",
  "shapeMouseLeave",
  "zoomEnd",
  "zoomStart"
]);
var Bo = 1.5, Ei = 0.4, Tf = "#000", np = "Arial, Helvetica, sans-serif", Z1 = "11px " + np, da = "12px " + np, Cf = "16px " + np, kf = "transparent", Pf = "#fff", Of = function() {
  return {
    icon: {
      border: {
        width: 1
      }
    },
    label: {
      font: da,
      padding: 3
    },
    line: {
      length: 10,
      width: 2
    },
    visible: !0
  };
}, Q1 = function() {
  return {
    labels: {
      font: da
    },
    notes: Of(),
    title: {
      font: Cf,
      margin: 5
    }
  };
}, Sc = function() {
  return {
    highlight: {
      markers: {
        border: {}
      }
    },
    line: {
      opacity: 1,
      width: 0
    },
    markers: {
      size: 6,
      visible: !1
    },
    opacity: 0.4
  };
}, Tc = function() {
  return {
    highlight: {
      markers: {
        border: {}
      }
    },
    line: {
      opacity: 1,
      width: 0
    },
    markers: {
      size: 6,
      visible: !1
    },
    opacity: 0.4
  };
}, K1 = function() {
  return {
    gap: Bo,
    spacing: Ei
  };
}, Cc = function() {
  return {
    outliersField: "",
    meanField: "",
    border: {
      _brightness: 0.8,
      width: 1
    },
    downColor: Pf,
    gap: 1,
    highlight: {
      border: {
        opacity: 1,
        width: 2
      },
      whiskers: {
        width: 3
      },
      mean: {
        width: 2
      },
      median: {
        width: 2
      }
    },
    mean: {
      width: 2
    },
    median: {
      width: 2
    },
    spacing: 0.3,
    whiskers: {
      width: 2
    }
  };
}, J1 = function() {
  return {
    border: {
      width: 0
    },
    labels: {
      background: kf
    },
    opacity: 0.6
  };
}, kc = function() {
  return {
    gap: Bo,
    spacing: Ei,
    target: {
      color: "#ff0000"
    }
  };
}, tw = function() {
  return {
    border: {
      _brightness: 0.8,
      width: 1
    },
    downColor: Pf,
    gap: 1,
    highlight: {
      border: {
        opacity: 1,
        width: 2
      },
      line: {
        width: 2
      }
    },
    line: {
      color: Tf,
      width: 1
    },
    spacing: 0.3
  };
}, ew = function() {
  return {
    gap: Bo,
    spacing: Ei
  };
}, rw = function() {
  return {
    margin: 1
  };
}, Pc = function() {
  return {
    width: 2
  };
}, iw = function() {
  return {
    gap: 1,
    highlight: {
      line: {
        opacity: 1,
        width: 3
      }
    },
    line: {
      width: 1
    },
    spacing: 0.3
  };
}, Oc = function() {
  return {
    line: {
      opacity: 1,
      width: 0
    },
    markers: {
      size: 6,
      visible: !1
    },
    opacity: 0.5
  };
}, Ec = function() {
  return {
    markers: {
      visible: !1
    },
    width: 2
  };
}, ow = function() {
  return {
    gap: Bo,
    spacing: Ei
  };
}, nw = function() {
  return {
    gap: Bo,
    spacing: Ei
  };
}, aw = function() {
  return {
    width: 1
  };
}, Mc = function() {
  return {
    gap: 0.5,
    line: {
      color: Tf,
      width: 1
    },
    spacing: Ei
  };
}, sw = function() {
  return {
    labels: {
      background: "",
      color: "",
      padding: {
        top: 5,
        bottom: 5,
        left: 7,
        right: 7
      }
    }
  };
}, Ef = function() {
  return {
    labels: {
      background: "",
      color: "",
      padding: {
        top: 5,
        bottom: 5,
        left: 7,
        right: 7
      }
    }
  };
}, lw = Ef, pw = function() {
  return {
    labels: {
      color: "",
      background: kf,
      visible: !0
    },
    highlight: {
      border: {
        width: 0
      }
    }
  };
}, hw = function(n) {
  return {
    visible: !0,
    labels: {
      font: Z1
    },
    overlay: n.gradients ? {} : {
      gradient: "none"
    },
    area: Sc(),
    rangeArea: Tc(),
    verticalRangeArea: Tc(),
    bar: K1(),
    boxPlot: Cc(),
    bubble: J1(),
    bullet: kc(),
    candlestick: tw(),
    column: ew(),
    heatmap: pw(),
    pie: sw(),
    donut: rw(),
    funnel: Ef(),
    pyramid: lw(),
    horizontalWaterfall: Mc(),
    line: Pc(),
    notes: Of(),
    ohlc: iw(),
    radarArea: Oc(),
    radarLine: Ec(),
    polarArea: Oc(),
    polarLine: Ec(),
    rangeBar: ow(),
    rangeColumn: nw(),
    scatterLine: aw(),
    verticalArea: Sc(),
    verticalBoxPlot: Cc(),
    verticalBullet: kc(),
    verticalLine: Pc(),
    waterfall: Mc()
  };
}, cw = function() {
  return {
    font: Cf
  };
}, uw = function() {
  return {
    font: da
  };
}, vw = function() {
  return {
    labels: {
      font: da
    }
  };
}, Rc = function(n) {
  return n === void 0 && (n = {}), {
    axisDefaults: Q1(),
    categoryAxis: {
      majorGridLines: {
        visible: !0
      }
    },
    navigator: {
      pane: {
        height: 90,
        margin: {
          top: 10
        }
      }
    },
    seriesDefaults: hw(n),
    title: cw(),
    subtitle: uw(),
    legend: vw()
  };
}, Mf = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), ap = function() {
  for (var n = [], r = 0; r < arguments.length; r++)
    n[r] = arguments[r];
  var o = {}, t = function(i) {
    return typeof i == "object" ? Object.keys(i).forEach(function(a) {
      o[a] = i[a];
    }) : o[i] = !0;
  }, e = function(i) {
    return i.filter(function(a) {
      return a !== !0 && !!a;
    }).map(function(a) {
      return Array.isArray(a) ? e(a) : t(a);
    });
  };
  return e(n), Object.keys(o).map(function(i) {
    return o[i] && i || null;
  }).filter(function(i) {
    return i !== null;
  }).join(" ");
}, fw = ["telerik.com", "progress.com", "stackblitz.io", "csb.app"];
function dw(n) {
  if (typeof Xa < "u")
    Wc(n);
  else {
    var r = "License activation failed for ".concat(n.name, `
`);
    r += `The @progress/kendo-licensing script is not loaded.
`, r += "See ".concat(n.licensingDocsUrl, ` for more information.
`), console.warn(r);
  }
}
function gw(n) {
  var r = fw.some(function(o) {
    var t;
    return (t = globalThis.document) === null || t === void 0 ? void 0 : t.location.hostname.endsWith(o);
  });
  return !r && !(!(Xa === null || Xa === void 0) && Wc(n));
}
var yw = "https://www.telerik.com/kendo-react-ui/components/my-license/", Lc = !1, mw = function() {
  var n = M.useState(!0), r = n[0], o = n[1], t = M.useState(!1), e = t[0], i = t[1];
  M.useEffect(function() {
    Lc || (i(!0), Lc = !0);
  }, []);
  var a = function() {
    o(!1);
  }, s = M.createElement(M.Fragment, null, r && M.createElement(
    "div",
    { style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "fixed",
      top: "16px",
      right: "16px",
      padding: "12px",
      borderRadius: "4px",
      boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.03)",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      backgroundColor: "#FFC000",
      color: "#1E1E1E",
      zIndex: 999
    } },
    M.createElement(
      "span",
      { style: { display: "flex", alignSelf: "center", marginRight: "8px" } },
      M.createElement(
        "svg",
        { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        M.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1L0 15H16L8 1ZM7 6V11H9V6H7ZM7 14V12H9V14H7Z", fill: "#1E1E1E" })
      )
    ),
    M.createElement("span", null, "No license found for KendoReact. Learn how to activate your license."),
    M.createElement(
      "div",
      { style: { display: "flex", alignItems: "center", marginLeft: "24px" } },
      M.createElement(
        "a",
        { href: yw, style: { marginRight: "8px", display: "flex" } },
        M.createElement(
          "button",
          { title: "Learn More", style: {
            display: "inline-flex",
            position: "relative",
            border: "none",
            borderRadius: "4px",
            padding: "5px",
            backgroundColor: "transparent",
            transition: "color 0.2s ease-in-out",
            outline: "none",
            cursor: "pointer"
          } },
          M.createElement(
            "svg",
            { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
            M.createElement("path", { d: "M15 8C15 11.8656 11.8656 15 8 15C4.13437 15 1 11.8656 1 8C1 4.13437 4.13437 1 8 1C11.8656 1 15 4.13437 15 8ZM14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8ZM11 6C11 7.4125 10.2687 8.05937 9.73125 8.53125C9.25937 8.94688 9 9.17813 9 10H7C7 8.275 7.84688 7.525 8.40938 7.03125C8.84062 6.65312 9 6.50938 9 6C9 5.45 8.55 5 8 5C7.45 5 7 5.45 7 6H5C5 4.34375 6.34375 3 8 3C9.65625 3 11 4.34375 11 6ZM9 13V11H7V13H9Z", fill: "#1E1E1E" })
          )
        )
      ),
      M.createElement(
        "button",
        { title: "Close", style: {
          display: "inline-flex",
          position: "relative",
          border: "none",
          borderRadius: "4px",
          padding: "5px",
          backgroundColor: "transparent",
          transition: "color 0.2s ease-in-out",
          outline: "none",
          cursor: "pointer"
        }, onClick: a },
        M.createElement(
          "svg",
          { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
          M.createElement("path", { d: "M13 4.41562L9.41563 8L13 11.5844L11.5844 13L8 9.41563L4.41562 13L3 11.5844L6.58437 8L3 4.41562L4.41562 3L8 6.58437L11.5844 3L13 4.41562Z", fill: "#1E1E1E" })
        )
      )
    )
  ));
  return M.createElement(
    M.Fragment,
    null,
    M.createElement("div", { style: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0.2,
      zIndex: 101,
      pointerEvents: "none",
      backgroundImage: "url('data:image/png;base64,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')"
    } }),
    e && Vd.createPortal(s, document.body)
  );
};
function Rf(n, r) {
  for (var o = n; o && o !== r; )
    o = o.parentNode;
  return !!o;
}
function sp(n, r, o, t) {
  var e = n[r];
  if (e && Array.isArray(e))
    for (var i = 0, a = e; i < a.length; i++) {
      var s = a[i];
      if (!s.type || s.type !== t)
        return new Error("".concat(o, " children should be Array of type ").concat(t.displayName, "."));
    }
  return null;
}
var Ic = function(n) {
  return n === void 0 ? !1 : !n;
}, _w = function(n) {
  return {
    x: {
      location: n.pageX
    },
    y: {
      location: n.pageY
    }
  };
}, xw = function(n, r) {
  var o = n.pointers, t = o[0], e = t.pageX, i = t.pageY, a = 0;
  if (o.length > 1) {
    var s = o[0], l = o[1];
    a = Math.sqrt(Math.pow(s.pageX - l.pageX, 2) + Math.pow(s.pageY - l.pageY, 2));
  }
  return {
    distance: a,
    event: n.srcEvent,
    preventDefault: function() {
      n.preventDefault();
    },
    target: n.target,
    touches: o.map(_w),
    type: n.type,
    x: {
      delta: r ? e - r.x.location : 0,
      initialDelta: n.deltaX,
      location: e,
      startLocation: e - n.deltaX
    },
    y: {
      delta: r ? i - r.y.location : 0,
      initialDelta: n.deltaY,
      location: i,
      startLocation: i - n.deltaY
    }
  };
};
function ww(n, r) {
  for (var o = 0; o < n.length; o++)
    if (r[n[o]])
      return !0;
  return !1;
}
var Dc = [{
  end: "panend",
  move: "panmove",
  start: "panstart"
}, {
  gesturechange: "pinchmove",
  gestureend: "pinchend",
  gesturestart: "pinchstart"
}, {
  press: "press"
}, {
  tap: "tap"
}], bw = (
  /** @class */
  function() {
    function n(r, o) {
      this.hammerInstance = r, this.eventHandlers = {}, this.tap = this.tap.bind(this), this.press = this.press.bind(this), this.panstart = this.panstart.bind(this), this.panmove = this.panmove.bind(this), this.panend = this.panend.bind(this), this.pinchstart = this.pinchstart.bind(this), this.pinchmove = this.pinchmove.bind(this), this.pinchend = this.pinchend.bind(this), o && this.bind(o);
    }
    return n.prototype.tap = function(r) {
      this.trigger("tap", r);
    }, n.prototype.press = function(r) {
      this.trigger("press", r);
    }, n.prototype.panstart = function(r) {
      delete this.previous, this.previous = this.trigger("start", r);
    }, n.prototype.panmove = function(r) {
      this.previous = this.trigger("move", r);
    }, n.prototype.panend = function(r) {
      this.trigger("end", r), delete this.previous;
    }, n.prototype.pinchstart = function(r) {
      this.trigger("gesturestart", r);
    }, n.prototype.pinchmove = function(r) {
      this.trigger("gesturechange", r);
    }, n.prototype.pinchend = function(r) {
      this.trigger("gestureend", r);
    }, n.prototype.trigger = function(r, o) {
      var t = xw(o, this.previous);
      return this.eventHandlers[r] && this.eventHandlers[r](t), t;
    }, n.prototype.bind = function(r) {
      r === void 0 && (r = {}), this.unbind(), this.eventHandlers = r;
      for (var o = 0; o < Dc.length; o++) {
        var t = Dc[o], e = Object.keys(t);
        if (ww(e, r))
          for (var i = 0; i < e.length; i++) {
            var a = t[e[i]];
            this.hammerInstance.on(a, this[a]);
          }
      }
    }, n.prototype.unbind = function() {
      this.hammerInstance && this.hammerInstance.off(), this.eventHandlers = {};
    }, n.prototype.destroy = function() {
      this.hammerInstance && (this.hammerInstance.destroy(), delete this.hammerInstance), delete this.eventHandlers;
    }, n.prototype.toggleDrag = function(r) {
      this.toggle("pan", r);
    }, n.prototype.toggleZoom = function(r) {
      this.toggle("pinch", r);
    }, n.prototype.toggle = function(r, o) {
      if (this.hammerInstance) {
        var t = this.hammerInstance.get(r);
        t.set({
          enable: o
        });
      }
    }, n;
  }()
), Aw = "Hammerjs is not loaded.Solution: http://www.telerik.com/kendo-react-ui/components/charts/troubleshooting/#toc-installation", Sw = (
  /** @class */
  function() {
    function n() {
    }
    return n.create = function(r, o) {
      if (typeof window < "u") {
        var t = window.Hammer;
        if (!t) {
          process.env.NODE_ENV !== "production" && console.warn(Aw);
          return;
        }
        var e = new t(r, {
          recognizers: [
            [t.Tap],
            [t.Pan],
            [t.Pinch],
            [t.Press, { time: 0 }]
          ]
        });
        return new bw(e, o);
      }
    }, n;
  }()
), Jt = (
  /** @class */
  function() {
    function n(r) {
      this.target = r;
    }
    return n;
  }()
), Tw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Cw = (
  /** @class */
  function(n) {
    Tw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axis = o.axis, e.dataItem = o.dataItem, e.index = o.index, e.text = o.text, e.value = o.value, e;
    }
    return r;
  }(Jt)
), kw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), je = (
  /** @class */
  function(n) {
    kw(r, n);
    function r() {
      var o = n !== null && n.apply(this, arguments) || this;
      return o.prevented = !1, o;
    }
    return r.prototype.preventDefault = function() {
      this.prevented = !0;
    }, r.prototype.isDefaultPrevented = function() {
      return this.prevented;
    }, r;
  }(Jt)
), Pw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Ow = (
  /** @class */
  function(n) {
    Pw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axisRanges = o.axisRanges, e.nativeEvent = o.originalEvent, e;
    }
    return r;
  }(je)
), Ew = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Mw = (
  /** @class */
  function(n) {
    Ew(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axisRanges = o.axisRanges, e.nativeEvent = o.originalEvent, e;
    }
    return r;
  }(Jt)
), Rw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Lw = (
  /** @class */
  function(n) {
    Rw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axisRanges = o.axisRanges, e.nativeEvent = o.originalEvent, e;
    }
    return r;
  }(je)
), Iw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Lf = (
  /** @class */
  function(n) {
    Iw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.value = o.value, e.point = o.point, e.series = o.series, e.currentState = o.currentState, e.nextState = o.nextState, e;
    }
    return r;
  }(Jt)
), Dw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Bw = (
  /** @class */
  function(n) {
    Dw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.series = o.series, e.seriesIndex = o.seriesIndex, e.pointIndex = o.pointIndex, e.text = o.text, e;
    }
    return r.prototype.preventDefault = function() {
      n.prototype.preventDefault.call(this);
    }, r;
  }(je)
), zw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), jw = (
  /** @class */
  function(n) {
    zw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.series = o.series, e.seriesIndex = o.seriesIndex, e.pointIndex = o.pointIndex, e.text = o.text, e;
    }
    return r.prototype.preventDefault = function() {
      n.prototype.preventDefault.call(this);
    }, r;
  }(je)
), Vw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Nw = (
  /** @class */
  function(n) {
    Vw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.series = o.series, e.seriesIndex = o.seriesIndex, e.pointIndex = o.pointIndex, e.text = o.text, e;
    }
    return r.prototype.preventDefault = function() {
      n.prototype.preventDefault.call(this);
    }, r;
  }(je)
), Hw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Fw = (
  /** @class */
  function(n) {
    Hw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.from = o.from, e.to = o.to, e;
    }
    return r;
  }(Jt)
), Uw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), $w = (
  /** @class */
  function(n) {
    Uw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.category = o.category, e.dataItem = o.dataItem, e.series = o.series, e.value = o.value, e.visual = o.visual, e;
    }
    return r;
  }(Jt)
), Gw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Ww = (
  /** @class */
  function(n) {
    Gw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.category = o.category, e.dataItem = o.dataItem, e.series = o.series, e.value = o.value, e.visual = o.visual, e;
    }
    return r;
  }(Jt)
), Xw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Yw = (
  /** @class */
  function(n) {
    Xw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.category = o.category, e.nativeEvent = o.originalEvent, e.value = o.value, e.x = o.x, e.y = o.y, e;
    }
    return r;
  }(Jt)
), qw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Zw = (
  /** @class */
  function(n) {
    qw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.category = o.category, e.nativeEvent = o.originalEvent, e.value = o.value, e.x = o.x, e.y = o.y, e;
    }
    return r;
  }(Jt)
), Qw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Kw = (
  /** @class */
  function(n) {
    Qw(r, n);
    function r(o, t) {
      return n.call(this, t) || this;
    }
    return r;
  }(Jt)
), Jw = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), tb = (
  /** @class */
  function(n) {
    Jw(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axis = o.axis, e.from = o.from, e.to = o.to, e;
    }
    return r;
  }(je)
), eb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), rb = (
  /** @class */
  function(n) {
    eb(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axis = o.axis, e.from = o.from, e.to = o.to, e;
    }
    return r;
  }(Jt)
), ib = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), ob = (
  /** @class */
  function(n) {
    ib(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axis = o.axis, e.from = o.from, e.to = o.to, e;
    }
    return r;
  }(je)
), nb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), ab = (
  /** @class */
  function(n) {
    nb(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.category = o.category, e.dataItem = o.dataItem, e.nativeEvent = o.originalEvent, e.percentage = o.percentage, e.point = o.point, e.series = o.series, e.stackValue = o.stackValue, e.value = o.value, e;
    }
    return r;
  }(Jt)
), sb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), lb = (
  /** @class */
  function(n) {
    sb(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.category = o.category, e.categoryPoints = o.categoryPoints, e.dataItem = o.dataItem, e.nativeEvent = o.originalEvent, e.percentage = o.percentage, e.point = o.point, e.series = o.series, e.stackValue = o.stackValue, e.value = o.value, e;
    }
    return r;
  }(je)
), pb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), hb = (
  /** @class */
  function(n) {
    pb(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axisRanges = o.axisRanges, e.delta = o.delta, e.nativeEvent = o.originalEvent, e;
    }
    return r;
  }(je)
), cb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), ub = (
  /** @class */
  function(n) {
    cb(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axisRanges = o.axisRanges, e.nativeEvent = o.originalEvent, e;
    }
    return r;
  }(Jt)
), vb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), fb = (
  /** @class */
  function(n) {
    vb(r, n);
    function r(o, t) {
      var e = n.call(this, t) || this;
      return e.axisRanges = o.axisRanges, e.nativeEvent = o.originalEvent, e;
    }
    return r;
  }(je)
), Bc = {
  axisLabelClick: Cw,
  drag: Ow,
  dragEnd: Mw,
  dragStart: Lw,
  drilldownEvent: Lf,
  legendItemHover: Bw,
  legendItemClick: jw,
  legendItemLeave: Nw,
  navigatorFilter: Fw,
  noteClick: $w,
  noteHover: Ww,
  plotAreaClick: Yw,
  plotAreaHover: Zw,
  render: Kw,
  select: tb,
  selectEnd: rb,
  selectStart: ob,
  seriesClick: ab,
  seriesHover: lb,
  zoom: hb,
  zoomEnd: ub,
  zoomStart: fb
};
function db(n, r, o) {
  if (Bc[n])
    return new Bc[n](r, o);
}
var gb = (
  /** @class */
  function() {
    function n(r, o) {
      this.sender = r, this.syntheticEvent = o;
    }
    return n;
  }()
);
function If(n, r) {
  return new gb(n, r);
}
var an = function(n) {
  return "".concat(n.fontWeight, " ").concat(n.fontSize, " ").concat(n.fontFamily);
}, zc = function(n) {
  return window.getComputedStyle(n).backgroundColor;
}, yb = function(n) {
  return n.toLowerCase().charCodeAt(0) - "a".charCodeAt(0);
}, mb = function(n) {
  var r = n.match(/series-([a-z])$/);
  if (r !== null)
    return yb(r[1]);
  var o = n.split("--series-")[1];
  return parseInt(o, 10) - 1;
}, _b = 30, xb = function() {
  for (var n = `
      <div class="k-var--series-a"></div>
      <div class="k-var--series-b"></div>
      <div class="k-var--series-c"></div>
      <div class="k-var--series-d"></div>
      <div class="k-var--series-e"></div>
      <div class="k-var--series-f"></div>
`, r = 0; r < _b; r++)
    n += `
      <div class="k-var--series-`.concat(r + 1, '"></div>');
  return n;
}, wb = `
    <div class="k-var--primary"></div>
    <div class="k-var--base"></div>
    <div class="k-var--background"></div>

    <div class="k-var--normal-background"></div>
    <div class="k-var--normal-text-color"></div>
    <div class="k-var--hover-background"></div>
    <div class="k-var--hover-text-color"></div>
    <div class="k-var--selected-background"></div>
    <div class="k-var--selected-text-color"></div>
    <div class="k-var--chart-error-bars-background"></div>
    <div class="k-var--chart-notes-background"></div>
    <div class="k-var--chart-notes-border"></div>
    <div class="k-var--chart-notes-lines"></div>
    <div class="k-var--chart-crosshair-background"></div>

    <div class="k-var--chart-inactive"></div>
    <div class="k-var--chart-major-lines"></div>
    <div class="k-var--chart-minor-lines"></div>
    <div class="k-var--chart-area-opacity"></div>
    <div class="k-var--chart-area-inactive-opacity"></div>
    <div class="k-var--chart-line-inactive-opacity"></div>

    <div class="k-widget k-chart">
        <div class="k-var--chart-font"></div>
        <div class="k-var--chart-title-font"></div>
        <div class="k-var--chart-pane-title-font"></div>
        <div class="k-var--chart-label-font"></div>
    </div>

    <div class="k-var--series-unset"></div>
    <div class="k-var--series">
      `.concat(xb(), `
    </div>
`), bb = (
  /** @class */
  function() {
    function n(r) {
      this.store = r;
    }
    return n.prototype.setStyle = function(r, o) {
      this.store.dispatch({ type: "set", payload: { field: r, value: o } });
    }, n.prototype.setColors = function() {
      this.mapColor("axisDefaults.crosshair.color", "chart-crosshair-background"), this.mapColor("axisDefaults.labels.color", "normal-text-color"), this.mapColor("axisDefaults.line.color", "chart-major-lines"), this.mapColor("axisDefaults.majorGridLines.color", "chart-major-lines"), this.mapColor("axisDefaults.minorGridLines.color", "chart-minor-lines"), this.mapColor("axisDefaults.notes.icon.background", "chart-notes-background"), this.mapColor("axisDefaults.notes.icon.border.color", "chart-notes-border"), this.mapColor("axisDefaults.notes.line.color", "chart-notes-lines"), this.mapColor("axisDefaults.title.color", "normal-text-color"), this.mapColor("chartArea.background", "background"), this.mapColor("legend.inactiveItems.labels.color", "chart-inactive"), this.mapColor("legend.inactiveItems.markers.color", "chart-inactive"), this.mapColor("legend.labels.color", "normal-text-color"), this.mapColor("seriesDefaults.boxPlot.downColor", "chart-major-lines"), this.mapColor("seriesDefaults.boxPlot.mean.color", "base"), this.mapColor("seriesDefaults.boxPlot.median.color", "base"), this.mapColor("seriesDefaults.boxPlot.whiskers.color", "primary"), this.mapColor("seriesDefaults.bullet.target.color", "normal-text-color"), this.mapColor("seriesDefaults.candlestick.downColor", "normal-text-color"), this.mapColor("seriesDefaults.candlestick.line.color", "normal-text-color"), this.mapColor("seriesDefaults.errorBars.color", "chart-error-bars-background"), this.mapColor("seriesDefaults.horizontalWaterfall.line.color", "chart-major-lines"), this.mapColor("seriesDefaults.icon.border.color", "chart-major-lines"), this.mapColor("seriesDefaults.labels.background", "background"), this.mapColor("seriesDefaults.labels.color", "normal-text-color"), this.mapColor("seriesDefaults.notes.icon.background", "chart-notes-background"), this.mapColor("seriesDefaults.notes.icon.border.color", "chart-notes-border"), this.mapColor("seriesDefaults.notes.line.color", "chart-notes-lines"), this.mapColor("seriesDefaults.verticalBoxPlot.downColor", "chart-major-lines"), this.mapColor("seriesDefaults.verticalBoxPlot.mean.color", "base"), this.mapColor("seriesDefaults.verticalBoxPlot.median.color", "base"), this.mapColor("seriesDefaults.verticalBoxPlot.whiskers.color", "primary"), this.mapColor("seriesDefaults.verticalBullet.target.color", "normal-text-color"), this.mapColor("seriesDefaults.waterfall.line.color", "chart-major-lines"), this.mapColor("title.color", "normal-text-color"), this.mapColor("subtitle.color", "normal-text-color");
      var r = parseFloat(this.queryStyle("chart-area-opacity").opacity);
      isNaN(r) || (this.setStyle("seriesDefaults.area.opacity", r), this.setStyle("seriesDefaults.radarArea.opacity", r), this.setStyle("seriesDefaults.verticalArea.opacity", r), this.setStyle("seriesDefaults.labels.opacity", r)), this.setInactiveOpacity(["area", "verticalArea"], "chart-area-inactive-opacity"), this.setInactiveOpacity(["line", "verticalLine"], "chart-line-inactive-opacity");
    }, n.prototype.setFonts = function() {
      var r = an(this.queryStyle("chart-font")), o = an(this.queryStyle("chart-title-font")), t = an(this.queryStyle("chart-pane-title-font")), e = an(this.queryStyle("chart-label-font"));
      this.setStyle("axisDefaults.labels.font", e), this.setStyle("axisDefaults.notes.label.font", r), this.setStyle("axisDefaults.title.font", r), this.setStyle("legend.labels.font", r), this.setStyle("seriesDefaults.labels.font", e), this.setStyle("seriesDefaults.notes.label.font", r), this.setStyle("title.font", o), this.setStyle("subtitle.font", t), this.setStyle("paneDefaults.title.font", t);
    }, n.prototype.setSeriesColors = function() {
      var r = this.element, o = [].slice.call(r.querySelectorAll(".k-var--series div")), t = zc(r.querySelector(".k-var--series-unset")), e = o.reduce(
        function(i, a) {
          var s = mb(a.className), l = zc(a);
          return l !== t && (i[s] = l), i;
        },
        []
        // Will populate the series colors in this array
      );
      this.setStyle("seriesColors", e);
    }, n.prototype.mapColor = function(r, o) {
      this.setStyle(r, this.queryStyle(o).backgroundColor);
    }, n.prototype.queryStyle = function(r) {
      var o = this.element;
      return window.getComputedStyle(o.querySelector(".k-var--".concat(r)));
    }, n.prototype.setInactiveOpacity = function(r, o) {
      var t = this, e = parseFloat(this.queryStyle(o).opacity);
      !isNaN(e) && e < 1 && r.forEach(function(i) {
        return t.setStyle("seriesDefaults.".concat(i, ".highlight.inactiveOpacity"), e);
      });
    }, n;
  }()
), Ab = function(n, r, o) {
  var t = new bb(n);
  if (typeof o > "u") {
    n.dispatch({ type: "push", payload: Rc() });
    return;
  }
  var e = t.element = o.createElement("div");
  e.style.display = "none", e.innerHTML = wb, o.body.appendChild(e);
  try {
    n.dispatch({ type: "push", payload: Rc() }), t.setColors(), t.setFonts(), t.setSeriesColors();
  } finally {
    o.body.removeChild(t.element), delete t.element, r();
  }
}, Sb = 1e3 / 60, Tb = function(n) {
  var r, o, t = [], e = function() {
    return r;
  }, i = function(s) {
    r = n(r, s), Mf && (window.clearTimeout(o), o = window.setTimeout(function() {
      return t.forEach(function(l) {
        return l();
      });
    }, Sb));
  }, a = function(s) {
    return t.push(s), function() {
      return t = t.filter(function(l) {
        return l !== s;
      });
    };
  };
  return i({}), { getState: e, dispatch: i, subscribe: a };
};
const gn = Tb;
var jc = globalThis && globalThis.__spreadArray || function(n, r, o) {
  if (o || arguments.length === 2)
    for (var t = 0, e = r.length, i; t < e; t++)
      (i || !(t in r)) && (i || (i = Array.prototype.slice.call(r, 0, t)), i[t] = r[t]);
  return n.concat(i || Array.prototype.slice.call(r));
}, Df = function(n, r) {
  return r.chartCollectionIdxKey ? Ts.collectionConfigurationItem(n, r) : r.chartKey ? Ts.configurationItem(n, r) : {};
}, Cb = function(n, r) {
  if (r.type)
    switch (r.type) {
      case "set":
        return Ts.themeItem(n, r);
      case "push":
        return Object.assign(n, r.payload);
      default:
        return n;
    }
  else
    return {};
}, kb = function(n, r) {
  if (r.type)
    switch (r.type) {
      case "add":
        return jc(jc([], n, !0), [r.payload], !1);
      case "remove":
        return n.filter(function(o) {
          return o !== r.payload;
        });
      default:
        return n;
    }
  else
    return [];
}, Ts = {
  configurationItem: function(n, r) {
    var o;
    return Object.assign(n, (o = {}, o[r.chartKey] = r.payload, o));
  },
  collectionConfigurationItem: function(n, r) {
    var o, t = !1, e = r.chartCollectionIdxKey.split("_"), i = e[0], a = e[1], s = n[i].map(function(l, p) {
      return parseInt(a, 10) === p ? (t = !0, r.payload) : l;
    });
    return t === !1 && s.splice(parseInt(a, 10), 0, r.payload), Object.assign(n, (o = {}, o[i] = s, o));
  },
  themeItem: function(n, r) {
    for (var o = {}, t = Object.assign(o, n), e = r.payload, i = e.field, a = e.value, s = i.split("."), l = s.shift(); s.length > 0; )
      o = o[l] = o[l] || {}, l = s.shift();
    return o[l] = a, t;
  }
}, Vc = (
  /** @class */
  function() {
    function n(r, o) {
      this.value = r.value, this.category = r.category, this.categoryIndex = r.categoryIx, this.series = r.series, this.dataItem = r.dataItem, this.percentage = r.percentage, this.runningTotal = r.runningTotal, this.total = r.total, this.low = r.low, this.high = r.high, this.xLow = r.xLow, this.xHigh = r.xHigh, this.yLow = r.yLow, this.yHigh = r.yHigh, this.point = r, this.format = ((r.options || {}).tooltip || {}).format || o;
    }
    return Object.defineProperty(n.prototype, "formattedValue", {
      get: function() {
        return this.format ? this.point.formatValue(this.format) : String(this.value);
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }()
), Pb = "k-chart-shared-tooltip-marker", Ob = function(n) {
  var r = n.categoryText, o = n.colorMarker, t = n.colspan, e = n.nameColumn, i = n.points, a = function(s, l) {
    return M.createElement(
      "tr",
      { key: l },
      o && M.createElement(
        "td",
        null,
        M.createElement("span", { className: Pb, style: { backgroundColor: s.series.color } })
      ),
      e && M.createElement("td", null, s.series.name),
      M.createElement("td", { dangerouslySetInnerHTML: { __html: s.formattedValue } })
    );
  };
  return M.createElement(
    "table",
    null,
    M.createElement(
      "thead",
      null,
      M.createElement(
        "tr",
        null,
        M.createElement("th", { colSpan: t }, r)
      )
    ),
    M.createElement("tbody", null, i.map(a))
  );
}, Ve = M.createContext(null);
Ve.displayName = "ChartContext";
var Eb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Mb = { horizontal: "fit", vertical: "fit" }, Rb = "k-chart-tooltip", Lb = "k-chart-tooltip-wrapper", Bf = (
  /** @class */
  function(n) {
    Eb(r, n);
    function r(o, t) {
      var e = n.call(this, o, t) || this;
      return e.context = null, e.element = null, e.onChartMouseLeave = function(i) {
        var a = i.syntheticEvent;
        return !!Rf(a.relatedTarget, e.element);
      }, e.onMouseLeave = function(i) {
        var a = If(e, i), s = e.context.childrenObserver.trigger("onMouseLeave", a);
        s && i.preventDefault();
      }, e.chartObserver = new de(e, {
        onMouseLeave: "onChartMouseLeave"
      }), t.observersStore.dispatch({
        type: "add",
        payload: e.chartObserver
      }), e;
    }
    return r.prototype.render = function() {
      var o = this, t = this.props, e = t.popupShown, i = t.popupAlign, a = t.popupOffset, s = t.popupStyles, l = t.popupContent, p = t.className, h = [Rb, p].join(" ").trim(), c = M.createElement(
        jd,
        { animate: !1, popupAlign: i, offset: a, show: e, collision: Mb, className: Lb },
        M.createElement("div", { className: h, style: s, onMouseLeave: this.onMouseLeave, ref: function(u) {
          return o.element = u;
        } }, l())
      );
      return c;
    }, r.prototype.componentWillUnmount = function() {
      this.context.observersStore.dispatch({
        type: "remove",
        payload: this.chartObserver
      });
    }, r.contextType = Ve, r;
  }(M.Component)
), Ib = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Bn = globalThis && globalThis.__assign || function() {
  return Bn = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Bn.apply(this, arguments);
}, Db = globalThis && globalThis.__rest || function(n, r) {
  var o = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && r.indexOf(t) < 0 && (o[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var e = 0, t = Object.getOwnPropertySymbols(n); e < t.length; e++)
      r.indexOf(t[e]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[e]) && (o[t[e]] = n[t[e]]);
  return o;
}, Bb = "k-chart-shared-tooltip", zb = "k-chart-tooltip-inverse", jb = (
  /** @class */
  function(n) {
    Ib(r, n);
    function r() {
      var o = n !== null && n.apply(this, arguments) || this;
      return o.context = null, o.state = {
        popupShown: !1
      }, o.chartObserver = null, o;
    }
    return r.prototype.componentDidMount = function() {
      this.chartObserver = new de(this, {
        showTooltip: "onShowTooltip",
        hideTooltip: "onHideTooltip"
      }), this.context.observersStore.dispatch({
        type: "add",
        payload: this.chartObserver
      });
    }, r.prototype.render = function() {
      var o, t = this, e = this.state, i = e.popupContext, a = e.shared, s = e.className, l = Db(e, ["popupContext", "shared", "className"]), p = this.state.popupShown ? function() {
        var c = t.findRenderFunction();
        if (a)
          return c !== null ? c(i) : M.createElement(Ob, Bn({}, i));
        var u = i.point, v = t.findRenderFunctionByIndex(u.series.index);
        return v !== null ? v(i) : c !== null ? c(i) : M.createElement("span", { dangerouslySetInnerHTML: { __html: i.point.formattedValue } });
      } : Function.prototype, h = ap((o = {}, o[Bb] = a, o[zb] = !!s, o));
      return M.createElement(Bf, Bn({}, l, { popupContent: p, className: h }));
    }, r.prototype.componentWillUnmount = function() {
      this.context.observersStore.dispatch({
        type: "remove",
        payload: this.chartObserver
      });
    }, r.prototype.onShowTooltip = function(o) {
      var t = o.anchor, e = o.style, i = o.shared, a = o.className, s = o.crosshair, l;
      s || (i ? l = this.createSharedTooltipContext(o) : l = this.createTooltipContext(o), this.setState({
        popupShown: !0,
        popupAlign: t.align,
        popupOffset: t.point,
        popupContext: l,
        popupStyles: e,
        className: a,
        shared: i
      }));
    }, r.prototype.onHideTooltip = function() {
      this.setState({
        popupShown: !1,
        popupStyles: {},
        className: void 0
      });
    }, r.prototype.createSharedTooltipContext = function(o) {
      var t = o.points, e = o.categoryText, i = t.filter(function(l) {
        return typeof l.series.name < "u";
      }).length > 0, a = o.series.length > 1, s = 1;
      return i && s++, a && s++, {
        categoryText: e,
        colorMarker: a,
        colspan: s,
        nameColumn: i,
        points: o.points.map(function(l) {
          return new Vc(l, o.format);
        })
      };
    }, r.prototype.createTooltipContext = function(o) {
      var t = o.point, e = o.format;
      return { point: new Vc(t, e) };
    }, r.prototype.findRenderFunctionByIndex = function(o) {
      var t = this.context.optionsStore.getState().series;
      return t !== void 0 && Array.isArray(t) && t[o] !== void 0 && t[o].hasOwnProperty("tooltip") && t[o].tooltip.hasOwnProperty("render") ? t[o].tooltip.render : null;
    }, r.prototype.findRenderFunction = function() {
      var o = this.context.optionsStore.getState().tooltip;
      return o !== void 0 && o.hasOwnProperty("render") ? o.render : null;
    }, r.contextType = Ve, r;
  }(M.Component)
), zf = function(n) {
  return n.children;
};
zf.displayName = "Container";
var Vb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Cs = globalThis && globalThis.__assign || function() {
  return Cs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Cs.apply(this, arguments);
}, Nb = globalThis && globalThis.__rest || function(n, r) {
  var o = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && r.indexOf(t) < 0 && (o[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var e = 0, t = Object.getOwnPropertySymbols(n); e < t.length; e++)
      r.indexOf(t[e]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[e]) && (o[t[e]] = n[t[e]]);
  return o;
}, Hb = "k-chart-crosshair-tooltip", Fb = "k-chart-tooltip-inverse", Ub = (
  /** @class */
  function(n) {
    Vb(r, n);
    function r(o, t) {
      var e = n.call(this, o, t) || this;
      return e.context = null, e.state = {
        popupShown: !1
      }, e.chartObserver = new de(e, {
        showTooltip: "onShowTooltip",
        hideTooltip: "onHideTooltip"
      }), t.observersStore.dispatch({
        type: "add",
        payload: e.chartObserver
      }), e;
    }
    return r.prototype.render = function() {
      var o, t = this.state, e = t.popupContend, i = t.className, a = Nb(t, ["popupContend", "className"]), s = this.state.popupShown ? function() {
        return e;
      } : Function.prototype, l = ap((o = {}, o[Hb] = !0, o[Fb] = !!i, o));
      return M.createElement(Bf, Cs({}, a, { popupContent: s, className: l }));
    }, r.prototype.componentWillUnmount = function() {
      var o;
      (o = this.context) === null || o === void 0 || o.observersStore.dispatch({
        type: "remove",
        payload: this.chartObserver
      });
    }, r.prototype.onShowTooltip = function(o) {
      var t = o.anchor, e = o.style, i = o.className, a = o.crosshair, s = o.axisName, l = o.axisIndex, p = o.value, h = this.props, c = h.name, u = h.index;
      a && s === c && l === u && this.setState({
        popupShown: !0,
        popupAlign: t.align,
        popupOffset: t.point,
        popupContend: p,
        popupStyles: e,
        className: i
      });
    }, r.prototype.onHideTooltip = function() {
      this.setState({
        popupShown: !1,
        popupStyles: {},
        className: void 0
      });
    }, r.contextType = Ve, r;
  }(M.Component)
), $b = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), ks = globalThis && globalThis.__assign || function() {
  return ks = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, ks.apply(this, arguments);
}, Nc = ["categoryAxis", "valueAxis", "xAxis", "yAxis"];
function Gb(n) {
  for (var r = {}, o = 0; o < Nc.length; o++)
    for (var t = Wb(n, Nc[o]), e = 0; e < t.length; e++) {
      var i = t[e];
      r[i.name + i.index] = i;
    }
  return r;
}
function Wb(n, r) {
  var o = [];
  if (n[r])
    for (var t = [].concat(n[r]), e = 0; e < t.length; e++) {
      var i = (t[e].crosshair || {}).tooltip;
      i && i.visible && o.push({
        index: e,
        name: r
      });
    }
  return o;
}
var Xb = (
  /** @class */
  function(n) {
    $b(r, n);
    function r() {
      var o = n !== null && n.apply(this, arguments) || this;
      return o.context = null, o.state = {
        tooltips: {}
      }, o.storeUnsubscriber = Function.prototype, o.subscriber = function() {
        var t;
        o.setState({
          tooltips: Gb((t = o.context) === null || t === void 0 ? void 0 : t.optionsStore.getState())
        });
      }, o;
    }
    return r.prototype.componentDidMount = function() {
      this.storeUnsubscriber = this.context.optionsStore.subscribe(this.subscriber);
    }, r.prototype.render = function() {
      var o = this.state.tooltips, t = Object.keys(o).map(function(e) {
        return M.createElement(Ub, ks({}, o[e], { key: e }));
      });
      return M.createElement(zf, null, t);
    }, r.prototype.componentWillUnmount = function() {
      this.storeUnsubscriber();
    }, r.contextType = Ve, r;
  }(M.Component)
), Hc = {
  name: "@progress/kendo-react-charts",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1690380112,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Yb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), ti = globalThis && globalThis.__assign || function() {
  return ti = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, ti.apply(this, arguments);
}, qb = globalThis && globalThis.__rest || function(n, r) {
  var o = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && r.indexOf(t) < 0 && (o[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var e = 0, t = Object.getOwnPropertySymbols(n); e < t.length; e++)
      r.indexOf(t[e]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[e]) && (o[t[e]] = n[t[e]]);
  return o;
}, Fc = globalThis && globalThis.__spreadArray || function(n, r, o) {
  if (o || arguments.length === 2)
    for (var t = 0, e = r.length, i; t < e; t++)
      (i || !(t in r)) && (i || (i = Array.prototype.slice.call(r, 0, t)), i[t] = r[t]);
  return n.concat(i || Array.prototype.slice.call(r));
}, jf = (
  /** @class */
  function(n) {
    Yb(r, n);
    function r(o) {
      var t = n.call(this, o) || this;
      return t.chartInstance = null, t.surface = null, t._element = null, t.optionsStore = {}, t.optionsUnsubscriber = Function.prototype, t.themeStore = {}, t.themeUnsubscriber = Function.prototype, t.observersStore = {}, t.suppressTransitions = !1, t.showLicenseWatermark = !1, t.onRender = function(e) {
        t.chartInstance !== null && (t.surface = e.sender.surface, t.trigger("render", e));
      }, t.onDrilldown = function(e) {
        var i, a = t.optionsStore.getState().series, s = a.find(function(f) {
          return f.name === e.series.name;
        });
        if (!s.drilldownSeriesFactory)
          return !0;
        var l = "onDrilldown";
        if (t.props.hasOwnProperty(l)) {
          var p = { seriesName: s.name, drilldownValue: e.value }, h = Fc(Fc([], ((i = t.props.drilldownState) === null || i === void 0 ? void 0 : i.steps) || [], !0), [p], !1), c = t.props.getTarget(), u = ti(ti({}, e), { currentState: t.props.drilldownState, nextState: { steps: h } }), v = new Lf(u, c);
          t.props[l].call(void 0, v);
        }
        return !0;
      }, t.onLegendItemClick = function(e) {
        if (t.chartInstance !== null)
          if (t.props.onLegendItemClick)
            t.trigger("legendItemClick", e);
          else {
            var i = t.optionsStore.getState().series;
            if (!i)
              return;
            var a = {}, s = e.seriesIndex, l = e.pointIndex, p = i[s];
            if (l === void 0)
              a = Object.assign({}, p, { visible: Ic(p.visible) });
            else {
              var h = p.pointVisibility = p.pointVisibility || [];
              h[l] = Ic(h[l]), a = Object.assign({}, p);
            }
            t.optionsStore.dispatch({
              chartCollectionIdxKey: "series_".concat(s),
              payload: a
            }), t.suppressTransitions = !0;
          }
      }, t.onWindowResize = function() {
        t.chartInstance !== null && t.chartInstance.resize();
      }, t.onChartMouseLeave = function(e) {
        var i = If(t, e), a = t.triggerDomEvent("onMouseLeave", i);
        a ? e.preventDefault() : t.chartInstance !== null && t.chartInstance.hideElements();
      }, t.onChildMouseLeave = function(e) {
        var i = e.syntheticEvent;
        return t.chartInstance && !Rf(i.relatedTarget, t.element) && t.chartInstance.hideElements(), !1;
      }, dw(Hc), t.showLicenseWatermark = gw(Hc), t.optionsStore = gn(Df), t.observersStore = gn(kb), t.childrenObserver = new de(t, { onMouseLeave: "onChildMouseLeave" }), t.state = {
        optionsStore: t.optionsStore,
        observersStore: t.observersStore,
        childrenObserver: t.childrenObserver,
        drilldownState: { steps: [] }
      }, t.themeStore = gn(Cb), t.chartObserver = new de(t, {
        render: "onRender",
        legendItemClick: "onLegendItemClick",
        drilldown: "onDrilldown"
      }), t;
    }
    return Object.defineProperty(r.prototype, "element", {
      /**
       * @hidden
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), r.getDerivedStateFromProps = function(o, t) {
      return ti(ti({}, t), { drilldownState: o.drilldownState || [] });
    }, r.prototype.componentDidMount = function() {
      var o, t = ((o = this._element) === null || o === void 0 ? void 0 : o.ownerDocument) || document;
      Ab(this.themeStore, this.instantiateCoreChart.bind(this), t), this.optionsUnsubscriber = this.optionsStore.subscribe(this.refresh.bind(this)), this.themeUnsubscriber = this.themeStore.subscribe(this.refresh.bind(this)), window.addEventListener("resize", this.onWindowResize);
    }, r.prototype.componentWillUnmount = function() {
      this.optionsUnsubscriber(), this.themeUnsubscriber(), this.chartInstance !== null && (this.chartInstance.destroy(), this.chartInstance = null), window.removeEventListener("resize", this.onWindowResize);
    }, r.prototype.componentDidUpdate = function(o) {
      var t = this.props, e = t.dir;
      t.children;
      var i = qb(t, ["dir", "children"]);
      if (this.chartInstance !== null) {
        var a = Mp(this), s = this.chartInstance.chartService, l = a.locale !== s._intlService.locale, p = Object.entries(o).filter(function(h) {
          return h[0] !== "dir" && h[0] !== "children";
        }).some(function(h) {
          var c = h[0], u = h[1];
          return !(i.hasOwnProperty(c) && i[c] === u);
        });
        l && (this.chartInstance.chartService._intlService = a, this.chartInstance.chartService.format._intlService = a, p || this.chartInstance.noTransitionsRedraw()), p && this.refresh(), o.dir !== e && this.chartInstance.setDirection(this.getDirection(e));
      }
    }, r.prototype.render = function() {
      var o = this, t = this.props, e = t.style, i = e === void 0 ? {} : e, a = t.className, s = t.wrapper, l = t.children, p = Object.assign({}, i, { position: "relative" }), h = M.createElement(s, {
        className: a,
        style: p,
        key: "chartElement"
      }, M.createElement("div", { onMouseLeave: this.onChartMouseLeave, ref: function(c) {
        return o._element = c;
      }, className: "k-chart-surface" }, l), M.createElement(M.Fragment, null, this.showLicenseWatermark && M.createElement(mw, null)));
      return M.createElement(
        Ve.Provider,
        { value: this.state },
        M.createElement(jb, { key: "seriesTooltip" }),
        M.createElement(Xb, { key: "crosshairTooltips" }),
        h
      );
    }, r.prototype.getDirection = function(o) {
      var t = this, e = function() {
        return Mf && window.getComputedStyle(t.element).direction;
      }, i = o !== void 0 ? o : e() || "ltr";
      return i === "rtl";
    }, r.prototype.getChartOptions = function() {
      var o = this.props, t = o.renderAs, e = o.pannable, i = o.zoomable, a = o.paneDefaults, s = o.panes, l = o.transitions, p = o.seriesColors, h = o.seriesDefaults, c = o.axisDefaults, u = o.deriveOptionsFromParent, v = {};
      return t !== void 0 && (v.renderAs = t), e !== void 0 && (v.pannable = e), i !== void 0 && (v.zoomable = i), a !== void 0 && (v.paneDefaults = a), s !== void 0 && (v.panes = s), l !== void 0 && (v.transitions = l), p !== void 0 && (v.seriesColors = p), h !== void 0 && (v.seriesDefaults = h), c !== void 0 && (v.axisDefaults = c), v = Object.assign(v, this.optionsStore.getState()), u && (v = u(v)), v;
    }, r.prototype.refresh = function() {
      if (this.chartInstance !== null) {
        var o = this.themeStore.getState(), t = this.getChartOptions(), e = t.transitions;
        this.suppressTransitions && (t.transitions = !1), this.props.onRefresh ? this.props.onRefresh.call(void 0, t, o, this.chartInstance) : this.chartInstance.setOptions(t, o), this.suppressTransitions && (t.transitions = e, this.suppressTransitions = !1);
      }
    }, r.prototype.instantiateCoreChart = function() {
      var o = this.props, t = o.dir, e = o.chartConstructor, i = this.getChartOptions();
      this.chartInstance = new e(this.element, i, this.themeStore.getState(), {
        rtl: this.getDirection(t),
        intlService: Mp(this),
        observer: this.chartObserver,
        sender: this
      });
    }, r.prototype.trigger = function(o, t) {
      for (var e = this.props.getTarget(), i = db(o, t, e), a = "on" + o.charAt(0).toUpperCase() + o.slice(1), s = this.observersStore.getState(), l = !1, p = 0; p < s.length; p++)
        s[p].trigger(o, t) && (l = !0);
      return l === !1 && i && this.props.hasOwnProperty(a) ? (this.props[a].call(void 0, i), i.isDefaultPrevented && i.isDefaultPrevented()) : l;
    }, r.prototype.requiresHandlers = function(o) {
      for (var t = 0; t < o.length; t++) {
        var e = o[t], i = "on" + e.charAt(0).toUpperCase() + e.slice(1);
        if (this.props.hasOwnProperty(i))
          return !0;
      }
      return !1;
    }, r.prototype.triggerDomEvent = function(o, t) {
      for (var e = this.observersStore.getState(), i = !1, a = 0; a < e.length; a++)
        e[a].trigger(o, t) && (i = !0);
      return i;
    }, r.propTypes = {
      dir: Ep.string,
      renderAs: Ep.oneOf(["svg", "canvas"])
    }, r.defaultProps = {
      renderAs: "svg"
    }, r;
  }(M.Component)
);
Ad(jf);
yo.register(Sw);
var Zb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Qb = (
  /** @class */
  function(n) {
    Zb(r, n);
    function r(o, t) {
      var e = n.call(this, o, t) || this;
      return e.context = null, e.state = {
        donutCenterStyles: null
      }, e.chartObserver = new de(e, {
        render: "onRender"
      }), t.observersStore.dispatch({
        type: "add",
        payload: e.chartObserver
      }), e;
    }
    return r.prototype.render = function() {
      var o = this.props.render, t = this.state.donutCenterStyles, e = null;
      return o && t && (e = M.createElement(
        "div",
        { className: "k-chart-donut-center", style: t },
        M.createElement(o, null)
      )), e;
    }, r.prototype.onRender = function(o) {
      var t, e = (t = this.context) === null || t === void 0 ? void 0 : t.optionsStore.getState().series, i = Array.isArray(e) ? e[0] : null, a = o.sender._plotArea.charts;
      if (!(!i || i.type !== "donut" || a[0].points.length === 0)) {
        var s = a[0].points[0].sector, l = s.innerRadius, p = s.center.y - l, h = s.center.x - l, c = l * 2;
        this.setState({
          donutCenterStyles: {
            height: c,
            left: h,
            top: p,
            width: c
          }
        });
      }
    }, r.contextType = Ve, r;
  }(M.Component)
), Kb = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), Ps = globalThis && globalThis.__assign || function() {
  return Ps = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Ps.apply(this, arguments);
}, Jb = globalThis && globalThis.__rest || function(n, r) {
  var o = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && r.indexOf(t) < 0 && (o[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var e = 0, t = Object.getOwnPropertySymbols(n); e < t.length; e++)
      r.indexOf(t[e]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[e]) && (o[t[e]] = n[t[e]]);
  return o;
}, t0 = (
  /** @class */
  function(n) {
    Kb(r, n);
    function r() {
      var o = n !== null && n.apply(this, arguments) || this;
      return o._baseChart = null, o.getTarget = function() {
        return o;
      }, o;
    }
    return Object.defineProperty(r.prototype, "chartInstance", {
      /**
       * @hidden
       */
      get: function() {
        return this._baseChart !== null ? this._baseChart.chartInstance : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "surface", {
      /**
       * The Drawing `Surface` of the Chart.
       */
      get: function() {
        return this._baseChart !== null ? this._baseChart.surface : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "element", {
      /**
       * The DOM element of the Chart.
       */
      get: function() {
        return this._baseChart !== null ? this._baseChart.element : null;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var o = this, t = this.props, e = t.donutCenterRender, i = t.children, a = t.className, s = Jb(t, ["donutCenterRender", "children", "className"]);
      return M.createElement(
        jf,
        Ps({}, s, { ref: function(l) {
          return o._baseChart = l;
        }, chartConstructor: sa, getTarget: this.getTarget, wrapper: "div", className: ap("k-chart k-widget", a) }),
        i,
        M.createElement(Qb, { render: e })
      );
    }, r;
  }(M.Component)
), e0 = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), zn = globalThis && globalThis.__assign || function() {
  return zn = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, zn.apply(this, arguments);
}, lp = (
  /** @class */
  function(n) {
    e0(r, n);
    function r(o, t) {
      var e = n.call(this, o, t) || this;
      return e.optionsStore = t.optionsStore, e;
    }
    return r.prototype.renderChildren = function(o, t) {
      var e = o.props.children, i = this.props, a = i._chartKey, s = i._parentStore, l = zn(zn({}, o.props), { _chartCollectionIdxKey: "".concat(a, "_").concat(t), _parentStore: s });
      return M.cloneElement(o, l, e);
    }, r.prototype.render = function() {
      var o = this, t = this.props, e = t._chartKey, i = t._parentStore, a = t.children, s = i || this.optionsStore;
      return s.dispatch({
        chartKey: e,
        payload: []
      }), M.Children.map(a, function(l, p) {
        return M.isValidElement(l) ? o.renderChildren(l, p) : l;
      });
    }, r.contextType = Ve, r;
  }(M.Component)
), r0 = globalThis && globalThis.__extends || function() {
  var n = function(r, o) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
      t.__proto__ = e;
    } || function(t, e) {
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }, n(r, o);
  };
  return function(r, o) {
    if (typeof o != "function" && o !== null)
      throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");
    n(r, o);
    function t() {
      this.constructor = r;
    }
    r.prototype = o === null ? Object.create(o) : (t.prototype = o.prototype, new t());
  };
}(), jn = globalThis && globalThis.__assign || function() {
  return jn = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, jn.apply(this, arguments);
}, i0 = globalThis && globalThis.__rest || function(n, r) {
  var o = {};
  for (var t in n)
    Object.prototype.hasOwnProperty.call(n, t) && r.indexOf(t) < 0 && (o[t] = n[t]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var e = 0, t = Object.getOwnPropertySymbols(n); e < t.length; e++)
      r.indexOf(t[e]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[e]) && (o[t[e]] = n[t[e]]);
  return o;
}, Ae = (
  /** @class */
  function(n) {
    r0(r, n);
    function r(o, t) {
      var e = n.call(this, o, t) || this;
      return e.optionsStore = t.optionsStore, e.childStore = gn(Df), e;
    }
    return r.prototype.render = function() {
      var o = this, t = this.props.children;
      return t !== void 0 ? M.Children.map(t, function(e) {
        return M.isValidElement(e) ? o.renderChildren(e) : e;
      }) : null;
    }, r.prototype.componentDidMount = function() {
      this.dispatch();
    }, r.prototype.componentDidUpdate = function() {
      this.dispatch();
    }, r.prototype.dispatch = function() {
      var o = this.props, t = o._chartKey, e = o._chartCollectionIdxKey, i = o._parentStore;
      o.children;
      var a = i0(o, ["_chartKey", "_chartCollectionIdxKey", "_parentStore", "children"]), s = i || this.optionsStore;
      s.dispatch({
        chartKey: t,
        chartCollectionIdxKey: e,
        payload: Object.assign({}, a, this.childStore.getState())
      });
    }, r.prototype.renderChildren = function(o) {
      var t = o.props.children, e = jn(jn({}, o.props), { _parentStore: this.childStore });
      return M.cloneElement(o, e, t);
    }, r.contextType = Ve, r;
  }(M.Component)
), Os = globalThis && globalThis.__assign || function() {
  return Os = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Os.apply(this, arguments);
}, o0 = function(n) {
  return M.createElement(Ae, Os({}, n, { _chartKey: "chartArea" }));
}, Es = globalThis && globalThis.__assign || function() {
  return Es = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Es.apply(this, arguments);
}, pp = function(n) {
  return M.createElement(Ae, Es({}, n));
};
pp.displayName = "ChartCategoryAxisItem";
var Ms = globalThis && globalThis.__assign || function() {
  return Ms = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Ms.apply(this, arguments);
}, Vf = function(n) {
  return M.createElement(lp, Ms({}, n, { _chartKey: "categoryAxis" }));
};
Vf.propTypes = {
  children: function(n, r, o) {
    return sp(n, r, o, pp);
  }
};
var Rs = globalThis && globalThis.__assign || function() {
  return Rs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Rs.apply(this, arguments);
}, Nf = function(n) {
  return M.createElement(Ae, Rs({}, n, { _chartKey: "legend" }));
};
Nf.defaultProps = {
  visible: !0
};
var Ls = globalThis && globalThis.__assign || function() {
  return Ls = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Ls.apply(this, arguments);
}, n0 = function(n) {
  return M.createElement(Ae, Ls({}, n, { _chartKey: "plotArea" }));
}, Is = globalThis && globalThis.__assign || function() {
  return Is = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Is.apply(this, arguments);
}, zo = function(n) {
  var r = function(t) {
    return M.createElement(M.Fragment, null);
  };
  n.drilldownSeriesFactory && (r = n.drilldownSeriesFactory);
  var o = function(t) {
    var e, i;
    return t && ((i = (e = t.drilldownState) === null || e === void 0 ? void 0 : e.steps) === null || i === void 0 ? void 0 : i.find(function(a) {
      var s = a.seriesName;
      return s === n.name;
    }));
  };
  return M.createElement(Ve.Consumer, null, function(t) {
    return o(t) ? M.createElement(r, { _chartCollectionIdxKey: n._chartCollectionIdxKey, drilldownValue: o(t).drilldownValue }) : M.createElement(Ae, Is({}, n));
  });
};
zo.displayName = "ChartSeriesItem";
var Ds = globalThis && globalThis.__assign || function() {
  return Ds = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Ds.apply(this, arguments);
}, Hf = function(n) {
  return M.createElement(lp, Ds({}, n, { _chartKey: "series" }));
};
Hf.propTypes = {
  children: function(n, r, o) {
    return sp(n, r, o, zo);
  }
};
var Bs = globalThis && globalThis.__assign || function() {
  return Bs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Bs.apply(this, arguments);
}, a0 = function(n) {
  return M.createElement(Ae, Bs({}, n, { _chartKey: "subtitle" }));
}, zs = globalThis && globalThis.__assign || function() {
  return zs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, zs.apply(this, arguments);
}, s0 = function(n) {
  return M.createElement(Ae, zs({}, n, { _chartKey: "title" }));
}, js = globalThis && globalThis.__assign || function() {
  return js = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, js.apply(this, arguments);
}, hp = function(n) {
  return M.createElement(Ae, js({}, n));
};
hp.displayName = "ChartValueAxisItem";
var Vs = globalThis && globalThis.__assign || function() {
  return Vs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Vs.apply(this, arguments);
}, Ff = function(n) {
  return M.createElement(lp, Vs({}, n, { _chartKey: "valueAxis" }));
};
Ff.propTypes = {
  children: function(n, r, o) {
    return sp(n, r, o, hp);
  }
};
var Ns = globalThis && globalThis.__assign || function() {
  return Ns = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Ns.apply(this, arguments);
}, Uf = function(n) {
  return M.createElement(Ae, Ns({}, n, { _chartKey: "crosshair" }));
};
Uf.defaultProps = {
  visible: !0
};
var Hs = globalThis && globalThis.__assign || function() {
  return Hs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Hs.apply(this, arguments);
}, $f = function(n) {
  return M.createElement(Ae, Hs({}, n, { _chartKey: "tooltip" }));
};
$f.defaultProps = {
  visible: !0
};
var Fs = globalThis && globalThis.__assign || function() {
  return Fs = Object.assign || function(n) {
    for (var r, o = 1, t = arguments.length; o < t; o++) {
      r = arguments[o];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, Fs.apply(this, arguments);
}, Gf = function(n) {
  return M.createElement(Ae, Fs({}, n, { _chartKey: "title" }));
};
Gf.displayName = "ChartCategoryAxisTitle";
const y0 = (n) => {
  var r, o, t, e, i, a;
  return /* @__PURE__ */ Mt.jsxs(t0, { ...n == null ? void 0 : n.chart, children: [
    ((r = n == null ? void 0 : n.display) == null ? void 0 : r.plotArea) && /* @__PURE__ */ Mt.jsx(n0, { ...n == null ? void 0 : n.display.plotArea }),
    ((o = n == null ? void 0 : n.display) == null ? void 0 : o.area) && /* @__PURE__ */ Mt.jsx(o0, { ...n == null ? void 0 : n.display.area }),
    ((t = n.titles) == null ? void 0 : t.title) && /* @__PURE__ */ Mt.jsx(s0, { ...n.titles.title }),
    ((e = n.titles) == null ? void 0 : e.subTitle) && /* @__PURE__ */ Mt.jsx(a0, { ...n.titles.subTitle }),
    /* @__PURE__ */ Mt.jsx(Vf, { children: /* @__PURE__ */ Mt.jsxs(pp, { ...n.categoryAxisItem, children: [
      n.categoryAxisTitle && /* @__PURE__ */ Mt.jsx(Gf, { ...n.categoryAxisTitle }),
      n.legend && /* @__PURE__ */ Mt.jsx(Nf, { ...n.legend }),
      (n == null ? void 0 : n.categoryCrosshair) && /* @__PURE__ */ Mt.jsx(Uf, { ...(i = n.categoryCrosshair) == null ? void 0 : i.crossHair, children: /* @__PURE__ */ Mt.jsx($f, { ...(a = n.categoryCrosshair) == null ? void 0 : a.toolTip }) })
    ] }) }),
    /* @__PURE__ */ Mt.jsx(Ff, { children: n.valueAxisItem && /* @__PURE__ */ Mt.jsx(hp, { ...n.valueAxisItem }) }),
    /* @__PURE__ */ Mt.jsx(Hf, { children: n.children })
  ] });
};
function m0(n) {
  return /* @__PURE__ */ Mt.jsx(zo, { ...n, type: "pie" });
}
function _0(n) {
  return /* @__PURE__ */ Mt.jsx(zo, { ...n, type: "bar" });
}
function x0(n) {
  return /* @__PURE__ */ Mt.jsx(zo, { ...n, type: "column" });
}
export {
  _0 as BarChartSeriesItem,
  y0 as Chart,
  x0 as ColumnChartSeriesItem,
  m0 as PieChartSeriesItem
};
